{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024-2025                                 }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCDataGridRenderer;

interface

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$DEFINE FMXWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE FMXWEBLIB}
{$ENDIF}

uses
  {$IFDEF MSWINDOWS}
  Windows,
  {$ENDIF}
  Classes, SysUtils, WEBLib.Graphics, WEBLib.TMSFNCDataBinding, WEBLib.TMSFNCHTMLEditor, TMS.TMSFNCFilterBuilder, WEBLib.TMSFNCDataGridCell, WEBLib.TMSFNCColorPicker, WEBLib.TMSFNCDataGridData, WEBLib.TMSFNCDataGridCore, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes, Types,
  WEBLib.StdCtrls, WEBLib.TMSFNCScrollBar, WEBLib.TMSFNCFilterDialog, WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCToolBar, WEBLib.TMSFNCCheckedListBox, WEBLib.TMSFNCListBox, WEBLib.TMSFNCPopup, WEBLib.TMSFNCTypes, Generics.Collections, Generics.Defaults, WEBLib.TMSFNCBitmapContainer, WEBLib.TMSFNCImage,
  WEBLib.Controls, WEBLib.ExtCtrls, WEBLib.TMSFNCEdit, WEBLib.TMSFNCFindDialog, WEBLib.TMSFNCReplaceDialog, WEBLib.Menus, WEBLib.TMSFNCStyles
  {$IFDEF FMXLIB}
  ,FMX.DateTimeCtrls, FMX.ComboEdit, FMX.ListBox, FMX.Edit, FMX.Memo, FMX.SpinBox
  ,FMX.Memo.Types, FMX.Objects, FMX.Types, UITypes
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,ComCtrls, Messages, Spin, UITypes
  {$ENDIF}
  ;

type
  TTMSFNCDataGridCellList = class(TObjectList<TTMSFNCDataGridCell>)
  public
    function GetItemForCell(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCell;
  end;

  TTMSFNCDataGridDisplayList = class(TList<TTMSFNCDataGridCell>)
  public
    function GetItemForCell(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCell;
  end;

  TTMSFNCDataGridFixedColumnCellDisplayList = class(TTMSFNCDataGridDisplayList);
  TTMSFNCDataGridFixedColumnCellList = class(TTMSFNCDataGridCellList);
  TTMSFNCDataGridFixedRootCellDisplayList = class(TTMSFNCDataGridDisplayList);
  TTMSFNCDataGridFixedRootCellList = class(TTMSFNCDataGridCellList);
  TTMSFNCDataGridFixedRowCellDisplayList = class(TTMSFNCDataGridDisplayList);
  TTMSFNCDataGridFixedRowCellList = class(TTMSFNCDataGridCellList);
  TTMSFNCDataGridNormalCellDisplayList = class(TTMSFNCDataGridDisplayList);
  TTMSFNCDataGridNormalCellList = class(TTMSFNCDataGridCellList);

  TTMSFNCDataGridSelectedCellDictionary = class(TDictionary<TTMSFNCDataGridCellCoord, Boolean>);

  TTMSFNCDataGridFilterAppearance = class(TPersistent)
  private
    FFill: TTMSFNCGraphicsFill;
    FStroke: TTMSFNCGraphicsStroke;
    FFont: TTMSFNCGraphicsFont;
    procedure SetFill(const Value: TTMSFNCGraphicsFill);
    procedure SetStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetFont(const Value: TTMSFNCGraphicsFont);
  protected
    procedure DoChange(Sender: TObject);
    procedure DoFillChanged(Sender: TObject);
    procedure DoFontChanged(Sender: TObject);
    procedure DoStrokeChanged(Sender: TObject);
  public
    constructor Create;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
  published
    property Fill: TTMSFNCGraphicsFill read FFill write SetFill;
    property Font: TTMSFNCGraphicsFont read FFont write SetFont;
    property Stroke: TTMSFNCGraphicsStroke read FStroke write SetStroke;
  end;

  TTMSFNCDataGridDragAppearance = class(TPersistent)
  private
    FFill: TTMSFNCGraphicsFill;
    FStroke: TTMSFNCGraphicsStroke;
    FSize: Single;
    procedure SetFill(const Value: TTMSFNCGraphicsFill);
    procedure SetStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetSize(const Value: Single);
    function IsSizeStored: Boolean;
  protected
    procedure DoChange(Sender: TObject);
    procedure DoFillChanged(Sender: TObject);
    procedure DoStrokeChanged(Sender: TObject);
  public
    constructor Create;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
  published
    property Fill: TTMSFNCGraphicsFill read FFill write SetFill;
    property Stroke: TTMSFNCGraphicsStroke read FStroke write SetStroke;
    property Size: Single read FSize write SetSize stored IsSizeStored nodefault;
  end;

  TTMSFNCDataGridCellAppearance = class(TPersistent)
  private
    FBandLayout: TTMSFNCDataGridCellLayout;
    FFilterInverseMatchLayout: TTMSFNCDataGridCellLayout;
    FFilterMatchLayout: TTMSFNCDataGridCellLayout;
    FFixedLayout: TTMSFNCDataGridCellLayout;
    FFixedSelectedLayout: TTMSFNCDataGridCellLayout;
    FFocusedLayout: TTMSFNCDataGridCellLayout;
    FGroupLayout: TTMSFNCDataGridCellLayout;
    FNormalLayout: TTMSFNCDataGridCellLayout;
    FOnChange: TNotifyEvent;
    FSelectedLayout: TTMSFNCDataGridCellLayout;
    FShowFocus: Boolean;
    FSummaryLayout: TTMSFNCDataGridCellLayout;
    procedure SetBandLayout(const Value: TTMSFNCDataGridCellLayout);
    procedure SetFilterMatchLayout(const Value: TTMSFNCDataGridCellLayout);
    procedure SetFilterInverseMatchLayout(const Value: TTMSFNCDataGridCellLayout);
    procedure SetFixedLayout(const Value: TTMSFNCDataGridCellLayout);
    procedure SetFixedSelectedLayout(const Value: TTMSFNCDataGridCellLayout);
    procedure SetFocusedLayout(const Value: TTMSFNCDataGridCellLayout);
    procedure SetGroupLayout(const Value: TTMSFNCDataGridCellLayout);
    procedure SetNormalLayout(const Value: TTMSFNCDataGridCellLayout);
    procedure SetSelectedLayout(const Value: TTMSFNCDataGridCellLayout);
    procedure SetShowFocus(const Value: Boolean);
    procedure SetSummaryLayout(const Value: TTMSFNCDataGridCellLayout);
  protected
    procedure LayoutChanged(Sender: TObject);
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  public
    constructor Create;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
  published
    property FilterMatchLayout: TTMSFNCDataGridCellLayout read FFilterMatchLayout write SetFilterMatchLayout;
    property FilterInverseMatchLayout: TTMSFNCDataGridCellLayout read FFilterInverseMatchLayout write SetFilterInverseMatchLayout;
    property BandLayout: TTMSFNCDataGridCellLayout read FBandLayout write SetBandLayout;
    property FixedLayout: TTMSFNCDataGridCellLayout read FFixedLayout write SetFixedLayout;
    property FixedSelectedLayout: TTMSFNCDataGridCellLayout read FFixedSelectedLayout write SetFixedSelectedLayout;
    property FocusedLayout: TTMSFNCDataGridCellLayout read FFocusedLayout write SetFocusedLayout;
    property GroupLayout: TTMSFNCDataGridCellLayout read FGroupLayout write SetGroupLayout;
    property NormalLayout: TTMSFNCDataGridCellLayout read FNormalLayout write SetNormalLayout;
    property SelectedLayout: TTMSFNCDataGridCellLayout read FSelectedLayout write SetSelectedLayout;
    property ShowFocus: Boolean read FShowFocus write SetShowFocus default True;
    property SummaryLayout: TTMSFNCDataGridCellLayout read FSummaryLayout write SetSummaryLayout;
  end;

  TTMSFNCDataGridIcons = class(TPersistent)
  private
    FOnChange: TNotifyEvent;
    FExpandIcon: TTMSFNCBitmap;
    FCollapseIcon: TTMSFNCBitmap;
    FFilterIcon: TTMSFNCBitmap;
    FFilterActiveIcon: TTMSFNCBitmap;
    FFilterTypeIcon: TTMSFNCBitmap;
    FSortDescendingIcon: TTMSFNCBitmap;
    FSortAscendingIcon: TTMSFNCBitmap;
    FFilterClearIcon: TTMSFNCBitmap;
    FCloseIcon: TTMSFNCBitmap;
    procedure SetCollapseIcon(const Value: TTMSFNCBitmap);
    procedure SetExpandIcon(const Value: TTMSFNCBitmap);
    procedure SetFilterIcon(const Value: TTMSFNCBitmap);
    procedure SetFilterActiveIcon(const Value: TTMSFNCBitmap);
    procedure SetSortAscendingIcon(const Value: TTMSFNCBitmap);
    procedure SetSortDescendingIcon(const Value: TTMSFNCBitmap);
    procedure SetFilterClearIcon(const Value: TTMSFNCBitmap);
    procedure SetFilterTypeIcon(const Value: TTMSFNCBitmap);
    procedure SetCloseIcon(const Value: TTMSFNCBitmap);
  protected
    procedure IconChanged(Sender: TObject);
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  public
    constructor Create;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
  published
    property ExpandIcon: TTMSFNCBitmap read FExpandIcon write SetExpandIcon;
    property CollapseIcon: TTMSFNCBitmap read FCollapseIcon write SetCollapseIcon;
    property FilterIcon: TTMSFNCBitmap read FFilterIcon write SetFilterIcon;
    property FilterActiveIcon: TTMSFNCBitmap read FFilterActiveIcon write SetFilterActiveIcon;
    property FilterClearIcon: TTMSFNCBitmap read FFilterClearIcon write SetFilterClearIcon;
    property FilterTypeIcon: TTMSFNCBitmap read FFilterTypeIcon write SetFilterTypeIcon;
    property SortAscendingIcon: TTMSFNCBitmap read FSortAscendingIcon write SetSortAscendingIcon;
    property SortDescendingIcon: TTMSFNCBitmap read FSortDescendingIcon write SetSortDescendingIcon;
    property CloseIcon: TTMSFNCBitmap read FCloseIcon write SetCloseIcon;
  end;

  TTMSFNCDataGridEmptySpaceKind = (gekColumnTop, gekColumnBottom, gekRowLeft, gekRowRight, gekColumnBottomRowRight);

  TTMSFNCDataGridDropFilesEvent = procedure(Sender: TObject; ADropFiles: TTMSFNCCustomControlDropFiles) of object;
  TTMSFNCDataGridAfterLookupEvent = procedure(Sender: TObject; ALookupString: string) of object;
  TTMSFNCDataGridBeforeLookupEvent = procedure(Sender: TObject; var ALookupString: string; var ACanLookup: Boolean) of object;
  TTMSFNCDataGridAfterDrawCellEvent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell) of object;
  TTMSFNCDataGridAfterDrawGridEvent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF) of object;
  TTMSFNCDataGridBeforeDrawCellEvent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell; var ACanDraw: Boolean) of object;
  TTMSFNCDataGridBeforeDrawEmptySpaceEvent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AKind: TTMSFNCDataGridEmptySpaceKind; var ACanDraw: Boolean) of object;
  TTMSFNCDataGridAfterDrawEmptySpaceEvent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AKind: TTMSFNCDataGridEmptySpaceKind) of object;
  TTMSFNCDataGridGetCellClassEvent = procedure(Sender: TObject; AColumn, ARow: Integer; var ACellClass: TTMSFNCDataGridCellClass) of object;
  TTMSFNCDataGridGetCellLayoutEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCell) of object;
  TTMSFNCDataGridGetCellLayoutHasPriorityEvent = procedure(Sender: TObject;  ACell: TTMSFNCDataGridCellCoord; var AHasPriority: Boolean) of object;
  TTMSFNCDataGridGetCellHintEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; var AHint: string) of object;
  TTMSFNCDataGridGetCellPropertiesEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCell) of object;
  TTMSFNCDataGridCanEditCellEvent = procedure(Sender: TObject; AColumn, ARow: Integer; var ACanEdit: Boolean) of object;
  TTMSFNCDataGridCellClickEvent = procedure(Sender: TObject; AColumn, ARow: Integer) of object;
  TTMSFNCDataGridCellAnchorClickEvent = procedure(Sender: TObject; AColumn, ARow: Integer; AAnchor: string) of object;

  TTMSFNCDataGridCellConfigureMode = (gccmLayout, gccmProperties, gccmBoth);

  TTMSFNCDataGridMergedCells = TList<TTMSFNCDataGridCellCoord>;

  TTMSFNCDataGridStretchingOptions = class(TPersistent)
  private
    FOnChangeRebuild: TNotifyEvent;
    FEnabled: Boolean;
    FIndex: Integer;
    FMode: TTMSFNCDataGridStretchingMode;
    FRange: TTMSFNCDataGridStretchingRange;
    procedure SetEnabled(const Value: Boolean);
    procedure SetIndex(const Value: Integer);
    procedure SetMode(const Value: TTMSFNCDataGridStretchingMode);
    procedure SetRange(const Value: TTMSFNCDataGridStretchingRange);
  protected
    property OnChangeRebuild: TNotifyEvent read FOnChangeRebuild write FOnChangeRebuild;
  public
    constructor Create;
    procedure Assign(Source: TPersistent); override;
  published
    property Enabled: Boolean read FEnabled write SetEnabled default False;
    property Mode: TTMSFNCDataGridStretchingMode read FMode write SetMode default gstmAll;
    property Range: TTMSFNCDataGridStretchingRange read FRange write SetRange default gstrNormal;
    property &Index: Integer read FIndex write SetIndex default -1;
  end;

  TTMSFNCDataGridColumnRowOptions = class(TPersistent)
  private
    FOnChangeRebuild: TNotifyEvent;
    FStretching: TTMSFNCDataGridStretchingOptions;
    procedure SetStretching(const Value: TTMSFNCDataGridStretchingOptions);
  protected
    procedure DoStretchingChanged(Sender: TObject);
    property OnChangeRebuild: TNotifyEvent read FOnChangeRebuild write FOnChangeRebuild;
  public
    constructor Create; virtual;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
  published
    property Stretching: TTMSFNCDataGridStretchingOptions read FStretching write SetStretching;
  end;

  TTMSFNCDataGridColumnOptions = class(TTMSFNCDataGridColumnRowOptions)
  private
    FNodeIndex: Integer;
    FFixedAutoCheckAll: Boolean;
    procedure SetNodeIndex(const Value: Integer);
  public
    constructor Create; override;
    procedure Assign(Source: TPersistent); override;
  published
    property FixedAutoCheckAll: Boolean read FFixedAutoCheckAll write FFixedAutoCheckAll default True;
    property NodeIndex: Integer read FNodeIndex write SetNodeIndex default 0;
  end;

  TTMSFNCDataGridRowOptions = class(TTMSFNCDataGridColumnRowOptions);

  TTMSFNCDataGridSelectionMode = (gsmNone, gsmSingleCell, gsmSingleRow, gsmSingleColumn, gsmCellRange, gsmRowRange, gsmColumnRange, gsmDisjunctRow, gsmDisjunctColumn, gsmDisjunctCell,
    gsmDisjunctCellRange);

  TTMSFNCDataGridSelectionOptions = class(TPersistent)
  private
    FMode: TTMSFNCDataGridSelectionMode;
    FOnChange: TNotifyEvent;
    FShowSelectionInFixedCells: Boolean;
    FOnChangeRebuild: TNotifyEvent;
    procedure SetMode(const Value: TTMSFNCDataGridSelectionMode);
    procedure SetShowSelectionInFixedCells(const Value: Boolean);
  protected
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
    property OnChangeRebuild: TNotifyEvent read FOnChangeRebuild write FOnChangeRebuild;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create;
    procedure Changed;
    procedure ChangedRebuild;
  published
    property Mode: TTMSFNCDataGridSelectionMode read FMode write SetMode default gsmSingleCell;
    property ShowSelectionInFixedCells: Boolean read FShowSelectionInFixedCells write SetShowSelectionInFixedCells default False;
  end;

  TTMSFNCDataGridLocalizationOptions = class(TPersistent)
  private
    FFilterAllText: string;
    FFilterEmptyText: string;
    FFilterNotEmptyText: string;
    FFilterClearButtonHint: string;
    FFilterEditPrompt: string;
    FFilterSortButtonAscendingHint: string;
    FFilterSortButtonAscendingText: string;
    FFilterSortButtonDescendingHint: string;
    FFilterSortButtonDescendingText: string;
    FFilterTypeButtonHint: string;
    FFilterTypeContainsText: string;
    FFilterTypeEmptyText: string;
    FFilterTypeEndsWithText: string;
    FFilterTypeEqualText: string;
    FFilterTypeLargerOrEqualThanText: string;
    FFilterTypeLargerThanText: string;
    FFilterTypeNotContainsText: string;
    FFilterTypeNotEmptyText: string;
    FFilterTypeNotEqualText: string;
    FFilterTypeSmallerOrEqualThanText: string;
    FFilterTypeSmallerThanText: string;
    FFilterTypeStartsWithText: string;
    function IsFilterAllTextStored: Boolean;
    function IsFilterEmptyTextStored: Boolean;
    function IsFilterNotEmptyTextStored: Boolean;
    function IsFilterClearButtonHintStored: Boolean;
    function IsFilterEditPromptStored: Boolean;
    function IsFilterSortButtonAscendingHintStored: Boolean;
    function IsFilterSortButtonAscendingTextStored: Boolean;
    function IsFilterSortButtonDescendingHintStored: Boolean;
    function IsFilterSortButtonDescendingTextStored: Boolean;
    function IsFilterTypeButtonHintStored: Boolean;
    function IsFilterTypeContainsTextStored: Boolean;
    function IsFilterTypeEmptyTextStored: Boolean;
    function IsFilterTypeEndsWithTextStored: Boolean;
    function IsFilterTypeEqualTextStored: Boolean;
    function IsFilterTypeLargerOrEqualThanTextStored: Boolean;
    function IsFilterTypeLargerThanTextStored: Boolean;
    function IsFilterTypeNotContainsTextStored: Boolean;
    function IsFilterTypeNotEmptyTextStored: Boolean;
    function IsFilterTypeNotEqualTextStored: Boolean;
    function IsFilterTypeSmallerOrEqualThanTextStored: Boolean;
    function IsFilterTypeSmallerThanTextStored: Boolean;
    function IsFilterTypeStartsWithTextStored: Boolean;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create;
  published
    property FilterAllText: string read FFilterAllText write FFilterAllText stored IsFilterAllTextStored nodefault;
    property FilterEmptyText: string read FFilterEmptyText write FFilterEmptyText stored IsFilterEmptyTextStored nodefault;
    property FilterNotEmptyText: string read FFilterNotEmptyText write FFilterNotEmptyText stored IsFilterNotEmptyTextStored nodefault;
    property FilterClearButtonHint: string read FFilterClearButtonHint write FFilterClearButtonHint stored IsFilterClearButtonHintStored nodefault;
    property FilterEditPrompt: string read FFilterEditPrompt write FFilterEditPrompt stored IsFilterEditPromptStored nodefault;
    property FilterSortButtonAscendingHint: string read FFilterSortButtonAscendingHint write FFilterSortButtonAscendingHint stored IsFilterSortButtonAscendingHintStored nodefault;
    property FilterSortButtonAscendingText: string read FFilterSortButtonAscendingText write FFilterSortButtonAscendingText stored IsFilterSortButtonAscendingTextStored nodefault;
    property FilterSortButtonDescendingHint: string read FFilterSortButtonDescendingHint write FFilterSortButtonDescendingHint stored IsFilterSortButtonDescendingHintStored nodefault;
    property FilterSortButtonDescendingText: string read FFilterSortButtonDescendingText write FFilterSortButtonDescendingText stored IsFilterSortButtonDescendingTextStored nodefault;
    property FilterTypeButtonHint: string read FFilterTypeButtonHint write FFilterTypeButtonHint stored IsFilterTypeButtonHintStored nodefault;
    property FilterTypeContainsText: string read FFilterTypeContainsText write FFilterTypeContainsText stored IsFilterTypeContainsTextStored nodefault;
    property FilterTypeEmptyText: string read FFilterTypeEmptyText write FFilterTypeEmptyText stored IsFilterTypeEmptyTextStored nodefault;
    property FilterTypeEndsWithText: string read FFilterTypeEndsWithText write FFilterTypeEndsWithText stored IsFilterTypeEndsWithTextStored nodefault;
    property FilterTypeEqualText: string read FFilterTypeEqualText write FFilterTypeEqualText stored IsFilterTypeEqualTextStored nodefault;
    property FilterTypeLargerOrEqualThanText: string read FFilterTypeLargerOrEqualThanText write FFilterTypeLargerOrEqualThanText stored IsFilterTypeLargerOrEqualThanTextStored nodefault;
    property FilterTypeLargerThanText: string read FFilterTypeLargerThanText write FFilterTypeLargerThanText stored IsFilterTypeLargerThanTextStored nodefault;
    property FilterTypeNotContainsText: string read FFilterTypeNotContainsText write FFilterTypeNotContainsText stored IsFilterTypeNotContainsTextStored nodefault;
    property FilterTypeNotEmptyText: string read FFilterTypeNotEmptyText write FFilterTypeNotEmptyText stored IsFilterTypeNotEmptyTextStored nodefault;
    property FilterTypeNotEqualText: string read FFilterTypeNotEqualText write FFilterTypeNotEqualText stored IsFilterTypeNotEqualTextStored nodefault;
    property FilterTypeSmallerOrEqualThanText: string read FFilterTypeSmallerOrEqualThanText write FFilterTypeSmallerOrEqualThanText stored IsFilterTypeSmallerOrEqualThanTextStored nodefault;
    property FilterTypeSmallerThanText: string read FFilterTypeSmallerThanText write FFilterTypeSmallerThanText stored IsFilterTypeSmallerThanTextStored nodefault;
    property FilterTypeStartsWithText: string read FFilterTypeStartsWithText write FFilterTypeStartsWithText stored IsFilterTypeStartsWithTextStored nodefault;  end;

  TTMSFNCDataGridBandingOptions = class(TPersistent)
  private
    FEnabled: Boolean;
    FOnChange: TNotifyEvent;
    FBandRowCount: integer;
    FNormalRowCount: integer;
    FTotalRowCount: integer;
    procedure SetEnabled(const Value: Boolean);
    procedure SetBandRowCount(const Value: integer);
    procedure SetNormalRowCount(const Value: integer);
  protected
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create;
    procedure Changed; virtual;
    property TotalRowCount: integer read FTotalRowCount;
  published
    property BandRowCount: integer read FBandRowCount write SetBandRowCount default 1;
    property Enabled: Boolean read FEnabled write SetEnabled default False;
    property NormalRowCount: integer read FNormalRowCount write SetNormalRowCount default 1;
  end;

  TTMSFNCDataGridClipboardPasteAction = (gpaReplace, gpaInsert);

  TTMSFNCDataGridClipboardOptions = class(TPersistent)
  private
    FPasteAction: TTMSFNCDataGridClipboardPasteAction;
    FEnabled: Boolean;
    FIgnoreReadOnly: Boolean;
    FAllowRowGrow: Boolean;
    FAllowColumnGrow: Boolean;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create;
  published
    property AllowColumnGrow: Boolean read FAllowColumnGrow write FAllowColumnGrow default false;
    property AllowRowGrow: Boolean read FAllowRowGrow write FAllowRowGrow default False;
    property Enabled: Boolean read FEnabled write FEnabled default True;
    property IgnoreReadOnly: Boolean read FIgnoreReadOnly write FIgnoreReadOnly default False;
    property PasteAction: TTMSFNCDataGridClipboardPasteAction read FPasteAction write FPasteAction default gpaReplace;
  end;

  TTMSFNCDataGridEditCellStart = (gcsNone, gcsStart, gcsEnd);
  TTMSFNCDataGridTabKeyHandling = (gtkhNextControl, gtkhNextCell, gtkhMixed);
  TTMSFNCDataGridTabKeyDirection = (gtkdNextColumnCell, gtkdNextRowCell);
  TTMSFNCDataGridTabKeyMode = (gtkmNone, gtkmNormal, gtkmShift);

  TTMSFNCDataGridInsertKeyHandling = (gikhNone, gikhInsertRowBefore, gikhInsertRowAfter);

  TTMSFNCDataGridEnterKeyHandling = (gekhNone, gekhNextColumn, gekhNextRow, gekhNextColumnInRow, gekhNextRowInColumn,
    gekhNextColumnAndAppend, gekhNextRowAndAppend, gekhNextRowAndColumnAppend, gekhNextColumnAndRowAppend);

  TTMSFNCDataGridDeleteKeyHandling = (gdkhNone, gdkhDeleteRow);

  TTMSFNCDataGridHomeKeyHandling = (ghkhNone, ghkhFirstRow, ghkhFirstColumn);

  TTMSFNCDataGridEndKeyHandling = (genkhNone, genkhLastRow, genkhLastColumn);

  TTMSFNCDataGridKeyboardOptions = class(TPersistent)
  private
    FAppendColumnOnArrowKeyRight: Boolean;
    FAppendRowOnArrowKeyDown: Boolean;
    FArrowKeyDirectEdit: Boolean;
    FCellMergeShortcut: Boolean;
    FDeleteKeyHandling: TTMSFNCDataGridDeleteKeyHandling;
    FEndKeyHandling: TTMSFNCDataGridEndKeyHandling;
    FEnterKeyDirectEdit: Boolean;
    FEnterKeyHandling: TTMSFNCDataGridEnterKeyHandling;
    FFindShortcut: Boolean;
    FHomeKeyHandling: TTMSFNCDataGridHomeKeyHandling;
    FInsertKeyHandling: TTMSFNCDataGridInsertKeyHandling;
    FPageScrollSize: Integer;
    FReplaceShortcut: Boolean;
    FTabKeyDirectEdit: Boolean;
    FTabKeyDirection: TTMSFNCDataGridTabKeyDirection;
    FTabKeyHandling: TTMSFNCDataGridTabKeyHandling;
    procedure SetPageScrollSize(const Value: Integer);
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create;
  published
    property AppendColumnOnArrowKeyRight: Boolean read FAppendColumnOnArrowKeyRight write FAppendColumnOnArrowKeyRight default False;
    property AppendRowOnArrowKeyDown: Boolean read FAppendRowOnArrowKeyDown write FAppendRowOnArrowKeyDown default False;
    property ArrowKeyDirectEdit: Boolean read FArrowKeyDirectEdit write FArrowKeyDirectEdit default False;
    property CellMergeShortcut: Boolean read FCellMergeShortcut write FCellMergeShortcut default False;
    property DeleteKeyHandling: TTMSFNCDataGridDeleteKeyHandling read FDeleteKeyHandling write FDeleteKeyHandling default gdkhNone;
    property EndKeyHandling: TTMSFNCDataGridEndKeyHandling read FEndKeyHandling write FEndKeyHandling default genkhLastColumn;
    property EnterKeyDirectEdit: Boolean read FEnterKeyDirectEdit write FEnterKeyDirectEdit default False;
    property EnterKeyHandling: TTMSFNCDataGridEnterKeyHandling read FEnterKeyHandling write FEnterKeyHandling default gekhNone;
    property FindShortcut: Boolean read FFindShortcut write FFindShortcut default True;
    property HomeKeyHandling: TTMSFNCDataGridHomeKeyHandling read FHomeKeyHandling write FHomeKeyHandling default ghkhFirstColumn;
    property InsertKeyHandling: TTMSFNCDataGridInsertKeyHandling read FInsertKeyHandling write FInsertKeyHandling default gikhNone;
    property PageScrollSize: Integer read FPageScrollSize write SetPageScrollSize default 0;
    property ReplaceShortcut: Boolean read FReplaceShortcut write FReplaceShortcut default True;
    property TabKeyDirectEdit: Boolean read FTabKeyDirectEdit write FTabKeyDirectEdit default False;
    property TabKeyDirection: TTMSFNCDataGridTabKeyDirection read FTabKeyDirection write FTabKeyDirection default gtkdNextColumnCell;
    property TabKeyHandling: TTMSFNCDataGridTabKeyHandling read FTabKeyHandling write FTabKeyHandling default gtkhMixed;
  end;

  TTMSFNCDataGridFixedCellSelectionMode = (gfcsAll, gfcsRow, gfcsColumn, gfcsRowRange, gfcsColumnRange, gfcsDisjunctRow, gfcsDisjunctColumn);

  TTMSFNCDataGridFixedCellSelection = set of TTMSFNCDataGridFixedCellSelectionMode;

  TTMSFNCDataGridAutoScrollingSpeedMode = (gasmPixels, gasmCell);

  TTMSFNCDataGridIOHTMLOptions = class(TPersistent)
  private
    FConvertSpecialChars: Boolean;
    FExportColors: Boolean;
    FExportImages: Boolean;
    FFooterFile: string;
    FFooterText: string;
    FHeaderFile: string;
    FHeaderText: string;
    FImageBaseName: string;
    FImageFolder: string;
    FNonBreakingText: Boolean;
    FPrefixTag: string;
    FSuffixTag: string;
    FSummary: string;
    FTableBorderSize: Integer;
    FTableCellPadding: Integer;
    FTableCellSpacing: Integer;
    FTableStyle: string;
    FTableWidth: Integer;
    FXHTML: Boolean;
    function IsImageBaseNameStored: Boolean;
    function IsImageFolderStored: Boolean;
  public
    constructor Create; virtual;
    procedure Assign(Source: TPersistent); override;
  published
    property ConvertSpecialChars: Boolean read FConvertSpecialChars write FConvertSpecialChars default False;
    property ExportColors: Boolean read FExportColors write FExportColors default True;
    property ExportImages: Boolean read FExportImages write FExportImages default True;
    property FooterFile: string read FFooterFile write FFooterFile;
    property FooterText: string read FFooterText write FFooterText;
    property HeaderFile: string read FHeaderFile write FHeaderFile;
    property HeaderText: string read FHeaderText write FHeaderText;
    property ImageBaseName: string read FImageBaseName write FImageBaseName stored IsImageBaseNameStored nodefault;
    property ImageFolder: string read FImageFolder write FImageFolder stored IsImageFolderStored nodefault;
    property NonBreakingText: Boolean read FNonBreakingText write FNonBreakingText default False;
    property PrefixTag: string read FPrefixTag write FPrefixTag;
    property SuffixTag: string read FSuffixTag write FSuffixTag;
    property Summary: string read FSummary write FSummary;
    property TableBorderSize: Integer read FTableBorderSize write FTableBorderSize default 1;
    property TableCellPadding: Integer read FTableCellPadding write FTableCellPadding default 0;
    property TableCellSpacing: Integer read FTableCellSpacing write FTableCellSpacing default 0;
    property TableStyle: string read FTableStyle write FTableStyle;
    property TableWidth: Integer read FTableWidth write FTableWidth default 100;
    property XHTML: Boolean read FXHTML write FXHTML default False;
  end;

  TTMSFNCDataGridIOOptions = class(TTMSFNCDataGridDataIOOptions)
  private
    FHTML: TTMSFNCDataGridIOHTMLOptions;
    procedure SetHTML(const Value: TTMSFNCDataGridIOHTMLOptions);
  public
    constructor Create; override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
  published
    property HTML: TTMSFNCDataGridIOHTMLOptions read FHTML write SetHTML;
  end;

  TTMSFNCDataGridDragMode = (gdmReorder, gdmDrag);

  TTMSFNCDataGridColumnDragMode = (gcdmReorder, gcdmVisualGrouping);

  TTMSFNCDataGridColumnDragModes = set of TTMSFNCDataGridColumnDragMode;

  TTMSFNCDataGridMouseOptions = class(TPersistent)
  private
    FAutoDragging: Boolean;
    FAutoScrolling: Boolean;
    FAutoScrollingInterval: Integer;
    FAutoScrollingSpeed: Integer;
    FAutoScrollingSpeedMode: TTMSFNCDataGridAutoScrollingSpeedMode;
    FClickMargin: Integer;
    FColumnAutoSizeOnDblClick: Boolean;
    FColumnDragging: Boolean;
    FColumnSizeMargin: Integer;
    FColumnSizing: Boolean;
    FDirectEdit: Boolean;
    FDragMode: TTMSFNCDataGridDragMode;
    FFixedCellSelection: TTMSFNCDataGridFixedCellSelection;
    FFixedColumnSizing: Boolean;
    FFixedRowSizing: Boolean;
    FRowAutoSizeOnDblClick: Boolean;
    FRowDragging: Boolean;
    FRowSizeMargin: Integer;
    FRowSizing: Boolean;
    FTouchScrolling: Boolean;
    FTouchScrollingSensitivity: Single;
    FWheelScrollKeepSelection: Boolean;
    FWheelScrollSize: Integer;
    FColumnDragModes: TTMSFNCDataGridColumnDragModes;
    function IsTouchScrollingSensitivityStored: Boolean;
    procedure SetAutoScrollingInterval(const Value: Integer);
    procedure SetClickMargin(const Value: Integer);
    procedure SetColumnSizeMargin(const Value: Integer);
    procedure SetRowSizeMargin(const Value: Integer);
    procedure SetTouchScrolling(const Value: Boolean);
    procedure SetWheelScrollKeepSelection(const Value: Boolean);
    procedure SetWheelScrollSize(const Value: Integer);
    procedure SetColumnDragModes(const Value: TTMSFNCDataGridColumnDragModes);
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create;
  published
    property AutoDragging: Boolean read FAutoDragging write FAutoDragging default True;
    property AutoScrolling: Boolean read FAutoScrolling write FAutoScrolling default True;
    property AutoScrollingInterval: Integer read FAutoScrollingInterval write SetAutoScrollingInterval default 100;
    property AutoScrollingSpeed: Integer read FAutoScrollingSpeed write FAutoScrollingSpeed default 1;
    property AutoScrollingSpeedMode: TTMSFNCDataGridAutoScrollingSpeedMode read FAutoScrollingSpeedMode write FAutoScrollingSpeedMode default gasmPixels;
    property ClickMargin: Integer read FClickMargin write SetClickMargin default 2;
    property ColumnAutoSizeOnDblClick: Boolean read FColumnAutoSizeOnDblClick write FColumnAutoSizeOnDblClick default True;
    property ColumnDragging: Boolean read FColumnDragging write FColumnDragging default False;
    property ColumnDragModes: TTMSFNCDataGridColumnDragModes read FColumnDragModes write SetColumnDragModes default [gcdmReorder, gcdmVisualGrouping];
    property ColumnSizeMargin: Integer read FColumnSizeMargin write SetColumnSizeMargin default 6;
    property ColumnSizing: Boolean read FColumnSizing write FColumnSizing default False;
    property DirectEdit: Boolean read FDirectEdit write FDirectEdit default false;
    property DragMode: TTMSFNCDataGridDragMode read FDragMode write FDragMode default gdmReorder;
    property FixedCellSelection: TTMSFNCDataGridFixedCellSelection read FFixedCellSelection write FFixedCellSelection default [];
    property FixedColumnSizing: Boolean read FFixedColumnSizing write FFixedColumnSizing default False;
    property FixedRowSizing: Boolean read FFixedRowSizing write FFixedRowSizing default False;
    property RowAutoSizeOnDblClick: Boolean read FRowAutoSizeOnDblClick write FRowAutoSizeOnDblClick default True;
    property RowDragging: Boolean read FRowDragging write FRowDragging default False;
    property RowSizeMargin: Integer read FRowSizeMargin write SetRowSizeMargin default 6;
    property RowSizing: Boolean read FRowSizing write FRowSizing default False;
    property TouchScrolling: Boolean read FTouchScrolling write SetTouchScrolling default False;
    property TouchScrollingSensitivity: Single read FTouchScrollingSensitivity write FTouchScrollingSensitivity stored IsTouchScrollingSensitivityStored nodefault;
    property WheelScrollKeepSelection: Boolean read FWheelScrollKeepSelection write SetWheelScrollKeepSelection default True;
    property WheelScrollSize: Integer read FWheelScrollSize write SetWheelScrollSize default 4;
  end;

  TTMSFNCDataGridLookupOptions = class(TPersistent)
  private
    FCaseSensitive: Boolean;
    FIncremental: Boolean;
    FEnabled: Boolean;
    FResetInterval: Integer;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create;
  published
    property CaseSensitive: Boolean read FCaseSensitive write FCaseSensitive default False;
    property Enabled: Boolean read FEnabled write FEnabled default False;
    property Incremental: Boolean read FIncremental write FIncremental default True;
    property ResetInterval: Integer read FResetInterval write FResetInterval default 4000;
  end;

  TTMSFNCDataGridAutoCompleteType = (gactDisabled, gactNormal, gactLookupList);

  TTMSFNCDataGridAutoCompleteOptions = class(TPersistent)
  private
    FType: TTMSFNCDataGridAutoCompleteType;
    FCaseSensitive: Boolean;
    FItems: TStringList;
    procedure SetItems(const Value: TStringList);
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create;
    destructor Destroy; override;
  published
    property &Type: TTMSFNCDataGridAutoCompleteType read FType write FType default gactDisabled;
    property CaseSensitive: Boolean read FCaseSensitive write FCaseSensitive default false;
    property Items: TStringList read FItems write SetItems;
  end;

  TTMSFNCDataGridEditingOptions = class(TPersistent)
  private
    FEnabled: Boolean;
    FDirectDropDown: Boolean;
    FAutoComplete: TTMSFNCDataGridAutoCompleteOptions;
    procedure SetAutoComplete(const Value: TTMSFNCDataGridAutoCompleteOptions);
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create;
    destructor Destroy; override;
  published
    property Enabled: Boolean read FEnabled write FEnabled default True;
    property AutoComplete: TTMSFNCDataGridAutoCompleteOptions read FAutoComplete write SetAutoComplete;
    property DirectDropDown: Boolean read FDirectDropDown write FDirectDropDown default False;
  end;

  TTMSFNCDataGridOptions = class(TTMSFNCDataGridDataOptions)
  private
    FBanding: TTMSFNCDataGridBandingOptions;
    FClipboard: TTMSFNCDataGridClipboardOptions;
    FColumn: TTMSFNCDataGridColumnOptions;
    FEditing: TTMSFNCDataGridEditingOptions;
    FKeyboard: TTMSFNCDataGridKeyboardOptions;
    FLocalization: TTMSFNCDataGridLocalizationOptions;
    FLookup: TTMSFNCDataGridLookupOptions;
    FMouse: TTMSFNCDataGridMouseOptions;
    FRow: TTMSFNCDataGridRowOptions;
    FSelection: TTMSFNCDataGridSelectionOptions;
    function GetIO: TTMSFNCDataGridIOOptions;
    procedure SetBanding(const Value: TTMSFNCDataGridBandingOptions);
    procedure SetClipboard(const Value: TTMSFNCDataGridClipboardOptions);
    procedure SetColumn(const Value: TTMSFNCDataGridColumnOptions);
    procedure SetEditing(const Value: TTMSFNCDataGridEditingOptions);
    procedure SetIO(const Value: TTMSFNCDataGridIOOptions);
    procedure SetKeyboard(const Value: TTMSFNCDataGridKeyboardOptions);
    procedure SetLocalization(const Value: TTMSFNCDataGridLocalizationOptions);
    procedure SetLookup(const Value: TTMSFNCDataGridLookupOptions);
    procedure SetMouse(const Value: TTMSFNCDataGridMouseOptions);
    procedure SetRow(const Value: TTMSFNCDataGridRowOptions);
    procedure SetSelection(const Value: TTMSFNCDataGridSelectionOptions);
  protected
    function GetIOOptionsClass: TTMSFNCDataGridDataIOOptionsClass; override;
    procedure DoBandingChanged(Sender: TObject);
    procedure DoCellsChangedRebuild(Sender: TObject);
    procedure DoColumnChangedRebuild(Sender: TObject);
    procedure DoRowChangedRebuild(Sender: TObject);
    procedure DoSelectionChanged(Sender: TObject);
    procedure DoSelectionChangedRebuild(Sender: TObject);
  public
    constructor Create; override;
    procedure Assign(Source: TPersistent); override;
    destructor Destroy; override;
  published
    property Banding: TTMSFNCDataGridBandingOptions read FBanding write SetBanding;
    property Clipboard: TTMSFNCDataGridClipboardOptions read FClipboard write SetClipboard;
    property Column: TTMSFNCDataGridColumnOptions read FColumn write SetColumn;
    property Editing: TTMSFNCDataGridEditingOptions read FEditing write SetEditing;
    property IO: TTMSFNCDataGridIOOptions read GetIO write SetIO;
    property Keyboard: TTMSFNCDataGridKeyboardOptions read FKeyboard write SetKeyboard;
    property Localization: TTMSFNCDataGridLocalizationOptions read FLocalization write SetLocalization;
    property Lookup: TTMSFNCDataGridLookupOptions read FLookup write SetLookup;
    property Mouse: TTMSFNCDataGridMouseOptions read FMouse write SetMouse;
    property Row: TTMSFNCDataGridRowOptions read FRow write SetRow;
    property Selection: TTMSFNCDataGridSelectionOptions read FSelection write SetSelection;
  end;

  TTMSFNCDataGridScrollMode = (gsmPixelScrolling, gsmCellScrolling);
  TTMSFNCDataGridScrollUpdate = (gsuContinuous, gsuOnce);
  TTMSFNCDataGridScrollEvent = procedure(Sender: TObject; APosition: Single) of object;
  TTMSFNCDataGridInteractionDirection = (gidNone, gidLeft, gidRight, gidUp, gidDown, gidLeftUp, gidRightDown);

  TTMSFNCDataGridSizeMode = (gsmColumnSizing, gsmRowSizing, gsmPreviousColumnSizing, gsmPreviousRowSizing);

  TTMSFNCDataGridDraggingMode = (gdmNone, gdmRowDragging, gdmColumnDragging);
  TTMSFNCDataGridDraggingType = (gdtNone, gdtSwap, gdtInsert);

  TTMSFNCDataGridRendererUpdateCursorEvent = procedure(Sender: TObject; ACursor: TCursor) of object;
  TTMSFNCDataGridRendererIsLoadingEvent = function(Sender: TObject): Boolean of object;
  TTMSFNCDataGridRendererIsDestroyingEvent = function(Sender: TObject): Boolean of object;
  TTMSFNCDataGridRendererIsDesigntimeEvent = function(Sender: TObject): Boolean of object;
  TTMSFNCDataGridRendererIsFocusedEvent = function(Sender: TObject): Boolean of object;

  TTMSFNCDataGridRenderer = class;

  ITMSFNCDataGridRendererLink = interface
    ['{DA896D18-6547-430D-A3C8-82A6077CB799}']
    function GetLink: TTMSFNCDataGridRenderer;
    property Link: TTMSFNCDataGridRenderer read GetLink;
  end;

  TTMSFNCDataGridScrollBar = class(TTMSFNCScrollBar)
  protected
    procedure DrawEx(AGraphics: TTMSFNCGraphics);
  end;

  {$IFDEF FMXLIB}
  TTMSFNCDataGridInplaceEditor = TControl;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCDataGridInplaceEditor = TWinControl;
  {$ENDIF}
  TTMSFNCDataGridInplaceEditorClass = class of TTMSFNCDataGridInplaceEditor;

  TTMSFNCDataGridInplaceEditorType = (getNone, getEdit, getNumericEdit, getSignedNumericEdit, getFloatEdit, getSignedFloatEdit, getUppercaseEdit, getMixedCaseEdit, getLowerCaseEdit,
    getMoneyEdit, getHexEdit, getAlphaNumericEdit, getValidCharsEdit, getComboBox, getComboEdit, getSpinBox, getDatePicker, getColorPicker,
    getTrackBar, getMemo, getHTMLEditor, getCustom);
  TTMSFNCDataGridInplaceEditorTarget = (getCellValue, getFillColor);

  TTMSFNCDataGridBeforeOpenInplaceEditorEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; var AValue: TTMSFNCDataGridCellValue; var ACanOpen: Boolean) of object;
  TTMSFNCDataGridAfterOpenInplaceEditorEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; AValue: TTMSFNCDataGridCellValue) of object;
  TTMSFNCDataGridBeforeSortColumnEvent = procedure(Sender: TObject; AColumn: Integer; var ACanSort: Boolean) of object;
  TTMSFNCDataGridAfterSortColumnEvent = procedure(Sender: TObject; AColumn: Integer) of object;
  TTMSFNCDataGridBeforeApplyFilterEvent = procedure(Sender: TObject; AColumn: Integer; var ACondition: string; var ACanApply: Boolean) of object;
  TTMSFNCDataGridAfterApplyFilterEvent = procedure(Sender: TObject; AColumn: Integer; ACondition: string) of object;
  TTMSFNCDataGridRemoveFilterEvent = procedure(Sender: TObject; AColumn: Integer) of object;
  TTMSFNCDataGridBeforeShowFilterEvent = procedure(Sender: TObject; AColumn: Integer; var ACanShow: Boolean) of object;
  TTMSFNCDataGridAfterShowFilterEvent = procedure(Sender: TObject; AColumn: Integer) of object;
  TTMSFNCDataGridCustomizeFilterPopupEditorEvent = procedure(Sender: TObject; AColumn: Integer; var AEditor: TTMSFNCDataGridCellControl) of object;
  TTMSFNCDataGridBeforeClipboardEvent = procedure(Sender: TObject; var ACanExecute: Boolean) of object;
  TTMSFNCDataGridAfterClipboardEvent = procedure(Sender: TObject) of object;
  TTMSFNCDataGridBeforeShowFilterDialogEvent = procedure(Sender: TObject; AFilterDialog: TTMSFNCFilterDialog; var ACanShow: Boolean) of object;
  TTMSFNCDataGridBeforeShowFindDialogEvent = procedure(Sender: TObject; AFindDialog: TTMSFNCFindDialog; var ACanShow: Boolean) of object;
  TTMSFNCDataGridAfterShowFindDialogEvent = procedure(Sender: TObject; AFindDialog: TTMSFNCFindDialog) of object;
  TTMSFNCDataGridAfterShowFilterDialogEvent = procedure(Sender: TObject; AFilterDialog: TTMSFNCFilterDialog) of object;
  TTMSFNCDataGridBeforeShowReplaceDialogEvent = procedure(Sender: TObject; AReplaceDialog: TTMSFNCReplaceDialog; var ACanShow: Boolean) of object;
  TTMSFNCDataGridAfterShowReplaceDialogEvent = procedure(Sender: TObject; AReplaceDialog: TTMSFNCReplaceDialog) of object;
  TTMSFNCDataGridBeforeCloseInplaceEditorEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; ACancelled: Boolean; var AValue: TTMSFNCDataGridCellValue; var ACanClose: Boolean) of object;
  TTMSFNCDataGridAfterCloseInplaceEditorEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; ACancel: Boolean; AValue: TTMSFNCDataGridCellValue) of object;
  TTMSFNCDataGridCellEditValidateDataEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AValue: TTMSFNCDataGridCellValue; var AValid: Boolean) of object;
  TTMSFNCDataGridCellBeforeShowPopupMenuEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; APopupMenu: TPopupMenu; var ACanShow: Boolean) of object;
  TTMSFNCDataGridCellBeforeNodeExpandEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; var ACanExpand: Boolean) of object;
  TTMSFNCDataGridCellBeforeNodeCollapseEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; var ACanCollapse: Boolean) of object;
  TTMSFNCDataGridCellAfterNodeExpandEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord) of object;
  TTMSFNCDataGridCellAfterNodeCollapseEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord) of object;
  TTMSFNCDataGridNeedFilterDropDownData = procedure(Sender: TObject; AColumn: Integer; AValues: TStrings) of object;
  TTMSFNCDataGridCellEditGetDataEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AValue: TTMSFNCDataGridCellValue) of object;
  TTMSFNCDataGridCellEditSetDataEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AValue: TTMSFNCDataGridCellValue) of object;
  TTMSFNCDataGridGetInplaceEditorClassEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; var AInplaceEditorClass: TTMSFNCDataGridInplaceEditorClass) of object;
  TTMSFNCDataGridGetInplaceEditorTypeEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; var AInplaceEditorType: TTMSFNCDataGridInplaceEditorType) of object;
  TTMSFNCDataGridGetInplaceEditorTargetEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; var AInplaceEditorTarget: TTMSFNCDataGridInplaceEditorTarget) of object;
  TTMSFNCDataGridGetInplaceEditorRectEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AInplaceEditorRect: TRectF) of object;
  TTMSFNCDataGridGetInplaceEditorPropertiesEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; AInplaceEditorType: TTMSFNCDataGridInplaceEditorType) of object;
  TTMSFNCDataGridSelectingCellEvent = procedure(Sender: TObject; AStartCell, AEndCell: TTMSFNCDataGridCellCoord; var ACanSelect: Boolean) of object;
  TTMSFNCDataGridSelectCellEvent = procedure(Sender: TObject; AStartCell, AEndCell: TTMSFNCDataGridCellCoord) of object;
  TTMSFNCDataGridCanAppendColumnEvent = procedure(Sender: TObject; AColumn: Integer; var ACanAppend: Boolean) of object;
  TTMSFNCDataGridCanAppendRowEvent = procedure(Sender: TObject; ARow: Integer; var ACanAppend: Boolean) of object;
  TTMSFNCDataGridAppendColumnEvent = procedure(Sender: TObject; AColumn: Integer) of object;
  TTMSFNCDataGridAppendRowEvent = procedure(Sender: TObject; ARow: Integer) of object;
  TTMSFNCDataGridCanDeleteColumnEvent = procedure(Sender: TObject; AColumn: Integer; var ACanDelete: Boolean) of object;
  TTMSFNCDataGridCanDeleteRowEvent = procedure(Sender: TObject; ARow: Integer; var ACanDelete: Boolean) of object;
  TTMSFNCDataGridDeleteColumnEvent = procedure(Sender: TObject; AColumn: Integer) of object;
  TTMSFNCDataGridDeleteRowEvent = procedure(Sender: TObject; ARow: Integer) of object;
  TTMSFNCDataGridCanDropColumnEvent = procedure(Sender: TObject; AFromColumn, AToColumn: Integer; var ACanDrop: Boolean) of object;
  TTMSFNCDataGridCanDropRowEvent = procedure(Sender: TObject; AFromRow, AToRow: Integer; var ACanDrop: Boolean) of object;
  TTMSFNCDataGridCanDragColumnEvent = procedure(Sender: TObject; AColumn: Integer; var ACanDrag: Boolean) of object;
  TTMSFNCDataGridCanDragRowEvent = procedure(Sender: TObject; ARow: Integer; var ACanDrag: Boolean) of object;
  TTMSFNCDataGridColumnDroppedEvent = procedure(Sender: TObject; AFromColumn, AToColumn: Integer) of object;
  TTMSFNCDataGridRowDroppedEvent = procedure(Sender: TObject; AFromRow, AToRow: Integer) of object;
  TTMSFNCDataGridCanInsertColumnEvent = procedure(Sender: TObject; AColumn: Integer; var ACanInsert: Boolean) of object;
  TTMSFNCDataGridCanInsertRowEvent = procedure(Sender: TObject; ARow: Integer; var ACanInsert: Boolean) of object;
  TTMSFNCDataGridInsertColumnEvent = procedure(Sender: TObject; AColumn: Integer) of object;
  TTMSFNCDataGridInsertRowEvent = procedure(Sender: TObject; ARow: Integer) of object;
  TTMSFNCDataGridCanSizeColumnEvent = procedure(Sender: TObject; AColumn: Integer; var ASize: Double; var ACanSize: Boolean) of object;
  TTMSFNCDataGridCanSizeRowEvent = procedure(Sender: TObject; ARow: Integer; var ASize: Double; var ACanSize: Boolean) of object;
  TTMSFNCDataGridSizeColumnEvent = procedure(Sender: TObject; AColumn: Integer; ASize: Double) of object;
  TTMSFNCDataGridSizeRowEvent = procedure(Sender: TObject; ARow: Integer; ASize: Double) of object;
  TTMSFNCDataGridColumnSizedEvent = procedure(Sender: TObject; AColumn: Integer; ASize: Double) of object;
  TTMSFNCDataGridRowSizedEvent = procedure(Sender: TObject; ARow: Integer; ASize: Double) of object;

  TTMSFNCDataGridEdit = class(TTMSFNCEdit)
  {$IFDEF VCLLIB}
  private
    procedure WMGetDlgCode(var Message: TWMGetDlgCode); message WM_GETDLGCODE;
  {$ENDIF}
  public
    {$IFDEF FMXLIB}
    function GetDefaultStyleLookupName: string; override;
    {$ENDIF}
    constructor Create(AOwner: TComponent); override;
  end;

  TComboBoxSafe = class(TComboBox)
  strict private
    {$IFDEF VCLLIB}
    FSafeItemIndex: Integer;
    FSafeItems: TArray<string>;
    {$ENDIF}
    function GetSafeItemIndex: Integer;
    function GetSafeItems: TArray<string>;
    procedure SetSafeItemIndex(const AValue: Integer);
    procedure SetSafeItems(const AValue: TArray<string>);
  {$IFDEF VCLLIB}
  strict protected
    procedure CreateWnd; override;
    procedure DestroyWnd; override;
  {$ENDIF}
  public
    constructor Create(AOwner: TComponent); override;
    property SafeItemIndex: Integer read GetSafeItemIndex write SetSafeItemIndex;
    property SafeItems: TArray<string> read GetSafeItems write SetSafeItems;
  end;

  TTMSFNCDataGridComboBox = class(TComboBox);
  {$IFDEF FMXLIB}
  TTMSFNCDataGridComboEdit = class(TComboEdit);
  {$ELSE}
  TTMSFNCDataGridComboEdit = class(TComboBox);
  {$ENDIF}
  TTMSFNCDataGridTrackBar = class(TTrackBar);
  TTMSFNCDataGridColorPicker = class(TTMSFNCColorPicker);
  TTMSFNCDataGridMemo = class(TMemo);

  {$IFDEF FMXLIB}
  TTMSFNCDataGridDatePicker = class(TDateEdit)
  protected
    procedure KeyDown(var Key: Word; var KeyChar: System.WideChar; Shift: TShiftState); override;
  end;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCDataGridDatePicker = class(TDateTimePicker);
  {$ENDIF}

  {$IFDEF FMXLIB}
  TTMSFNCDataGridSpinBox = class(TSpinBox);
  TTMSFNCDataGridCaretPosition = TCaretPosition;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCDataGridSpinBox = class(TSpinEdit);
  TTMSFNCDataGridCaretPosition = TPoint;
  {$ENDIF}

  TTMSFNCDataGridHTMLEditor = class(TTMSFNCHTMLEditor);

  TTMSFNCDataGridInplaceEditorHelper = class helper for TTMSFNCDataGridInplaceEditor
  private
    function GetDataValue: TTMSFNCDataGridCellValue;
    procedure SetDataValue(const Value: TTMSFNCDataGridCellValue);
  public
    function IsEdit: Boolean;
    function AsEdit: TTMSFNCDataGridEdit;
    function IsComboBox: Boolean;
    function AsComboBox: TTMSFNCDataGridComboBox;
    function IsComboEdit: Boolean;
    function AsComboEdit: TTMSFNCDataGridComboEdit;
    function IsSpinBox: Boolean;
    function AsSpinBox: TTMSFNCDataGridSpinBox;
    function IsDatePicker: Boolean;
    function AsDatePicker: TTMSFNCDataGridDatePicker;
    function IsColorPicker: Boolean;
    function AsColorPicker: TTMSFNCDataGridColorPicker;
    function IsTrackBar: Boolean;
    function AsTrackBar: TTMSFNCDataGridTrackBar;
    function IsMemo: Boolean;
    function AsMemo: TTMSFNCDataGridMemo;
    function IsHTMLEditor: Boolean;
    function AsHTMLEditor: TTMSFNCDataGridHTMLEditor;
    property DataValue: TTMSFNCDataGridCellValue read GetDataValue write SetDataValue;
  end;

  TTMSFNCDataGridRendererDataAdapter = class(TTMSFNCDataGridDataAdapter)
  private
    function GetRenderer: TTMSFNCDataGridRenderer;
    procedure SetRenderer(const Value: TTMSFNCDataGridRenderer);
  protected
    procedure CanEditCell(ACell: TTMSFNCDataGridCellCoord; var ACanEdit: Boolean); virtual; abstract;
    procedure DeleteRow(ARow: Integer); virtual; abstract;
    procedure EditCell(ACell: TTMSFNCDataGridCellCoord); virtual; abstract;
    procedure EditSetData(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AValue: TTMSFNCDataGridCellValue); virtual; abstract;
    procedure ExportNotification(AState: TTMSFNCDataGridExportState; ARow: Integer); virtual; abstract;
    procedure GetCellProperties(ACell: TTMSFNCDataGridCell); virtual; abstract;
    procedure GetFilterData(AColumn: Integer; AValues: TStrings); virtual; abstract;
    procedure GetInplaceEditorProperties(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; AInplaceEditorType: TTMSFNCDataGridInplaceEditorType); virtual; abstract;
    procedure GetInplaceEditorType(ACell: TTMSFNCDataGridCellCoord; var AInplaceEditorType: TTMSFNCDataGridInplaceEditorType); virtual; abstract;
    procedure InsertRow(ARow: Integer); virtual; abstract;
    procedure RowAfterCollapse(ARow: Integer); virtual; abstract;
    procedure RowAfterExpand(ARow: Integer); virtual; abstract;
    procedure RowBeforeCollapse(ARow: Integer); virtual; abstract;
    procedure RowBeforeExpand(ARow: Integer); virtual; abstract;
    procedure Scroll; virtual; abstract;
    procedure SelectCell(ACell: TTMSFNCDataGridCellCoord); virtual; abstract;
    procedure UpdateBounds; virtual; abstract;
    procedure UpdateScrollMode; virtual; abstract;
  public
    property Renderer: TTMSFNCDataGridRenderer read GetRenderer write SetRenderer;
  end;

  TTMSFNCDataGridHilightMode = (ghmCell, ghmColumn, ghmRow, ghmGrid);

  TTMSFNCDataGridHilightOptions = record
    IncludeFixed: Boolean;
    CaseSensitive: Boolean;
    FullText: Boolean;
    Mode: TTMSFNCDataGridHilightMode;
    Column: Integer;
    Row: Integer;
  end;

  TTMSFNCDataGridMarkOptions = TTMSFNCDataGridHilightOptions;

  TTMSFNCCommentPopup = class(TTMSFNCPopup)
  private
    FCell: TTMSFNCDataGridCell;
  end;

  TTMSFNCDataGridColumnSetting = (gcsAppearance, gcsType, gcsEditor, gcsEditorTarget, gcsEditorItems, gcsReadOnly, gcsFormatting,
    gcsControlText, gcsControlWidth, gcsControlHeight, gcsControlAlign, gcsControlPosition, gcsControlMargins,
    gcsFilterButton, gcsFilterEditor, gcsFilterEditorType, gcsFilterDefaultType);

  TTMSFNCDataGridColumnSettings = set of TTMSFNCDataGridColumnSetting;

  TTMSFNCDataGridColumns = class;

  TTMSFNCDataGridColumnFormatting = class(TPersistent)
  private
    FFormat: string;
    FType: TTMSFNCDataGridDataFormattingType;
    FOnChange: TNotifyEvent;
    FConvertSettings: TFormatSettings;
    FBooleanFalseText: string;
    FBooleanTrueText: string;
    procedure SetFormat(const Value: string);
    procedure SetType(const Value: TTMSFNCDataGridDataFormattingType);
    function IsFormatStored: Boolean;
    function IsBooleanFalseTextStored: Boolean;
    function IsBooleanTrueTextStored: Boolean;
  protected
    procedure UpdateColumnFormatting;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  public
    constructor Create; virtual;
    procedure Assign(Source: TPersistent); override;
    property ConvertSettings: TFormatSettings read FConvertSettings write FConvertSettings;
  published
    property &Type: TTMSFNCDataGridDataFormattingType read FType write SetType default gdftDefault;
    property Format: string read FFormat write SetFormat stored IsFormatStored;
    property BooleanTrueText: string read FBooleanTrueText write FBooleanTrueText stored IsBooleanTrueTextStored nodefault;
    property BooleanFalseText: string read FBooleanFalseText write FBooleanFalseText stored IsBooleanFalseTextStored nodefault;
  end;

  TTMSFNCDataGridColumnBinding = class(TPersistent)
  private
    FBooleanFalseValue: string;
    FBooleanTrueValue: string;
    FOnChange: TNotifyEvent;
    function IsBooleanFalseValueStored: Boolean;
    function IsBooleanTrueValueStored: Boolean;
    procedure SetBooleanFalseValue(const Value: string);
    procedure SetBooleanTrueValue(const Value: string);
  protected
    procedure UpdateColumnBinding;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  public
    constructor Create; virtual;
    procedure Assign(Source: TPersistent); override;
  published
    property BooleanTrueValue: string read FBooleanTrueValue write SetBooleanTrueValue stored IsBooleanTrueValueStored nodefault;
    property BooleanFalseValue: string read FBooleanFalseValue write SetBooleanFalseValue stored IsBooleanFalseValueStored nodefault;
  end;

  TTMSFNCDataGridFilterEditorType = (gfetAutomatic, gfetString, gfetBoolean, gfetDateTime, gfetFloat, gfetNumber, gfetCustom);

  TTMSFNCDataGridColumn = class(TCollectionItem)
  private
    FAppearance: TTMSFNCDataGridCellAppearance;
    FBinding: TTMSFNCDataGridColumnBinding;
    FColumns: TTMSFNCDataGridColumns;
    FControlAlign: TTMSFNCDataGridCellControlAlign;
    FControlHeight: Integer;
    FControlMargins: TTMSFNCMargins;
    FControlPosition: TTMSFNCDataGridCellControlPosition;
    FControlText: string;
    FControlWidth: Integer;
    FDataBoolean: Boolean;
    FDataInteger: NativeInt;
    FDataObject: TObject;
    FDataPointer: Pointer;
    FDataString: String;
    FEditor: TTMSFNCDataGridInplaceEditorType;
    FEditorItems: TStringList;
    FEditorTarget: TTMSFNCDataGridInplaceEditorTarget;
    FFilterButton: Boolean;
    FFilterDefaultType: TTMSFNCDataGridDataFilterType;
    FFilterEditor: Boolean;
    FFilterEditorType: TTMSFNCDataGridFilterEditorType;
    FFormatting: TTMSFNCDataGridColumnFormatting;
    FHeader: string;
    FName: string;
    FReadOnly: Boolean;
    FSettings: TTMSFNCDataGridColumnSettings;
    FType: TTMSFNCDataGridCellItemType;
    FTypeRange: TTMSFNCDataGridCellItemTypeRange;
    FVisible: Boolean;
    FWidth: Single;
    function GetHeader: string;
    function GetRenderer: TTMSFNCDataGridRenderer;
    function GetValueType: TTypeKind;
    function GetVisible: Boolean;
    function GetWidth: Single;
    function IsControlHeightStored: Boolean;
    function IsControlTextStored: Boolean;
    function IsControlWidthStored: Boolean;
    function IsHeaderStored: Boolean;
    function IsWidthStored: Boolean;
    procedure SetAppearance(const Value: TTMSFNCDataGridCellAppearance);
    procedure SetBinding(const Value: TTMSFNCDataGridColumnBinding);
    procedure SetControlAlign(const Value: TTMSFNCDataGridCellControlAlign);
    procedure SetControlHeight(const Value: Integer);
    procedure SetControlMargins(const Value: TTMSFNCMargins);
    procedure SetControlPosition(const Value: TTMSFNCDataGridCellControlPosition);
    procedure SetControlText(const Value: string);
    procedure SetControlWidth(const Value: Integer);
    procedure SetEditor(const Value: TTMSFNCDataGridInplaceEditorType);
    procedure SetEditorItems(const Value: TStringList);
    procedure SetEditorTarget(const Value: TTMSFNCDataGridInplaceEditorTarget);
    procedure SetFilterButton(const Value: Boolean);
    procedure SetFilterDefaultType(const Value: TTMSFNCDataGridDataFilterType);
    procedure SetFilterEditor(const Value: Boolean);
    procedure SetFilterEditorType(const Value: TTMSFNCDataGridFilterEditorType);
    procedure SetFormatting(const Value: TTMSFNCDataGridColumnFormatting);
    procedure SetHeader(const Value: string);
    procedure SetReadOnly(const Value: Boolean);
    procedure SetSettings(const Value: TTMSFNCDataGridColumnSettings);
    procedure SetType(const Value: TTMSFNCDataGridCellItemType);
    procedure SetTypeRange(const Value: TTMSFNCDataGridCellItemTypeRange);
    procedure SetVisible(const Value: Boolean);
    procedure SetWidth(const Value: Single);
  protected
    function GetDisplayName: string; override;
    procedure AppearanceChanged(Sender: TObject);
    procedure BindingChanged(Sender: TObject);
    procedure ClearColumn;
    procedure EditorItemsChanged(Sender: TObject);
    procedure FormattingChanged(Sender: TObject);
    procedure MarginsChanged(Sender: TObject);
    procedure UpdateColumn;
    procedure SetIndex(Value: Integer); override;
    procedure UpdateSettings(ASetting: TTMSFNCDataGridColumnSetting);
    property Renderer: TTMSFNCDataGridRenderer read GetRenderer;
  public
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;
    procedure AddSetting(ASetting: TTMSFNCDataGridColumnSetting);
    procedure Assign(Source: TPersistent); override;
    procedure RemoveSetting(ASetting: TTMSFNCDataGridColumnSetting);
    property DataBoolean: Boolean read FDataBoolean write FDataBoolean;
    property DataInteger: NativeInt read FDataInteger write FDataInteger;
    property DataObject: TObject read FDataObject write FDataObject;
    property DataPointer: Pointer read FDataPointer write FDataPointer;
    property DataString: String read FDataString write FDataString;
  published
    property &ReadOnly: Boolean read FReadOnly write SetReadOnly default False;
    property &Type: TTMSFNCDataGridCellItemType read FType write SetType default gcitNormal;
    property Appearance: TTMSFNCDataGridCellAppearance read FAppearance write SetAppearance;
    property Binding: TTMSFNCDataGridColumnBinding read FBinding write SetBinding;
    property ControlAlign: TTMSFNCDataGridCellControlAlign read FControlAlign write SetControlAlign default gcaNone;
    property ControlHeight: Integer read FControlHeight write SetControlHeight stored IsControlHeightStored nodefault;
    property ControlMargins: TTMSFNCMargins read FControlMargins write SetControlMargins;
    property ControlPosition: TTMSFNCDataGridCellControlPosition read FControlPosition write SetControlPosition default gcpCenterRight;
    property ControlText: string read FControlText write SetControlText stored IsControlTextStored nodefault;
    property ControlWidth: Integer read FControlWidth write SetControlWidth stored IsControlWidthStored nodefault;
    property Editor: TTMSFNCDataGridInplaceEditorType read FEditor write SetEditor default getEdit;
    property EditorItems: TStringList read FEditorItems write SetEditorItems;
    property EditorTarget: TTMSFNCDataGridInplaceEditorTarget read FEditorTarget write SetEditorTarget default getCellValue;
    property FilterButton: Boolean read FFilterButton write SetFilterButton default True;
    property FilterDefaultType: TTMSFNCDataGridDataFilterType read FFilterDefaultType write SetFilterDefaultType default gftEqual;
    property FilterEditor: Boolean read FFilterEditor write SetFilterEditor default False;
    property FilterEditorType: TTMSFNCDataGridFilterEditorType read FFilterEditorType write SetFilterEditorType default gfetAutomatic;
    property Formatting: TTMSFNCDataGridColumnFormatting read FFormatting write SetFormatting;
    property Header: string read GetHeader write SetHeader stored IsHeaderStored nodefault;
    property Name: string read FName write FName;
    property Settings: TTMSFNCDataGridColumnSettings read FSettings write SetSettings default [];
    property TypeRange: TTMSFNCDataGridCellItemTypeRange read FTypeRange write SetTypeRange default gcirAll;
    property ValueType: TTypeKind read GetValueType;
    property Visible: Boolean read GetVisible write SetVisible default True;
    property Width: Single read GetWidth write SetWidth stored IsWidthStored nodefault;
  end;

  TTMSFNCDataGridColumnClass = class of TTMSFNCDataGridColumn;

  {$IFDEF WEBLIB}
  TTMSFNCDataGridColumns = class(TTMSFNCOwnedCollection)
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCDataGridColumns = class(TTMSFNCOwnedCollection<TTMSFNCDataGridColumn>)
  {$ENDIF}
  private
    FRenderer: TTMSFNCDataGridRenderer;
    FOnChange: TNotifyEvent;
    function GetItem(Index: integer): TTMSFNCDataGridColumn;
    procedure SetItem(Index: integer; const Value: TTMSFNCDataGridColumn);
  protected
    property Renderer: TTMSFNCDataGridRenderer read FRenderer;
    procedure UpdateColumns;
    procedure ClearColumn(AIndex: Integer);
    function GetColumnClass: TTMSFNCDataGridColumnClass; virtual;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  public
    function ColumnByName(AName: string): TTMSFNCDataGridColumn;
    function ColumnByHeader(AHeader: string): TTMSFNCDataGridColumn;
    constructor Create(AHost: TPersistent; ARenderer: TTMSFNCDataGridRenderer);
    property Items[Index: integer]: TTMSFNCDataGridColumn read GetItem write SetItem; default;
    function Add: TTMSFNCDataGridColumn;
    function Insert(Index: integer): TTMSFNCDataGridColumn;
  end;

  TTMSFNCDataGridColumnsClass = class of TTMSFNCDataGridColumns;

  TTMSFNCDataGridAutoSizeMode = (gamVisibleCells, gamAllCells);

  TTMSFNCDataGridRendererExportNewPageCallback = reference to procedure;

  TTMSFNCDataGridRendererExportGetPageIndexCallback = reference to function: Integer;

  {$IFDEF WEBLIB}
  TTMSFNCDataGridCellControlWrapperListItem = class
  private
    FKey: string;
    FWrapper: TTMSFNCDataGridCellControlWrapper;
  public
    constructor Create(AKey: string; AWrapper: TTMSFNCDataGridCellControlWrapper);
    property Key: string read FKey;
    property Wrapper: TTMSFNCDataGridCellControlWrapper read FWrapper write FWrapper;
  end;

  TTMSFNCDataGridCellControlWrapperList = class(TObjectList<TTMSFNCDataGridCellControlWrapperListItem>)
  private
    function GetKeys: TArray<string>;
  public
    function TryGetValue(AKey: string; var AWrapper: TTMSFNCDataGridCellControlWrapper): Boolean;
    procedure AddOrSetValue(AKey: string; AWrapper: TTMSFNCDataGridCellControlWrapper);
    procedure Remove(AKey: string);
    property Keys: TArray<string> read GetKeys;
  end;
  {$ELSE}
  TTMSFNCDataGridCellControlWrapperList = class(TObjectDictionary<string, TTMSFNCDataGridCellControlWrapper>);
  {$ENDIF}

  TTMSFNCDataGridCreateCustomFilterEditorEvent = function(Sender: TObject; ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCellControl of object;
  TTMSFNCDataGridBeforeCreateFilterEditorEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; var ACanCreate: Boolean) of object;
  TTMSFNCDataGridAfterCreateFilterEditorEvent = procedure(Sender: TObject; ACell: TTMSFNCDataGridCellCoord; AEditor: TTMSFNCDataGridCellControl) of object;

  TTMSFNCDataGridFilterPanel = class(TTMSFNCCustomControl)
  private
    FAutoHideControls: Boolean;
    FBlockChange: Boolean;
    FCell: TTMSFNCDataGridCellCoord;
    FClearButton: TTMSFNCToolBarButton;
    FEditor: TTMSFNCDataGridCellControl;
    FEditorTime: Integer;
    FEditorTimer: TTimer;
    FRenderer: TTMSFNCDataGridRenderer;
    FType: TTMSFNCDataGridFilterEditorType;
    FTypeButton: TTMSFNCToolBarButton;
    FTypeListBox: TTMSFNCListBox;
    function GetEditorTimer: TTimer;
  protected
    function GetDefaultFilterType(AType: TTMSFNCDataGridFilterEditorType): TTMSFNCDataGridDataFilterType;
    function ItemIndexByType(AType: TTMSFNCDataGridDataFilterType): Integer;
    procedure DoClearClick(Sender: TObject);
    procedure DoEditorChange(Sender: TObject);
    procedure DoEditorTimerChanged(Sender: TObject);
    procedure DoTypeButtonClick(Sender: TObject);
    procedure DoTypeListBoxSelected(Sender: TObject; AItem: TTMSFNCListBoxItem);
    procedure Notification(AComponent: TComponent; Operation: TOperation); override;
    procedure UpdateControlAfterResize; override;
    property EditorTimer: TTimer read GetEditorTimer;
  public
    constructor Create(AOwner: TComponent; ARenderer: TTMSFNCDataGridRenderer; ACell: TTMSFNCDataGridCellCoord; AType: TTMSFNCDataGridFilterEditorType); reintroduce; virtual;
    destructor Destroy; override;
    procedure Reset;
    procedure SetFilter(AFilter: TTMSFNCDataGridDataFilterData);
    property AutoHideControls: Boolean read FAutoHideControls write FAutoHideControls default True;
    property ClearButton: TTMSFNCToolBarButton read FClearButton;
    property Editor: TTMSFNCDataGridCellControl read FEditor;
    property TypeButton: TTMSFNCToolBarButton read FTypeButton;
    property TypeListBox: TTMSFNCListBox read FTypeListBox;
  end;

  TTMSFNCDataGridFilterTimerMode = (gftmDropDown, gftmEditor);

  TTMSFNCDataGridFilterEditMode = (gfemList, gfemEdit);

  TTMSFNCDataGridRenderer = class(TTMSFNCDataGridData, ITMSFNCDataBinderSelection, ITMSFNCAppearanceGlobalFont, ITMSFNCBitmapContainer, ITMSFNCAdaptToStyle)
  private
    FIsStyling: Boolean;
    FAdaptedToStyle: Boolean;
    FAdaptToStyle: Boolean;
    FAnimateVerticalPos, FAnimateHorizontalPos: Boolean;
    FAnimating: Boolean;
    FBitmapContainer: TTMSFNCBitmapContainer;
    FBlockScrollingUpdate: Boolean;
    FBlockSynchronizeColumns: Boolean;
    FCapturedScrollbar: TTMSFNCDataGridScrollBar;
    FCellAnchor, FDragScrollCell: TTMSFNCDataGridCellCoord;
    FCellAnchorString: string;
    FCellAppearance: TTMSFNCDataGridCellAppearance;
    FCellLayout: TTMSFNCDataGridCellLayout;
    FCellPopupMenu: TPopupMenu;
    FClosing: Boolean;
    FColumns: TTMSFNCDataGridColumns;
    FColumnsEditor: TObject;
    FColumnStretchingActive: Boolean;
    FColumnStretchingApplied: Boolean;
    FCommentPopup: TTMSFNCCommentPopup;
    FControlWrapperList: TTMSFNCDataGridCellControlWrapperList;
    FCustomScrollBars: Boolean;
    FCustomVerticalScrollBar, FCustomHorizontalScrollBar: TTMSFNCDataGridScrollBar;
    FDblClick, FClearMouseDown: Boolean;
    FDoTouchScroll, FTouchScrolling: Boolean;
    FDoubleSelection: Boolean;
    FDragAppearance: TTMSFNCDataGridDragAppearance;
    FDragBitmap: TTMSFNCImage;
    FDragCell, FDragCellTo: TTMSFNCDataGridCellCoord;
    FDraggingMode: TTMSFNCDataGridDraggingMode;
    FDraggingType: TTMSFNCDataGridDraggingType;
    FDroppedDown: Boolean;
    FEditing: Boolean;
    FEditingCell: TTMSFNCDataGridCellCoord;
    FFilterAppearance: TTMSFNCDataGridFilterAppearance;
    FFilterClearButton: TTMSFNCToolBarButton;
    FFilterContainer: TTMSFNCCustomControl;
    FFilterCustomEditor: TTMSFNCDataGridCellControl;
    FFilterEdit: TTMSFNCEdit;
    FFilterEditMode: TTMSFNCDataGridFilterEditMode;
    FFilterExitTimer: TTimer;
    FFilterListBox: TTMSFNCCheckedListBox;
    FFilterPopup: TTMSFNCPopup;
    FFilterSortAscendingButton: TTMSFNCToolBarButton;
    FFilterSortDescendingButton: TTMSFNCToolBarButton;
    FFilterTime: Integer;
    FFilterTimer: TTimer;
    FFilterTypeComboBox: TComboBoxSafe;
    FFindDialog: TTMSFNCFindDialog;
    FFilterDialog: TTMSFNCFilterDialog;
    FFixedColumnCellDisplay: TTMSFNCDataGridFixedColumnCellDisplayList;
    FFixedColumnCellList: TTMSFNCDataGridFixedColumnCellList;
    FFixedRootCellDisplay: TTMSFNCDataGridFixedRootCellDisplayList;
    FFixedRootCellList: TTMSFNCDataGridFixedRootCellList;
    FFixedRowCellDisplay: TTMSFNCDataGridFixedRowCellDisplayList;
    FFixedRowCellList: TTMSFNCDataGridFixedRowCellList;
    FGlobalFont: TTMSFNCAppearanceGlobalFont;
    FHorizontalScrollBarVisible: Boolean;
    FHost: TObject;
    FHoverCell, FFocusedCell, FFirstCell, FSaveCell, FRealCell: TTMSFNCDataGridCellCoord;
    FIcons: TTMSFNCDataGridIcons;
    FInplaceEditor: TTMSFNCDataGridInplaceEditor;
    FInplaceEditorActive: Boolean;
    FInplaceEditorCustomClass: TTMSFNCDataGridInplaceEditorClass;
    FInplaceEditorTarget: TTMSFNCDataGridInplaceEditorTarget;
    FInplaceEditorType: TTMSFNCDataGridInplaceEditorType;
    FDragging: Boolean;
    FKeyDown: Boolean;
    FLoadFilter: Boolean;
    FLocalHScrollValue: Double;
    FLocalRectChanged: Boolean;
    FLocalVScrollValue: Double;
    FLookupString: string;
    FLookupTimer: TTimer;
    FMergedCells: TTMSFNCDataGridMergedCells;
    FMouseDblClick, FMouseSizing, FMouseDown, FMouseUp, FDragFixed, FMouseScrollingUp, FMouseDragging: Boolean;
    FNormalCellDisplay: TTMSFNCDataGridNormalCellDisplayList;
    FNormalCellList: TTMSFNCDataGridNormalCellList;
    FOldCursor: TCursor;
    FOnAfterApplyFilter: TTMSFNCDataGridAfterApplyFilterEvent;
    FOnAfterCloseInplaceEditor: TTMSFNCDataGridAfterCloseInplaceEditorEvent;
    FOnAfterCloseInplaceEditorInternal: TTMSFNCDataGridAfterCloseInplaceEditorEvent;
    FOnAfterCopyToClipboard: TTMSFNCDataGridAfterClipboardEvent;
    FOnAfterCreateFilterEditor: TTMSFNCDataGridAfterCreateFilterEditorEvent;
    FOnAfterCutToClipboard: TTMSFNCDataGridAfterClipboardEvent;
    FOnAfterDrawCell: TTMSFNCDataGridAfterDrawCellEvent;
    FOnAfterDrawEmptySpace: TTMSFNCDataGridAfterDrawEmptySpaceEvent;
    FOnAfterDrawGrid: TTMSFNCDataGridAfterDrawGridEvent;
    FOnAfterLookup: TTMSFNCDataGridAfterLookupEvent;
    FOnAfterOpenInplaceEditor: TTMSFNCDataGridAfterOpenInplaceEditorEvent;
    FOnAfterPasteFromClipboard: TTMSFNCDataGridAfterClipboardEvent;
    FOnAfterShowFilter: TTMSFNCDataGridAfterShowFilterEvent;
    FOnAfterShowFilterDialog: TTMSFNCDataGridAfterShowFilterDialogEvent;
    FOnAfterShowFindDialog: TTMSFNCDataGridAfterShowFindDialogEvent;
    FOnAfterShowReplaceDialog: TTMSFNCDataGridAfterShowReplaceDialogEvent;
    FOnAfterSortColumn: TTMSFNCDataGridAfterSortColumnEvent;
    FOnAppendColumn: TTMSFNCDataGridAppendColumnEvent;
    FOnAppendRow: TTMSFNCDataGridAppendRowEvent;
    FOnBeforeApplyFilter: TTMSFNCDataGridBeforeApplyFilterEvent;
    FOnBeforeCloseInplaceEditor: TTMSFNCDataGridBeforeCloseInplaceEditorEvent;
    FOnBeforeCopyToClipboard: TTMSFNCDataGridBeforeClipboardEvent;
    FOnBeforeCreateFilterEditor: TTMSFNCDataGridBeforeCreateFilterEditorEvent;
    FOnBeforeCutToClipboard: TTMSFNCDataGridBeforeClipboardEvent;
    FOnBeforeDrawCell: TTMSFNCDataGridBeforeDrawCellEvent;
    FOnBeforeDrawEmptySpace: TTMSFNCDataGridBeforeDrawEmptySpaceEvent;
    FOnBeforeLookup: TTMSFNCDataGridBeforeLookupEvent;
    FOnBeforeOpenInplaceEditor: TTMSFNCDataGridBeforeOpenInplaceEditorEvent;
    FOnBeforePasteFromClipboard: TTMSFNCDataGridBeforeClipboardEvent;
    FOnBeforeShowFilter: TTMSFNCDataGridBeforeShowFilterEvent;
    FOnBeforeShowFilterDialog: TTMSFNCDataGridBeforeShowFilterDialogEvent;
    FOnBeforeShowFindDialog: TTMSFNCDataGridBeforeShowFindDialogEvent;
    FOnBeforeShowReplaceDialog: TTMSFNCDataGridBeforeShowReplaceDialogEvent;
    FOnBeforeSortColumn: TTMSFNCDataGridBeforeSortColumnEvent;
    FOnCanAppendColumn: TTMSFNCDataGridCanAppendColumnEvent;
    FOnCanAppendRow: TTMSFNCDataGridCanAppendRowEvent;
    FOnCanDeleteColumn: TTMSFNCDataGridCanDeleteColumnEvent;
    FOnCanDeleteRow: TTMSFNCDataGridCanDeleteRowEvent;
    FOnCanDragColumn: TTMSFNCDataGridCanDragColumnEvent;
    FOnCanDragRow: TTMSFNCDataGridCanDragRowEvent;
    FOnCanDropColumn: TTMSFNCDataGridCanDropColumnEvent;
    FOnCanDropRow: TTMSFNCDataGridCanDropRowEvent;
    FOnCanEditCell: TTMSFNCDataGridCanEditCellEvent;
    FOnCanInsertColumn: TTMSFNCDataGridCanInsertColumnEvent;
    FOnCanInsertRow: TTMSFNCDataGridCanInsertRowEvent;
    FOnCanSizeColumn: TTMSFNCDataGridCanSizeColumnEvent;
    FOnCanSizeRow: TTMSFNCDataGridCanSizeRowEvent;
    FOnCellAfterNodeCollapse: TTMSFNCDataGridCellAfterNodeCollapseEvent;
    FOnCellAfterNodeExpand: TTMSFNCDataGridCellAfterNodeExpandEvent;
    FOnCellAnchorClick: TTMSFNCDataGridCellAnchorClickEvent;
    FOnCellBeforeNodeCollapse: TTMSFNCDataGridCellBeforeNodeCollapseEvent;
    FOnCellBeforeNodeExpand: TTMSFNCDataGridCellBeforeNodeExpandEvent;
    FOnCellBeforeShowPopupMenu: TTMSFNCDataGridCellBeforeShowPopupMenuEvent;
    FOnCellButtonClick: TTMSFNCDataGridCellClickEvent;
    FOnCellCheckBoxChange: TTMSFNCDataGridCellClickEvent;
    FOnCellClick: TTMSFNCDataGridCellClickEvent;
    FOnCellDblClick: TTMSFNCDataGridCellClickEvent;
    FOnCellEditGetData: TTMSFNCDataGridCellEditGetDataEvent;
    FOnCellEditSetData: TTMSFNCDataGridCellEditSetDataEvent;
    FOnCellEditValidateData: TTMSFNCDataGridCellEditValidateDataEvent;
    FOnCellRadioButtonChange: TTMSFNCDataGridCellClickEvent;
    FOnCellRightClick: TTMSFNCDataGridCellClickEvent;
    FOnColumnDropped: TTMSFNCDataGridColumnDroppedEvent;
    FOnColumnSized: TTMSFNCDataGridColumnSizedEvent;
    FOnCreateCustomFilterEditor: TTMSFNCDataGridCreateCustomFilterEditorEvent;
    FOnCustomizeFilterPopupEditor: TTMSFNCDataGridCustomizeFilterPopupEditorEvent;
    FOnDeleteColumn: TTMSFNCDataGridDeleteColumnEvent;
    FOnDeleteRow: TTMSFNCDataGridDeleteRowEvent;
    FOnDisplay: TNotifyEvent;
    FOnDropFiles: TTMSFNCDataGridDropFilesEvent;
    FOnFocus: TNotifyEvent;
    FOnGetCellClass: TTMSFNCDataGridGetCellClassEvent;
    FOnGetCellHint: TTMSFNCDataGridGetCellHintEvent;
    FOnGetCellLayout: TTMSFNCDataGridGetCellLayoutEvent;
    FOnGetCellLayoutHasPriority: TTMSFNCDataGridGetCellLayoutHasPriorityEvent;
    FOnGetCellProperties: TTMSFNCDataGridGetCellPropertiesEvent;
    FOnGetInplaceEditorClass: TTMSFNCDataGridGetInplaceEditorClassEvent;
    FOnGetInplaceEditorProperties: TTMSFNCDataGridGetInplaceEditorPropertiesEvent;
    FOnGetInplaceEditorRect: TTMSFNCDataGridGetInplaceEditorRectEvent;
    FOnGetInplaceEditorTarget: TTMSFNCDataGridGetInplaceEditorTargetEvent;
    FOnGetInplaceEditorType: TTMSFNCDataGridGetInplaceEditorTypeEvent;
    FOnHScroll: TTMSFNCDataGridScrollEvent;
    FOnInsertColumn: TTMSFNCDataGridInsertColumnEvent;
    FOnInsertRow: TTMSFNCDataGridInsertRowEvent;
    FOnIsDesigntime: TTMSFNCDataGridRendererIsDesigntimeEvent;
    FOnIsDestroying: TTMSFNCDataGridRendererIsDestroyingEvent;
    FOnIsFocused: TTMSFNCDataGridRendererIsFocusedEvent;
    FOnIsLoading: TTMSFNCDataGridRendererIsLoadingEvent;
    FOnNeedFilterDropDownData: TTMSFNCDataGridNeedFilterDropDownData;
    FOnRemoveFilter: TTMSFNCDataGridRemoveFilterEvent;
    FOnRowDropped: TTMSFNCDataGridRowDroppedEvent;
    FOnRowSized: TTMSFNCDataGridRowSizedEvent;
    FOnSelectCell: TTMSFNCDataGridSelectCellEvent;
    FOnSelectingCell: TTMSFNCDataGridSelectingCellEvent;
    FOnSizeColumn: TTMSFNCDataGridSizeColumnEvent;
    FOnSizeRow: TTMSFNCDataGridSizeRowEvent;
    FOnUpdateCursor: TTMSFNCDataGridRendererUpdateCursorEvent;
    FOnVScroll: TTMSFNCDataGridScrollEvent;
    FPadding: TTMSFNCMargins;
    FPrevX, FPrevY, FSizeX, FSizeY, FDownX, FDownY: Single;
    FReplaceDialog: TTMSFNCReplaceDialog;
    FRowStretchingActive: Boolean;
    FRowStretchingApplied: Boolean;
    FSaveClipRect, FClipRect: TRectF;
    FSaveHScrollPos, FSaveVScrollPos: Single;
    FSaveLeft: Single;
    FSaveTop: Single;
    FScale: Single;
    FScrollHTo, FScrollVTo: Double;
    FScrollMode: TTMSFNCDataGridScrollMode;
    FScrollTimer, FDragTimer, FAnimateTimer: TTimer;
    FScrollUpdate: TTMSFNCDataGridScrollUpdate;
    FSelectedCellDictionary: TTMSFNCDataGridSelectedCellDictionary;
    FSelectedColumnDictionary: TTMSFNCDataGridBooleanDictionary;
    FSelectedRowDictionary: TTMSFNCDataGridBooleanDictionary;
    FSelection: TTMSFNCDataGridCellCoordRange;
    FSizeMode: TTMSFNCDataGridSizeMode;
    FSizing: Boolean;
    FSpY, FSpX, FX, FY, FTouchX, FTouchY, FScrollX, FScrollY, FMouseX, FMouseY: Single;
    FStretchScrollBars: Boolean;
    FStroke: TTMSFNCGraphicsStroke;
    FStyleApplied: Boolean;
    FTabKey: TTMSFNCDataGridTabKeyMode;
    FTimeStart, FTimeStop: Double;
    FUseClipRect: Boolean;
    FVerticalScrollBar, FHorizontalScrollBar: TScrollBar;
    FVerticalScrollBarVisible: Boolean;
    FOnCalculate: TNotifyEvent;
    FOnBeforeCalculate: TNotifyEvent;
    FIsMouseDown: Boolean;
    function GetAdaptToStyle: Boolean;
    function GetAnimateTimer: TTimer;
    function GetBitmapContainer: TTMSFNCBitmapContainer;
    function GetBitmapNames(AColumn, ARow: Integer): string;
    function GetBitmaps(AColumn, ARow: Integer): TTMSFNCBitmap;
    function GetBottomRow: Integer;
    function GetColors(AColumn, ARow: Integer): TTMSFNCGraphicsColor;
    function GetColumnsEditor: TObject;
    function GetCommentPopup: TTMSFNCCommentPopup;
    function GetComments(AColumn, ARow: Integer): string;
    function GetControlAligns(AColumn, ARow: Integer): TTMSFNCDataGridCellControlAlign;
    function GetControlHeights(AColumn, ARow: Integer): Integer;
    function GetControlMargins(AColumn, ARow: Integer): TTMSFNCMargins;
    function GetControlPositions(AColumn, ARow: Integer): TTMSFNCDataGridCellControlPosition;
    function GetControlTexts(AColumn, ARow: Integer): string;
    function GetControlWidths(AColumn, ARow: Integer): Integer;
    function GetControlWrapperList: TTMSFNCDataGridCellControlWrapperList;
    function GetCustomHorizontalScrollBar: TTMSFNCDataGridScrollBar;
    function GetCustomVerticalScrollBar: TTMSFNCDataGridScrollBar;
    function GetDragTimer: TTimer;
    function GetFilterClearButton: TTMSFNCToolBarButton;
    function GetFilterContainer: TTMSFNCCustomControl;
    function GetFilterEdit: TTMSFNCEdit;
    function GetFilterEditors(AColumn, ARow: Integer): TTMSFNCDataGridCellControl;
    function GetFilterExitTimer: TTimer;
    function GetFilterListBox: TTMSFNCCheckedListBox;
    function GetFilterPopup: TTMSFNCPopup;
    function GetFilterSortAscendingButton: TTMSFNCToolBarButton;
    function GetFilterSortDescendingButton: TTMSFNCToolBarButton;
    function GetFilterTimer: TTimer;
    function GetFilterTypeComboBox: TComboBoxSafe;
    function GetFindDialog: TTMSFNCFindDialog;
    function GetFocusedCell: TTMSFNCDataGridCellCoord;
    function GetFontColors(AColumn, ARow: Integer): TTMSFNCGraphicsColor;
    function GetFontNames(AColumn, ARow: Integer): string;
    function GetFontSizes(AColumn, ARow: Integer): Single;
    function GetFontStyles(AColumn, ARow: Integer): TFontStyles;
    function GetGrids(AColumn, ARow: Integer): TTMSFNCDataGridRenderer;
    function GetHasBitmap(AColumn, ARow: Integer): Boolean;
    function GetHasButton(AColumn, ARow: Integer): Boolean;
    function GetHasCheckBox(AColumn, ARow: Integer): Boolean;
    function GetHasDataCheckBox(AColumn, ARow: Integer): Boolean;
    function GetHasDataProgressBar(AColumn, ARow: Integer): Boolean;
    function GetHasDataRadioButton(AColumn, ARow: Integer): Boolean;
    function GetHasFilterEditor(AColumn, ARow: Integer): Boolean;
    function GetHasGrid(AColumn, ARow: Integer): Boolean;
    function GetHasLayout(AColumn, ARow: Integer): Boolean;
    function GetHasProgressBar(AColumn, ARow: Integer): Boolean;
    function GetHasRadioButton(AColumn, ARow: Integer): Boolean;
    function GetHints(AColumn, ARow: Integer): string;
    function GetLayouts(AColumn, ARow: Integer): TTMSFNCDataGridCellLayout;
    function GetLeftColumn: Integer;
    function GetLookupTimer: TTimer;
    function GetOptions: TTMSFNCDataGridOptions;
    function GetPageCount: Integer;
    function GetPageIndex: Integer;
    function GetProgressValue(AColumn, ARow: Integer): Integer;
    function GetRadioGroupIndex(AColumn, ARow: Integer): Integer;
    function GetReadOnlys(AColumn, ARow: Integer): Boolean;
    function GetReplaceDialog: TTMSFNCReplaceDialog;
    function GetRightColumn: Integer;
    function GetScrollTimer: TTimer;
    function GetSelectedCell(AColumn, ARow: Integer): Boolean;
    function GetSelectedCellDictionary: TTMSFNCDataGridSelectedCellDictionary;
    function GetSelectedColumn(AColumn: Integer): Boolean;
    function GetSelectedColumnDictionary: TTMSFNCDataGridBooleanDictionary;
    function GetSelectedRow(ARow: Integer): Boolean;
    function GetSelectedRowDictionary: TTMSFNCDataGridBooleanDictionary;
    function GetStates(AColumn, ARow: Integer): TTMSFNCDataGridCellState;
    function GetTextAligns(AColumn, ARow: Integer): TTMSFNCGraphicsTextAlign;
    function GetTextAngles(AColumn, ARow: Integer): Double;
    function GetTopRow: Integer;
    function GetVerticalTextAligns(AColumn, ARow: Integer): TTMSFNCGraphicsTextAlign;
    function GetWordWrapping(AColumn, ARow: Integer): Boolean;
    procedure SetAdaptToStyle(const Value: Boolean);
    procedure SetBitmapContainer(const Value: TTMSFNCBitmapContainer);
    procedure SetCellAppearance(const Value: TTMSFNCDataGridCellAppearance);
    procedure SetColors(AColumn, ARow: Integer; const Value: TTMSFNCGraphicsColor);
    procedure SetColumns(const Value: TTMSFNCDataGridColumns);
    procedure SetComments(AColumn, ARow: Integer; const Value: string);
    procedure SetControlAligns(AColumn, ARow: Integer; const Value: TTMSFNCDataGridCellControlAlign);
    procedure SetControlHeights(AColumn, ARow: Integer; const Value: Integer);
    procedure SetControlPositions(AColumn, ARow: Integer; const Value: TTMSFNCDataGridCellControlPosition);
    procedure SetControlTexts(AColumn, ARow: Integer; const Value: string);
    procedure SetControlWidths(AColumn, ARow: Integer; const Value: Integer);
    procedure SetCustomScrollBars(const Value: Boolean);
    procedure SetDragAppearance(const Value: TTMSFNCDataGridDragAppearance);
    procedure SetFilterAppearance(const Value: TTMSFNCDataGridFilterAppearance);
    procedure SetFocusedCell(const Value: TTMSFNCDataGridCellCoord);
    procedure SetFontColors(AColumn, ARow: Integer; const Value: TTMSFNCGraphicsColor);
    procedure SetFontNames(AColumn, ARow: Integer; const Value: string);
    procedure SetFontSizes(AColumn, ARow: Integer; const Value: Single);
    procedure SetFontStyles(AColumn, ARow: Integer; const Value: TFontStyles);
    procedure SetGlobalFont(const Value: TTMSFNCAppearanceGlobalFont);
    procedure SetHints(AColumn, ARow: Integer; const Value: string);
    procedure SetHorizontalScrollBarVisible(const Value: Boolean);
    procedure SetHScrollValue(AValue: Single);
    procedure SetIcons(const Value: TTMSFNCDataGridIcons);
    procedure SetLeftColumn(const Value: Integer);
    procedure SetOptions(const Value: TTMSFNCDataGridOptions);
    procedure SetPadding(const Value: TTMSFNCMargins);
    procedure SetPageIndex(const Value: Integer);
    procedure SetRadioGroupIndex(AColumn, ARow: Integer; const Value: Integer);
    procedure SetReadOnlys(AColumn, ARow: Integer; const Value: Boolean);
    procedure SetScrollMode(const Value: TTMSFNCDataGridScrollMode);
    procedure SetScrollUpdate(const Value: TTMSFNCDataGridScrollUpdate);
    procedure SetSelectedCell(AColumn, ARow: Integer; const Value: Boolean);
    procedure SetSelectedColumn(AColumn: Integer; const Value: Boolean);
    procedure SetSelectedRow(ARow: Integer; const Value: Boolean);
    procedure SetStretchScrollBars(const Value: Boolean);
    procedure SetTextAligns(AColumn, ARow: Integer; const Value: TTMSFNCGraphicsTextAlign);
    procedure SetTextAngles(AColumn, ARow: Integer; const Value: Double);
    procedure SetTopRow(const Value: Integer);
    procedure SetVerticalScrollBarVisible(const Value: Boolean);
    procedure SetVerticalTextAligns(AColumn, ARow: Integer; const Value: TTMSFNCGraphicsTextAlign);
    procedure SetVScrollValue(AValue: Single);
    procedure SetWordWrapping(AColumn, ARow: Integer; const Value: Boolean);
    function GetFilterDialog: TTMSFNCFilterDialog;
    function GetRowIndex(ARow: Integer): Integer;
    procedure SetRowIndex(ARow: Integer; const Value: Integer);
  protected
    function DataGetItemIndex: Integer;
    procedure DataSetItemIndex(AValue: Integer);

    function CheckRange(ARange: TTMSFNCDataGridCellItemTypeRange; ARow: Integer): Boolean; virtual;
    function CloseInplaceEditor(ACancel: Boolean; AFlagClose: Boolean = False; AEnterKey: Boolean = False): Boolean; virtual;
    function ColumnStretchingActive: Boolean;
    function ConfigureScrollBarsRect(ARect: TRectF): TRectF;
    function CreateFilterEditor(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCellControl; virtual;
    function DoCreateCustomFilterEditor(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCellControl; virtual;
    function DoIsDesigntimeGrid(Sender: TObject): Boolean;
    function DoIsDestroyingGrid(Sender: TObject): Boolean;
    function DoIsFocusedGrid(Sender: TObject): Boolean;
    function DoIsLoadingGrid(Sender: TObject): Boolean;
    function GetBaseCellClass(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCellClass;
    function GetBooleans(AColumn, ARow: Integer): Boolean; override;
    function GetCalculationRect: TRectF; virtual;
    function GetCellAppearance(AState: TTMSFNCDataGridCellState; ACell: TTMSFNCDataGridCellCoord; ASkipCellLayout: Boolean = False): TTMSFNCDataGridCellLayout;
    function GetCellState(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCellState; virtual;
    function GetColumn(AColumn: Integer): TTMSFNCDataGridColumn; virtual;
    function GetColumnsClass: TTMSFNCDataGridColumnsClass; virtual;
    function GetColumnFilterName(AColumn: Integer): string; override;
    function GetColumnViewPortSize: Double;
    function GetContentRect: TRectF; override;
    function GetFullRect: TRectF; virtual;
    function GetHintString: string; virtual;
    function GetHorizontalScrollBar: TScrollBar;
    function GetHorizontalScrollPosition: Double; override;
    function GetHVisible: Boolean;
    function GetInplaceEditor: TTMSFNCDataGridInplaceEditor;
    function GetInplaceEditorRect(ACell: TTMSFNCDataGridCellCoord): TRectF;
    function GetOptionsClass: TTMSFNCDataGridDataOptionsClass; override;
    function GetPageScrollSize: Integer;
    function GetRowViewPortSize: Double;
    function GetSelectedCellCount: Integer;
    function GetSelectedColumnCount: Integer;
    function GetSelectedRowCount: Integer;
    function GetSelection: TTMSFNCDataGridCellCoordRange; override;
    function GetVerticalScrollBar: TScrollBar;
    function GetVerticalScrollPosition: Double; override;
    function GetVVisible: Boolean;
    function HasHint: Boolean; virtual;
    function IsBlocked: Boolean; override;
    function IsDesigntime: Boolean;
    function IsFocused: Boolean;
    function LocalRect: TRectF; override;
    function NeedsItemExtended(ACell: TTMSFNCDataGridCellCoord): Boolean; override;
    function OnlyLastFullVisibleRow: Boolean; override;
    function ProcessEnterKey(ACell: TTMSFNCDataGridCellCoord; AKeyHandling: TTMSFNCDataGridEnterKeyHandling): TTMSFNCDataGridCellCoord; virtual;
    function RowStretchingActive: Boolean;
    function SavetoHTMLString(ARange: TTMSFNCDataGridCellCoordRange; AImageDirectory: string = ''): string;

    procedure Animate(Sender: TObject);
    procedure ApplyFilterFromValue(AColumn: Integer; AValue: TTMSFNCDataGridCellValue; AType: TTMSFNCDataGridDataFilterType);
    procedure ApplyFilterFromBuilder;
    procedure ApplyCellScale(ACell: TTMSFNCDataGridCell; AScale: Single);
    {$IFDEF FMXLIB}
    procedure ApplyInplaceEditorStyleLookup(Sender: TObject);
    {$ENDIF}
    procedure AddCellToDisplay(ACell: TTMSFNCDataGridCell; ADisplay: TTMSFNCDataGridDisplayList);
    procedure BuildDisplay(AList: TTMSFNCDataGridCellList; ADisplay: TTMSFNCDataGridDisplayList);
    procedure CellAppearanceChanged(Sender: TObject);
    procedure ConfigureCell(ACell: TTMSFNCDataGridCell; AMode: TTMSFNCDataGridCellConfigureMode = gccmBoth); virtual;
    procedure ConfigureLayout(ACell: TTMSFNCDataGridCellCoord; ALayout: TTMSFNCDataGridCellLayout; ASkipCellLayout: Boolean = False); virtual;
    procedure CopyColumnDataTo(AColumn, ADestinationColumn: Integer; ADestination: TTMSFNCDataGridData); override;
    procedure DeleteColumnData(AColumn: Integer); override;
    procedure DeleteRowData(ARow: Integer); override;
    procedure DestroyEditor;
    procedure DoAfterApplyFilter(AColumn: Integer; ACondition: string); virtual;
    procedure DoAfterCloseInplaceEditor(ACell: TTMSFNCDataGridCellCoord; ACancelled: Boolean; AValue: TTMSFNCDataGridCellValue); virtual;
    procedure DoAfterCopyToClipboard; virtual;
    procedure DoAfterCreateFilterEditor(ACell: TTMSFNCDataGridCellCoord; AEditor: TTMSFNCDataGridCellControl); virtual;
    procedure DoAfterCutToClipboard; virtual;
    procedure DoAfterDrawEmptySpace(AGraphics: TTMSFNCGraphics; ARect: TRectF; AKind: TTMSFNCDataGridEmptySpaceKind); virtual;
    procedure DoAfterDrawGrid(AGraphics: TTMSFNCGraphics; ARect: TRectF); virtual;
    procedure DoAfterLookup(ALookupString: string); virtual;
    procedure DoAfterOpenInplaceEditor(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; AValue: TTMSFNCDataGridCellValue); virtual;
    procedure DoAfterPasteFromClipboard; virtual;
    procedure DoAfterShowFilter(AColumn: Integer); virtual;
    procedure DoAfterShowFilterDialog(AFilterDialog: TTMSFNCFilterDialog); virtual;
    procedure DoAfterShowFindDialog(AFindDialog: TTMSFNCFindDialog); virtual;
    procedure DoAfterShowReplaceDialog(AReplaceDialog: TTMSFNCReplaceDialog); virtual;
    procedure DoAfterSortColumn(AColumn: Integer); virtual;
    procedure DoAppendColumn(AColumn: Integer); virtual;
    procedure DoAppendRow(ARow: Integer); virtual;
    procedure DoBeforeApplyFilter(AColumn: Integer; var ACondition: string; var ACanApply: Boolean); virtual;
    procedure DoBeforeCloseInplaceEditor(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; ACancelled: Boolean; var AValue: TTMSFNCDataGridCellValue; var ACanClose: Boolean); virtual;
    procedure DoBeforeCopyToClipboard(var ACanCopy: Boolean); virtual;
    procedure DoBeforeCreateFilterEditor(ACell: TTMSFNCDataGridCellCoord; var ACanCreate: Boolean); virtual;
    procedure DoBeforeCutToClipboard(var ACanCut: Boolean); virtual;
    procedure DoBeforeDrawEmptySpace(AGraphics: TTMSFNCGraphics; ARect: TRectF; AKind: TTMSFNCDataGridEmptySpaceKind; var ACanDraw: Boolean); virtual;
    procedure DoBeforeLookup(var ALookupString: string; var ACanLookup: Boolean); virtual;
    procedure DoBeforeOpenInplaceEditor(ACell: TTMSFNCDataGridCellCoord; var AValue: TTMSFNCDataGridCellValue; var ACanOpen: Boolean); virtual;
    procedure DoBeforePasteFromClipboard(var ACanPaste: Boolean); virtual;
    procedure DoBeforeShowFilter(AColumn: Integer; var ACanShow: Boolean); virtual;
    procedure DoBeforeShowFilterDialog(AFilterDialog: TTMSFNCFilterDialog; var ACanShow: Boolean); virtual;
    procedure DoBeforeShowFindDialog(AFindDialog: TTMSFNCFindDialog; var ACanShow: Boolean); virtual;
    procedure DoBeforeShowReplaceDialog(AReplaceDialog: TTMSFNCReplaceDialog; var ACanShow: Boolean); virtual;
    procedure DoBeforeSortColumn(AColumn: Integer; var ACanSort: Boolean); virtual;
    procedure DoCanAppendColumn(AColumn: Integer; var ACanAppend: Boolean); virtual;
    procedure DoCanAppendRow(ARow: Integer; var ACanAppend: Boolean); virtual;
    procedure DoCanDeleteColumn(AColumn: Integer; var ACanDelete: Boolean); virtual;
    procedure DoCanDeleteRow(ARow: Integer; var ACanDelete: Boolean); virtual;
    procedure DoCanDragColumn(AColumn: Integer; var ACanDrag: Boolean); virtual;
    procedure DoCanDragRow(ARow: Integer; var ACanDrag: Boolean); virtual;
    procedure DoCanDropColumn(AFromColumn, AToColumn: Integer; var ACanDrop: Boolean); virtual;
    procedure DoCanDropRow(AFromRow, AToRow: Integer; var ACanDrop: Boolean); virtual;
    procedure DoCanEditCell(AColumn, ARow: Integer; var ACanEdit: Boolean); virtual;
    procedure DoCanInsertColumn(AColumn: Integer; var ACanInsert: Boolean); virtual;
    procedure DoCanInsertRow(ARow: Integer; var ACanInsert: Boolean); virtual;
    procedure DoCanSizeColumn(AColumn: Integer; var ASize: Double; var ACanSize: Boolean); virtual;
    procedure DoCanSizeRow(ARow: Integer; var ASize: Double; var ACanSize: Boolean); virtual;
    procedure DoCellAfterDraw(Sender: TObject; AGraphics: TTMSFNCGraphics); virtual;
    procedure DoCellAfterNodeCollapse(ACell: TTMSFNCDataGridCellCoord); virtual;
    procedure DoCellAfterNodeExpand(ACell: TTMSFNCDataGridCellCoord); virtual;
    procedure DoCellAnchorClick(AColumn, ARow: Integer; AAnchor: string); virtual;
    procedure DoCellBeforeDraw(Sender: TObject; AGraphics: TTMSFNCGraphics; var ACanDraw: Boolean); virtual;
    procedure DoCellBeforeNodeCollapse(ACell: TTMSFNCDataGridCellCoord; var ACanCollapse: Boolean); virtual;
    procedure DoCellBeforeNodeExpand(ACell: TTMSFNCDataGridCellCoord; var ACanExpand: Boolean); virtual;
    procedure DoCellBeforeShowPopupMenu(ACell: TTMSFNCDataGridCellCoord; APopupMenu: TPopupMenu; var ACanShow: Boolean); virtual;
    procedure DoCellButtonClick(Sender: TObject);
    procedure DoCellCheckChange(Sender: TObject);
    procedure DoCellClick(ACell: TTMSFNCDataGridCellCoord; AMouseInfo: TTMSFNCDataGridMouseInfo); virtual;
    procedure DoCellCommentIndicatorClick(Sender: TObject);
    procedure DoCellDblClick(AColumn, ARow: Integer); virtual;
    procedure DoCellEditGetData(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AValue: TTMSFNCDataGridCellValue); virtual;
    procedure DoCellEditSetData(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AValue: TTMSFNCDataGridCellValue); virtual;
    procedure DoCellEditValidateData(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AValue: TTMSFNCDataGridCellValue; var AValid: Boolean); virtual;
    procedure DoCellFilterButtonClick(Sender: TObject);
    procedure DoCellNodeCollapse(Sender: TObject);
    procedure DoCellNodeExpand(Sender: TObject);
    procedure DoCellRightClick(AColumn, ARow: Integer); virtual;
    procedure DoColumnDropped(AFromColumn, AToColumn: Integer); virtual;
    procedure DoColumnsChanged(Sender: TObject);
    procedure DoColumnSized(AColumn: Integer; ASize: Double); virtual;
    procedure DoCustomizeFilterPopupEditor(AColumn: Integer; var AEditor: TTMSFNCDataGridCellControl); virtual;
    procedure DoDeleteColumn(AColumn: Integer); virtual;
    procedure DoDeleteRow(ARow: Integer); virtual;
    procedure DoDisplay;
    procedure DoDisplayGrid(Sender: TObject);
    procedure DoDragTimer(Sender: TObject);
    procedure DoEditorExit(Sender: TObject);
    procedure DoEditorKeyDown(Sender: TObject; var Key: Word; {$IFDEF FMXLIB}var KeyChar: WideChar; {$ENDIF}Shift: TShiftState);
    procedure DoFilterBuilderApplyButtonClicked(Sender: TObject; AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean);
    procedure DoFilterBuilderClose(Sender: TObject);
    procedure DoLayoutChanged(Sender: TObject);
    procedure IconsChanged(Sender: TObject);
    {$IFNDEF FMXLIB}
    procedure DoEditorKeyPress(Sender: TObject; var Key: Char);
    {$ENDIF}
    procedure DoEditorKeyUp(Sender: TObject; var Key: Word; {$IFDEF FMXLIB}var KeyChar: WideChar; {$ENDIF}Shift: TShiftState);
    {$IFDEF FMXLIB}
    procedure DoFilterEditApplyStyleLookup(Sender: TObject);
    {$ENDIF}
    procedure BeginDrag;
    procedure DoDropFiles(ADropFiles: TTMSFNCCustomControlDropFiles); virtual;
    procedure DoFilterClearClick(Sender: TObject);
    procedure DoFilterEditChange(Sender: TObject);
    procedure DoFilterEnter(Sender: TObject);
    procedure DoFilterExitTimer(Sender: TObject);
    procedure DoFilterListBoxItemCheckChanged(Sender: TObject; AItem: TTMSFNCCheckedListBoxItem);
    procedure DoFilterSortClick(Sender: TObject);
    procedure DoFilterTimer(Sender: TObject);
    procedure DoFilterTypeChange(Sender: TObject);
    procedure DoFind(Sender: TObject; AFindText: string; var AFound: Boolean); virtual;
    procedure DoFindNext(Sender: TObject; AFindText: string; var AFound: Boolean); virtual;
    procedure DoFocusGrid(Sender: TObject);
    procedure DoCalculateGrid(Sender: TObject);
    procedure DoBeforeCalculateGrid(Sender: TObject);
    procedure DoGetCellClass(AColumn, ARow: Integer; var ACellClass: TTMSFNCDataGridCellClass); virtual;
    procedure DoGetCellFormatting(ACell: TTMSFNCDataGridCellCoord; AData: TTMSFNCDataGridCellValue; var AFormatting: TTMSFNCDataGridDataFormatting; var AConvertSettings: TFormatSettings; var ACanFormat: Boolean); override;
    procedure DoGetCellHint(ACell: TTMSFNCDataGridCellCoord; var AHint: string); virtual;
    procedure DoGetCellLayout(ACell: TTMSFNCDataGridCell); virtual;
    procedure DoGetCellLayoutHasPriority(ACell: TTMSFNCDataGridCellCoord; var AHasPriority: Boolean); virtual;
    procedure DoGetCellProperties(ACell: TTMSFNCDataGridCell); virtual;
    procedure DoGetInplaceEditorClass(ACell: TTMSFNCDataGridCellCoord; var AInplaceEditorClass: TTMSFNCDataGridInplaceEditorClass); virtual;
    procedure DoGetInplaceEditorProperties(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; AInplaceEditorType: TTMSFNCDataGridInplaceEditorType); virtual;
    procedure DoGetInplaceEditorRect(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AInplaceEditorRect: TRectF); virtual;
    procedure DoGetInplaceEditorTarget(ACell: TTMSFNCDataGridCellCoord; var AInplaceEditorTarget: TTMSFNCDataGridInplaceEditorTarget); virtual;
    procedure DoGetInplaceEditorType(ACell: TTMSFNCDataGridCellCoord; var AInplaceEditorType: TTMSFNCDataGridInplaceEditorType); virtual;
    procedure DoGetSortOptions(AColumn: Integer; ALevel: Integer; var AOptions: TTMSFNCDataGridDataSortOptions); override;
    procedure DoHScroll(APosition: Single); virtual;
    procedure DoInsertColumn(AColumn: Integer); virtual;
    procedure DoInsertRow(ARow: Integer); virtual;
    procedure DoLookupTimer(Sender: TObject);
    procedure DoNeedFilterDropDownData(AColumn: Integer; AValues: TStrings); virtual;
    procedure DoPaintCommentPopup(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF);
    procedure DoRemoveFilter(AColumn: Integer); virtual;
    procedure DoReplace(Sender: TObject; AFindText, AReplaceText: string); virtual;
    procedure DoReplaceAll(Sender: TObject; AFindText, AReplaceText: string); virtual;
    procedure DoReplaceFind(Sender: TObject; AReplaceText: string); virtual;
    procedure DoReplaceFindNext(Sender: TObject; AFindText: string); virtual;
    procedure DoRowDropped(AFromRow, AToRow: Integer); virtual;
    procedure DoRowSized(ARow: Integer; ASize: Double); virtual;
    procedure DoScrollTimer(Sender: TObject);
    procedure DoSelectCell(AStartCell, AEndCell: TTMSFNCDataGridCellCoord);
    procedure DoSelectingCell(AStartCell, AEndCell: TTMSFNCDataGridCellCoord; var ACanSelect: Boolean);
    procedure DoSizeColumn(AColumn: Integer; ASize: Double); virtual;
    procedure DoSizeRow(ARow: Integer; ASize: Double); virtual;
    procedure DoUpdateCursorGrid(Sender: TObject; ACursor: TCursor);
    procedure DoVScroll(APosition: Single); virtual;
    procedure DrawCell(AGraphics: TTMSFNCGraphics; ACache: TTMSFNCDataGridCell);
    procedure DrawDisplay(AGraphics: TTMSFNCGraphics; ADisplay: TTMSFNCDataGridDisplayList);
    procedure DrawDragging(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawEmptySpaces(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawScrollBars(AGraphics: TTMSFNCGraphics);
    procedure HandleDragDrop(const Source: TObject; const Point: TPointF); virtual;
    procedure HandleDragOver(const Source: TObject; const Point: TPointF; var Accept: Boolean); virtual;
    procedure HCustomScrollChanged(Sender: TObject; {%H-}AValue: Double);
    procedure HideDragCell;
    procedure HorizontalScrollPositionChanged; virtual;
    procedure HScrollChanged(Sender: TObject);
    procedure InternalAutoSizeColumn(AColumn: Integer; const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5; const AGraphics: TTMSFNCGraphics = nil);
    procedure InternalAutoSizeRow(ARow: integer; const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5; const AGraphics: TTMSFNCGraphics = nil);
    procedure InternalClear; override;
    procedure InternalMarkCells(AValue, ATag: string; ACaseSensitive: Boolean; AFromColumn, AFromRow, AToColumn, AToRow: Integer; AFullCell: Boolean = False);
    procedure InternalSaveToHTML(AFileName: string; AEncoding: TEncoding); virtual;
    procedure InternalSaveToHTMLStream(AStream: TStream; AEncoding: TEncoding; AImageDirectory: string = ''); virtual;
    procedure InternalSaveToImage(AFileName: string); virtual;
    procedure InternalSaveToImageStream(AStream: TStream); virtual;
    procedure InternalUnmarkCells(ATag: string; AFromColumn, AFromRow, AToColumn, AToRow: Integer);
    procedure MoveColumnData(AFromColumn, AToColumn: Integer); override;
    procedure MoveRowData(AFromRow, AToRow: Integer); override;
    procedure OptionsChanged(Sender: TObject);
    procedure OptionsChangedRebuild(Sender: TObject);
    procedure PaddingChanged(Sender: TObject);
    procedure ProcessTab(var AKeyInfo: TTMSFNCDataGridKeyInfo; Mode: TTMSFNCDataGridTabKeyDirection; Handling: TTMSFNCDataGridTabKeyHandling; DirectEdit: Boolean; CellStart: TTMSFNCDataGridEditCellStart = gcsNone);
    procedure RemoveCellControlFromCache(AColumn, ARow: Integer); override;
    procedure ResetColumnWidths;
    procedure ResetRowHeights;
    procedure ResetScrollBarCapture;
    procedure SetBooleans(AColumn, ARow: Integer; const Value: Boolean); override;
    procedure SetClipRect(ARect: TRectF);
    procedure SetFocusCell(ACol, ARow: Integer);
    procedure SetFonts(ASetType: TTMSFNCAppearanceGlobalFontType);
    procedure SetLayout(ACell: TTMSFNCDataGridCell); virtual;
    procedure SetProperties(ACell: TTMSFNCDataGridCell); virtual;
    procedure SetStartCell(AColumn, ARow: Integer);
    procedure SetStopCell(AColumn, ARow: Integer);
    procedure StopAnimationTimer;
    procedure SwapColumnData(AFromColumn, AToColumn: Integer); override;
    procedure SwapRowData(AFromRow, AToRow: Integer); override;
    procedure SynchronizeColumns(ACollectionUpdate: Boolean = False); override;
    procedure UpdateAutoSizing;
    procedure UpdateCursor(ACursor: TCursor);
    procedure UpdateFilterList(AColumn: Integer);
    procedure UpdateInplaceEditorPosition;
    procedure UpdateScrollBars(AUpdate: Boolean = True; ACalculate: Boolean = True);
    procedure VCustomScrollChanged(Sender: TObject; {%H-}AValue: Double);
    procedure VerticalScrollPositionChanged; virtual;
    procedure VScrollChanged(Sender: TObject);
    procedure WidthChanged(AColumn: Integer); override;
    procedure VisibilityChanged(AColumn: Integer); override;
    property AnimateTimer: TTimer read GetAnimateTimer;
    property BlockScrollingUpdate: Boolean read FBlockScrollingUpdate write FBlockScrollingUpdate;
    property ControlWrapperList: TTMSFNCDataGridCellControlWrapperList read GetControlWrapperList;
    property DraggingMode: TTMSFNCDataGridDraggingMode read FDraggingMode;
    property DragTimer: TTimer read GetDragTimer;
    property FilterExitTimer: TTimer read GetFilterExitTimer;
    property FilterTimer: TTimer read GetFilterTimer;
    property LookupTimer: TTimer read GetLookupTimer;
    property OnAfterCloseInplaceEditorInternal: TTMSFNCDataGridAfterCloseInplaceEditorEvent read FOnAfterCloseInplaceEditorInternal write FOnAfterCloseInplaceEditorInternal;
    property SaveLeft: Single read FSaveLeft write FSaveLeft;
    property SaveTop: Single read FSaveTop write FSaveTop;
    property ScrollTimer: TTimer read GetScrollTimer;
    property SelectedCellDictionary: TTMSFNCDataGridSelectedCellDictionary read GetSelectedCellDictionary;
    property SelectedColumnDictionary: TTMSFNCDataGridBooleanDictionary read GetSelectedColumnDictionary;
    property SelectedRowDictionary: TTMSFNCDataGridBooleanDictionary read GetSelectedRowDictionary;
  public
    constructor Create(AHost: TObject = nil); reintroduce; virtual;
    destructor Destroy; override;
    function AddGrid(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridRenderer; overload;
    function AddGrid(AColumn, ARow: Integer): TTMSFNCDataGridRenderer; overload;
    function CancelEditing: Boolean;
    function CanRegisterRuntimeClasses: Boolean; override;
    function ColumnByHeader(AHeader: string): TTMSFNCDataGridColumn;
    function ColumnByName(AName: string): TTMSFNCDataGridColumn;
    function ColumnIndexByHeader(AHeader: string): Integer;
    function ColumnIndexByName(AName: string): Integer;
    function CreateCell(ARect: TRectF; ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCell; overload;
    function CreateCell(ARect: TRectF; AColumn: Integer; ARow: Integer): TTMSFNCDataGridCell; overload;
    function GetCellObjectForCell(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCell;
    function GetFilterTypeName(AType: TTMSFNCDataGridDataFilterType): string;
    function GetHMax: Single;
    function GetHScrollValue: Single;
    function GetHViewPortSize: Single;
    function GetIsDestroying: Boolean; override;
    function GetIsLoading: Boolean; override;
    function GetPageIndexForRow(ARow: Integer): Integer;
    function GetParentHost: TTMSFNCDataGridCellParent;
    function GetVMax: Single;
    function GetVScrollValue: Single;
    function GetVViewPortSize: Single;
    function HasCustomScrollBars: Boolean;
    function HasValidHost: Boolean;
    function HilightText(ACaseSensitive: Boolean; AValue, AText: string): string;
    function IsCellDisplayList(ADisplay: TTMSFNCDataGridDisplayList): Boolean;
    function IsCellReadOnly(ACell: TTMSFNCDataGridCellCoord): Boolean;
    function IsCellSelected(ACell: TTMSFNCDataGridCellCoord): Boolean;
    function IsRowBand(ARow: Integer): Boolean;
    function IsEditing: Boolean;
    function IsFixedCellSelected(ACell: TTMSFNCDataGridCellCoord): Boolean;
    function Lookup(AValue: string; AAllRows: Boolean = False; AAutoGoto: Boolean = False): TTMSFNCDataGridCellCoord;
    function LookupInColumn(AColumn: Integer; AValue: string; AAllRows: Boolean = False; AAutoGoto: Boolean = False): TTMSFNCDataGridCellCoord;
    function LookupInColumnFromRow(AColumn, ARow: Integer; AValue: string; AAllRows: Boolean = False; AAutoGoto: Boolean = False): TTMSFNCDataGridCellCoord;
    function MarkText(ACaseSensitive: Boolean; AValue, AText: string): string;
    function NextSelectableColumn(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
    function NextSelectableRow(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
    function NextVisibleColumn(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
    function NextVisibleRow(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
    function PreviousSelectableColumn(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
    function PreviousSelectableRow(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
    function PreviousVisibleColumn(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
    function PreviousVisibleRow(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
    function SetGrid(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridRenderer; overload;
    function SetGrid(AColumn, ARow: Integer): TTMSFNCDataGridRenderer; overload;
    function StopEditing: Boolean;
    function UnhilightText(ACaseSensitive: Boolean; AValue: string): string;
    function UnmarkText(AValue: string): string;
    function XYToCell(X, Y: Double): TTMSFNCDataGridCellCoord;
    function XYToColumn(X, Y: Double): Integer;
    function XYToRenderer(X, Y: Double): TTMSFNCDataGridRenderer;
    function XYToRow(X, Y: Double): Integer;
    procedure &Export(AGraphics: TTMSFNCGraphics); overload; virtual;
    procedure &Export(AGraphics: TTMSFNCGraphics; ARect: TRectF; ASelection: TTMSFNCDataGridCellCoordRange; ARepeatFixedColumns: Boolean = False; ARepeatFixedRows: Boolean = False; AFitToPage: Boolean = True; ASkipSaveBounds: Boolean = False; AScale: Single = 1.0; AOnNewPage: TTMSFNCDataGridRendererExportNewPageCallback = nil; AOnGetPageIndex: TTMSFNCDataGridRendererExportGetPageIndexCallback = nil); overload; virtual;
    procedure AddBitmap(ACell: TTMSFNCDataGridCellCoord; ABitmap: TTMSFNCBitmap); overload;
    procedure AddBitmap(ACell: TTMSFNCDataGridCellCoord; AName: string); overload;
    procedure AddBitmap(AColumn, ARow: Integer; ABitmap: TTMSFNCBitmap); overload;
    procedure AddBitmap(AColumn, ARow: Integer; AName: string); overload;
    procedure AddBitmapColumn(AColumn: Integer; ABitmap: TTMSFNCBitmap); overload;
    procedure AddBitmapColumn(AColumn: Integer; AName: string); overload;
    procedure AddButton(ACell: TTMSFNCDataGridCellCoord; AText: string = ''); overload;
    procedure AddButton(AColumn, ARow: Integer; AText: string = ''); overload;
    procedure AddButtonColumn(AColumn: Integer; AText: string = '');
    procedure AddCheckBox(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False); overload;
    procedure AddCheckBox(AColumn, ARow: Integer; AValue: Boolean = False); overload;
    procedure AddCheckBoxColumn(AColumn: Integer; AValue: Boolean = False);
    procedure AddDataCheckBox(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure AddDataCheckBox(AColumn, ARow: Integer); overload;
    procedure AddDataCheckBoxColumn(AColumn: Integer);
    procedure AddDataProgressBar(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure AddDataProgressBar(AColumn, ARow: Integer); overload;
    procedure AddDataProgressBarColumn(AColumn: Integer);
    procedure AddDataRadioButton(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False; AGroupIndex: Integer = 0); overload;
    procedure AddDataRadioButton(AColumn, ARow: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0); overload;
    procedure AddDataRadioButtonColumn(AColumn: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0);
    procedure AddFilterEditor(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure AddFilterEditor(AColumn, ARow: Integer); overload;
    procedure AddProgressBar(ACell: TTMSFNCDataGridCellCoord; AValue: Integer = 0); overload;
    procedure AddProgressBar(AColumn, ARow: Integer; AValue: Integer = 0); overload;
    procedure AddProgressBarColumn(AColumn: Integer; AValue: Integer = 0);
    procedure AddRadioButton(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False; AGroupIndex: Integer = 0); overload;
    procedure AddRadioButton(AColumn, ARow: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0); overload;
    procedure AddRadioButtonColumn(AColumn: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0);
    procedure AfterExport; override;
    procedure ApplyExportScale(AScale: Single); virtual;
    procedure ApplyStyle; virtual;
    procedure Assign(Source: TPersistent); override;
    procedure AutoSizeColumn(AColumn: Integer; const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5);
    procedure AutoSizeColumns(const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5);
    procedure AutoSizeGrid(const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APaddingColumn: Integer = 5; const APaddingRow: Integer = 5);
    procedure AutoSizeRow(ARow: Integer; const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5);
    procedure AutoSizeRows(const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5);
    procedure BeforeExport; override;
    procedure Calculate;
    procedure ChangeDPIScale(M, D: Integer);
    procedure ClearColumns;
    procedure ClearControlCache;
    procedure ClearFocus;
    procedure ClearSelection;
    procedure CloseColumnsEditor;
    procedure CloseFilterPopup;
    procedure CopyToClipboard(ASelectedCells: Boolean = True);
    procedure CreateDragBitmap(AMouseInfo: TTMSFNCDataGridMouseInfo);
    procedure CutToClipboard(ASelectedCells: Boolean = True);
    procedure DestroyDragBitmap;
    procedure Display;
    procedure Draw(AGraphics: TTMSFNCGraphics); virtual;
    procedure EditCell(ACell: TTMSFNCDataGridCellCoord; ACellStart: TTMSFNCDataGridEditCellStart = gcsNone; AInsertKey: Boolean = False; AValue: string = ''; AKey: Word = 0); virtual;
    procedure ExportNotification(AState: TTMSFNCDataGridExportState; ARow: Integer); override;
    procedure FirstPage;
    procedure Focus;
    procedure GoToCell(ACell: TTMSFNCDataGridCellCoord; ASelect: Boolean = True); override;
    procedure GoToPage(APageIndex: Integer);
    procedure HandleDragBitmapDrop(AMouseInfo: TTMSFNCDataGridMouseInfo); virtual;
    procedure HandleDragBitmapOver(AMouseInfo: TTMSFNCDataGridMouseInfo); virtual;
    procedure HandleDragBitmapStart(AMouseInfo: TTMSFNCDataGridMouseInfo); virtual;
    procedure HandleDragEnd(AMouseInfo: TTMSFNCDataGridMouseInfo);
    procedure HandleDragging(AMouseInfo: TTMSFNCDataGridMouseInfo); virtual;
    procedure HandleEnter;
    procedure HandleExit;
    procedure HandleKey(var AKeyInfo: TTMSFNCDataGridKeyInfo);
    procedure HandleMouse(var AMouseInfo: TTMSFNCDataGridMouseInfo); virtual;
    procedure HilightCells(AHilightText: string; AOptions: TTMSFNCDataGridHilightOptions);
    procedure LastPage;
    procedure MarkCells(AHilightText: string; AOptions: TTMSFNCDataGridMarkOptions); overload;
    procedure Navigate(ACell: TTMSFNCDataGridCellCoord; AForceScroll: Boolean = False; AIgnoreColumn: Boolean = False; AIgnoreRow: Boolean = False);
    procedure NextPage;
    procedure PasteFromClipboard;
    procedure PreviousPage;
    procedure RegisterRuntimeClasses; override;
    procedure RemoveBitmap(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveBitmap(AColumn, ARow: Integer); overload;
    procedure RemoveButton(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveButton(AColumn, ARow: Integer); overload;
    procedure RemoveCheckBox(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveCheckBox(AColumn, ARow: Integer); overload;
    procedure RemoveDataCheckBox(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveDataCheckBox(AColumn, ARow: Integer); overload;
    procedure RemoveDataProgressBar(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveDataProgressBar(AColumn, ARow: Integer); overload;
    procedure RemoveDataRadioButton(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveDataRadioButton(AColumn, ARow: Integer); overload;
    procedure RemoveFilterEditor(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveFilterEditor(AColumn, ARow: Integer); overload;
    procedure RemoveGrid(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveGrid(AColumn, ARow: Integer); overload;
    procedure RemoveLayout(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveLayout(AColumn, ARow: Integer); overload;
    procedure RemoveProgressBar(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveProgressBar(AColumn, ARow: Integer); overload;
    procedure RemoveRadioButton(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure RemoveRadioButton(AColumn, ARow: Integer); overload;
    procedure ResetExportScale; virtual;
    procedure ResetToDefaultStyle; virtual;
    procedure RestoreScrollPosition;
    procedure ResetDrag;
    procedure SaveScrollPosition;
    procedure SaveToHTMLData(AFileName: string); overload; virtual;
    procedure SaveToHTMLData(AFileName: string; AEncoding: TEncoding); overload; virtual;
    procedure SaveToHTMLStreamData(AStream: TStream); overload; virtual;
    procedure SaveToHTMLStreamData(AStream: TStream; AEncoding: TEncoding); overload; virtual;
    procedure SaveToImageData(AFileName: string); overload; virtual;
    procedure SaveToImageStreamData(AStream: TStream); overload; virtual;
    procedure Scroll(AHorizontalPos, AVerticalPos: Double);
    procedure SelectAllCells(AIncludeHidden: Boolean = True);
    procedure SelectCell(ACell: TTMSFNCDataGridCellCoord; AShift: TShiftState = []; AMouseDragging: Boolean = False); virtual;
    procedure SelectColumns(AFromColumn, AToColumn: Integer);
    procedure SelectRows(AFromRow, AToRow: Integer);
    procedure SetBitmap(ACell: TTMSFNCDataGridCellCoord; ABitmap: TTMSFNCBitmap); overload;
    procedure SetBitmap(ACell: TTMSFNCDataGridCellCoord; AName: string); overload;
    procedure SetBitmap(AColumn, ARow: Integer; ABitmap: TTMSFNCBitmap); overload;
    procedure SetBitmap(AColumn, ARow: Integer; AName: string); overload;
    procedure SetBitmapColumn(AColumn: Integer; ABitmap: TTMSFNCBitmap); overload;
    procedure SetBitmapColumn(AColumn: Integer; AName: string); overload;
    procedure SetButton(ACell: TTMSFNCDataGridCellCoord; AText: string = ''); overload;
    procedure SetButton(AColumn, ARow: Integer; AText: string = ''); overload;
    procedure SetButtonColumn(AColumn: Integer; AText: string = '');
    procedure SetCheckBox(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False); overload;
    procedure SetCheckBox(AColumn, ARow: Integer; AValue: Boolean = False); overload;
    procedure SetCheckBoxColumn(AColumn: Integer; AValue: Boolean = False);
    procedure SetDataCheckBox(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure SetDataCheckBox(AColumn, ARow: Integer); overload;
    procedure SetDataCheckBoxColumn(AColumn: Integer);
    procedure SetDataProgressBar(ACell: TTMSFNCDataGridCellCoord); overload;
    procedure SetDataProgressBar(AColumn, ARow: Integer); overload;
    procedure SetDataProgressBarColumn(AColumn: Integer);
    procedure SetDataRadioButton(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False; AGroupIndex: Integer = 0); overload;
    procedure SetDataRadioButton(AColumn, ARow: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0); overload;
    procedure SetDataRadioButtonColumn(AColumn: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0);
    procedure SetLocalRect(ARect: TRectF); override;
    procedure SetProgressBar(ACell: TTMSFNCDataGridCellCoord; AValue: Integer = 0); overload;
    procedure SetProgressBar(AColumn, ARow: Integer; AValue: Integer = 0); overload;
    procedure SetProgressBarColumn(AColumn: Integer; AValue: Integer = 0);
    procedure SetRadioButton(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False; AGroupIndex: Integer = 0); overload;
    procedure SetRadioButton(AColumn, ARow: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0); overload;
    procedure SetRadioButtonColumn(AColumn: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0);
    procedure ShowColumnsEditor;
    procedure ShowFilterDialog;
    procedure ShowFindDialog;
    procedure ShowReplaceDialog;
    procedure StartDragging(AMouseInfo: TTMSFNCDataGridMouseInfo; ACanStartDrag: Boolean);
    procedure UnhilightCells(AOptions: TTMSFNCDataGridHilightOptions);
    procedure UnmarkCells(AOptions: TTMSFNCDataGridMarkOptions); overload;
    procedure Update; override;
    procedure UpdateBounds; virtual;
    property BitmapContainer: TTMSFNCBitmapContainer read GetBitmapContainer write SetBitmapContainer;
    property BitmapNames[AColumn, ARow: Integer]: string read GetBitmapNames;
    property Bitmaps[AColumn, ARow: Integer]: TTMSFNCBitmap read GetBitmaps;
    property BottomRow: Integer read GetBottomRow;
    property CellPopupMenu: TPopupMenu read FCellPopupMenu write FCellPopupMenu;
    property Colors[AColumn, ARow: Integer]: TTMSFNCGraphicsColor read GetColors write SetColors;
    property ColumnsEditor: TObject read GetColumnsEditor;
    property CommentPopup: TTMSFNCCommentPopup read GetCommentPopup;
    property Comments[AColumn, ARow: Integer]: string read GetComments write SetComments;
    property ControlAligns[AColumn, ARow: Integer]: TTMSFNCDataGridCellControlAlign read GetControlAligns write SetControlAligns;
    property ControlHeights[AColumn, ARow: Integer]: Integer read GetControlHeights write SetControlHeights;
    property ControlMargins[AColumn, ARow: Integer]: TTMSFNCMargins read GetControlMargins;
    property ControlPositions[AColumn, ARow: Integer]: TTMSFNCDataGridCellControlPosition read GetControlPositions write SetControlPositions;
    property ControlTexts[AColumn, ARow: Integer]: string read GetControlTexts write SetControlTexts;
    property ControlWidths[AColumn, ARow: Integer]: Integer read GetControlWidths write SetControlWidths;
    property CustomHorizontalScrollBar: TTMSFNCDataGridScrollBar read GetCustomHorizontalScrollBar;
    property CustomVerticalScrollBar: TTMSFNCDataGridScrollBar read GetCustomVerticalScrollBar;
    property DragCell: TTMSFNCDataGridCellCoord read FDragCell;
    property EditingCell: TTMSFNCDataGridCellCoord read FEditingCell;
    property FilterDialog: TTMSFNCFilterDialog read GetFilterDialog;
    property FilterClearButton: TTMSFNCToolBarButton read GetFilterClearButton;
    property FilterContainer: TTMSFNCCustomControl read GetFilterContainer;
    property FilterEdit: TTMSFNCEdit read GetFilterEdit;
    property FilterEditors[AColumn, ARow: Integer]: TTMSFNCDataGridCellControl read GetFilterEditors;
    property FilterListBox: TTMSFNCCheckedListBox read GetFilterListBox;
    property FilterPopup: TTMSFNCPopup read GetFilterPopup;
    property FilterSortAscendingButton: TTMSFNCToolBarButton read GetFilterSortAscendingButton;
    property FilterSortDescendingButton: TTMSFNCToolBarButton read GetFilterSortDescendingButton;
    property FilterTypeComboBox: TComboBoxSafe read GetFilterTypeComboBox;
    property FindDialog: TTMSFNCFindDialog read GetFindDialog;
    property FocusedCell: TTMSFNCDataGridCellCoord read GetFocusedCell write SetFocusedCell;
    property FontColors[AColumn, ARow: Integer]: TTMSFNCGraphicsColor read GetFontColors write SetFontColors;
    property FontNames[AColumn, ARow: Integer]: string read GetFontNames write SetFontNames;
    property FontSizes[AColumn, ARow: Integer]: Single read GetFontSizes write SetFontSizes;
    property FontStyles[AColumn, ARow: Integer]: TFontStyles read GetFontStyles write SetFontStyles;
    property Grids[AColumn, ARow: Integer]: TTMSFNCDataGridRenderer read GetGrids;
    property HasBitmap[AColumn, ARow: Integer]: Boolean read GetHasBitmap;
    property HasButton[AColumn, ARow: Integer]: Boolean read GetHasButton;
    property HasCheckBox[AColumn, ARow: Integer]: Boolean read GetHasCheckBox;
    property HasDataCheckBox[AColumn, ARow: Integer]: Boolean read GetHasDataCheckBox;
    property HasDataProgressBar[AColumn, ARow: Integer]: Boolean read GetHasDataProgressBar;
    property HasDataRadioButton[AColumn, ARow: Integer]: Boolean read GetHasDataRadioButton;
    property HasFilterEditor[AColumn, ARow: Integer]: Boolean read GetHasFilterEditor;
    property HasGrid[AColumn, ARow: Integer]: Boolean read GetHasGrid;
    property HasLayout[AColumn, ARow: Integer]: Boolean read GetHasLayout;
    property HasProgressBar[AColumn, ARow: Integer]: Boolean read GetHasProgressBar;
    property HasRadioButton[AColumn, ARow: Integer]: Boolean read GetHasRadioButton;
    property Hints[AColumn, ARow: Integer]: string read GetHints write SetHints;
    property HorizontalScrollBar: TScrollBar read GetHorizontalScrollBar;
    property Host: TObject read FHost;
    property InplaceEditor: TTMSFNCDataGridInplaceEditor read GetInplaceEditor;
    property IsMouseDown: Boolean read FIsMouseDown write FIsMouseDown;
    property Layouts[AColumn, ARow: Integer]: TTMSFNCDataGridCellLayout read GetLayouts;
    property LeftColumn: Integer read GetLeftColumn write SetLeftColumn;
    property OnAfterApplyFilter: TTMSFNCDataGridAfterApplyFilterEvent read FOnAfterApplyFilter write FOnAfterApplyFilter;
    property OnAfterCloseInplaceEditor: TTMSFNCDataGridAfterCloseInplaceEditorEvent read FOnAfterCloseInplaceEditor write FOnAfterCloseInplaceEditor;
    property OnAfterCopyToClipboard: TTMSFNCDataGridAfterClipboardEvent read FOnAfterCopyToClipboard write FOnAfterCopyToClipboard;
    property OnAfterCreateFilterEditor: TTMSFNCDataGridAfterCreateFilterEditorEvent read FOnAfterCreateFilterEditor write FOnAfterCreateFilterEditor;
    property OnAfterCutToClipboard: TTMSFNCDataGridAfterClipboardEvent read FOnAfterCutToClipboard write FOnAfterCutToClipboard;
    property OnAfterDrawCell: TTMSFNCDataGridAfterDrawCellEvent read FOnAfterDrawCell write FOnAfterDrawCell;
    property OnAfterDrawEmptySpace: TTMSFNCDataGridAfterDrawEmptySpaceEvent read FOnAfterDrawEmptySpace write FOnAfterDrawEmptySpace;
    property OnAfterDrawGrid: TTMSFNCDataGridAfterDrawGridEvent read FOnAfterDrawGrid write FOnAfterDrawGrid;
    property OnAfterLookup: TTMSFNCDataGridAfterLookupEvent read FOnAfterLookup write FOnAfterLookup;
    property OnAfterOpenInplaceEditor: TTMSFNCDataGridAfterOpenInplaceEditorEvent read FOnAfterOpenInplaceEditor write FOnAfterOpenInplaceEditor;
    property OnAfterPasteFromClipboard: TTMSFNCDataGridAfterClipboardEvent read FOnAfterPasteFromClipboard write FOnAfterPasteFromClipboard;
    property OnAfterShowFilter: TTMSFNCDataGridAfterShowFilterEvent read FOnAfterShowFilter write FOnAfterShowFilter;
    property OnAfterShowFilterDialog: TTMSFNCDataGridAfterShowFilterDialogEvent read FOnAfterShowFilterDialog write FOnAfterShowFilterDialog;
    property OnAfterShowFindDialog: TTMSFNCDataGridAfterShowFindDialogEvent read FOnAfterShowFindDialog write FOnAfterShowFindDialog;
    property OnAfterShowReplaceDialog: TTMSFNCDataGridAfterShowReplaceDialogEvent read FOnAfterShowReplaceDialog write FOnAfterShowReplaceDialog;
    property OnAfterSortColumn: TTMSFNCDataGridAfterSortColumnEvent read FOnAfterSortColumn write FOnAfterSortColumn;
    property OnAppendColumn: TTMSFNCDataGridAppendColumnEvent read FOnAppendColumn write FOnAppendColumn;
    property OnAppendRow: TTMSFNCDataGridAppendRowEvent read FOnAppendRow write FOnAppendRow;
    property OnBeforeApplyFilter: TTMSFNCDataGridBeforeApplyFilterEvent read FOnBeforeApplyFilter write FOnBeforeApplyFilter;
    property OnBeforeCloseInplaceEditor: TTMSFNCDataGridBeforeCloseInplaceEditorEvent read FOnBeforeCloseInplaceEditor write FOnBeforeCloseInplaceEditor;
    property OnBeforeCopyToClipboard: TTMSFNCDataGridBeforeClipboardEvent read FOnBeforeCopyToClipboard write FOnBeforeCopyToClipboard;
    property OnBeforeCreateFilterEditor: TTMSFNCDataGridBeforeCreateFilterEditorEvent read FOnBeforeCreateFilterEditor write FOnBeforeCreateFilterEditor;
    property OnBeforeCutToClipboard: TTMSFNCDataGridBeforeClipboardEvent read FOnBeforeCutToClipboard write FOnBeforeCutToClipboard;
    property OnBeforeDrawCell: TTMSFNCDataGridBeforeDrawCellEvent read FOnBeforeDrawCell write FOnBeforeDrawCell;
    property OnBeforeDrawEmptySpace: TTMSFNCDataGridBeforeDrawEmptySpaceEvent read FOnBeforeDrawEmptySpace write FOnBeforeDrawEmptySpace;
    property OnBeforeLookup: TTMSFNCDataGridBeforeLookupEvent read FOnBeforeLookup write FOnBeforeLookup;
    property OnBeforeOpenInplaceEditor: TTMSFNCDataGridBeforeOpenInplaceEditorEvent read FOnBeforeOpenInplaceEditor write FOnBeforeOpenInplaceEditor;
    property OnBeforePasteFromClipboard: TTMSFNCDataGridBeforeClipboardEvent read FOnBeforePasteFromClipboard write FOnBeforePasteFromClipboard;
    property OnBeforeShowFilter: TTMSFNCDataGridBeforeShowFilterEvent read FOnBeforeShowFilter write FOnBeforeShowFilter;
    property OnBeforeShowFilterDialog: TTMSFNCDataGridBeforeShowFilterDialogEvent read FOnBeforeShowFilterDialog write FOnBeforeShowFilterDialog;
    property OnBeforeShowFindDialog: TTMSFNCDataGridBeforeShowFindDialogEvent read FOnBeforeShowFindDialog write FOnBeforeShowFindDialog;
    property OnBeforeShowReplaceDialog: TTMSFNCDataGridBeforeShowReplaceDialogEvent read FOnBeforeShowReplaceDialog write FOnBeforeShowReplaceDialog;
    property OnBeforeSortColumn: TTMSFNCDataGridBeforeSortColumnEvent read FOnBeforeSortColumn write FOnBeforeSortColumn;
    property OnCanAppendColumn: TTMSFNCDataGridCanAppendColumnEvent read FOnCanAppendColumn write FOnCanAppendColumn;
    property OnCanAppendRow: TTMSFNCDataGridCanAppendRowEvent read FOnCanAppendRow write FOnCanAppendRow;
    property OnCanDeleteColumn: TTMSFNCDataGridCanDeleteColumnEvent read FOnCanDeleteColumn write FOnCanDeleteColumn;
    property OnCanDeleteRow: TTMSFNCDataGridCanDeleteRowEvent read FOnCanDeleteRow write FOnCanDeleteRow;
    property OnCanDragColumn: TTMSFNCDataGridCanDragColumnEvent read FOnCanDragColumn write FOnCanDragColumn;
    property OnCanDragRow: TTMSFNCDataGridCanDragRowEvent read FOnCanDragRow write FOnCanDragRow;
    property OnCanDropColumn: TTMSFNCDataGridCanDropColumnEvent read FOnCanDropColumn write FOnCanDropColumn;
    property OnCanDropRow: TTMSFNCDataGridCanDropRowEvent read FOnCanDropRow write FOnCanDropRow;
    property OnCanEditCell: TTMSFNCDataGridCanEditCellEvent read FOnCanEditCell write FOnCanEditCell;
    property OnCanInsertColumn: TTMSFNCDataGridCanInsertColumnEvent read FOnCanInsertColumn write FOnCanInsertColumn;
    property OnCanInsertRow: TTMSFNCDataGridCanInsertRowEvent read FOnCanInsertRow write FOnCanInsertRow;
    property OnCanSizeColumn: TTMSFNCDataGridCanSizeColumnEvent read FOnCanSizeColumn write FOnCanSizeColumn;
    property OnCanSizeRow: TTMSFNCDataGridCanSizeRowEvent read FOnCanSizeRow write FOnCanSizeRow;
    property OnCellAfterNodeCollapse: TTMSFNCDataGridCellAfterNodeCollapseEvent read FOnCellAfterNodeCollapse write FOnCellAfterNodeCollapse;
    property OnCellAfterNodeExpand: TTMSFNCDataGridCellAfterNodeExpandEvent read FOnCellAfterNodeExpand write FOnCellAfterNodeExpand;
    property OnCellAnchorClick: TTMSFNCDataGridCellAnchorClickEvent read FOnCellAnchorClick write FOnCellAnchorClick;
    property OnCellBeforeNodeCollapse: TTMSFNCDataGridCellBeforeNodeCollapseEvent read FOnCellBeforeNodeCollapse write FOnCellBeforeNodeCollapse;
    property OnCellBeforeNodeExpand: TTMSFNCDataGridCellBeforeNodeExpandEvent read FOnCellBeforeNodeExpand write FOnCellBeforeNodeExpand;
    property OnCellBeforeShowPopupMenu: TTMSFNCDataGridCellBeforeShowPopupMenuEvent read FOnCellBeforeShowPopupMenu write FOnCellBeforeShowPopupMenu;
    property OnCellButtonClick: TTMSFNCDataGridCellClickEvent read FOnCellButtonClick write FOnCellButtonClick;
    property OnCellCheckBoxChange: TTMSFNCDataGridCellClickEvent read FOnCellCheckBoxChange write FOnCellCheckBoxChange;
    property OnCellClick: TTMSFNCDataGridCellClickEvent read FOnCellClick write FOnCellClick;
    property OnCellDblClick: TTMSFNCDataGridCellClickEvent read FOnCellDblClick write FOnCellDblClick;
    property OnCellEditGetData: TTMSFNCDataGridCellEditGetDataEvent read FOnCellEditGetData write FOnCellEditGetData;
    property OnCellEditSetData: TTMSFNCDataGridCellEditSetDataEvent read FOnCellEditSetData write FOnCellEditSetData;
    property OnCellEditValidateData: TTMSFNCDataGridCellEditValidateDataEvent read FOnCellEditValidateData write FOnCellEditValidateData;
    property OnCellRadioButtonChange: TTMSFNCDataGridCellClickEvent read FOnCellRadioButtonChange write FOnCellRadioButtonChange;
    property OnCellRightClick: TTMSFNCDataGridCellClickEvent read FOnCellRightClick write FOnCellRightClick;
    property OnColumnDropped: TTMSFNCDataGridColumnDroppedEvent read FOnColumnDropped write FOnColumnDropped;
    property OnColumnSized: TTMSFNCDataGridColumnSizedEvent read FOnColumnSized write FOnColumnSized;
    property OnCreateCustomFilterEditor: TTMSFNCDataGridCreateCustomFilterEditorEvent read FOnCreateCustomFilterEditor write FOnCreateCustomFilterEditor;
    property OnCustomizeFilterPopupEditor: TTMSFNCDataGridCustomizeFilterPopupEditorEvent read FOnCustomizeFilterPopupEditor write FOnCustomizeFilterPopupEditor;
    property OnDeleteColumn: TTMSFNCDataGridDeleteColumnEvent read FOnDeleteColumn write FOnDeleteColumn;
    property OnDeleteRow: TTMSFNCDataGridDeleteRowEvent read FOnDeleteRow write FOnDeleteRow;
    property OnDisplay: TNotifyEvent read FOnDisplay write FOnDisplay;
    property OnDropFiles: TTMSFNCDataGridDropFilesEvent read FOnDropFiles write FOnDropFiles;
    property OnFocus: TNotifyEvent read FOnFocus write FOnFocus;
    property OnCalculate: TNotifyEvent read FOnCalculate write FOnCalculate;
    property OnBeforeCalculate: TNotifyEvent read FOnBeforeCalculate write FOnBeforeCalculate;
    property OnGetCellClass: TTMSFNCDataGridGetCellClassEvent read FOnGetCellClass write FOnGetCellClass;
    property OnGetCellHint: TTMSFNCDataGridGetCellHintEvent read FOnGetCellHint write FOnGetCellHint;
    property OnGetCellLayout: TTMSFNCDataGridGetCellLayoutEvent read FOnGetCellLayout write FOnGetCellLayout;
    property OnGetCellLayoutHasPriority: TTMSFNCDataGridGetCellLayoutHasPriorityEvent read FOnGetCellLayoutHasPriority write FOnGetCellLayoutHasPriority;
    property OnGetCellProperties: TTMSFNCDataGridGetCellPropertiesEvent read FOnGetCellProperties write FOnGetCellProperties;
    property OnGetInplaceEditorClass: TTMSFNCDataGridGetInplaceEditorClassEvent read FOnGetInplaceEditorClass write FOnGetInplaceEditorClass;
    property OnGetInplaceEditorProperties: TTMSFNCDataGridGetInplaceEditorPropertiesEvent read FOnGetInplaceEditorProperties write FOnGetInplaceEditorProperties;
    property OnGetInplaceEditorRect: TTMSFNCDataGridGetInplaceEditorRectEvent read FOnGetInplaceEditorRect write FOnGetInplaceEditorRect;
    property OnGetInplaceEditorTarget: TTMSFNCDataGridGetInplaceEditorTargetEvent read FOnGetInplaceEditorTarget write FOnGetInplaceEditorTarget;
    property OnGetInplaceEditorType: TTMSFNCDataGridGetInplaceEditorTypeEvent read FOnGetInplaceEditorType write FOnGetInplaceEditorType;
    property OnHScroll: TTMSFNCDataGridScrollEvent read FOnHScroll write FOnHScroll;
    property OnInsertColumn: TTMSFNCDataGridInsertColumnEvent read FOnInsertColumn write FOnInsertColumn;
    property OnInsertRow: TTMSFNCDataGridInsertRowEvent read FOnInsertRow write FOnInsertRow;
    property OnIsDesigntime: TTMSFNCDataGridRendererIsDesigntimeEvent read FOnIsDesigntime write FOnIsDesigntime;
    property OnIsDestroying: TTMSFNCDataGridRendererIsDestroyingEvent read FOnIsDestroying write FOnIsDestroying;
    property OnIsFocused: TTMSFNCDataGridRendererIsFocusedEvent read FOnIsFocused write FOnIsFocused;
    property OnIsLoading: TTMSFNCDataGridRendererIsLoadingEvent read FOnIsLoading write FOnIsLoading;
    property OnNeedFilterDropDownData: TTMSFNCDataGridNeedFilterDropDownData read FOnNeedFilterDropDownData write FOnNeedFilterDropDownData;
    property OnRemoveFilter: TTMSFNCDataGridRemoveFilterEvent read FOnRemoveFilter write FOnRemoveFilter;
    property OnRowDropped: TTMSFNCDataGridRowDroppedEvent read FOnRowDropped write FOnRowDropped;
    property OnRowSized: TTMSFNCDataGridRowSizedEvent read FOnRowSized write FOnRowSized;
    property OnSelectCell: TTMSFNCDataGridSelectCellEvent read FOnSelectCell write FOnSelectCell;
    property OnSelectingCell: TTMSFNCDataGridSelectingCellEvent read FOnSelectingCell write FOnSelectingCell;
    property OnSizeColumn: TTMSFNCDataGridSizeColumnEvent read FOnSizeColumn write FOnSizeColumn;
    property OnSizeRow: TTMSFNCDataGridSizeRowEvent read FOnSizeRow write FOnSizeRow;
    property OnUpdateCursor: TTMSFNCDataGridRendererUpdateCursorEvent read FOnUpdateCursor write FOnUpdateCursor;
    property OnVScroll: TTMSFNCDataGridScrollEvent read FOnVScroll write FOnVScroll;
    property PageCount: Integer read GetPageCount;
    property PageIndex: Integer read GetPageIndex write SetPageIndex;
    property ProgressValue[AColumn, ARow: Integer]: Integer read GetProgressValue;
    property RadioGroupIndex[AColumn, ARow: Integer]: Integer read GetRadioGroupIndex write SetRadioGroupIndex;
    property ReadOnlys[AColumn, ARow: Integer]: Boolean read GetReadOnlys write SetReadOnlys;
    property ReplaceDialog: TTMSFNCReplaceDialog read GetReplaceDialog;
    property RowIndex[ARow: Integer]: Integer read GetRowIndex write SetRowIndex;
    property RightColumn: Integer read GetRightColumn;
    property SelectedCellCount: Integer read GetSelectedCellCount;
    property SelectedCells[AColumn, ARow: Integer]: Boolean read GetSelectedCell write SetSelectedCell;
    property SelectedColumnCount: Integer read GetSelectedColumnCount;
    property SelectedColumns[AColumn: Integer]: Boolean read GetSelectedColumn write SetSelectedColumn;
    property SelectedRowCount: Integer read GetSelectedRowCount;
    property SelectedRows[ARow: Integer]: Boolean read GetSelectedRow write SetSelectedRow;
    property Selection: TTMSFNCDataGridCellCoordRange read FSelection write FSelection;
    property States[AColumn, ARow: Integer]: TTMSFNCDataGridCellState read GetStates;
    property TextAligns[AColumn, ARow: Integer]: TTMSFNCGraphicsTextAlign read GetTextAligns write SetTextAligns;
    property TextAngles[AColumn, ARow: Integer]: Double read GetTextAngles write SetTextAngles;
    property TopRow: Integer read GetTopRow write SetTopRow;
    property VerticalScrollBar: TScrollBar read GetVerticalScrollBar;
    property VerticalTextAligns[AColumn, ARow: Integer]: TTMSFNCGraphicsTextAlign read GetVerticalTextAligns write SetVerticalTextAligns;
    property WordWrapping[AColumn, ARow: Integer]: Boolean read GetWordWrapping write SetWordWrapping;
  published
    property AdaptToStyle: Boolean read GetAdaptToStyle write SetAdaptToStyle default False;
    property CellAppearance: TTMSFNCDataGridCellAppearance read FCellAppearance write SetCellAppearance;
    property Columns: TTMSFNCDataGridColumns read FColumns write SetColumns;
    property CustomScrollBars: Boolean read FCustomScrollBars write SetCustomScrollBars default False;
    property DragAppearance: TTMSFNCDataGridDragAppearance read FDragAppearance write SetDragAppearance;
    property FilterAppearance: TTMSFNCDataGridFilterAppearance read FFilterAppearance write SetFilterAppearance;
    property GlobalFont: TTMSFNCAppearanceGlobalFont read FGlobalFont write SetGlobalFont;
    property HorizontalScrollBarVisible: Boolean read FHorizontalScrollBarVisible write SetHorizontalScrollBarVisible default True;
    property Icons: TTMSFNCDataGridIcons read FIcons write SetIcons;
    property Options: TTMSFNCDataGridOptions read GetOptions write SetOptions;
    property Padding: TTMSFNCMargins read FPadding write SetPadding;
    property ScrollMode: TTMSFNCDataGridScrollMode read FScrollMode write SetScrollMode default gsmPixelScrolling;
    property ScrollUpdate: TTMSFNCDataGridScrollUpdate read FScrollUpdate write SetScrollUpdate default gsuContinuous;
    property StretchScrollBars: Boolean read FStretchScrollBars write SetStretchScrollBars default False;
    property Stroke: TTMSFNCGraphicsStroke read FStroke;
    property VerticalScrollBarVisible: Boolean read FVerticalScrollBarVisible write SetVerticalScrollBarVisible default True;
  end;

  TTMSFNCDataGridRendererClass = class of TTMSFNCDataGridRenderer;

  TTMSFNCDataGridRendererCell = class(TTMSFNCDataGridCell)
  private
    FRenderRect: TRectF;
    FExportRenderer: TTMSFNCDataGridRenderer;
    function GetRenderer: TTMSFNCDataGridRenderer;
  protected
    function GetDrawElements(AIsEditing: Boolean): TTMSFNCDataGridCellDrawElements; override;
    function GetRendererRect: TRectF; virtual;
    function GetRequiredSize(AGraphics: TTMSFNCGraphics = nil): TSizeF; override;
    procedure ApplyScale(AScale: Single); override;
  public
    constructor Create(ARect: TRectF; AColumn, ARow: Integer; AData: TTMSFNCDataGridCellItem; AKind: TTMSFNCDataGridCellKind; ARoot: TObject = nil); override;
    destructor Destroy; override;
    procedure AfterExport; override;
    procedure BeforeExport; override;
    procedure DrawContent(AGraphics: TTMSFNCGraphics); override;
    property Renderer: TTMSFNCDataGridRenderer read GetRenderer;
  end;

function DefaultHilightOptions: TTMSFNCDataGridHilightOptions;
function DefaultMarkOptions: TTMSFNCDataGridMarkOptions;

resourcestring
  sTMSFNCDataGridAdvancedFilteringError = 'To use the advanced filter dialog, please enable Options.Filtering.Advanced';
  sTMSFNCDataGridCreateDirectoryError = 'Cannot create %simages';
  sTMSFNCDataGridNotAvailableError = 'Grid not available, please call SetGrid/AddGrid first.';
  sTMSFNCDataGridFilterAllText = '(All)';
  sTMSFNCDataGridFilterEmptyText = '(Empty)';
  sTMSFNCDataGridFilterNotEmptyText = '(Not Empty)';
  sTMSFNCDataGridFilterClearButtonHint = 'Clear Filter';
  sTMSFNCDataGridFilterEditPrompt = 'Filter';
  sTMSFNCDataGridFilterSortButtonAscendingHint = 'Sort Ascending';
  sTMSFNCDataGridFilterSortButtonAscendingText = 'Sort Ascending';
  sTMSFNCDataGridFilterSortButtonDescendingHint = 'Sort Descending';
  sTMSFNCDataGridFilterSortButtonDescendingText = 'Sort Descending';
  sTMSFNCDataGridFilterTypeButtonHint = 'Filter Type';
  sTMSFNCDataGridFilterTypeContainsText = 'Contains';
  sTMSFNCDataGridFilterTypeEmptyText = 'Empty';
  sTMSFNCDataGridFilterTypeEndsWithText = 'Ends with';
  sTMSFNCDataGridFilterTypeEqualText = 'Equals';
  sTMSFNCDataGridFilterTypeLargerOrEqualThanText = 'Larger than or equal to';
  sTMSFNCDataGridFilterTypeLargerThanText = 'Larger than';
  sTMSFNCDataGridFilterTypeNotContainsText = 'Does not contain';
  sTMSFNCDataGridFilterTypeNotEmptyText = 'Not Empty';
  sTMSFNCDataGridFilterTypeNotEqualText = 'Does not equal';
  sTMSFNCDataGridFilterTypeSmallerOrEqualThanText = 'Smaller than or equal to';
  sTMSFNCDataGridFilterTypeSmallerThanText = 'Smaller than';
  sTMSFNCDataGridFilterTypeStartsWithText = 'Starts with';

implementation

uses
  WEBLib.TMSFNCDataGridColumnsEditor, WEBLib.TMSFNCCustomTreeView, WEBLib.TMSFNCColorSelector, WEBLib.TMSFNCDataGridBase, WEBLib.TMSFNCCustomPicker, WEBLib.TMSFNCHTMLEngine, WEBLib.TMSFNCDataGridUtil,
  WEBLib.TMSFNCCustomComponent, WEBLib.Forms, Math, WEBLib.TMSFNCUtils, WEBLib.TMSFNCEditorsTools
  {$IFDEF FMXLIB}
  ,FMX.Styles.Objects
  {$ENDIF}
  ,Rtti
  ;

{$R TMSFNCDataGrid.res}

{$IFDEF WEBLIB}
const
  TTMSFNCDATAGRIDCLOSE =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNlY'+
  'TNmNDE7fS5jbHMtM3tjbGlwLXBhdGg6dXJsKCNjbGlwLXBhdGgpO30uY2xzLTR7ZmlsbDojZmFmYWZhO30uY2xzLTV7Y2xpcC1wYXRoOnVybCgjY2xpcC1wYXRoLTIpO30uY2xzLTZ7ZmlsbDp1cmwoI05ld19QYXR0ZXJuX1N3YXRjaF8zKTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+PHJlY3QgY2xhc3M9ImNscy0xIiB4'+
  'PSItNDUuNSIgeT0iLTQuNSIgd2lkdGg9IjM0IiBoZWlnaHQ9IjM0Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aC0yIj48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjIuNSIgeT0iMi41IiB3aWR0aD0iMjciIGhlaWdodD0iMjciLz48L2NsaXBQYXRoPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMyIgZGF0YS1'+
  'uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMyIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3'+
  'BhdHRlcm4+PC9kZWZzPjx0aXRsZT5XaW5kb3ctQ2xvc2U8L3RpdGxlPjxnIGlkPSJJY29uIj48ZyBjbGFzcz0iY2xzLTMiPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iLTU0IiB5PSItNDkiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtNCIgeD0iLTU0IiB5PSItNDkiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvP'+
  'jxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iLTU0IiB5PSIxOSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy00IiB4PSItNTQiIHk9IjE5IiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L2c+PGcgY2xhc3M9ImNscy01Ij48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjE0IiB5PSItNDkiIHdpZHRoPSI2OCIgaGVpZ2h0'+
  'PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtNCIgeD0iMTQiIHk9Ii00OSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxNCIgeT0iMTkiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtNCIgeD0iMTQiIHk9IjE5IiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGF'+
  'zcz0iY2xzLTEiIHg9Ii01NCIgeT0iLTQ5IiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTQiIHg9Ii01NCIgeT0iLTQ5IiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9Ii01NCIgeT0iMTkiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtNCIgeD'+
  '0iLTU0IiB5PSIxOSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PC9nPjxwYXRoIGNsYXNzPSJjbHMtNiIgZD0iTTMwLDMwSDJWMkgzMFpNMywyOUgyOVYzSDNaIi8+PHBvbHlnb24gY2xhc3M9ImNscy02IiBwb2ludHM9IjIyLjY1IDIzLjM1IDguNjUgOS4zNSA5LjM1IDguNjUgMjMuMzUgMjIuNjUgMjIuNjUgMjMuMzUiLz48cG9seWdvb'+
  'iBjbGFzcz0iY2xzLTYiIHBvaW50cz0iOS4zNSAyMy4zNSA4LjY1IDIyLjY1IDIyLjY1IDguNjUgMjMuMzUgOS4zNSA5LjM1IDIzLjM1Ii8+PC9nPjwvc3ZnPg';
  TTMSFNCDATAGRIDFILTERACTIVE=
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiM0N'+
  'jgyQjQ7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO30uY2xzLTR7ZmlsbDojM2EzYTM4O308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9u'+
  'VXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5GaWx0ZXI8L3RpdGxlPjxnIGlkPSJJY29uIj48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW5'+
  '0cz0iMS41IDYgMTIuNSAxNSAxMi41IDMwLjUgMTguNSAzMC41IDE4LjUgMTUgMjkuNSA2IDI5LjUgMS41IDEuNSAxLjUgMS41IDYiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik0xOSwzMUgxMlYxNS4yNGwtMTEtOVYxSDMwVjYuMjRsLTExLDlabS02LTFoNVYxNC43NmwxMS05VjJIMlY1Ljc2bDExLDlaIi8+PC9nPjwvc3ZnPg';
  TTMSFNCDATAGRIDFILTER =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNmY'+
  'WZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO30uY2xzLTR7ZmlsbDojM2EzYTM4O308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9u'+
  'VXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5GaWx0ZXI8L3RpdGxlPjxnIGlkPSJJY29uIj48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW5'+
  '0cz0iMS41IDYgMTIuNSAxNSAxMi41IDMwLjUgMTguNSAzMC41IDE4LjUgMTUgMjkuNSA2IDI5LjUgMS41IDEuNSAxLjUgMS41IDYiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik0xOSwzMUgxMlYxNS4yNGwtMTEtOVYxSDMwVjYuMjRsLTExLDlabS02LTFoNVYxNC43NmwxMS05VjJIMlY1Ljc2bDExLDlaIi8+PC9nPjwvc3ZnPg';
  TTMSFNCDATAGRIDFILTERCLEAR =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNhN'+
  'zRhYjA7fS5jbHMtM3tmaWxsOiNkMzk0ZDY7fS5jbHMtNHtmaWxsOiNmYWZhZmE7fS5jbHMtNXtmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzgpO30uY2xzLTZ7ZmlsbDp1cmwoI05ld19QYXR0ZXJuX1N3YXRjaF83KTt9PC9zdHlsZT48cGF0dGVybiBpZD0iTmV3X1BhdHRlcm5fU3dhdGNoXzgiIGRhdGEtbmFtZT0iTmV3IFBhdHRl'+
  'cm4gU3dhdGNoIDgiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgdmlld0JveD0iMCAwIDY4IDY4Ij48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PC9wYXR0ZXJuPjxwYXR0ZXJ'+
  'uIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfNyIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggNyIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9Im'+
  'Nscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5DbGVhcjwvdGl0bGU+PGcgaWQ9Ikljb24iPjxyZWN0IGNsYXNzPSJjbHMtNCIgeD0iMS44NiIgeT0iMTAuMzQiIHdpZHRoPSIyOC4yOCIgaGVpZ2h0PSIxMS4zMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYuNjMgMTYpIHJvdGF0ZSgtNDUpI'+
  'i8+PHBvbHlnb24gY2xhc3M9ImNscy01IiBwb2ludHM9IjIuNzEgMjIgMTAgMjkuMjkgMTUuNzkgMjMuNSA4LjUgMTYuMjEgMi43MSAyMiIvPjxwYXRoIGNsYXNzPSJjbHMtNiIgZD0iTTEwLjcxLDMwbDIwLTIwTDIyLDEuMjksMS4yOSwyMiwxMCwzMC43MVYzMUgzMVYzMFpNMjIsMi43MSwyOS4yOSwxMCwxNi41LDIyLjc5LDkuMjEsMTUu'+
  'NVpNMi43MSwyMiw4LjUsMTYuMjFsNy4yOSw3LjI5TDEwLDI5LjI5WiIvPjwvZz48L3N2Zz4';
  TTMSFNCDATAGRIDCOLLAPSE =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIA0KMzIiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMDAwMDA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5QbHVzPC90aXRsZT4gPGcgDQppZD0iSWNvbiI+PHJlY'+
  '3QgY2xhc3M9ImNscy0xIiB4PSI3IiB5PSIxNSIgd2lkdGg9IjE4IiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjEiIA0KeT0iMSIgd2lkdGg9IjEiIGhlaWdodD0iMzAiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjEiIHk9IjEiIHdpZHRoPSIzMCIgDQpoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjMw'+
  'IiB5PSIxIiB3aWR0aD0iMSIgaGVpZ2h0PSIzMCIvPjxyZWN0IA0KY2xhc3M9ImNscy0xIiB4PSIxIiB5PSIzMCIgd2lkdGg9IjMwIiBoZWlnaHQ9IjEiLz48L2c+PC9zdmc+';
  TTMSFNCDATAGRIDEXPAND =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIA0KMzIiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMDAwMDA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5QbHVzPC90aXRsZT4gPGcgDQppZD0iSWNvbiI+PHJlY'+
  '3QgY2xhc3M9ImNscy0xIiB4PSI3IiB5PSIxNSIgd2lkdGg9IjE4IiBoZWlnaHQ9IjEiLz48cmVjdCANCmNsYXNzPSJjbHMtMSIgeD0iMTUiIHk9IjciIHdpZHRoPSIxIiBoZWlnaHQ9IjE4Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxIiANCnk9IjEiIHdpZHRoPSIxIiBoZWlnaHQ9IjMwIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIx'+
  'IiB5PSIxIiB3aWR0aD0iMzAiIA0KaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIzMCIgeT0iMSIgd2lkdGg9IjEiIGhlaWdodD0iMzAiLz48cmVjdCANCmNsYXNzPSJjbHMtMSIgeD0iMSIgeT0iMzAiIHdpZHRoPSIzMCIgaGVpZ2h0PSIxIi8+PC9nPjwvc3ZnPg';
  TTMSFNCDATAGRIDSORTASC =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNhN'+
  'zRhYjA7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzcpO30uY2xzLTR7ZmlsbDojMWU4YmNkO30uY2xzLTV7ZmlsbDojM2EzYTM4O308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfNyIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggNyIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0'+
  'ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5Tb3J0LUFaPC90aXRsZT48ZyBpZD0iSWNvbiI+PHBhdGg'+
  'gY2xhc3M9ImNscy0zIiBkPSJNMiwyOS42NGw3LTEwVjIwSDNWMThoOXYxLjQ0TDUsMjkuMzZWMjloN3YySDJaIi8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNNS43LDExLDQuNTIsMTVIMS45M0w2LjMzLDFIOS41NEwxNCwxNWgtMi43bC0xLjI0LTRaTTkuNjQsOS4xMSw4LjU2LDUuNjZjLS4yNy0uODUtLjQ5LTEuOC0uNjktMi42MWgwYy'+
  '0uMi44MS0uNCwxLjc4LS42NSwyLjYxTDYuMTEsOS4xMVoiLz48cG9seWdvbiBjbGFzcz0iY2xzLTUiIHBvaW50cz0iMjMgMjUuMTIgMjMgNiAyMiA2IDIyIDI1LjEyIDE2LjQ0IDE5LjU2IDE1LjU2IDIwLjQ0IDIyLjUgMjcuMzggMjkuNDQgMjAuNDQgMjguNTYgMTkuNTYgMjMgMjUuMTIiLz48L2c+PC9zdmc+';
  TTMSFNCDATAGRIDSORTDESC =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNhN'+
  'zRhYjA7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzcpO30uY2xzLTR7ZmlsbDojMWU4YmNkO30uY2xzLTV7ZmlsbDojM2EzYTM4O308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfNyIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggNyIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0'+
  'ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5Tb3J0LVpBPC90aXRsZT48ZyBpZD0iSWNvbiI+PHBhdGg'+
  'gY2xhc3M9ImNscy0zIiBkPSJNMiwxMi42NGw3LTEwVjNIM1YxaDlWMi40NEw1LDEyLjM2VjEyaDd2MkgyWiIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTUuNywyNyw0LjUyLDMxSDEuOTNsNC40LTE0SDkuNTRMMTQsMzFoLTIuN2wtMS4yNC00Wm0zLjk0LTEuOTNMOC41NiwyMS42NmMtLjI3LS44NS0uNDktMS44LS42OS0yLjYxaDBjLS'+
  '4yLjgxLS40LDEuNzgtLjY1LDIuNjFMNi4xMSwyNS4xMVoiLz48cG9seWdvbiBjbGFzcz0iY2xzLTUiIHBvaW50cz0iMjMgMjUuMTIgMjMgNiAyMiA2IDIyIDI1LjEyIDE2LjQ0IDE5LjU2IDE1LjU2IDIwLjQ0IDIyLjUgMjcuMzggMjkuNDQgMjAuNDQgMjguNTYgMTkuNTYgMjMgMjUuMTIiLz48L2c+PC9zdmc+';
  TTMSFNCDATAGRIDFILTERTYPE =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiM3O'+
  'Tc3NzQ7fS5jbHMtM3tmaWxsOiNmYWZhZmE7fS5jbHMtNHtmaWxsOiMzYTNhMzg7fS5jbHMtNXtmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzQpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfNCIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggNCIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0'+
  'ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5UZXh0LUZpbHRlcjwvdGl0bGU+PGcgaWQ9Ik1hc2siPjx'+
  'wb2x5Z29uIGNsYXNzPSJjbHMtMyIgcG9pbnRzPSIyNS41IDkgMTkgMi41IDE5IDkgMjUuNSA5Ii8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTgsMTBWMkg2VjMwSDIxVjI2LjE4TDE5Ljg0LDI1SDhWMjRIMTguODVsLTItMkg4VjIxaDhWMTlIOFYxOGg4VjE2SDhWMTVIMjR2MWgyVjEwWk04LDloOHYxSDhabTAsNFYxMkgyNHYxWiIvPj'+
  'xwb2x5Z29uIGNsYXNzPSJjbHMtNCIgcG9pbnRzPSI1IDEgNSAzMSA2IDMxIDIxIDMxIDIxIDMwIDYgMzAgNiAyIDE4IDIgMTguNSAyIDE5IDIgMTkgMi41IDI1LjUgOSAyNiA5IDI2IDkuNSAyNiAxMCAyNiAxNiAyNyAxNiAyNyA5LjcgMjcgOSAxOSAxIDUgMSIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtNCIgcG9pbnRzPSIyNiAxMCAyNiA5L'+
  'jUgMjYgOSAyNS41IDkgMTkgOSAxOSAyLjUgMTkgMiAxOC41IDIgMTggMiAxOCAxMCAyNiAxMCIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iOCIgeT0iOSIgd2lkdGg9IjgiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtNSIgeD0iOCIgeT0iOSIgd2lkdGg9IjgiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iOCIg'+
  'eT0iMTIiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy01IiB4PSI4IiB5PSIxMiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjEiLz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iOCAxNSA4IDE2IDE2IDE2IDI0IDE2IDI0IDE1IDggMTUiLz48cG9seWdvbiBjbGFzcz0iY2xzLTUiIHBvaW50cz0iOCAxNSA4IDE'+
  '2IDE2IDE2IDI0IDE2IDI0IDE1IDggMTUiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjgiIHk9IjE4IiB3aWR0aD0iOCIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy01IiB4PSI4IiB5PSIxOCIgd2lkdGg9IjgiIGhlaWdodD0iMSIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMyIgcG9pbnRzPSI4IDIyIDE2Ljg3IDIyIDE2IDIxLjEyID'+
  'E2IDIxIDggMjEgOCAyMiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtNSIgcG9pbnRzPSI4IDIyIDE2Ljg3IDIyIDE2IDIxLjEyIDE2IDIxIDggMjEgOCAyMiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMyIgcG9pbnRzPSI4IDI1IDE5Ljg0IDI1IDE4Ljg1IDI0IDggMjQgOCAyNSIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtNSIgcG9pbnRzPSI4IDI1I'+
  'DE5Ljg0IDI1IDE4Ljg1IDI0IDggMjQgOCAyNSIvPjwvZz48ZyBpZD0iT3ZlcmxheSI+PHBvbHlnb24gY2xhc3M9ImNscy0zIiBwb2ludHM9IjMxLjUgMTcuNSAxNy41IDE3LjUgMTcuNSAyMC41IDIyLjUgMjUuNTYgMjIuNSAzMS41IDI2LjUgMzEuNSAyNi41IDI1LjU2IDMxLjUgMjAuNSAzMS41IDE3LjUiLz48cGF0aCBjbGFzcz0iY2xz'+
  'LTQiIGQ9Ik0yNywzMkgyMlYyNS43N2wtNS01LjA2VjE3SDMydjMuNzFsLTUsNS4wNlptLTQtMWgzVjI1LjM2bDUtNS4wN1YxOEgxOHYyLjI5bDUsNS4wN1oiLz48L2c+PC9zdmc+';  
{$ENDIF}

type
  TTMSFNCDataGridBaseOpen = class(TTMSFNCDataGridBase);
  TTMSFNCDataGridCellOpen = class(TTMSFNCDataGridCell);
  TTMSFNCDataGridCellControlOpen = class(TTMSFNCDataGridCellControl);
  TTMSFNCDataGridNodeCellOpen = class(TTMSFNCDataGridNodeCell);
  TTMSFNCDataGridCellItemExtendedOpen = class(TTMSFNCDataGridCellItemExtended);
  TTMSFNCDataGridInplaceEditorOpen = class(TTMSFNCDataGridInplaceEditor);
  TFNCControlOpen = class(TTMSFNCCustomControl);
  TCustomEditOpen = class(TCustomEdit);
  TCustomMemoOpen = class(TCustomMemo);
  TCustomComboBoxOpen = class(TCustomComboBox);

const
  SCROLLINGDELAY = 0;
  {$IFDEF MSWINDOWS}
  SWIPECOUNT = 300;
  {$ENDIF}
  {$IFDEF MACOS}
  {$IFDEF IOS}
  SWIPECOUNT = 300;
  {$ELSE}
  SWIPECOUNT = 300;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF ANDROID}
  SWIPECOUNT = 300;
  {$ENDIF}
  {$IFDEF FMXLIB}
  {$IFDEF LINUX}
  SWIPECOUNT = 300;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF WEBLIB}
  SWIPECOUNT = 300;
  {$ENDIF}
  FILTERDELAY = 40;

function GetTickCountX: DWORD;
var
  h, m, s, ms: Word;
begin
  DecodeTime(Now, h, m, s, ms);
  Result := ms + s * 1000 + m * 60 * 1000 + h * 60 * 60 * 1000;
end;

function AnimateDouble(var Start, Stop: Double; Delta, Margin: Double): Boolean;
begin
  Result := true;
  if (Start > Stop - Margin) and (Start < Stop + Margin) then
  begin
    Start := Stop;
    Result := false;
  end
  else
  begin
    Delta := Max(Margin, Delta);
    if Start < Stop then
      Start := Start + Delta
    else
      Start := Start - Delta;
  end;
end;

function DefaultHilightOptions: TTMSFNCDataGridHilightOptions;
begin
  Result.IncludeFixed := False;
  Result.CaseSensitive := False;
  Result.FullText := False;
  Result.Mode := ghmGrid;
  Result.Column := -1;
  Result.Row := -1;
end;

function DefaultMarkOptions: TTMSFNCDataGridMarkOptions;
begin
  Result := DefaultHilightOptions;
end;

{ TTMSFNCDataGridRenderer }

{$IFDEF FMXLIB}
procedure TTMSFNCDataGridRenderer.ApplyInplaceEditorStyleLookup(Sender: TObject);
var
  obj: TFmxObject;
begin
  if (Sender = FInplaceEditor) {$IFDEF FMXLIB} and not (FInplaceEditor is TCustomComboEdit) {$ENDIF} then
  begin
    obj := FInplaceEditor.FindStyleResource('background');
    if Assigned(obj) and (obj is TActiveStyleObject) then
      TActiveStyleObject(obj).Source := nil;
  end;
end;
{$ENDIF}

procedure TTMSFNCDataGridRenderer.DoAfterOpenInplaceEditor(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; AValue: TTMSFNCDataGridCellValue);
begin
  if Assigned(OnAfterOpenInplaceEditor) then
    OnAfterOpenInplaceEditor(Self, ACell, AInplaceEditor, AValue);
end;

procedure TTMSFNCDataGridRenderer.DoAfterPasteFromClipboard;
begin
  if Assigned(OnAfterPasteFromClipboard) then
    OnAfterPasteFromClipboard(Self);
end;

procedure TTMSFNCDataGridRenderer.DoAppendColumn(AColumn: Integer);
begin
  if Assigned(OnAppendColumn) then
    OnAppendColumn(Self, AColumn);
end;

procedure TTMSFNCDataGridRenderer.DoAppendRow(ARow: Integer);
begin
  if Assigned(OnAppendRow) then
    OnAppendRow(Self, ARow);
end;

procedure TTMSFNCDataGridRenderer.DoDeleteColumn(AColumn: Integer);
begin
  if Assigned(OnDeleteColumn) then
    OnDeleteColumn(Self, AColumn);
end;

procedure TTMSFNCDataGridRenderer.DoDeleteRow(ARow: Integer);
begin
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).DeleteRow(ARow);

  if Assigned(OnDeleteRow) then
    OnDeleteRow(Self, ARow);
end;

procedure TTMSFNCDataGridRenderer.DoColumnDropped(AFromColumn, AToColumn: Integer);
begin
  if Assigned(OnColumnDropped) then
    OnColumnDropped(Self, AFromColumn, AToColumn);
end;

procedure TTMSFNCDataGridRenderer.DoColumnsChanged(Sender: TObject);
begin
  SynchronizeColumns(True);

  if (UpdateCount > 0) or GetIsDestroying then
    Exit;

  RefreshData;
  Update;
end;

procedure TTMSFNCDataGridRenderer.DoRowDropped(AFromRow, AToRow: Integer);
begin
  if Assigned(OnRowDropped) then
    OnRowDropped(Self, AFromRow, AToRow);
end;

procedure TTMSFNCDataGridRenderer.DoInsertColumn(AColumn: Integer);
begin
  if Assigned(OnInsertColumn) then
    OnInsertColumn(Self, AColumn);
end;

procedure TTMSFNCDataGridRenderer.DoInsertRow(ARow: Integer);
begin
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).InsertRow(ARow);

  if Assigned(OnInsertRow) then
    OnInsertRow(Self, ARow);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeOpenInplaceEditor(ACell: TTMSFNCDataGridCellCoord; var AValue: TTMSFNCDataGridCellValue; var ACanOpen: Boolean);
begin
  if Assigned(OnBeforeOpenInplaceEditor) then
    OnBeforeOpenInplaceEditor(Self, ACell, AValue, ACanOpen);
end;

procedure TTMSFNCDataGridRenderer.DoBeforePasteFromClipboard(
  var ACanPaste: Boolean);
begin
  if Assigned(OnBeforePasteFromClipboard) then
    OnBeforePasteFromClipboard(Self, ACanPaste);
end;

procedure TTMSFNCDataGridRenderer.DoAfterSortColumn(AColumn: Integer);
begin
  if Assigned(OnAfterSortColumn) then
    OnAfterSortColumn(Self, AColumn);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeSortColumn(AColumn: Integer; var ACanSort: Boolean);
begin
  if Assigned(OnBeforeSortColumn) then
    OnBeforeSortColumn(Self, AColumn, ACanSort);
end;

procedure TTMSFNCDataGridRenderer.DoGetInplaceEditorClass(ACell: TTMSFNCDataGridCellCoord; var AInplaceEditorClass: TTMSFNCDataGridInplaceEditorClass);
begin
  if Assigned(OnGetInplaceEditorClass) then
    OnGetInplaceEditorClass(Self, ACell, AInplaceEditorClass);
end;

procedure TTMSFNCDataGridRenderer.DoGetInplaceEditorTarget(
  ACell: TTMSFNCDataGridCellCoord;
  var AInplaceEditorTarget: TTMSFNCDataGridInplaceEditorTarget);
var
  cl: TTMSFNCDataGridColumn;
begin
  cl := GetColumn(ACell.Column);
  if Assigned(cl) and (gcsEditor in cl.Settings) then
    AInplaceEditorTarget := cl.EditorTarget
  else
    AInplaceEditorTarget := getCellValue;

  if Assigned(OnGetInplaceEditorTarget) then
    OnGetInplaceEditorTarget(Self, ACell, AInplaceEditorTarget);
end;

procedure TTMSFNCDataGridRenderer.DoGetInplaceEditorType(ACell: TTMSFNCDataGridCellCoord; var AInplaceEditorType: TTMSFNCDataGridInplaceEditorType);
var
  cl: TTMSFNCDataGridColumn;
begin
  cl := GetColumn(ACell.Column);
  if Assigned(cl) and (gcsEditor in cl.Settings) then
    AInplaceEditorType := cl.Editor
  else
    AInplaceEditorType := getEdit;

  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).GetInplaceEditorType(ACell, AInplaceEditorType);

  if Assigned(OnGetInplaceEditorType) then
    OnGetInplaceEditorType(Self, ACell, AInplaceEditorType);
end;

procedure TTMSFNCDataGridRenderer.DoGetSortOptions(AColumn, ALevel: Integer;
  var AOptions: TTMSFNCDataGridDataSortOptions);
var
  cl: TTMSFNCDataGridColumn;
begin
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsFormatting in cl.Settings) then
    AOptions.FormatSettings := cl.Formatting.ConvertSettings;
  inherited;
end;

procedure TTMSFNCDataGridRenderer.DoGetInplaceEditorProperties(
  ACell: TTMSFNCDataGridCellCoord;
  AInplaceEditor: TTMSFNCDataGridInplaceEditor; AInplaceEditorType: TTMSFNCDataGridInplaceEditorType);
begin
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).GetInplaceEditorProperties(ACell, AInplaceEditor, AInplaceEditorType);

  if Assigned(OnGetInplaceEditorProperties) then
    OnGetInplaceEditorProperties(Self, ACell, AInplaceEditor, AInplaceEditorType);
end;

procedure TTMSFNCDataGridRenderer.DoGetInplaceEditorRect(
  ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; var AInplaceEditorRect: TRectF);
begin
  if Assigned(OnGetInplaceEditorRect) then
    OnGetInplaceEditorRect(Self, ACell, AInplaceEditor, AInplaceEditorRect);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeCalculateGrid(Sender: TObject);
begin
  if Assigned(OnBeforeCalculate) then
    OnBeforeCalculate(Sender);
end;

procedure TTMSFNCDataGridRenderer.DoCalculateGrid(Sender: TObject);
begin
  if Assigned(OnCalculate) then
    OnCalculate(Sender);
end;

procedure TTMSFNCDataGridRenderer.DoCanAppendColumn(AColumn: Integer;
  var ACanAppend: Boolean);
begin
  if Assigned(OnCanAppendColumn) then
    OnCanAppendColumn(Self, AColumn, ACanAppend);
end;

procedure TTMSFNCDataGridRenderer.DoCanAppendRow(ARow: Integer;
  var ACanAppend: Boolean);
begin
  if Assigned(OnCanAppendRow) then
    OnCanAppendRow(Self, ARow, ACanAppend);
end;

procedure TTMSFNCDataGridRenderer.DoCanDeleteColumn(AColumn: Integer;
  var ACanDelete: Boolean);
begin
  if Assigned(OnCanDeleteColumn) then
    OnCanDeleteColumn(Self, AColumn, ACanDelete);
end;

procedure TTMSFNCDataGridRenderer.DoCanDeleteRow(ARow: Integer;
  var ACanDelete: Boolean);
begin
  if Assigned(OnCanDeleteRow) then
    OnCanDeleteRow(Self, ARow, ACanDelete);
end;

procedure TTMSFNCDataGridRenderer.DoCanDropColumn(AFromColumn, AToColumn: Integer;
  var ACanDrop: Boolean);
begin
  if Assigned(OnCanDropColumn) then
    OnCanDropColumn(Self, AFromColumn, AToColumn, ACanDrop);
end;

procedure TTMSFNCDataGridRenderer.DoCanDropRow(AFromRow, AToRow: Integer;
  var ACanDrop: Boolean);
begin
  if Assigned(OnCanDropRow) then
    OnCanDropRow(Self, AFromRow, AToRow, ACanDrop);
end;

procedure TTMSFNCDataGridRenderer.DoCanDragColumn(AColumn: Integer;
  var ACanDrag: Boolean);
begin
  if Assigned(OnCanDragColumn) then
    OnCanDragColumn(Self, AColumn, ACanDrag);
end;

procedure TTMSFNCDataGridRenderer.DoCanDragRow(ARow: Integer;
  var ACanDrag: Boolean);
begin
  if Assigned(OnCanDragRow) then
    OnCanDragRow(Self, ARow, ACanDrag);
end;

procedure TTMSFNCDataGridRenderer.DoCanEditCell(AColumn, ARow: Integer;
  var ACanEdit: Boolean);
begin
  ACanEdit := ACanEdit and Options.Editing.Enabled;
  ACanEdit := ACanEdit and not IsCellReadOnly(MakeCell(AColumn, ARow));

  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).CanEditCell(MakeCell(AColumn, ARow), ACanEdit);

  if Assigned(OnCanEditCell) then
    OnCanEditCell(Self, AColumn, ARow, ACanEdit);
end;

procedure TTMSFNCDataGridRenderer.DoCanInsertColumn(AColumn: Integer;
  var ACanInsert: Boolean);
begin
  if Assigned(OnCanInsertColumn) then
    OnCanInsertColumn(Self, AColumn, ACanInsert);
end;

procedure TTMSFNCDataGridRenderer.DoCanInsertRow(ARow: Integer;
  var ACanInsert: Boolean);
begin
  if Assigned(OnCanInsertRow) then
    OnCanInsertRow(Self, ARow, ACanInsert);
end;

procedure TTMSFNCDataGridRenderer.DoCanSizeColumn(AColumn: Integer;
  var ASize: Double; var ACanSize: Boolean);
begin
  if Assigned(OnCanSizeColumn) then
    OnCanSizeColumn(Self, AColumn, ASize, ACanSize);
end;

procedure TTMSFNCDataGridRenderer.DoCanSizeRow(ARow: Integer;
  var ASize: Double; var ACanSize: Boolean);
begin
  if Assigned(OnCanSizeRow) then
    OnCanSizeRow(Self, ARow, ASize, ACanSize);
end;

procedure TTMSFNCDataGridRenderer.DoCellAfterDraw(Sender: TObject;
  AGraphics: TTMSFNCGraphics);
begin
  if Assigned(OnAfterDrawCell) and (Sender is TTMSFNCDataGridCell) then
    OnAfterDrawCell(Self, AGraphics, Sender as TTMSFNCDataGridCell);
end;

procedure TTMSFNCDataGridRenderer.DoCellAfterNodeCollapse(
  ACell: TTMSFNCDataGridCellCoord);
begin
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).RowAfterCollapse(ACell.Row);

  if Assigned(OnCellAfterNodeCollapse) then
    OnCellAfterNodeCollapse(Self, ACell);
end;

procedure TTMSFNCDataGridRenderer.DoCellAfterNodeExpand(
  ACell: TTMSFNCDataGridCellCoord);
begin
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).RowAfterExpand(ACell.Row);

  if Assigned(OnCellAfterNodeExpand) then
    OnCellAfterNodeExpand(Self, ACell);
end;

procedure TTMSFNCDataGridRenderer.DoCellAnchorClick(AColumn, ARow: Integer;
  AAnchor: string);
begin
  if Options.URL.AutoOpen then
    TTMSFNCUtils.OpenURL(AAnchor);

  if Assigned(OnCellAnchorClick) then
    OnCellAnchorClick(Self, AColumn, ARow, AAnchor);
end;

procedure TTMSFNCDataGridRenderer.DoCellButtonClick(Sender: TObject);
var
  cl: TTMSFNCDataGridCell;
begin
  if Assigned(Sender) and (Sender is TTMSFNCDataGridCell) then
  begin
    cl := (Sender as TTMSFNCDataGridCell);
    if Assigned(OnCellButtonClick) then
      OnCellButtonClick(Self, cl.Column, cl.Row);
  end;
end;

procedure TTMSFNCDataGridRenderer.DoCellCheckChange(Sender: TObject);
var
  cl: TTMSFNCDataGridCell;
  I, g: Integer;
  b: Boolean;

  procedure TriggerEvents(ACell: TTMSFNCDataGridCellCoord);
  var
    cll: TTMSFNCDataGridCell;
  begin
    cll := GetCellObjectForCell(ACell);
    if Assigned(cll) then
    begin
      if cll is TTMSFNCDataGridCheckBoxCell then
      begin
        if Assigned(OnCellCheckBoxChange) then
          OnCellCheckBoxChange(Self, cll.Column, cll.Row);
      end
      else if cll is TTMSFNCDataGridRadioButtonCell then
      begin
        if Assigned(OnCellRadioButtonChange) then
          OnCellRadioButtonChange(Self, cll.Column, cll.Row);
      end;
    end;
  end;
begin
  if Assigned(Sender) and (Sender is TTMSFNCDataGridCell) then
  begin
    cl := (Sender as TTMSFNCDataGridCell);
    if cl is TTMSFNCDataGridCheckedCell then
    begin
      IncUpdateCount;

      b := (cl as TTMSFNCDataGridCheckedCell).Checked;

      if (cl is TTMSFNCDataGridCheckBoxCell) then
      begin
        if (cl.Row <= FixedRowCount - 1) and Options.Column.FixedAutoCheckAll then
        begin
          for I := cl.Row to RowCount - FixedBottomRowCount - 1 do
          begin
            if (I <> cl.Row) and IsCellDisplayed(MakeCell(cl.Column, I)) then
            begin
              if Booleans[cl.Column, I] <> b then
              begin
                Booleans[cl.Column, I] := b;
                TriggerEvents(MakeCell(cl.Column, I));
              end;
            end;
          end;
        end;
      end
      else if cl is TTMSFNCDataGridRadioButtonCell then
      begin
        g := RadioGroupIndex[cl.Column, cl.Row];
        for I := 0 to RowCount - 1 do
        begin
          if (I <> cl.Row) and IsCellDisplayed(MakeCell(cl.Column, I)) then
          begin
            if RadioGroupIndex[cl.Column, I] = g then
            begin
              if Booleans[cl.Column, I] <> False then
              begin
                Booleans[cl.Column, I] := False;
                TriggerEvents(MakeCell(cl.Column, I));
              end;
            end;
          end;
        end;
      end;

      if b <> Booleans[cl.Column, cl.Row] then
      begin
        Booleans[cl.Column, cl.Row] := b;
        TriggerEvents(MakeCell(cl.Column, cl.Row));
      end;

      DecUpdateCount;
      Display;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoCellClick(ACell: TTMSFNCDataGridCellCoord; AMouseInfo: TTMSFNCDataGridMouseInfo);
var
  c: Boolean;
  sd: TTMSFNCDataGridSortDirection;
  idx: TTMSFNCDataGridSortIndex;
  cl: TTMSFNCDataGridCell;
begin
  if IsCellFixed(ACell) and (ACell.Row = Options.Sorting.Row) and Options.Sorting.Enabled then
  begin
    c := True;
    DoBeforeSortColumn(ACell.Column, c);

    if c then
    begin
      cl := GetCellObjectForCell(ACell);

      if Assigned(cl) then
      begin
        if not (ssShift in AMouseInfo.Shift) then
          SortIndexList.Clear;

        case cl.SortIndicator of
          gsiAscending: sd := gsdDescending;
          else sd := gsdAscending;
        end;

        idx := nil;
        if not SortIndexList.Find(ACell.Column, idx) then
          SortIndexList.Add(ACell.Column, sd)
        else
        begin
          case idx.Direction of
            gsdAscending: idx.Direction := gsdDescending;
            gsdDescending: idx.Direction := gsdAscending;
          end;          
        end;

        if IsGrouped then
          GroupSortIndexed
        else
          SortIndexed;
      end;

      DoAfterSortColumn(ACell.Column);
    end;
  end;

  if Assigned(OnCellClick) then
    OnCellClick(Self, ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.DoCellDblClick(AColumn, ARow: Integer);
begin
  if Assigned(OnCellDblClick) then
    OnCellDblClick(Self, AColumn, ARow);
end;

procedure TTMSFNCDataGridRenderer.DoCellEditGetData(
  ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor;
  var AValue: TTMSFNCDataGridCellValue);
begin
  if Assigned(OnCellEditGetData) then
    OnCellEditGetData(Self, ACell, AInplaceEditor, AValue);
end;

procedure TTMSFNCDataGridRenderer.DoCellEditSetData(
  ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor;
  var AValue: TTMSFNCDataGridCellValue);
begin
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).EditSetData(ACell, AInplaceEditor, AValue);

  if Assigned(OnCellEditSetData) then
    OnCellEditSetData(Self, ACell, AInplaceEditor, AValue);
end;

procedure TTMSFNCDataGridRenderer.DoCellEditValidateData(
  ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor;
  var AValue: TTMSFNCDataGridCellValue; var AValid: Boolean);
begin
  if Assigned(OnCellEditValidateData) then
    OnCellEditValidateData(Self, ACell, AInplaceEditor, AValue, AValid);
end;

procedure TTMSFNCDataGridRenderer.DoCellRightClick(AColumn, ARow: Integer);
begin
  if Assigned(OnCellRightClick) then
    OnCellRightClick(Self, AColumn, ARow);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeApplyFilter(AColumn: Integer;
  var ACondition: string; var ACanApply: Boolean);
begin
  if Assigned(OnBeforeApplyFilter) then
    OnBeforeApplyFilter(Self, AColumn, ACondition, ACanApply);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeShowFilter(AColumn: Integer; var ACanShow: Boolean);
begin
  if Assigned(OnBeforeShowFilter) then
    OnBeforeShowFilter(Self, AColumn, ACanShow);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeShowFindDialog(
  AFindDialog: TTMSFNCFindDialog; var ACanShow: Boolean);
begin
  if Assigned(OnBeforeShowFindDialog) then
    OnBeforeShowFindDialog(Self, AFindDialog, ACanShow);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeShowFilterDialog(
  AFilterDialog: TTMSFNCFilterDialog; var ACanShow: Boolean);
begin
  if Assigned(OnBeforeShowFilterDialog) then
    OnBeforeShowFilterDialog(Self, AFilterDialog, ACanShow);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeShowReplaceDialog(
  AReplaceDialog: TTMSFNCReplaceDialog; var ACanShow: Boolean);
begin
  if Assigned(OnBeforeShowReplaceDialog) then
    OnBeforeShowReplaceDialog(Self, AReplaceDialog, ACanShow);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeCloseInplaceEditor(ACell: TTMSFNCDataGridCellCoord; AInplaceEditor: TTMSFNCDataGridInplaceEditor; ACancelled: Boolean; var AValue: TTMSFNCDataGridCellValue; var ACanClose: Boolean);
begin
  if Assigned(OnBeforeCloseInplaceEditor) then
    OnBeforeCloseInplaceEditor(Self, ACell, AInplaceEditor, ACancelled, AValue, ACanClose);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeCopyToClipboard(var ACanCopy: Boolean);
begin
  if Assigned(OnBeforeCopyToClipboard) then
    OnBeforeCopyToClipboard(Self, ACanCopy);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeCreateFilterEditor(
  ACell: TTMSFNCDataGridCellCoord; var ACanCreate: Boolean);
begin
  if Assigned(OnBeforeCreateFilterEditor) then
    OnBeforeCreateFilterEditor(Self, ACell, ACanCreate);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeCutToClipboard(var ACanCut: Boolean);
begin
  if Assigned(OnBeforeCutToClipboard) then
    OnBeforeCutToClipboard(Self, ACanCut);
end;

procedure TTMSFNCDataGridRenderer.DoAfterApplyFilter(AColumn: Integer;
  ACondition: string);
begin
  if Assigned(OnAfterApplyFilter) then
    OnAfterApplyFilter(Self, AColumn, ACondition);
end;

procedure TTMSFNCDataGridRenderer.DoCustomizeFilterPopupEditor(AColumn: Integer; var AEditor: TTMSFNCDataGridCellControl);
begin
  if Assigned(OnCustomizeFilterPopupEditor) then
    OnCustomizeFilterPopupEditor(Self, AColumn, AEditor);
end;

procedure TTMSFNCDataGridRenderer.DoAfterShowFilter(AColumn: Integer);
begin
  if Assigned(OnAfterShowFilter) then
    OnAfterShowFilter(Self, AColumn);
end;

procedure TTMSFNCDataGridRenderer.DoAfterShowFilterDialog(
  AFilterDialog: TTMSFNCFilterDialog);
begin
  if Assigned(OnAfterShowFilterDialog) then
    OnAfterShowFilterDialog(Self, AFilterDialog);
end;

procedure TTMSFNCDataGridRenderer.DoAfterShowFindDialog(
  AFindDialog: TTMSFNCFindDialog);
begin
  if Assigned(OnAfterShowFindDialog) then
    OnAfterShowFindDialog(Self, AFindDialog);
end;

procedure TTMSFNCDataGridRenderer.DoAfterShowReplaceDialog(
  AReplaceDialog: TTMSFNCReplaceDialog);
begin
  if Assigned(OnAfterShowReplaceDialog) then
    OnAfterShowReplaceDialog(Self, AReplaceDialog);
end;

procedure TTMSFNCDataGridRenderer.DoAfterCloseInplaceEditor(ACell: TTMSFNCDataGridCellCoord; ACancelled: Boolean; AValue: TTMSFNCDataGridCellValue);
begin
  if Assigned(OnAfterCloseInplaceEditorInternal) then
    OnAfterCloseInplaceEditorInternal(Self, ACell, ACancelled, AValue);

  if Assigned(OnAfterCloseInplaceEditor) then
    OnAfterCloseInplaceEditor(Self, ACell, ACancelled, AValue);
end;

procedure TTMSFNCDataGridRenderer.DoAfterCopyToClipboard;
begin
  if Assigned(OnAfterCopyToClipboard) then
    OnAfterCopyToClipboard(Self);
end;

procedure TTMSFNCDataGridRenderer.DoAfterCreateFilterEditor(
  ACell: TTMSFNCDataGridCellCoord; AEditor: TTMSFNCDataGridCellControl);
begin
  if Assigned(OnAfterCreateFilterEditor) then
    OnAfterCreateFilterEditor(Self, ACell, AEditor);
end;

procedure TTMSFNCDataGridRenderer.DoAfterCutToClipboard;
begin
  if Assigned(OnAfterCutToClipboard) then
    OnAfterCutToClipboard(Self);
end;

procedure TTMSFNCDataGridRenderer.UpdateInplaceEditorPosition;
var
  r: TRectF;
begin
  if (UpdateCount > 0) or GetIsDestroying then
    Exit;

  if Assigned(FInplaceEditor) then
  begin
    r := GetInplaceEditorRect(FEditingCell);
    FInplaceEditor.BoundsRect := {$IFNDEF FMXLIB}ConvertToRect{$ENDIF}(r);
  end;
end;

procedure TTMSFNCDataGridRenderer.CloseColumnsEditor;
begin
  if Assigned(ColumnsEditor) and (ColumnsEditor is TTMSFNCDataGridColumnsEditor) then
    (ColumnsEditor as TTMSFNCDataGridColumnsEditor).Close;
end;

procedure TTMSFNCDataGridRenderer.CloseFilterPopup;
begin
  if Assigned(FFilterPopup) then
    FFilterPopup.IsOpen := False;
end;

function TTMSFNCDataGridRenderer.CloseInplaceEditor(ACancel: Boolean; AFlagClose: Boolean = False; AEnterKey: Boolean = False): Boolean;
var
  ivl: TValue;
  vl: TTMSFNCDataGridCellValue;
  vlv, vlt: TValue;
  cc, a: Boolean;
  nav: Boolean;
  cl, rl: TTMSFNCDataGridCellCoord;
  Allow: Boolean;
  l: TTMSFNCDataGridCellLayout;
begin
  Result := True;

  if FClosing then
    Exit;

  FClosing := True;

  try
    vl := GetObjectValue(FInplaceEditor);
    vlv := CellValueToTValue(vl);

    case FInplaceEditorTarget of
      getCellValue: vlt := CellValueToTValue(Cells[FEditingCell.Column, FEditingCell.Row]);
      getFillColor:
      begin
        vlt := CellValueToTValue(gcNull);
        if HasLayout[FEditingCell.Column, FEditingCell.Row] then
          vlt := CellValueToTValue(Layouts[FEditingCell.Column, FEditingCell.Row].Fill.Color);
      end;
    end;

    if vlt.Kind <> vlv.Kind then
    begin
      case vlt.Kind of
        tkInteger, tkEnumeration: vl := ValueToInteger(vl, FormatSettings);
        tkFloat: vl := ValueToFloat(vl, FormatSettings);
        tkString{$IFNDEF WEBLIB}, tkWString, tkLString, tkUString{$ENDIF}: vl := ValueToString(vl);
        {$IFNDEF WEBLIB}
        tkInt64: vl := ValueToInt64(vl, FormatSettings);
        {$ENDIF}
        else
          vl := ValueToString(vl);
      end;
    end;

    cc := True;
    DoBeforeCloseInplaceEditor(FEditingCell, FInplaceEditor, ACancel, vl, cc);
    if cc then
    begin
      if not ACancel then
      begin
        if IsCellValid(FEditingCell) then
        begin
          a := True;
          DoCellEditValidateData(FEditingCell, FInplaceEditor, vl, a);
          if a then
          begin
            DoCellEditSetData(FEditingCell, FInplaceEditor, vl);

            case FInplaceEditorTarget of
              getCellValue: Cells[FEditingCell.Column, FEditingCell.Row] := vl;
              getFillColor:
              begin
                ivl := CellValueToTValue(vl);
                if ivl.IsType<TTMSFNCGraphicsColor> then
                begin
                  l := Layouts[FEditingCell.Column, FEditingCell.Row];
                  if Assigned(l) then
                  begin
                    l.Fill.Kind := gfkSolid;
                    l.Fill.Color := ivl.AsType<TTMSFNCGraphicsColor>;
                  end;
                end;
              end;
            end;
          end;
        end;
      end;

      DestroyEditor;

      nav := False;
      cl := FocusedCell;
      rl := FRealCell;

      if AEnterKey and (Options.Keyboard.EnterKeyHandling <> gekhNone) then
      begin
        nav := True;
        cl := ProcessEnterKey(cl, Options.Keyboard.EnterKeyHandling);
      end;

      DoAfterCloseInplaceEditor(FEditingCell, ACancel, vl);

      FEditingCell := MakeCell(-1, -1);

      Focus;

      if nav then
      begin
        SelectCell(cl);
        if AEnterKey and Options.Keyboard.EnterKeyDirectEdit then
        begin
          Allow := True;
          DoCanEditCell(FocusedCell.Column, FocusedCell.Row, Allow);
          if Allow then
            EditCell(FocusedCell);
        end;
      end;

      Result := True;
    end
    else
    begin
      Result := False;
      if FInplaceEditor.CanFocus then
      begin
        TTMSFNCDataGridInplaceEditorOpen(FInplaceEditor).SetFocus;
        FClearMouseDown := False;
        FDblClick := False;
      end;
    end;
  finally
    FClosing := False;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoAfterDrawEmptySpace(
  AGraphics: TTMSFNCGraphics; ARect: TRectF;
  AKind: TTMSFNCDataGridEmptySpaceKind);
begin
  if Assigned(OnAfterDrawEmptySpace) then
    OnAfterDrawEmptySpace(AGraphics, AGraphics, ARect, AKind);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeDrawEmptySpace(
  AGraphics: TTMSFNCGraphics; ARect: TRectF;
  AKind: TTMSFNCDataGridEmptySpaceKind; var ACanDraw: Boolean);
begin
  if Assigned(OnBeforeDrawEmptySpace) then
    OnBeforeDrawEmptySpace(Self, AGraphics, ARect, AKind, ACanDraw);
end;

procedure TTMSFNCDataGridRenderer.DoBeforeLookup(var ALookupString: string;
  var ACanLookup: Boolean);
begin
  if Assigned(OnBeforeLookup) then
    OnBeforeLookup(Self, ALookupString, ACanLookup);
end;

procedure TTMSFNCDataGridRenderer.DoGetCellClass(AColumn, ARow: Integer;
  var ACellClass: TTMSFNCDataGridCellClass);
begin
  if Assigned(OnGetCellClass) then
    OnGetCellClass(Self, AColumn, ARow, ACellClass);
end;

procedure TTMSFNCDataGridRenderer.DoGetCellFormatting(
  ACell: TTMSFNCDataGridCellCoord; AData: TTMSFNCDataGridCellValue;
  var AFormatting: TTMSFNCDataGridDataFormatting; var AConvertSettings: TFormatSettings; var ACanFormat: Boolean);
var
  cl: TTMSFNCDataGridColumn;
begin
  cl := GetColumn(ACell.Column);
  if Assigned(cl) and (gcsFormatting in cl.Settings) then
  begin
    AFormatting.Format := cl.Formatting.Format;
    AFormatting.&Type := cl.Formatting.&Type;
    AFormatting.BooleanTrueText := cl.Formatting.BooleanTrueText;
    AFormatting.BooleanFalseText := cl.Formatting.BooleanFalseText;
    AConvertSettings := cl.Formatting.ConvertSettings;
  end;
  inherited;
end;

procedure TTMSFNCDataGridRenderer.DoGetCellHint(ACell: TTMSFNCDataGridCellCoord;
  var AHint: string);
begin
  if Assigned(OnGetCellHint) then
    OnGetCellHint(Self, ACell, AHint);
end;

procedure TTMSFNCDataGridRenderer.DoGetCellLayout(ACell: TTMSFNCDataGridCell);
begin
  if Assigned(OnGetCellLayout) then
    OnGetCellLayout(Self, ACell);
end;

procedure TTMSFNCDataGridRenderer.DoGetCellLayoutHasPriority(ACell: TTMSFNCDataGridCellCoord; var AHasPriority: Boolean);
begin
  if Assigned(OnGetCellLayoutHasPriority) then
    OnGetCellLayoutHasPriority(Self, ACell, AHasPriority);
end;

procedure TTMSFNCDataGridRenderer.DoGetCellProperties(ACell: TTMSFNCDataGridCell);
begin
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).GetCellProperties(ACell);

  if Assigned(OnGetCellProperties) then
    OnGetCellProperties(Self, ACell);
end;

procedure TTMSFNCDataGridRenderer.DoHScroll(APosition: Single);
begin
  if Assigned(OnHScroll) then
    OnHScroll(Self, APosition);
end;

function TTMSFNCDataGridRenderer.DoIsDesigntimeGrid(Sender: TObject): Boolean;
begin
  Result := False;
  if Assigned(OnIsDesigntime) then
    Result := OnIsDesigntime(Sender);
end;

function TTMSFNCDataGridRenderer.DoIsDestroyingGrid(Sender: TObject): Boolean;
begin
  Result := False;
  if Assigned(OnIsDestroying) then
    Result := OnIsDestroying(Sender);
end;

function TTMSFNCDataGridRenderer.DoIsLoadingGrid(Sender: TObject): Boolean;
begin
  Result := False;
  if Assigned(OnIsLoading) then
    Result := OnIsLoading(Sender);
end;

procedure TTMSFNCDataGridRenderer.DoLayoutChanged(Sender: TObject);
begin
  DoUpdate;
end;

procedure TTMSFNCDataGridRenderer.DoLookupTimer(Sender: TObject);
begin
  FLookupString := '';
  LookupTimer.Enabled := False;
end;

function TTMSFNCDataGridRenderer.DoIsFocusedGrid(Sender: TObject): Boolean;
begin
  Result := False;
  if Assigned(OnIsFocused) then
    Result := OnIsFocused(Sender);
end;

procedure TTMSFNCDataGridRenderer.DoNeedFilterDropDownData(AColumn: Integer;
  AValues: TStrings);
begin
  if Assigned(OnNeedFilterDropDownData) then
    OnNeedFilterDropDownData(Self, AColumn, AValues);
end;

procedure TTMSFNCDataGridRenderer.DoPaintCommentPopup(Sender: TObject;
  AGraphics: TTMSFNCGraphics; ARect: TRectF);
var
  c: TTMSFNCCommentPopup;
  cl: TTMSFNCDataGridCell;
  r: TRectF;
begin
  if Sender is TTMSFNCCommentPopup then
  begin
    c := (Sender as TTMSFNCCommentPopup);
    cl := c.FCell;
    if Assigned(cl) then
    begin
      r := ARect;
      InflateRectEx(r, -4, -4);
      AGraphics.DrawText(r, cl.Comment, True, gtaLeading, gtaLeading);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoCellCommentIndicatorClick(Sender: TObject);
var
  g: TTMSFNCGraphics;
  sz: TSizeF;
  pt: TPointF;
  {$IFNDEF FMXLIB}
  ptx: TPoint;
  {$ENDIF}
  p: TTMSFNCDataGridCellParent;
  cl: TTMSFNCDataGridCell;
  cr: TRectF;
  cm: string;
begin
  inherited;

  if Sender is TTMSFNCDataGridCell then
  begin
    cl := Sender as TTMSFNCDataGridCell;

    p := GetParentHost;

    if p is TTMSFNCDataGridCellControl then
      CommentPopup.PlacementControl := p as TTMSFNCDataGridCellControl;

    cr := TTMSFNCDataGridCellOpen(cl).GetCommentIndicatorRect;

    pt := PointF(cr.Left, cr.Bottom);

    if p is TTMSFNCDataGridCellControl then
    begin
      {$IFDEF FMXLIB}
      pt := TTMSFNCDataGridCellControlOpen(p as TTMSFNCDataGridCellControl).LocalToScreen(pt);
      {$ELSE}
      ptx := (p as TTMSFNCDataGridCellControl).ClientToScreen(Point(Round(pt.X), Round(pt.Y)));
      pt := PointF(ptx.X, ptx.Y);
      {$ENDIF}
    end;

    cm := cl.Comment;

    CommentPopup.FCell := cl;

    g := TTMSFNCGraphics.CreateBitmapCanvas;
    g.BeginScene;
    g.BitmapContainer := BitmapContainer;
    //g.OptimizedHTMLDrawing := OptimizedHTMLDrawing;
    try
      sz := g.CalculateTextSize(cm, RectF(0, 0, 10000, 10000), True, True);
      CommentPopup.DropDownHeight := sz.cy + 10;
      CommentPopup.DropDownWidth := sz.cx + 10;
    finally
      g.EndScene;
      g.Free;
    end;

    //pt := PointF(pt.X  - FCommentPopup.DropDownWidth, ACell.Top - FCommentPopup.DropDownHeight));
    CommentPopup.PlacementRectangle.Left := pt.X;
    CommentPopup.PlacementRectangle.Top := pt.Y;
    CommentPopup.PlacementRectangle.Right := pt.X + CommentPopup.DropDownWidth;
    CommentPopup.PlacementRectangle.Bottom := pt.Y + CommentPopup.DropDownHeight;

    CommentPopup.Popup;

    //if Assigned(OnCellCommentClick) then
    //  OnCellCommentClick(Self, ACol, ARow, ACell);
  end;
end;

procedure TTMSFNCDataGridRenderer.DoCellFilterButtonClick(Sender: TObject);
var
  pt: TPointF;
  cl: TTMSFNCDataGridCell;
  fr: TRectF;
  p: TTMSFNCDataGridCellParent;
  c: Boolean;
  {$IFNDEF FMXLIB}
  ptx: TPoint;
  {$ENDIF}
  ed: TTMSFNCDataGridCellControl;
begin
  if Assigned(Sender) and (Sender is TTMSFNCDataGridCell) then
  begin
    cl := (Sender as TTMSFNCDataGridCell);
    if (Options.Filtering.Enabled) and (Options.Filtering.Row = cl.Row) then
    begin
      if Options.Filtering.Advanced then
        ShowFilterDialog
      else
      begin
        c := True;
        DoBeforeShowFilter(cl.Column, c);

        if c then
        begin
          UpdateFilterList(cl.Column);

          p := GetParentHost;

          if p is TTMSFNCDataGridCellControl then
            FilterPopup.PlacementControl := p as TTMSFNCDataGridCellControl;

          fr := TTMSFNCDataGridCellOpen(cl).GetFilterButtonRect;

          pt := PointF(fr.Left, fr.Bottom);

          if p is TTMSFNCDataGridCellControl then
          begin
            {$IFDEF FMXLIB}
            pt := TTMSFNCDataGridCellControlOpen(p as TTMSFNCDataGridCellControl).LocalToScreen(pt);
            {$ELSE}
            ptx := (p as TTMSFNCDataGridCellControl).ClientToScreen(Point(Round(pt.X), Round(pt.Y)));
            pt := PointF(ptx.X, ptx.Y);
            {$ENDIF}
          end;

          FilterPopup.PlacementRectangle.Left := pt.X;
          FilterPopup.PlacementRectangle.Top := pt.Y;
          FilterPopup.PlacementRectangle.Right := pt.X + FilterPopup.DropDownWidth;
          FilterPopup.PlacementRectangle.Bottom := pt.Y + FilterPopup.DropDownHeight;

          if not FStyleApplied then
          begin
            FilterPopup.FillColor := FilterAppearance.Fill.Color;
            FilterPopup.StrokeColor := FilterAppearance.Stroke.Color;
            TFNCControlOpen(FilterContainer).Fill.Assign(FilterAppearance.Fill);
            TFNCControlOpen(FilterContainer).Stroke.Assign(FilterAppearance.Stroke);
          end;

          FilterContainer.Width := Options.Filtering.DropDownWidth;
          FilterContainer.Height := Options.Filtering.DropDownHeight;
          FilterPopup.DropDownHeight := Options.Filtering.DropDownHeight;
          FilterPopup.DropDownWidth := Options.Filtering.DropDownWidth;

          //controls
          FilterTypeComboBox.Parent := nil;
          FilterEdit.Parent := nil;
          FilterClearButton.Parent := nil;
          FilterListBox.Parent := nil;
          FilterSortAscendingButton.Parent := nil;
          FilterSortDescendingButton.Parent := nil;

          if Assigned(FFilterCustomEditor) then
            FFilterCustomEditor.Parent := nil;

          ed := nil;
          DoCustomizeFilterPopupEditor(cl.Column, ed);
          if not Assigned(ed) then
          begin
            FilterTypeComboBox.Parent := FilterContainer;
            FilterEdit.Parent := FilterContainer;
            FilterClearButton.Parent := FilterContainer;
            FilterListBox.Parent := FilterContainer;
            FilterSortAscendingButton.Parent := FilterContainer;
            FilterSortDescendingButton.Parent := FilterContainer;

            FilterClearButton.DataInteger := cl.Column;
            FilterSortAscendingButton.DataInteger := cl.Column;
            FilterSortDescendingButton.DataInteger := cl.Column;
            FilterSortAscendingButton.Visible := Options.Sorting.Enabled;
            FilterSortDescendingButton.Visible := Options.Sorting.Enabled;

            FilterEdit.Tag := cl.Column;
            FilterPopup.FocusedControl := FilterEdit;
          end
          else
          begin
            ed.Parent := FilterContainer;
            FilterPopup.FocusedControl := ed;
          end;

          FFilterCustomEditor := ed;

          FilterPopup.ContentControl := FilterContainer;
          {$IFDEF FMXMOBILE}
          FilterPopup.StaysOpen := True;
          {$ENDIF}
          FilterPopup.Popup;
          {$IFDEF FMXMOBILE}
          FilterExitTimer.Enabled := True;
          {$ENDIF}

          if not Assigned(ed) then
          begin
            if not FStyleApplied then
            begin
              FilterListBox.ItemsAppearance.Font.Assign(FilterAppearance.Font);
              FilterSortAscendingButton.Font.Assign(FilterAppearance.Font);
              FilterSortAscendingButton.Appearance.NormalFill.Assign(FilterAppearance.Fill);
              FilterSortAscendingButton.Appearance.NormalStroke.Assign(FilterAppearance.Stroke);
              FilterSortDescendingButton.Font.Assign(FilterAppearance.Font);
              FilterSortDescendingButton.Appearance.NormalFill.Assign(FilterAppearance.Fill);
              FilterSortDescendingButton.Appearance.NormalStroke.Assign(FilterAppearance.Stroke);
            end
            else
            begin
              FilterSortAscendingButton.Appearance.NormalStroke.Kind := gskNone;
              FilterSortDescendingButton.Appearance.NormalStroke.Kind := gskNone;
            end;
          end;

          TTMSFNCDataGridCellControlOpen(FilterContainer).Realign;
          DoAfterShowFilter(cl.Column);
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoCellNodeCollapse(Sender: TObject);
var
  cl: TTMSFNCDataGridCell;
  cc: Boolean;
  c: TTMSFNCDataGridCellCoord;
begin
  if Assigned(Sender) and (Sender is TTMSFNCDataGridCell) then
  begin
    cl := (Sender as TTMSFNCDataGridCell);
    cc := True;
    c := cl.Coordinate;
    DoCellBeforeNodeCollapse(c, cc);
    if cc then
    begin
      CollapseNode(c.Row);
      DoCellAfterNodeCollapse(c);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoCellNodeExpand(Sender: TObject);
var
  cl: TTMSFNCDataGridCell;
  c: TTMSFNCDataGridCellCoord;
  ce: Boolean;
begin
  if Assigned(Sender) and (Sender is TTMSFNCDataGridCell) then
  begin
    cl := (Sender as TTMSFNCDataGridCell);
    ce := True;
    c := cl.Coordinate;
    DoCellBeforeNodeExpand(c, ce);
    if ce then
    begin
      ExpandNode(c.Row);
      DoCellAfterNodeExpand(c);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoCellBeforeDraw(Sender: TObject;
  AGraphics: TTMSFNCGraphics; var ACanDraw: Boolean);
begin
  if Assigned(OnBeforeDrawCell) and (Sender is TTMSFNCDataGridCell) then
    OnBeforeDrawCell(Self, AGraphics, Sender as TTMSFNCDataGridCell, ACanDraw);
end;

procedure TTMSFNCDataGridRenderer.DoCellBeforeNodeCollapse(
  ACell: TTMSFNCDataGridCellCoord; var ACanCollapse: Boolean);
begin
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).RowBeforeCollapse(ACell.Row);

  if Assigned(OnCellBeforeNodeCollapse) then
    OnCellBeforeNodeCollapse(Self, ACell, ACanCollapse);
end;

procedure TTMSFNCDataGridRenderer.DoCellBeforeNodeExpand(
  ACell: TTMSFNCDataGridCellCoord; var ACanExpand: Boolean);
begin
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).RowBeforeExpand(ACell.Row);

  if Assigned(OnCellBeforeNodeExpand) then
    OnCellBeforeNodeExpand(Self, ACell, ACanExpand);
end;

procedure TTMSFNCDataGridRenderer.DoCellBeforeShowPopupMenu(ACell: TTMSFNCDataGridCellCoord; APopupMenu: TPopupMenu; var ACanShow: Boolean);
begin
  if Assigned(OnCellBeforeShowPopupMenu) then
    OnCellBeforeShowPopupMenu(Self, ACell, APopupMenu, ACanShow);
end;

procedure TTMSFNCDataGridRenderer.DoSelectCell(AStartCell,
  AEndCell: TTMSFNCDataGridCellCoord);
begin
  if Assigned(OnSelectCell) then
    OnSelectCell(Self, AStartCell, AEndCell);
end;

procedure TTMSFNCDataGridRenderer.DoSelectingCell(AStartCell,
  AEndCell: TTMSFNCDataGridCellCoord; var ACanSelect: Boolean);
begin
  if Assigned(OnSelectingCell) then
    OnSelectingCell(Self, AStartCell, AEndCell, ACanSelect);
end;

procedure TTMSFNCDataGridRenderer.DoColumnSized(AColumn: Integer; ASize: Double);
begin
  if Assigned(OnColumnSized) then
    OnColumnSized(Self, AColumn, ASize);
end;

function TTMSFNCDataGridRenderer.DoCreateCustomFilterEditor(
  ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCellControl;
begin
  Result := nil;
  if Assigned(OnCreateCustomFilterEditor) then
    Result := OnCreateCustomFilterEditor(Self, ACell);
end;

procedure TTMSFNCDataGridRenderer.DoRowSized(ARow: Integer; ASize: Double);
begin
  if Assigned(OnRowSized) then
    OnRowSized(Self, ARow, ASize);
end;

procedure TTMSFNCDataGridRenderer.DoSizeColumn(AColumn: Integer; ASize: Double);
begin
  if Assigned(OnSizeColumn) then
    OnSizeColumn(Self, AColumn, ASize);
end;

procedure TTMSFNCDataGridRenderer.DoSizeRow(ARow: Integer; ASize: Double);
begin
  if Assigned(OnSizeRow) then
    OnSizeRow(Self, ARow, ASize);
end;

procedure TTMSFNCDataGridRenderer.DoUpdateCursorGrid(Sender: TObject;
  ACursor: TCursor);
begin
  if Assigned(OnUpdateCursor) then
    OnUpdateCursor(Sender, ACursor);
end;

procedure TTMSFNCDataGridRenderer.DoVScroll(APosition: Single);
begin
  if Assigned(OnVScroll) then
    OnVScroll(Self, APosition);
end;

procedure TTMSFNCDataGridRenderer.DoDisplay;
begin
  if Assigned(OnDisplay) then
    OnDisplay(Self);
end;

procedure TTMSFNCDataGridRenderer.DoDisplayGrid(Sender: TObject);
begin
  if Assigned(OnDisplay) then
    OnDisplay(Sender);
end;

procedure TTMSFNCDataGridRenderer.DoEditorExit(Sender: TObject);
begin
  StopEditing;
end;

procedure TTMSFNCDataGridRenderer.DoEditorKeyDown(Sender: TObject; var Key: Word;
  {$IFDEF FMXLIB}var KeyChar: WideChar; {$ENDIF}Shift: TShiftState);
begin
  if Shift <> [] then
    Exit;

  FKeyDown := True;

  case Key of
    KEY_TAB: if FInplaceEditorActive then Key := 0;
    KEY_RETURN, KEY_F2:
    begin
      FDroppedDown := ((FInplaceEditor is TCustomComboBox) and (FInplaceEditor as TCustomComboBox).DroppedDown);
      FDroppedDown := FDroppedDown or ((FInplaceEditor is TTMSFNCDataGridEdit) and (FInplaceEditor as TTMSFNCDataGridEdit).LookupList.IsOpen);
      FDroppedDown := FDroppedDown or ((FInplaceEditor is TTMSFNCCustomPicker) and (FInplaceEditor as TTMSFNCCustomPicker).Popup.IsOpen);
      {$IFDEF FMXLIB}
      FDroppedDown := FDroppedDown or ((FInplaceEditor is TCustomComboEdit) and (FInplaceEditor as TCustomComboEdit).DroppedDown);
      FDroppedDown := FDroppedDown or ((FInplaceEditor is TCustomDateTimeEdit) and (FInplaceEditor as TCustomDateTimeEdit).IsPickerOpened);
      {$ENDIF}

      if not ((FInplaceEditor is TCustomComboBox) and (FInplaceEditor as TCustomComboBox).DroppedDown)
        and not ((FInplaceEditor is TTMSFNCDataGridEdit) and (FInplaceEditor as TTMSFNCDataGridEdit).LookupList.IsOpen)
        and not ((FInplaceEditor is TTMSFNCCustomPicker) and (FInplaceEditor as TTMSFNCCustomPicker).Popup.IsOpen)
        {$IFDEF FMXLIB}
        and not ((FInplaceEditor is TCustomComboEdit) and (FInplaceEditor as TCustomComboEdit).DroppedDown)
        and not ((FInplaceEditor is TCustomDateTimeEdit) and (FInplaceEditor as TCustomDateTimeEdit).IsPickerOpened)
        {$ENDIF}
        then
        Key := 0;
    end;
    KEY_UP, KEY_DOWN:
    begin
      if not (FInplaceEditor is TCustomMemo) and not ((FInplaceEditor is TCustomComboBox) and (FInplaceEditor as TCustomComboBox).DroppedDown)
        and not ((FInplaceEditor is TTMSFNCDataGridEdit) and (FInplaceEditor as TTMSFNCDataGridEdit).LookupList.IsOpen)
        and not ((FInplaceEditor is TTMSFNCCustomPicker) and (FInplaceEditor as TTMSFNCCustomPicker).Popup.IsOpen)
        {$IFDEF FMXLIB}
        and not ((FInplaceEditor is TCustomComboEdit) and (FInplaceEditor as TCustomComboEdit).DroppedDown)
        and not ((FInplaceEditor is TCustomDateTimeEdit) and (FInplaceEditor as TCustomDateTimeEdit).IsPickerOpened)
        {$ENDIF}
        then
        Key := 0;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoEditorKeyUp(Sender: TObject; var Key: Word;
  {$IFDEF FMXLIB}var KeyChar: WideChar; {$ENDIF}Shift: TShiftState);
var
  ki: TTMSFNCDataGridKeyInfo;
  a, Allow: Boolean;
begin
  if not FKeyDown then
    Exit;

  FKeyDown := False;

  case Key of
    KEY_TAB:
    begin
      ki := DefaultKeyInfo;
      ki.Kind := gkkDialog;
      ki.Key := Key;
      ki.Shift := Shift;
      ki.Blocked := FInplaceEditorActive;
      HandleKey(ki);
    end;
  end;

  if Shift <> [] then
    Exit;

  case Key of
    KEY_ESCAPE: CancelEditing;
    KEY_RETURN, KEY_F2:
    begin
      if not FDroppedDown then
        CloseInplaceEditor(False, False, Key = KEY_RETURN);
    end;
    KEY_LEFT:
    begin
      if Options.Keyboard.ArrowKeyDirectEdit then
      begin
        if ((FInplaceEditor is TCustomEdit) and ((FInplaceEditor as TCustomEdit).SelStart = 0))
          or ((FInplaceEditor is TCustomMemo) and ((FInplaceEditor as TCustomMemo).SelStart = 0)) then
        begin
          ki := DefaultKeyInfo;
          ki.Key := KEY_TAB;
          ki.Shift := [ssShift];
          ProcessTab(ki, gtkdNextColumnCell, gtkhNextCell, True, gcsEnd);
        end;
      end;
    end;
    KEY_RIGHT:
    begin
      if Options.Keyboard.ArrowKeyDirectEdit then
      begin
        if ((FInplaceEditor is TCustomEdit) and ((FInplaceEditor as TCustomEdit).SelStart = Length((FInplaceEditor as TCustomEdit).Text)))
          or ((FInplaceEditor is TCustomMemo) and ((FInplaceEditor as TCustomMemo).SelStart = Length((FInplaceEditor as TCustomMemo).Text))) then
        begin
          ki := DefaultKeyInfo;
          ki.Key := KEY_TAB;
          ProcessTab(ki, gtkdNextColumnCell, gtkhNextCell, True, gcsStart);
        end;
      end;
    end;
    KEY_UP, KEY_DOWN:
    begin
      if not (FInplaceEditor is TCustomMemo) and not ((FInplaceEditor is TCustomComboBox) and (FInplaceEditor as TCustomComboBox).DroppedDown)
        and not ((FInplaceEditor is TTMSFNCDataGridEdit) and (FInplaceEditor as TTMSFNCDataGridEdit).LookupList.IsOpen)
        and not ((FInplaceEditor is TTMSFNCCustomPicker) and (FInplaceEditor as TTMSFNCCustomPicker).Popup.IsOpen)
        {$IFDEF FMXLIB}
        and not ((FInplaceEditor is TCustomComboEdit) and (FInplaceEditor as TCustomComboEdit).DroppedDown)
        and not ((FInplaceEditor is TCustomDateTimeEdit) and (FInplaceEditor as TCustomDateTimeEdit).IsPickerOpened)
        {$ENDIF}
        and not (FInplaceEditorType in [getSpinBox])
        then
      begin
        a := StopEditing;
        if a then
        begin
          ki := DefaultKeyInfo;
          ki.Key := Key;
          ki.Shift := Shift;
          ki.Kind := gkkDown;
          HandleKey(ki);

          if Options.Keyboard.ArrowKeyDirectEdit then
          begin
            Allow := True;
            DoCanEditCell(FocusedCell.Column, FocusedCell.Row, Allow);
            if Allow then
              EditCell(FocusedCell);
          end;
        end;
      end;
    end;
  end;

  FDroppedDown := False;

  {$IFDEF FMXLIB}
  KeyChar := ki.KeyChar;
  {$ENDIF}
  Key := ki.Key;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCDataGridRenderer.DoEditorKeyPress(Sender: TObject; var Key: Char);
begin
  if Ord(Key) in [KEY_ESCAPE, KEY_RETURN, KEY_TAB] then
    Key := #0;
end;
{$ENDIF}

procedure TTMSFNCDataGridRenderer.DoFocusGrid(Sender: TObject);
begin
  if Assigned(OnFocus) then
    OnFocus(Sender);
end;

procedure TTMSFNCDataGridRenderer.BeforeExport;
begin
  inherited;
  FSaveClipRect := FClipRect;
end;

procedure TTMSFNCDataGridRenderer.BeginDrag;
var
  p: TTMSFNCDataGridCellParent;
begin
  p := GetParentHost;
  if Assigned(p) and (p is TTMSFNCCustomControl) then
  begin
    FDragging := True;
    TFNCControlOpen(p).BeginDrag;
  end;
end;

procedure TTMSFNCDataGridRenderer.BuildDisplay(AList: TTMSFNCDataGridCellList; ADisplay: TTMSFNCDataGridDisplayList);
var
  I: Integer;
begin
  if (UpdateCount > 0) or GetIsDestroying or not Assigned(AList) or not Assigned(ADisplay) then
    Exit;

  ADisplay.Clear;
  for I := 0 to AList.Count - 1 do
    AddCellToDisplay(AList[I], ADisplay);
end;

procedure TTMSFNCDataGridRenderer.Display;
begin
  if (UpdateCount > 0) or GetIsDestroying then
    Exit;

  BuildDisplay(FNormalCellList, FNormalCellDisplay);
  BuildDisplay(FFixedRowCellList, FFixedRowCellDisplay);
  BuildDisplay(FFixedColumnCellList, FFixedColumnCellDisplay);
  BuildDisplay(FFixedRootCellList, FFixedRootCellDisplay);

  UpdateInplaceEditorPosition;

  DoDisplay;
end;

procedure TTMSFNCDataGridRenderer.CellAppearanceChanged(Sender: TObject);
begin
  Display;
end;

procedure TTMSFNCDataGridRenderer.IconsChanged(Sender: TObject);
begin
  Display;
end;

constructor TTMSFNCDataGridRenderer.Create(AHost: TObject = nil);
var
  p: TTMSFNCDataGridCellParent;
begin
  FHost := AHost;

  inherited Create(AHost);

  if Assigned(AHost) and (AHost is TPersistent) then
    FColumns := GetColumnsClass.Create(AHost as TPersistent, Self)
  else
    FColumns := GetColumnsClass.Create(nil, Self);

  FColumns.OnChange := @DoColumnsChanged;

  FScale := 1.0;
  FDragCell := MakeCell(-1, -1);
  FDragCellTo := MakeCell(-1, -1);

  FSelection := MakeCellRange(-1, -1, -1, -1);

  FStretchScrollBars := False;

  FScrollMode := gsmPixelScrolling;
  FScrollUpdate := gsuContinuous;
  FCustomScrollBars := False;
  FFilterEditMode := gfemList;

  FPadding := TTMSFNCMargins.Create;
  FPadding.OnChange := @PaddingChanged;

  FVerticalScrollBarVisible := True;
  FHorizontalScrollBarVisible := True;

  FEditingCell := MakeCell(-1, -1);
  FFocusedCell := MakeCell(-1, -1);
  FFirstCell := FFocusedCell;
  FRealCell := FFocusedCell;
  FSaveCell := FFocusedCell;

  Options.OnChange := @OptionsChanged;
  Options.OnChangeRebuild := OptionsChangedRebuild;
  FStroke := TTMSFNCGraphicsStroke.Create;
  FMergedCells := TTMSFNCDataGridMergedCells.Create;
  FNormalCellList := TTMSFNCDataGridNormalCellList.Create;
  FNormalCellDisplay := TTMSFNCDataGridNormalCellDisplayList.Create;
  FFixedColumnCellList := TTMSFNCDataGridFixedColumnCellList.Create;
  FFixedColumnCellDisplay := TTMSFNCDataGridFixedColumnCellDisplayList.Create;
  FFixedRowCellList := TTMSFNCDataGridFixedRowCellList.Create;
  FFixedRowCellDisplay := TTMSFNCDataGridFixedRowCellDisplayList.Create;
  FFixedRootCellList := TTMSFNCDataGridFixedRootCellList.Create;
  FFixedRootCellDisplay := TTMSFNCDataGridFixedRootCellDisplayList.Create;
  FCellAppearance := TTMSFNCDataGridCellAppearance.Create;
  FCellAppearance.OnChange := @CellAppearanceChanged;
  FIcons := TTMSFNCDataGridIcons.Create;
  FIcons.OnChange := @IconsChanged;

  FStyleApplied := False;
  FFilterAppearance := TTMSFNCDataGridFilterAppearance.Create;
  FDragAppearance := TTMSFNCDataGridDragAppearance.Create;

  FGlobalFont := TTMSFNCAppearanceGlobalFont.Create(Self);

  p := nil;
  if Assigned(AHost) and (AHost is TTMSFNCDataGridCellParent) then
  begin
    p := AHost as TTMSFNCDataGridCellParent;

    FVerticalScrollBar := TScrollBar.Create(p);
    FVerticalScrollBar.Parent := p;
    FVerticalScrollBar.TabStop := False;
    {$IFNDEF CMNWEBLIB}
    FVerticalScrollBar.CanFocus := False;
    {$ENDIF}

    FHorizontalScrollBar := TScrollBar.Create(p);
    FHorizontalScrollBar.Parent := p;
    FHorizontalScrollBar.TabStop := False;
    {$IFNDEF CMNWEBLIB}
    FHorizontalScrollBar.CanFocus := False;
    {$ENDIF}

    {$IFDEF FMXLIB}
    FVerticalScrollBar.Stored := False;
    FHorizontalScrollBar.Stored := False;
    FVerticalScrollBar.Orientation := TOrientation.Vertical;
    {$ENDIF}

    {$IFDEF CMNWEBLIB}
    FVerticalScrollBar.DoubleBuffered := False;
    FHorizontalScrollBar.DoubleBuffered := False;
    FVerticalScrollBar.Kind := sbVertical;
    {$ENDIF}

    FVerticalScrollBar.OnChange := @VScrollChanged;
    FHorizontalScrollBar.OnChange := @HScrollChanged;
  end;

  FCustomVerticalScrollBar := TTMSFNCDataGridScrollBar.Create(p);
  FCustomVerticalScrollBar.Parent := p;
  FCustomVerticalScrollBar.TabStop := False;
  {$IFNDEF CMNWEBLIB}
  FCustomVerticalScrollBar.CanFocus := False;
  {$ENDIF}

  FCustomHorizontalScrollBar := TTMSFNCDataGridScrollBar.Create(p);
  FCustomHorizontalScrollBar.Parent := p;
  FCustomHorizontalScrollBar.TabStop := False;
  {$IFNDEF CMNWEBLIB}
  FCustomHorizontalScrollBar.CanFocus := False;
  {$ENDIF}

  CustomVerticalScrollBar.Stroke.Color := Stroke.Color;
  CustomVerticalScrollBar.Appearance.ThumbStroke.Color := Stroke.Color;
  CustomVerticalScrollBar.Appearance.ScrollButtonLeftStroke.Color := Stroke.Color;
  CustomVerticalScrollBar.Appearance.ScrollButtonRightStroke.Color := Stroke.Color;
  CustomVerticalScrollBar.Appearance.ThumbButtonLeftStroke.Color := Stroke.Color;
  CustomVerticalScrollBar.Appearance.ThumbButtonRightStroke.Color := Stroke.Color;

  CustomHorizontalScrollBar.Appearance.Assign(CustomVerticalScrollBar.Appearance);
  FCustomVerticalScrollBar.Appearance.ThumbButtonSize := 0;
  FCustomHorizontalScrollBar.Appearance.ThumbButtonSize := 0;
  {$IFDEF FMXLIB}
  FCustomVerticalScrollBar.Stored := False;
  FCustomHorizontalScrollBar.Stored := False;
  {$ENDIF}
  FCustomHorizontalScrollBar.Kind := sbkHorizontal;
  FCustomVerticalScrollBar.Visible := False;
  FCustomHorizontalScrollBar.Visible := False;
  FCustomHorizontalScrollBar.OnValueChanged := HCustomScrollChanged;
  FCustomVerticalScrollBar.OnValueChanged := VCustomScrollChanged;

  if Assigned(AHost) then
  begin
    if (AHost is TTMSFNCDataGridRenderer) then
    begin
      OnDisplay := (AHost as TTMSFNCDataGridRenderer).DoDisplayGrid;
      OnFocus := (AHost as TTMSFNCDataGridRenderer).DoFocusGrid;
      OnCalculate := (AHost as TTMSFNCDataGridRenderer).DoCalculateGrid;
      OnBeforeCalculate := (AHost as TTMSFNCDataGridRenderer).DoBeforeCalculateGrid;
      OnUpdateCursor := (AHost as TTMSFNCDataGridRenderer).DoUpdateCursorGrid;
      OnIsDestroying := (AHost as TTMSFNCDataGridRenderer).DoIsDestroyingGrid;
      OnIsLoading := (AHost as TTMSFNCDataGridRenderer).DoIsLoadingGrid;
      OnIsDesigntime := (AHost as TTMSFNCDataGridRenderer).DoIsDesigntimeGrid;
      OnIsFocused := (AHost as TTMSFNCDataGridRenderer).DoIsFocusedGrid;
    end
    else if AHost is TTMSFNCDataGridBase then
    begin
      OnDisplay := TTMSFNCDataGridBaseOpen(AHost as TTMSFNCDataGridBase).DoRootDisplay;
      OnFocus := TTMSFNCDataGridBaseOpen(AHost as TTMSFNCDataGridBase).DoRootFocus;
      OnCalculate := TTMSFNCDataGridBaseOpen(AHost as TTMSFNCDataGridBase).DoRootCalculate;
      OnBeforeCalculate := TTMSFNCDataGridBaseOpen(AHost as TTMSFNCDataGridBase).DoRootBeforeCalculate;
      OnUpdateCursor := TTMSFNCDataGridBaseOpen(AHost as TTMSFNCDataGridBase).DoRootUpdateCursor;
      OnIsDestroying := TTMSFNCDataGridBaseOpen(AHost as TTMSFNCDataGridBase).DoRootIsDestroying;
      OnIsLoading := TTMSFNCDataGridBaseOpen(AHost as TTMSFNCDataGridBase).DoRootIsLoading;
      OnIsDesigntime := TTMSFNCDataGridBaseOpen(AHost as TTMSFNCDataGridBase).DoRootIsDesigntime;
      OnIsFocused := TTMSFNCDataGridBaseOpen(AHost as TTMSFNCDataGridBase).DoRootIsFocused;
    end;
  end;
end;

function TTMSFNCDataGridRenderer.CreateCell(ARect: TRectF;
  ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCell;
begin
  Result := CreateCell(ARect, ACell.Column, ACell.Row);
end;

function TTMSFNCDataGridRenderer.CreateCell(ARect: TRectF; AColumn,
  ARow: Integer): TTMSFNCDataGridCell;
var
  cls: TTMSFNCDataGridCellClass;
  ck: TTMSFNCDataGridCellKind;
  d: TTMSFNCDataGridCellItem;
begin
  Result := nil;
  cls := GetBaseCellClass(MakeCell(AColumn, ARow));
  DoGetCellClass(AColumn, ARow, cls);
  if Assigned(cls) then
  begin
    ck := GetCellKind(MakeCell(AColumn, ARow));
    d := CellData[AColumn, ARow];
    Result := cls.Create(ARect, AColumn, ARow, d, ck, Self);
  end;
end;

procedure TTMSFNCDataGridRenderer.DestroyDragBitmap;
begin
  if Assigned(FDragBitmap) then
  begin
    FDragBitmap.Parent := nil;
    FDragBitmap.Free;
    FDragBitmap := nil;
  end;
end;

procedure TTMSFNCDataGridRenderer.CreateDragBitmap(AMouseInfo: TTMSFNCDataGridMouseInfo);
var
  g: TTMSFNCGraphics;
  dr: TRectF;
  {$IFDEF WEBLIB}
  r: String;
  {$ENDIF}
  p: TTMSFNCDataGridCellParent;
  sc: Single;
  ci: TTMSFNCDataGridCell;
begin
  Exit;
  if not IsCellValid(FDragCell) then
    Exit;

  p := GetParentHost;
  if not Assigned(p) then
    Exit;

  sc := 1.0;
  if p is TTMSFNCCustomControl then
    sc := (p as TTMSFNCCustomControl).ResourceScaleFactor;

  DestroyDragBitmap;

  dr := RectF(AMouseInfo.X, AMouseInfo.Y, AMouseInfo.X + HiddenColumnWidths[FDragCell.Column], AMouseInfo.Y + HiddenRowHeights[FDragCell.Row]);

  FDragBitmap := TTMSFNCImage.Create(p);
  {$IFDEF FMXLIB}
  FDragBitmap.HitTest := False;
  {$ENDIF}
  FDragBitmap.Width := Round((dr.Right - dr.Left) / sc) + 1;
  FDragBitmap.Height := Round((dr.Bottom - dr.Top) / sc) + 1;
  FDragBitmap.Left := Round(dr.Left / sc);
  FDragBitmap.Top := Round(dr.Top / sc);
  g := TTMSFNCGraphics.CreateBitmapCanvas(Round(FDragBitmap.Width * sc), Round(FDragBitmap.Height * sc), False);
  g.BitmapContainer := BitmapContainer;
  try
    g.BeginScene;

    ci := CreateCell(RectF(0, 0, dr.Right - dr.Left, dr.Bottom - dr.Top), FDragCell);

    if Assigned(ci) then
    begin
      ci.BeforeExport;
      try
        ConfigureCell(ci);
        ApplyCellScale(ci, sc);
        DrawCell(g, ci);
      finally
        ci.AfterExport;
        ci.Free;
      end;
    end;

    g.EndScene;
    {$IFDEF WEBLIB}
    r := g.Bitmap.GetBase64Image;
    FDragBitmap.Bitmaps.AddBitmapFromResource(r);
    {$ENDIF}
    {$IFNDEF WEBLIB}
    FDragBitmap.Bitmaps.AddDrawBitmap(g.Bitmap);
    {$ENDIF}
  finally
    g.Free;
  end;

  FDragBitmap.Parent := p;
end;

function TTMSFNCDataGridRenderer.CreateFilterEditor(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCellControl;
var
  a: Boolean;
  cl: TTMSFNCDataGridColumn;
  fet, ft: TTMSFNCDataGridFilterEditorType;
  v: TTMSFNCDataGridCellValue;
  i: Integer;
  c: Boolean;
  f: TTMSFNCDataGridDataFormatting;
  fmt: TFormatSettings;

  I64val: Int64;
  Ival: Integer;
  Dval: Double;
  dt: TDateTime;
  vl: TValue;
begin
  Result := nil;

  i := FixedRowCount;
  while not IsRowNormal(i) and (i < RowCount) do
    Inc(i);

  v := Cells[ACell.Column, i];

  a := True;
  DoBeforeCreateFilterEditor(ACell, a);
  if a then
  begin
    cl := GetColumn(ACell.Column);
    if Assigned(cl) and (gcsFilterEditorType in cl.Settings) then
      fet := cl.FilterEditorType
    else
      fet := gfetAutomatic;

    ft := gfetString;

    if fet = gfetAutomatic then
    begin
      f := DefaultFormatting;
      fmt := FormatSettings;
      c := True;
      DoGetCellFormatting(ACell, v, f, fmt, c);

      if c then
      begin
        case f.&Type of
          gdftBoolean: ft := gfetBoolean;
          gdftDateTime, gdftDate, gdftTime: ft := gfetDateTime;
          gdftFloat: ft := gfetFloat;
          gdftNumber: ft := gfetNumber;
          gdftDefault:
          begin
            if ValueIsBoolean(v) then
              ft := gfetBoolean
            else if ValueIsInteger(v) then
              ft := gfetNumber
            else if ValueIsFloat(v) then
              ft := gfetFloat
            else if ValueIsString(v) then
            begin
              vl := CellValueToTValue(v);

              if TryStrToInt(vl.AsString, Ival) then
                ft := gfetNumber
              else if TryStrToInt64(vl.AsString, I64val) then
                ft := gfetNumber
              else if TryStrToFloat(vl.AsString, Dval, fmt) then
                ft := gfetFloat
              else if TryStrToDateTime(vl.AsString, dt) then
                ft := gfetDateTime;
            end;
          end;
        end;
      end
      else
        ft := gfetString;
    end
    else
      ft := fet;

   case ft of
      gfetCustom: Result := DoCreateCustomFilterEditor(ACell);
      else
        Result := TTMSFNCDataGridFilterPanel.Create(nil, Self, ACell, ft);
    end;

    if Assigned(Result) then
    begin
      Result.Tag := ACell.Column;
      DoAfterCreateFilterEditor(ACell, Result);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.ConfigureCell(ACell: TTMSFNCDataGridCell; AMode: TTMSFNCDataGridCellConfigureMode = gccmBoth);
begin
  if AMode in [gccmLayout, gccmBoth] then
  begin
    SetLayout(ACell);
    DoGetCellLayout(ACell);
  end;

  if AMode in [gccmProperties, gccmBoth] then
  begin
    SetProperties(ACell);
    DoGetCellProperties(ACell);
  end;

  ApplyCellScale(ACell, FScale);
end;

function TTMSFNCDataGridRenderer.GetAdaptToStyle: Boolean;
begin
  Result := FAdaptToStyle;
end;

function TTMSFNCDataGridRenderer.GetAnimateTimer: TTimer;
begin
  if not Assigned(FAnimateTimer) then
  begin
    FAnimateTimer := TTimer.Create(nil);
    FAnimateTimer.Interval := 1;
    FAnimateTimer.Enabled := False;
    FAnimateTimer.OnTimer := Animate;
  end;

  Result := FAnimateTimer;
end;

function TTMSFNCDataGridRenderer.GetBaseCellClass(
  ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCellClass;
var
  r: TTMSFNCDataGridRenderer;
  cl: TTMSFNCDataGridColumn;
  fe: Boolean;
begin
  Result := TTMSFNCDataGridCell;

  fe := False;
  if Options.Filtering.Enabled and not Options.Filtering.Advanced and (Options.Filtering.Row = ACell.Row) and (ACell.Column >= FixedColumnCount)
    and (ACell.Column <= ColumnCount - FixedRightColumnCount - 1) then
  begin
    cl := GetColumn(ACell.Column);
    if Assigned(cl) and (gcsFilterEditor in cl.Settings) then
      fe := cl.FilterEditor
    else
      fe := gfcEditor in Options.Filtering.Controls;
  end;

  if not fe and not Options.Filtering.Advanced then
    fe := HasFilterEditor[ACell.Column, ACell.Row];

  if HasGrid[ACell.Column, ACell.Row] then
  begin
    r := Grids[ACell.Column, ACell.Row];
    if Assigned(r) then
      Result := TTMSFNCDataGridRendererCell
  end
  else if fe then
    Result := TTMSFNCDataGridFilterEditorCell
  else if HasCheckBox[ACell.Column, ACell.Row] then
    Result := TTMSFNCDataGridCheckBoxCell
  else if HasDataCheckBox[ACell.Column, ACell.Row] then
    Result := TTMSFNCDataGridDataCheckBoxCell
  else if HasButton[ACell.Column, ACell.Row] then
    Result := TTMSFNCDataGridButtonCell
  else if HasBitmap[ACell.Column, ACell.Row] then
    Result := TTMSFNCDataGridBitmapCell
  else if HasProgressBar[ACell.Column, ACell.Row] then
    Result := TTMSFNCDataGridProgressBarCell
  else if HasDataProgressBar[ACell.Column, ACell.Row] then
    Result := TTMSFNCDataGridDataProgressBarCell
  else if HasRadioButton[ACell.Column, ACell.Row] then
    Result := TTMSFNCDataGridRadioButtonCell
  else if HasDataRadioButton[ACell.Column, ACell.Row] then
    Result := TTMSFNCDataGridDataRadioButtonCell
  else if (RowTypes[ACell.Row] = grtNode) and (ACell.Column = Options.Column.NodeIndex) then
    Result := TTMSFNCDataGridNodeCell;
end;

function TTMSFNCDataGridRenderer.GetBitmapContainer: TTMSFNCBitmapContainer;
begin
  Result := FBitmapContainer;
end;

function TTMSFNCDataGridRenderer.GetBitmapNames(AColumn, ARow: Integer): string;
var
  cd: TTMSFNCDataGridCellItem;
begin
  Result := '';
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitBitmap) then
    Result := AsExtendedCell(cd).BitmapName;
end;

function TTMSFNCDataGridRenderer.GetBitmaps(AColumn,
  ARow: Integer): TTMSFNCBitmap;
var
  cd: TTMSFNCDataGridCellItem;
begin
  Result := nil;
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitBitmap) then
    Result := AsExtendedCell(cd).Bitmap;
end;

procedure TTMSFNCDataGridRenderer.VCustomScrollChanged(Sender: TObject;
  AValue: Double);
begin
  if FBlockScrollingUpdate or not HasCustomScrollBars then
    Exit;

  if not IsMouseDown then
    StopAnimationTimer;

  VerticalScrollPositionChanged;
  SetVScrollValue(GetVScrollValue);
end;

procedure TTMSFNCDataGridRenderer.VerticalScrollPositionChanged;
begin
  BlockScrollingUpdate := True;
  Update;
  BlockScrollingUpdate := False;
  DoVScroll(GetVScrollValue);
  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).Scroll;
end;

procedure TTMSFNCDataGridRenderer.VisibilityChanged(AColumn: Integer);
var
  cl: TTMSFNCDataGridColumn;
begin
  inherited;
  cl := GetColumn(AColumn);
  if Assigned(cl) then
    cl.FVisible := not HiddenColumns[AColumn];
end;

procedure TTMSFNCDataGridRenderer.DestroyEditor;
begin
  if Assigned(FInplaceEditor) then
  begin
    FInplaceEditor.Parent := nil;
    FInplaceEditor.Free;
    FInplaceEditor := nil;
    FInplaceEditorActive := False;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoScrollTimer(Sender: TObject);
var
  c: TTMSFNCDataGridCellCoord;
  contentr: TRectF;
begin
  if not Options.Mouse.AutoScrolling then
  begin
    ScrollTimer.Enabled := False;
    Exit;
  end;

  contentr := GetContentRect;

  if (FX >= (contentr.Right - contentr.Left) - GetTotalFixedRightColumnWidth) then
  begin
    c := FocusedCell;
    if Options.Mouse.AutoScrollingSpeedMode = gasmPixels then
      c.Column := c.Column + Round(FX - ((contentr.Right - contentr.Left) - GetTotalFixedRightColumnWidth)) * Options.Mouse.AutoScrollingSpeed
    else
      c.Column := c.Column + Options.Mouse.AutoScrollingSpeed;
    SetFocusCell(c.Column, c.Row);
    SelectCell(FocusedCell, [], FMouseDragging);
  end
  else if FX <= GetTotalFixedColumnWidth then
  begin
    c := FocusedCell;
    if Options.Mouse.AutoScrollingSpeedMode = gasmPixels then
      c.Column := c.Column + Round(FX - GetTotalFixedColumnWidth) * Options.Mouse.AutoScrollingSpeed
    else
      c.Column := c.Column - Options.Mouse.AutoScrollingSpeed;
    SetFocusCell(c.Column, c.Row);
    SelectCell(FocusedCell, [], FMouseDragging);
  end;

  if (FY >= (contentr.Bottom - contentr.Top) - GetTotalFixedBottomRowHeight) then
  begin
    c := FocusedCell;
    if Options.Mouse.AutoScrollingSpeedMode = gasmPixels then
      c.Row := c.Row + Round(FY - ((contentr.Bottom - contentr.Top) - GetTotalFixedBottomRowHeight)) * Options.Mouse.AutoScrollingSpeed
    else
      c.Row := c.Row + Options.Mouse.AutoScrollingSpeed;
    SetFocusCell(c.Column, c.Row);
    SelectCell(FocusedCell, [], FMouseDragging);
  end
  else if FY <= GetTotalFixedRowHeight then
  begin
    c := FocusedCell;
    if Options.Mouse.AutoScrollingSpeedMode = gasmPixels then
      c.Row := c.Row + Round(FY - GetTotalFixedRowHeight) * Options.Mouse.AutoScrollingSpeed
    else
      c.Row := c.Row - Options.Mouse.AutoScrollingSpeed;
    SetFocusCell(c.Column, c.Row);
    SelectCell(FocusedCell, [], FMouseDragging);
  end;
end;

procedure TTMSFNCDataGridRenderer.VScrollChanged(Sender: TObject);
begin
  if FBlockScrollingUpdate or HasCustomScrollBars then
    Exit;

  if not IsMouseDown then
    StopAnimationTimer;

  VerticalScrollPositionChanged;
  SetVScrollValue(GetVScrollValue);
end;

procedure TTMSFNCDataGridRenderer.WidthChanged(AColumn: Integer);
var
  cl: TTMSFNCDataGridColumn;
begin
  inherited;
  cl := GetColumn(AColumn);
  if Assigned(cl) then
    cl.FWidth := ColumnWidths[AColumn];
end;

procedure TTMSFNCDataGridRenderer.HCustomScrollChanged(Sender: TObject;
  AValue: Double);
begin
  if FBlockScrollingUpdate or not HasCustomScrollBars then
    Exit;

  if not IsMouseDown then
    StopAnimationTimer;

  HorizontalScrollPositionChanged;
  SetHScrollValue(GetHScrollValue);
end;

procedure TTMSFNCDataGridRenderer.InternalMarkCells(AValue: string; ATag: string; ACaseSensitive: Boolean; AFromColumn: Integer; AFromRow: Integer; AToColumn: Integer; AToRow: Integer; AFullCell: Boolean = False);
var
  r, c: Integer;
  ct, h: string;
begin
  AValue := TTMSFNCUtils.FixMarkup(AValue, False);

  for r := AFromRow to AToRow do
  begin
    for c := AFromColumn to AToColumn do
    begin
      if IsCellBase(MakeCell(c, r)) then
      begin
        ct := Strings[c, r];
        h := Hilight(ct, AValue, ATag, ACaseSensitive, AFullCell);

        if h <> ct then
          Cells[c, r] := h;
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.InternalUnmarkCells(ATag: string; AFromColumn, AFromRow, AToColumn, AToRow: Integer);
var
  r,c: Integer;
  ct: string;
begin
  for r := AFromRow to AToRow do
  begin
    for c := AFromColumn to AToColumn do
    begin
      if IsCellBase(MakeCell(c,r)) then
      begin
        ct := Strings[c, r];
        ct := TTMSFNCUtils.UnFixMarkup(ct, False);
        Cells[c,r] := Unhilight(ct, ATag);
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.HideDragCell;
begin
  if IsCellValid(FDragCell) then
  begin
    case FDraggingMode of
      gdmRowDragging: HideRow(FDragCell.Row);
      gdmColumnDragging: HideColumn(FDragCell.Column);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.HilightCells(AHilightText: string;
  AOptions: TTMSFNCDataGridHilightOptions);
begin
  case AOptions.Mode of
    ghmCell: InternalMarkCells(AHilightText, 'hi', AOptions.CaseSensitive, AOptions.Column, AOptions.Row, AOptions.Column, AOptions.Row, AOptions.FullText);
    ghmColumn:
    begin
      if AOptions.IncludeFixed then
        InternalMarkCells(AHilightText, 'hi', AOptions.CaseSensitive, AOptions.Column, 0, AOptions.Column, RowCount - 1, AOptions.FullText)
      else
        InternalMarkCells(AHilightText, 'hi', AOptions.CaseSensitive, AOptions.Column, FixedRowCount, AOptions.Column, RowCount - 1 - FixedBottomRowCount, AOptions.FullText);
    end;
    ghmRow:
    begin
      if AOptions.IncludeFixed then
        InternalMarkCells(AHilightText, 'hi', AOptions.CaseSensitive, 0, AOptions.Row, ColumnCount - 1, AOptions.Row, AOptions.FullText)
      else
        InternalMarkCells(AHilightText, 'hi', AOptions.CaseSensitive, FixedColumnCount, AOptions.Row, ColumnCount - 1 - FixedRightColumnCount, AOptions.Row, AOptions.FullText);
    end;
    ghmGrid:
    begin
      if AOptions.IncludeFixed then
        InternalMarkCells(AHilightText, 'hi', AOptions.CaseSensitive, 0, 0, ColumnCount - 1, RowCount - 1, AOptions.FullText)
      else
        InternalMarkCells(AHilightText, 'hi', AOptions.CaseSensitive, FixedColumnCount, FixedRowCount, ColumnCount - 1 - FixedRightColumnCount, RowCount - 1 - FixedBottomRowCount, AOptions.FullText);
    end;
  end;
end;

function TTMSFNCDataGridRenderer.HilightText(ACaseSensitive: Boolean; AValue,
  AText: string): string;
begin
  Result := Hilight(AValue, AText, 'hi', ACaseSensitive, False);
end;

procedure TTMSFNCDataGridRenderer.HorizontalScrollPositionChanged;
begin
  BlockScrollingUpdate := True;
  Update;
  BlockScrollingUpdate := False;
  DoHScroll(GetHScrollValue);
end;

procedure TTMSFNCDataGridRenderer.HScrollChanged(Sender: TObject);
begin
  if FBlockScrollingUpdate or HasCustomScrollBars then
    Exit;

  if not IsMouseDown then
    StopAnimationTimer;

  HorizontalScrollPositionChanged;
  SetHScrollValue(GetHScrollValue);
end;

procedure TTMSFNCDataGridRenderer.InternalClear;
begin
  if Assigned(ControlWrapperList) then
    ControlWrapperList.Clear;

  SelectedCellDictionary.Clear;
  SelectedColumnDictionary.Clear;
  SelectedRowDictionary.Clear;

  FNormalCellDisplay.Clear;
  FFixedColumnCellDisplay.Clear;
  FFixedRowCellDisplay.Clear;
  FFixedRootCellDisplay.Clear;

  FNormalCellList.Clear;
  FFixedColumnCellList.Clear;
  FFixedRowCellList.Clear;
  FFixedRootCellList.Clear;

  ClearControlCache;
  inherited;
end;

procedure TTMSFNCDataGridRenderer.ApplyFilterFromBuilder;
begin
  if FilterBuilder.IsEmpty then
    ClearFilter
  else
  begin
    IncUpdateCount;
    RemoveFilter;
    DecUpdateCount;
    ApplyFilter;
  end;
end;

procedure TTMSFNCDataGridRenderer.ApplyFilterFromValue(AColumn: Integer; AValue: TTMSFNCDataGridCellValue; AType: TTMSFNCDataGridDataFilterType);
var
  fd: TTMSFNCDataGridDataFilterData;
  cnd, s, cs: string;
  i, filtercol: integer;
  c: Boolean;
begin
  filtercol := AColumn;

  fd := nil;

  if Options.Filtering.MultiColumn then
  begin
    if Filter.HasFilter(filtercol) then
      fd := Filter.ColumnFilter[filtercol];
  end
  else
    Filter.Clear;

  i := FixedRowCount;
  while not IsRowNormal(i) and (i < RowCount) do
    Inc(i);

  s := ValueToString(AValue);
  if (Pos('&', s) = 0) and (Pos('|', s) = 0) and (Pos('<', s) = 0) and (Pos('>', s) = 0)
    and (Pos('=', s) = 0) and (Pos('!', s) = 0) and (Pos('*', s) = 0) and (Pos('?', s) = 0) then
      s := FormatDisplayValue(MakeCell(AColumn, i), AValue);

  if s <> '' then
  begin
    if not Assigned(fd) then
      fd := Filter.Add;

    fd.Column := filtercol;
    fd.&Type := AType;
    fd.Condition := s;
    cnd := fd.FilterCondition;
  end;

  c := True;
  if Assigned(fd) then
  begin
    cs := cnd;
    DoBeforeApplyFilter(fd.Column, cnd, c);
  end;

  if c then
  begin
    if Assigned(fd) and (cnd <> cs) then
      fd.FilterCondition := cnd;

    IncUpdateCount;
    RemoveFilter;
    DecUpdateCount;
    ApplyFilter;

    if Assigned(fd) then
      DoAfterApplyFilter(fd.Column, cnd);
  end;
end;

procedure TTMSFNCDataGridRenderer.PreviousPage;
begin
  PageIndex := PageIndex - 1;
end;

function TTMSFNCDataGridRenderer.PreviousSelectableColumn(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
var
  c, r, rorig, corig: Integer;
begin
  c := AColumn;
  r := ARow;

  corig := c;
  rorig := r;

  Result.Column := c;
  Result.Row := r;

  if (Result.Column - 1 >= FixedColumnCount) then
  begin
    Result.Column := Result.Column - 1;

    while IsCellDisabled(Result) and (Result.Column > FixedColumnCount) do
      Result.Column := Result.Column - 1;
  end;

  if IsCellDisabled(Result) then
  begin
    Result.Column := corig;
    Result.Row := rorig;
  end;
end;

function TTMSFNCDataGridRenderer.PreviousSelectableRow(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
var
  c, r, corig, rorig: Integer;
begin
  c := AColumn;
  r := ARow;

  corig := c;
  rorig := r;

  Result.Column := c;
  Result.Row := r;

  if (Result.Row - 1 >= FixedRowCount) then
  begin
    Result.Row := Result.Row - 1;

    while IsCellDisabled(Result) and (Result.Row > FixedRowCount) do
      Result.Row := Result.Row - 1;
  end;

  if IsCellDisabled(Result) then
  begin
    Result.Column := corig;
    Result.Row := rorig;
  end;
end;

function TTMSFNCDataGridRenderer.NeedsItemExtended(
  ACell: TTMSFNCDataGridCellCoord): Boolean;
var
  cl: TTMSFNCDataGridColumn;
begin
  Result := inherited NeedsItemExtended(ACell);

  if Options.Filtering.Enabled and not Options.Filtering.Advanced and (ACell.Row = Options.Filtering.Row) and (ACell.Column >= FixedColumnCount)
    and (ACell.Column <= ColumnCount - FixedRightColumnCount - 1) then
  begin
    cl := GetColumn(ACell.Column);
    if Assigned(cl) and (gcsFilterEditor in cl.Settings) then
      Result := Result or cl.FilterEditor
    else
      Result := Result or (gfcEditor in Options.Filtering.Controls);
  end;
end;

procedure TTMSFNCDataGridRenderer.NextPage;
begin
  PageIndex := PageIndex + 1;
end;

function TTMSFNCDataGridRenderer.NextSelectableColumn(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
var
  c, corig, r, rorig: Integer;
  cs: Integer;
  chk: Boolean;
begin
  c := AColumn;
  r := ARow;

  corig := c;
  rorig := r;

  Result.Column := c;
  Result.Row := r;

  cs := ColumnSpan(MakeCell(c, r));
  if cs > 0 then
  begin
    chk := (Result.Column + cs <= ColumnCount - 1 - FixedRightColumnCount);
    if chk then
      Result.Column := Result.Column + cs
  end
  else
  begin
    chk := (Result.Column + 1 <= ColumnCount - 1 - FixedRightColumnCount);
    if chk then
      Result.Column := Result.Column + 1;
  end;

  if chk then
  begin
    while IsCellDisabled(Result) and (Result.Column < ColumnCount - 1 - FixedRightColumnCount) do
    begin
      cs := ColumnSpan(MakeCell(c, r));
      if cs > 0 then
        Result.Column := Result.Column + cs
      else
        Result.Column := Result.Column + 1;
    end;
  end;

  if IsCellDisabled(Result) then
  begin
    Result.Column := corig;
    Result.Row := rorig;
  end;
end;

function TTMSFNCDataGridRenderer.NextSelectableRow(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
var
  c, r, corig, rorig: Integer;
  rs: Integer;
  chk: Boolean;
begin
  c := AColumn;
  r := ARow;

  corig := c;
  rorig := r;

  Result.Column := c;
  Result.Row := r;

  rs := RowSpan(MakeCell(c, r));
  if rs > 0 then
  begin
    chk := (Result.Row + rs <= RowCount - 1 - FixedBottomRowCount);
    if chk then
      Result.Row := Result.Row + rs
  end
  else
  begin
    chk := (Result.Row + 1 <= RowCount - 1 - FixedBottomRowCount);
    if chk then
      Result.Row := Result.Row + 1;
  end;

  if chk then
  begin
    while IsCellDisabled(Result) and (Result.Row < RowCount - 1 - FixedBottomRowCount) do
    begin
      rs := RowSpan(MakeCell(c, r));
      if rs > 0 then
        Result.Row := Result.Row + rs
      else
        Result.Row := Result.Row + 1;
    end;
  end;

  if IsCellDisabled(Result) then
  begin
    Result.Column := corig;
    Result.Row := rorig;
  end;
end;

function TTMSFNCDataGridRenderer.PreviousVisibleColumn(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
var
  c, r, rorig, corig: Integer;
begin
  c := Max(0, Min(AColumn, ColumnCount - 1));
  r := Max(0, Min(ARow, RowCount - 1));

  corig := c;
  rorig := r;

  Result.Column := c;
  Result.Row := r;

  if (Result.Column - 1 >= FixedColumnCount) then
  begin
    Result.Column := Result.Column - 1;

    while not IsCellDisplayed(Result) and (Result.Column > FixedColumnCount) do
      Result.Column := Result.Column - 1;
  end;

  if not IsCellDisplayed(Result) then
  begin
    Result.Column := corig;
    Result.Row := rorig;
  end;
end;

function TTMSFNCDataGridRenderer.PreviousVisibleRow(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
var
  c, r, corig, rorig: Integer;
begin
  c := Max(0, Min(AColumn, ColumnCount - 1));
  r := Max(0, Min(ARow, RowCount - 1));

  corig := c;
  rorig := r;

  Result.Column := c;
  Result.Row := r;

  if (Result.Row - 1 >= FixedRowCount) then
  begin
    Result.Row := Result.Row - 1;

    while not IsCellDisplayed(Result) and (Result.Row > FixedRowCount) do
      Result.Row := Result.Row - 1;
  end;

  if not IsCellDisplayed(Result) then
  begin
    Result.Column := corig;
    Result.Row := rorig;
  end;
end;

function TTMSFNCDataGridRenderer.NextVisibleColumn(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
var
  c, corig, r, rorig: Integer;
  cs: Integer;
  chk: Boolean;
begin
  c := Max(0, Min(AColumn, ColumnCount - 1));
  r := Max(0, Min(ARow, RowCount - 1));

  corig := c;
  rorig := r;

  Result.Column := c;
  Result.Row := r;

  cs := ColumnSpan(MakeCell(c, r));
  if cs > 0 then
  begin
    chk := (Result.Column + cs <= ColumnCount - 1 - FixedRightColumnCount);
    if chk then
      Result.Column := Result.Column + cs
  end
  else
  begin
    chk := (Result.Column + 1 <= ColumnCount - 1 - FixedRightColumnCount);
    if chk then
      Result.Column := Result.Column + 1;
  end;

  if chk then
  begin
    while not IsCellDisplayed(Result) and (Result.Column < ColumnCount - 1 - FixedRightColumnCount) do
    begin
      cs := ColumnSpan(MakeCell(c, r));
      if cs > 0 then
        Result.Column := Result.Column + cs
      else
        Result.Column := Result.Column + 1;
    end;
  end;

  if not IsCellDisplayed(Result) then
  begin
    Result.Column := corig;
    Result.Row := rorig;
  end;
end;

function TTMSFNCDataGridRenderer.NextVisibleRow(AColumn, ARow: Integer): TTMSFNCDataGridCellCoord;
var
  c, r, corig, rorig: Integer;
  rs: Integer;
  chk: Boolean;
begin
  c := Max(0, Min(AColumn, ColumnCount - 1));
  r := Max(0, Min(ARow, RowCount - 1));

  corig := c;
  rorig := r;

  Result.Column := c;
  Result.Row := r;

  rs := RowSpan(MakeCell(c, r));
  if rs > 0 then
  begin
    chk := (Result.Row + rs <= RowCount - 1 - FixedBottomRowCount);
    if chk then
      Result.Row := Result.Row + rs
  end
  else
  begin
    chk := (Result.Row + 1 <= RowCount - 1 - FixedBottomRowCount);
    if chk then
      Result.Row := Result.Row + 1;
  end;

  if chk then
  begin
    while not IsCellDisplayed(Result) and (Result.Row < RowCount - 1 - FixedBottomRowCount) do
    begin
      rs := RowSpan(MakeCell(c, r));
      if rs > 0 then
        Result.Row := Result.Row + rs
      else
        Result.Row := Result.Row + 1;
    end;
  end;

  if not IsCellDisplayed(Result) then
  begin
    Result.Column := corig;
    Result.Row := rorig;
  end;
end;

function TTMSFNCDataGridRenderer.IsCellSelected(ACell: TTMSFNCDataGridCellCoord): Boolean;
var
  sc, stc: TTMSFNCDataGridCellCoord;
begin
  case Options.Selection.Mode of
    gsmDisjunctColumn: Result := SelectedColumns[ACell.Column];
    gsmDisjunctRow: Result := SelectedRows[ACell.Row];
    gsmDisjunctCell, gsmDisjunctCellRange: Result := SelectedCells[ACell.Column, ACell.Row];
    else
    begin
      sc := Selection.StartCell;
      stc := Selection.StopCell;
      Result := (ACell.Column >= sc.Column) and (ACell.Column <= stc.Column) and (ACell.Row >= sc.Row) and (ACell.Row <= stc.Row);
    end;
  end;
end;

function TTMSFNCDataGridRenderer.IsDesigntime: Boolean;
begin
  Result := False;
  if Assigned(OnIsDesigntime) then
    Result := OnIsDesigntime(Self);
end;

function TTMSFNCDataGridRenderer.IsFixedCellSelected(
  ACell: TTMSFNCDataGridCellCoord): Boolean;
begin
  Result := False;
  if IsCellFixed(ACell) then
  begin
    Result := ((ACell.Column >= Selection.StartCell.Column) and (ACell.Column <= Selection.StopCell.Column) and (Options.Selection.Mode <> gsmSingleRow) and (Options.Selection.Mode <> gsmDisjunctRow) and not (Options.Selection.Mode in [gsmDisjunctCell, gsmDisjunctCellRange])
      and (Options.Selection.Mode <> gsmRowRange)) or ((ACell.Row >= Selection.StartCell.Row) and (ACell.Row <= Selection.StopCell.Row)
        and (Options.Selection.Mode <> gsmSingleColumn) and (Options.Selection.Mode <> gsmDisjunctColumn) and not (Options.Selection.Mode in [gsmDisjunctCell, gsmDisjunctCellRange]) and (Options.Selection.Mode <> gsmColumnRange));

    if Options.Selection.Mode = gsmDisjunctRow then
      Result := SelectedRows[ACell.Row]
    else if Options.Selection.Mode = gsmDisjunctColumn then
      Result := SelectedColumns[ACell.Column]
    else if Options.Selection.Mode in [gsmDisjunctCell, gsmDisjunctCellRange] then
      Result := SelectedCells[ACell.Column, ACell.Row];
  end;
end;

function TTMSFNCDataGridRenderer.GetInplaceEditor: TTMSFNCDataGridInplaceEditor;
begin
  Result := FInplaceEditor;
end;

function TTMSFNCDataGridRenderer.IsEditing: Boolean;
begin
  Result := FInplaceEditorActive;
end;

function TTMSFNCDataGridRenderer.GetInplaceEditorRect(ACell: TTMSFNCDataGridCellCoord): TRectF;
var
  cr: TRectF;
  c: TTMSFNCDataGridCell;
begin
  Result := RectF(0, 0, 0, 0);

  c := GetCellObjectForCell(ACell);
  if Assigned(c) then
  begin
    if (FInplaceEditorType <> getNone) and Assigned(FInplaceEditor) then
    begin
      if ((FInplaceEditor is TCustomEdit) or (FInplaceEditor is TCustomMemo)) and not (FInplaceEditorType in [getCustom, getComboEdit]) then
      begin
        Result := TTMSFNCDataGridCellOpen(c).GetActualTextRect;
        {$IFDEF FMXLIB}
        InflateRectEx(Result, 2, 2);
        {$ENDIF}
        {$IFDEF WEBLIB}
        InflateRectEx(Result, 2, 0);
        OffsetRectEx(Result, 0, -2);
        {$ENDIF}
      end
      else
        Result := c.Rect;

      cr := GetContentClipRect;
      Result.Top := Max(Result.Top, cr.Top);
      Result.Bottom := Min(Result.Bottom, cr.Bottom);
      Result.Left := Max(Result.Left, cr.Left);
      Result.Right := Min(Result.Right, cr.Right);
      Result := RectF(Floor(Result.Left), Floor(Result.Top), Floor(Result.Right), Floor(Result.Bottom));

      DoGetInplaceEditorRect(ACell, FInplaceEditor, Result);
    end;
  end;
end;

function TTMSFNCDataGridRenderer.GetIsDestroying: Boolean;
begin
  Result := False;
  if Assigned(OnIsDestroying) then
    Result := OnIsDestroying(Self);
end;

function TTMSFNCDataGridRenderer.GetIsLoading: Boolean;
begin
  Result := False;
  if Assigned(OnIsLoading) then
    Result := OnIsLoading(Self);
end;

function TTMSFNCDataGridRenderer.IsFocused: Boolean;
begin
  Result := False;
  if Assigned(OnIsFocused) then
    Result := OnIsFocused(Self);
end;

function TTMSFNCDataGridRenderer.IsRowBand(ARow: Integer): Boolean;
begin
  Result := Odd(ARow);
end;

procedure TTMSFNCDataGridRenderer.ChangeDPIScale(M: Integer; D: Integer);
var
  I: Integer;
begin
  BeginUpdate;
  try
    Options.Filtering.DropDownWidth := TTMSFNCUtils.MulDivInt(Options.Filtering.DropDownWidth, M, D);
    Options.Filtering.DropDownHeight := TTMSFNCUtils.MulDivInt(Options.Filtering.DropDownHeight, M, D);

    FilterAppearance.Font.Height := TTMSFNCUtils.MulDivInt(FilterAppearance.Font.Height, M, D);
    CellAppearance.FixedLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.FixedLayout.Font.Height, M, D);
    CellAppearance.NormalLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.NormalLayout.Font.Height, M, D);
    CellAppearance.GroupLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.GroupLayout.Font.Height, M, D);
    CellAppearance.SummaryLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.SummaryLayout.Font.Height, M, D);
    CellAppearance.SelectedLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.SelectedLayout.Font.Height, M, D);
    CellAppearance.FocusedLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.FocusedLayout.Font.Height, M, D);
    CellAppearance.FixedSelectedLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.FixedSelectedLayout.Font.Height, M, D);
    CellAppearance.BandLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.BandLayout.Font.Height, M, D);
    CellAppearance.FilterMatchLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.FilterMatchLayout.Font.Height, M, D);
    CellAppearance.FilterInverseMatchLayout.Font.Height := TTMSFNCUtils.MulDivInt(CellAppearance.FilterInverseMatchLayout.Font.Height, M, D);

    DefaultRowHeight := Int(TTMSFNCUtils.MulDivSingle(DefaultRowHeight, M, D));
    DefaultColumnWidth := Int(TTMSFNCUtils.MulDivSingle(DefaultColumnWidth, M, D));

    Padding.Left := TTMSFNCUtils.MulDivSingle(Padding.Left, M, D);
    Padding.Top := TTMSFNCUtils.MulDivSingle(Padding.Left, M, D);
    Padding.Right := TTMSFNCUtils.MulDivSingle(Padding.Left, M, D);
    Padding.Bottom := TTMSFNCUtils.MulDivSingle(Padding.Left, M, D);

    for I := 0 to Columns.Count - 1 do
    begin
      Columns[I].Width := Int(TTMSFNCUtils.MulDivSingle(Columns[I].Width, M, D));
      Columns[I].Appearance.FixedLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.FixedLayout.Font.Height, M, D);
      Columns[I].Appearance.NormalLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.NormalLayout.Font.Height, M, D);
      Columns[I].Appearance.GroupLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.GroupLayout.Font.Height, M, D);
      Columns[I].Appearance.SummaryLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.SummaryLayout.Font.Height, M, D);
      Columns[I].Appearance.SelectedLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.SelectedLayout.Font.Height, M, D);
      Columns[I].Appearance.FocusedLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.FocusedLayout.Font.Height, M, D);
      Columns[I].Appearance.FixedSelectedLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.FixedSelectedLayout.Font.Height, M, D);
      Columns[I].Appearance.BandLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.BandLayout.Font.Height, M, D);
      Columns[I].Appearance.FilterMatchLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.FilterMatchLayout.Font.Height, M, D);
      Columns[I].Appearance.FilterInverseMatchLayout.Font.Height := TTMSFNCUtils.MulDivInt(Columns[I].Appearance.FilterInverseMatchLayout.Font.Height, M, D);
    end;

  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.ClearColumns;
begin
  Columns.Clear;
end;

procedure TTMSFNCDataGridRenderer.ClearControlCache;
begin
  if Assigned(TTMSFNCDataGridCellOpen.ControlCacheList) then
    TTMSFNCDataGridCellOpen.ControlCacheList.Clear;
end;

procedure TTMSFNCDataGridRenderer.ClearFocus;
begin
  {$IFDEF FMXMOBILE}
  if FilterPopup.IsOpen then
  begin
    if FilterListBox.IsFocused then
      FilterListBox.ResetFocus;

    if FilterListBox.TreeView.IsFocused then
      FilterListBox.TreeView.ResetFocus;

    if FilterEdit.IsFocused then
      FilterEdit.ResetFocus;

    if FilterTypeComboBox.IsFocused then
      FilterTypeComboBox.ResetFocus;

    if FilterClearButton.IsFocused then
      FilterClearButton.ResetFocus;

    if FilterSortAscendingButton.IsFocused then
      FilterSortAscendingButton.ResetFocus;

    if FilterSortDescendingButton.IsFocused then
      FilterSortDescendingButton.ResetFocus;

    if FilterContainer.IsFocused then
      FilterContainer.ResetFocus;
  end;
  {$ENDIF}
end;

procedure TTMSFNCDataGridRenderer.ClearSelection;
begin
  FFocusedCell := MakeCell(-1, -1);
  FFirstCell := MakeCell(-1, -1);
  FSaveCell := FFocusedCell;
  FRealCell := FFocusedCell;
  SelectedCellDictionary.Clear;
  SelectedColumnDictionary.Clear;
  SelectedRowDictionary.Clear;
  Selection := MakeCellRange(-1, -1, -1, -1);
  Display;
end;

function TTMSFNCDataGridRenderer.DataGetItemIndex: Integer;
begin
  Result := FocusedCell.Row - FixedRowCount;
end;

procedure TTMSFNCDataGridRenderer.DataSetItemIndex(AValue: Integer);
begin
  SelectCell(MakeCell(FFocusedCell.Column, AValue + FixedRowCount));
end;

procedure TTMSFNCDataGridRenderer.DeleteColumnData(AColumn: Integer);
var
  k: TTMSFNCDataGridCellCoord;
begin
  inherited;
  SelectedColumnDictionary.Remove(AColumn);
  for k in SelectedCellDictionary.Keys do
  begin
    if k.Column = AColumn then
      SelectedCellDictionary.Remove(k);
  end;
end;

procedure TTMSFNCDataGridRenderer.DeleteRowData(ARow: Integer);
var
  k: TTMSFNCDataGridCellCoord;
begin
  inherited;
  SelectedRowDictionary.Remove(ARow);
  for k in SelectedCellDictionary.Keys do
  begin
    if k.Row = ARow then
      SelectedCellDictionary.Remove(k);
  end;
end;

destructor TTMSFNCDataGridRenderer.Destroy;
begin
  FHost := nil;
  FColumns.Free;

  FreeAndNil(FCellLayout);
  FreeAndNil(FColumnsEditor);
  FreeAndNil(FFilterDialog);
  FreeAndNil(FFindDialog);
  FreeAndNil(FReplaceDialog);
  FreeAndNil(FInplaceEditor);
  FreeAndNil(FFilterTimer);
  FreeAndNil(FFilterExitTimer);
  FreeAndNil(FScrollTimer);
  FreeAndNil(FAnimateTimer);
  FreeAndNil(FDragTimer);
  FreeAndNil(FLookupTimer);
  FreeAndNil(FFilterTypeComboBox);
  FreeAndNil(FFilterListBox);
  FreeAndNil(FFilterEdit);
  FreeAndNil(FFilterClearButton);
  FreeAndNil(FFilterSortAscendingButton);
  FreeAndNil(FFilterSortDescendingButton);
  FreeAndNil(FFilterContainer);
  FreeAndNil(FFilterPopup);
  FreeAndNil(FCommentPopup);

  FFilterAppearance.Free;
  FDragAppearance.Free;

  FPadding.Free;
  FStroke.Free;
  FGlobalFont.Free;
  FCellAppearance.Free;
  FIcons.Free;
  FNormalCellDisplay.Free;
  FNormalCellList.Free;
  FMergedCells.Free;
  FreeAndNil(FSelectedCellDictionary);
  FreeAndNil(FSelectedColumnDictionary);
  FreeAndNil(FSelectedRowDictionary);
  FFixedRowCellDisplay.Free;
  FFixedRowCellList.Free;
  FFixedRootCellDisplay.Free;
  FFixedRootCellList.Free;
  FFixedColumnCellDisplay.Free;
  FFixedColumnCellList.Free;

  if Assigned(FCustomVerticalScrollBar) then
    FCustomVerticalScrollBar.Free;

  if Assigned(FCustomHorizontalScrollBar) then
    FCustomHorizontalScrollBar.Free;

  if Assigned(FVerticalScrollBar) then
    FVerticalScrollBar.Free;

  if Assigned(FHorizontalScrollBar) then
    FHorizontalScrollBar.Free;

  FreeAndNil(FControlWrapperList);

  inherited;
end;

function TTMSFNCDataGridRenderer.GetVerticalScrollPosition: Double;
var
  vVal, scrollv: Double;
begin
  vVal := GetVScrollValue;

  if ScrollMode = gsmCellScrolling then
  begin
    if GetVVisible then
      scrollv := RowPositions[Round(vval)]
    else
      scrollv := RowPositions[0];

    vVal := scrollv;
  end;

  Result := vVal;
end;

function TTMSFNCDataGridRenderer.GetVScrollValue: Single;
begin
  Result := FLocalVScrollValue;

  if HasCustomScrollBars and Assigned(CustomVerticalScrollBar) then
    Result := Min(CustomVerticalScrollBar.Max - CustomVerticalScrollBar.PageSize, Max(0, CustomVerticalScrollBar.Value))
  else if Assigned(VerticalScrollBar) then
  begin
    {$IFDEF FMXLIB}
    Result := Min(VerticalScrollBar.Max - VerticalScrollBar.ViewportSize, Max(0, VerticalScrollBar.Value));
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Result := Min(VerticalScrollBar.Max - VerticalScrollBar.PageSize, Max(0, Round(VerticalScrollBar.Position)));
    {$ENDIF}
  end;
end;

function TTMSFNCDataGridRenderer.GetVVisible: Boolean;
begin
  Result := False;
  if HasCustomScrollBars and Assigned(CustomVerticalScrollBar) then
    Result := CustomVerticalScrollBar.Visible
  else if Assigned(VerticalScrollBar) then
    Result := VerticalScrollBar.Visible;
end;

function TTMSFNCDataGridRenderer.GetWordWrapping(AColumn,
  ARow: Integer): Boolean;
var
  l: TTMSFNCDataGridCellLayout;
begin
  Result := False;
  l := GetCellAppearance(GetCellState(MakeCell(AColumn, ARow)), MakeCell(AColumn, ARow));
  if Assigned(l) then
    Result := l.WordWrapping;
end;

procedure TTMSFNCDataGridRenderer.GoToCell(ACell: TTMSFNCDataGridCellCoord;
  ASelect: Boolean);
begin
  inherited;
  if ASelect then
    SelectCell(ACell)
  else
    Navigate(ACell, True);
end;

procedure TTMSFNCDataGridRenderer.GoToPage(APageIndex: Integer);
var
  PageSize: Integer;
  TargetTopRow: Integer;
begin
  PageSize := GetPageScrollSize;

  if (PageSize = 0) or (RowCount = 0) then
    Exit;

  APageIndex := Max(0, Min(APageIndex, GetPageCount - 1));

  TargetTopRow := APageIndex * PageSize;
  TopRow := TargetTopRow;
end;

function TTMSFNCDataGridRenderer.GetVMax: Single;
begin
  Result := 0;
  if HasCustomScrollBars and Assigned(CustomVerticalScrollBar) then
    Result := CustomVerticalScrollBar.Max
  else if Assigned(VerticalScrollBar) then
    Result := VerticalScrollBar.Max
end;

function TTMSFNCDataGridRenderer.GetVViewPortSize: Single;
begin
  Result := 0;
  if HasCustomScrollBars and Assigned(CustomVerticalScrollBar) then
    Result := CustomVerticalScrollBar.PageSize
  else if Assigned(VerticalScrollBar) then
  begin
    {$IFDEF FMXLIB}
    Result := VerticalScrollBar.ViewportSize;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Result := VerticalScrollBar.PageSize;
    {$ENDIF}
  end;
end;

function TTMSFNCDataGridRenderer.GetVerticalTextAligns(AColumn,
  ARow: Integer): TTMSFNCGraphicsTextAlign;
var
  l: TTMSFNCDataGridCellLayout;
begin
  Result := gtaLeading;
  l := GetCellAppearance(GetCellState(MakeCell(AColumn, ARow)), MakeCell(AColumn, ARow));
  if Assigned(l) then
    Result := l.VerticalTextAlign;
end;

function TTMSFNCDataGridRenderer.GetVerticalScrollBar: TScrollBar;
begin
  Result := FVerticalScrollBar;
end;

procedure TTMSFNCDataGridRenderer.DrawDisplay(AGraphics: TTMSFNCGraphics; ADisplay: TTMSFNCDataGridDisplayList);
var
  I: Integer;
  cache: TTMSFNCDataGridCell;
begin
  if ADisplay.Count = 0 then
    Exit;

  for I := 0 to ADisplay.Count - 1 do
  begin
    cache := ADisplay[I];
    if IsCellDisplayList(ADisplay) then
      DrawCell(AGraphics, cache);
  end;
end;

procedure TTMSFNCDataGridRenderer.DrawScrollBars(AGraphics: TTMSFNCGraphics);
begin
  if {$IFNDEF WEBLIB}not BlockScrollingUpdate and {$ENDIF}HasCustomScrollBars and not HasValidHost and Assigned(FCustomVerticalScrollBar) and Assigned(FCustomHorizontalScrollBar) then
  begin
    if FCustomVerticalScrollBar.Visible then
      FCustomVerticalScrollBar.DrawEx(AGraphics);

    if FCustomHorizontalScrollBar.Visible then
      FCustomHorizontalScrollBar.DrawEx(AGraphics);
  end;
end;

procedure TTMSFNCDataGridRenderer.EditCell(ACell: TTMSFNCDataGridCellCoord; ACellStart: TTMSFNCDataGridEditCellStart = gcsNone; AInsertKey: Boolean = False; AValue: string = ''; AKey: Word = 0);
var
  ins, c, a, ci: Boolean;
  r: TRectF;
  v: TValue;
  cl: TTMSFNCDataGridColumn;
  ct: TTMSFNCGraphicsColor;
  vl: TTMSFNCDataGridCellValue;
  p: TTMSFNCDataGridCellParent;
  ctl: TTMSFNCDataGridCell;
  l: TTMSFNCDataGridCellLayout;
  {$IFNDEF FMXLIB}
  fc: TTMSFNCGraphicsColor;
  {$ENDIF}

  function CreateCaretPos(ALine, APos: Integer): TTMSFNCDataGridCaretPosition;
  begin
    {$IFDEF FMXLIB}
    Result.Line := ALine;
    Result.Pos := APos;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Result.X := ALine;
    Result.Y := APos;
    {$ENDIF}
  end;

  function TryExecuteEditor: TValue;
  var
    AContext: TRttiContext;
    rt: TRttiType;
    m: TRttiMethod;
  begin
    Result := TValue.Empty;
    AContext := TRttiContext.Create;
    try
      rt := AContext.GetType(FInplaceEditor.ClassInfo);
      m := rt.GetMethod('Execute');
      if Assigned(m) then
        Result := m.Invoke(FInplaceEditor, []);
    finally
      AContext.Free;
    end;
  end;

begin
  if IsCellDisabled(ACell) then
    Exit;

  p := GetParentHost;

  FInplaceEditorTarget := getCellValue;
  DoGetInplaceEditorTarget(ACell, FInplaceEditorTarget);
  DoGetInplaceEditorType(ACell, FInplaceEditorType);

  case FInplaceEditorTarget of
    getCellValue:
    begin
      ci := not (FInplaceEditorType in [getComboBox, getDatePicker, getColorPicker, getTrackBar, getHTMLEditor, getCustom]);
      if AInsertKey and ci then
        vl := AValue
      else
        vl := Cells[ACell.Column, ACell.Row];
    end;
    getFillColor:
    begin
      if HasLayout[ACell.Column, ACell.Row] then
      begin
        l := Layouts[ACell.Column, ACell.Row];
        if l.Fill.Kind = gfkSolid then
        begin
          ct := l.Fill.Color;
          vl := CellValueToTValue(ct);
        end;
      end;
    end;
  end;

  ins := true;
  DoBeforeOpenInplaceEditor(ACell, vl, ins);
  if ins then
  begin
    if Assigned(FInplaceEditor) then
    begin
      FInplaceEditor.Free;
      FInplaceEditor := nil;
    end;

    case FInplaceEditorType of
      getMixedCaseEdit, getUppercaseEdit, getSignedFloatEdit, getFloatEdit, getSignedNumericEdit,
      getHexEdit, getMoneyEdit, getLowerCaseEdit, getNumericEdit,
      getValidCharsEdit, getAlphaNumericEdit, getEdit:
      begin
        FInplaceEditor := TTMSFNCDataGridEdit.Create(p);
        case FInplaceEditorType of
          getNumericEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etNumeric;
          getSignedNumericEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etSignedNumeric;
          getFloatEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etFloat;
          getSignedFloatEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etSignedFloat;
          getUppercaseEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etUppercase;
          getMixedCaseEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etMixedCase;
          getLowerCaseEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etLowerCase;
          getMoneyEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etMoney;
          getHexEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etHex;
          getAlphaNumericEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etAlphaNumeric;
          getValidCharsEdit: (FInplaceEditor as TTMSFNCDataGridEdit).EditType := etValidChars;
        end;
      end;
      getComboBox:
      begin
        FInplaceEditor := TTMSFNCDataGridComboBox.Create(p);
        {$IFDEF CMNWEBLIB}
        (FInplaceEditor as TTMSFNCDataGridComboBox).Style := csDropDownList;
        {$ENDIF}
      end;
      getComboEdit:
      begin
        FInplaceEditor := TTMSFNCDataGridComboEdit.Create(p);
        {$IFDEF CMNWEBLIB}
        (FInplaceEditor as TTMSFNCDataGridComboEdit).Style := csDropDown;
        {$ENDIF}
      end;
      getSpinBox: FInplaceEditor := TTMSFNCDataGridSpinBox.Create(p);
      getDatePicker: FInplaceEditor := TTMSFNCDataGridDatePicker.Create(p);
      getColorPicker:
      begin
        FInplaceEditor := TTMSFNCDataGridColorPicker.Create(p);
        (FInplaceEditor as TTMSFNCDataGridColorPicker).Mode := csmExtended;
      end;
      getTrackBar: FInplaceEditor := TTMSFNCDataGridTrackBar.Create(p);
      getMemo: FInplaceEditor := TTMSFNCDataGridMemo.Create(p);
      getHTMLEditor: FInplaceEditor := TTMSFNCDataGridHTMLEditor.Create(p);
      getCustom:
      begin
        FInplaceEditorCustomClass := nil;
        DoGetInplaceEditorClass(ACell, FInplaceEditorCustomClass);
        if Assigned(FInplaceEditorCustomClass) then
          FInplaceEditor := FInplaceEditorCustomClass.Create(p);
      end;
    end;

    a := True;
    if Assigned(FInplaceEditor) and not (FInplaceEditor is TTMSFNCCustomComponent) then
    begin
      r := GetInplaceEditorRect(ACell);
      a := a and not RectIsEmpty(r);
    end;

    if Assigned(FInplaceEditor) and a then
    begin
      {$IFDEF FMXLIB}
      FInplaceEditor.OnApplyStyleLookup := ApplyInplaceEditorStyleLookup;
      {$ENDIF}

      if FInplaceEditor is TCustomEdit then
      begin
        ctl := GetCellObjectForCell(ACell);
        if Assigned(ctl) then
        begin
          {$IFDEF VCLLIB}
          FInplaceEditor.Visible := False;
          FInplaceEditor.Parent := p;
          TCustomEditOpen(FInplaceEditor as TCustomEdit).BorderStyle := bsNone;
          {$ENDIF}
          {$IFNDEF FMXLIB}
          fc := TCustomEditOpen(FInplaceEditor as TCustomEdit).Font.Color;
          {$ENDIF}

          TCustomEditOpen(FInplaceEditor as TCustomEdit).Font.Assign(ctl.Layout.Font);

          {$IFNDEF FMXLIB}
          TCustomEditOpen(FInplaceEditor as TCustomEdit).Font.Color := fc;
          case ctl.Layout.TextAlign of
            gtaCenter: TCustomEditOpen(FInplaceEditor as TCustomEdit).Alignment := taCenter;
            gtaLeading: TCustomEditOpen(FInplaceEditor as TCustomEdit).Alignment := taLeftJustify;
            gtaTrailing: TCustomEditOpen(FInplaceEditor as TCustomEdit).Alignment := taRightJustify;
          end;
          {$ENDIF}

          {$IFDEF FMXLIB}
          TCustomEditOpen(FInplaceEditor as TCustomEdit).VertTextAlign := TTextAlign.Leading;

          case ctl.Layout.TextAlign of
            gtaCenter: TCustomEditOpen(FInplaceEditor as TCustomEdit).TextSettings.HorzAlign := TTextAlign.Center;
            gtaLeading: TCustomEditOpen(FInplaceEditor as TCustomEdit).TextSettings.HorzAlign := TTextAlign.Leading;
            gtaTrailing: TCustomEditOpen(FInplaceEditor as TCustomEdit).TextSettings.HorzAlign := TTextAlign.Trailing;
          end;
          {$ENDIF}

          {$IFDEF VCLLIB}
          FInplaceEditor.Parent := nil;
          FInplaceEditor.Visible := True;
          {$ENDIF}
        end;
      end;

      if FInplaceEditor is TCustomMemo then
      begin
        ctl := GetCellObjectForCell(ACell);
        if Assigned(ctl) then
        begin
          {$IFDEF VCLLIB}
          FInplaceEditor.Visible := False;
          FInplaceEditor.Parent := p;
          {$ENDIF}
          {$IFNDEF FMXLIB}
          fc := TCustomMemoOpen(FInplaceEditor as TCustomMemo).Font.Color;
          {$ENDIF}

          TCustomMemoOpen(FInplaceEditor as TCustomMemo).Font.Assign(ctl.Layout.Font);

          {$IFNDEF FMXLIB}
          TCustomMemoOpen(FInplaceEditor as TCustomMemo).Font.Color := fc;
          {$ENDIF}

          {$IFDEF VCLLIB}
          FInplaceEditor.Parent := nil;
          FInplaceEditor.Visible := True;
          {$ENDIF}
        end;
      end;

      cl := GetColumn(ACell.Column);
      if Assigned(cl) and (gcsEditorItems in cl.Settings) then
      begin
        if (FInplaceEditor is TCustomComboBox) {$IFDEF FMXLIB}or (FInplaceEditor is TCustomComboEdit){$ENDIF} then
        begin
          {$IFDEF VCLLIB}
          FInplaceEditor.Visible := False;
          FInplaceEditor.Parent := p;
          {$ENDIF}

          if FInplaceEditor is TCustomComboBox then
            TCustomComboBoxOpen(FInplaceEditor as TCustomComboBox).Items.Assign(cl.EditorItems);

          {$IFDEF FMXLIB}
          if FInplaceEditor is TCustomComboEdit then
            (FInplaceEditor as TCustomComboEdit).Items.Assign(cl.EditorItems);
          {$ENDIF}

          {$IFDEF VCLLIB}
          FInplaceEditor.Parent := nil;
          FInplaceEditor.Visible := True;
          {$ENDIF}
        end
      end;

      if not (FInplaceEditor is TTMSFNCCustomComponent) then
      begin
        if FInplaceEditor is TCustomMemo then
        begin
          {$IFDEF FMXLIB}
          (FInplaceEditor as TCustomMemo).StyledSettings := [];
          {$ENDIF}
        end;

        if FInplaceEditor is TCustomEdit then
        begin
          {$IFDEF FMXLIB}
          (FInplaceEditor as TCustomEdit).StyledSettings := [];
          {$ENDIF}
        end;

        TTMSFNCDataGridInplaceEditorOpen(FInplaceEditor).OnKeyDown := @DoEditorKeyDown;
        TTMSFNCDataGridInplaceEditorOpen(FInplaceEditor).OnKeyUp := @DoEditorKeyUp;
        {$IFNDEF FMXLIB}
        TTMSFNCDataGridInplaceEditorOpen(FInplaceEditor).OnKeyPress := DoEditorKeyPress;
        {$ENDIF}
//        TTMSFNCDataGridInplaceEditorOpen(FInplaceEditor).OnExit := @DoEditorExit;
      end;

      if (FInplaceEditor is TTMSFNCDataGridEdit) and (Options.Editing.AutoComplete.&Type <> gactDisabled) then
      begin
        (FInplaceEditor as TTMSFNCDataGridEdit).Lookup.DisplayList.Assign(Options.Editing.AutoComplete.Items);
        (FInplaceEditor as TTMSFNCDataGridEdit).AutoComplete := Options.Editing.AutoComplete.&Type = gactNormal;
        (FInplaceEditor as TTMSFNCDataGridEdit).Lookup.Enabled := Options.Editing.AutoComplete.&Type <> gactNormal;
      end;

      if (FInplaceEditor is TTMSFNCDataGridHTMLEditor) then
        (FInplaceEditor as TTMSFNCDataGridHTMLEditor).BitmapContainer := BitmapContainer;

      FEditingCell := ACell;

      if not (FInplaceEditor is TTMSFNCCustomComponent) then
      begin
        FInplaceEditor.Parent := p;
        UpdateInplaceEditorPosition;
      end;

      DoGetInplaceEditorProperties(ACell, FInplaceEditor, FInplaceEditorType);
      DoCellEditGetData(ACell, FInplaceEditor, vl);

      SetObjectValue(FInplaceEditor, vl);

      if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
        (Adapter as TTMSFNCDataGridRendererDataAdapter).EditCell(ACell);

      c := False;

      if (FInplaceEditor is TTMSFNCCustomComponent) then
      begin
        v := TryExecuteEditor;
        if v.IsType<TModalResult> then
        begin
          FMouseDown := False;
          CloseInplaceEditor(v.AsType<TModalResult> = mrCancel);
          c := True;
        end;
      end
      else
      begin
        if (Options.Editing.DirectDropDown) then
        begin
          if (FInplaceEditor is TCustomComboBox) then
          begin
            {$IFDEF FMXLIB}
            (FInplaceEditor as TCustomComboBox).DropDown;
            {$ENDIF}

            {$IFDEF CMNWEBLIB}
            (FInplaceEditor as TCustomComboBox).DroppedDown := True;
            {$ENDIF}
          end
          {$IFDEF FMXLIB}
          else if FInplaceEditor is TCustomDateTimeEdit then
          begin
            (FInplaceEditor as TCustomDateTimeEdit).OpenPicker;
          end
          else if (FInplaceEditor is TCustomComboEdit) then
          begin
            (FInplaceEditor as TCustomComboEdit).DropDown;
          end
          {$ENDIF}
          else if FInplaceEditor is TTMSFNCCustomPicker then
          begin
            (FInplaceEditor as TTMSFNCCustomPicker).DropDown;
          end;
        end;

        if FInplaceEditor.CanFocus then
        begin
          TTMSFNCDataGridInplaceEditorOpen(FInplaceEditor).SetFocus;
          FClearMouseDown := False;
          FDblClick := False;
        end;

        if FInplaceEditor is TCustomEdit then
        begin
          try
            if AInsertKey then
            begin
              (FInplaceEditor as TCustomEdit).SelStart := Length((FInplaceEditor as TCustomEdit).Text);
              (FInplaceEditor as TCustomEdit).SelLength := 0;
            end
            else
            begin
              case ACellStart of
                gcsNone:
                begin
                  (FInplaceEditor as TCustomEdit).SelStart := 0;
                  (FInplaceEditor as TCustomEdit).SelLength := Length((FInplaceEditor as TCustomEdit).Text);
                end;
                gcsStart:
                begin
                  (FInplaceEditor as TCustomEdit).SelStart := 0;
                  (FInplaceEditor as TCustomEdit).SelLength := 0;
                end;
                gcsEnd:
                begin
                  (FInplaceEditor as TCustomEdit).SelStart := Length((FInplaceEditor as TCustomEdit).Text);
                  (FInplaceEditor as TCustomEdit).SelLength := 0;
                end;
              end;
            end;
          finally
          end;
        end
        else if FInplaceEditor is TCustomMemo then
        begin
          if AInsertKey then
          begin
            if (FInplaceEditor as TCustomMemo).Lines.Count > 0 then
              (FInplaceEditor as TCustomMemo).CaretPosition := CreateCaretPos((FInplaceEditor as TCustomMemo).Lines.Count - 1, Length((FInplaceEditor as TCustomMemo).Lines[(FInplaceEditor as TCustomMemo).Lines.Count - 1]))
            else
              (FInplaceEditor as TCustomMemo).CaretPosition := CreateCaretPos(0, 0);

            (FInplaceEditor as TCustomMemo).SelLength := 0;
          end
          else
          begin
            case ACellStart of
              gcsNone:
              begin
                (FInplaceEditor as TCustomMemo).CaretPosition := CreateCaretPos(0, 0);
                (FInplaceEditor as TCustomMemo).SelLength := Length((FInplaceEditor as TCustomMemo).Text);
              end;
              gcsStart:
              begin
                (FInplaceEditor as TCustomMemo).CaretPosition := CreateCaretPos(0, 0);
                (FInplaceEditor as TCustomMemo).SelLength := 0;
              end;
              gcsEnd:
              begin
                if (FInplaceEditor as TCustomMemo).Lines.Count > 0 then
                  (FInplaceEditor as TCustomMemo).CaretPosition := CreateCaretPos((FInplaceEditor as TCustomMemo).Lines.Count - 1, Length((FInplaceEditor as TCustomMemo).Lines[(FInplaceEditor as TCustomMemo).Lines.Count - 1]))
                else
                  (FInplaceEditor as TCustomMemo).CaretPosition := CreateCaretPos(0, 0);

                (FInplaceEditor as TCustomMemo).SelLength := 0;
              end;
            end;
          end;
        end;
      end;

      FInplaceEditorActive := not c;
    end;

    if FInplaceEditorActive then
      DoAfterOpenInplaceEditor(ACell, FInplaceEditor, vl);
  end;
end;

procedure TTMSFNCDataGridRenderer.&Export(AGraphics: TTMSFNCGraphics; ARect: TRectF; ASelection: TTMSFNCDataGridCellCoordRange;
  ARepeatFixedColumns: Boolean = False; ARepeatFixedRows: Boolean = False; AFitToPage: Boolean = True; ASkipSaveBounds: Boolean = False; AScale: Single = 1.0;
  AOnNewPage: TTMSFNCDataGridRendererExportNewPageCallback = nil; AOnGetPageIndex: TTMSFNCDataGridRendererExportGetPageIndexCallback = nil);
var
  c, r: Integer;
  cellstr: String;
  cwr, rhr, cw, rh, cwrt, rhrt: Single;
  pgi: Integer;
  I: Integer;
  xr, yr: Single;
  bc, br: Integer;
  cs, rs: Integer;
  cellr: TRectF;
  cls: TTMSFNCDataGridCellClass;
  off: Single;
  x, y: Single;
  rSt, csave, cSt: Integer;
  chk: Boolean;
  FFixedRowsSave, FFixedColumnsSave: Integer;
  FCSave, FRSave: Integer;
  FFixedRowGet, FFixedColGet: Boolean;
  FSetRSave, FSetCSave: Boolean;
  xs, ys: Single;
  ph, pw: Single;
  xts, yts: Single;
  FSaveXBounds: Single;
  FSaveYBounds: Single;
  sc: Single;
  ci: TTMSFNCDataGridCell;
  d: TTMSFNCDataGridCellItem;
  ck: TTMSFNCDataGridCellKind;
  mcpp: TDictionary<TTMSFNCDataGridCellCoord, Integer>;
  needspage: Boolean;

  function GetFixedPrintWidth: Single;
  var
    I: Integer;
  begin
    Result := 0;
    for I := 0 to FixedColumnCount - 1 do
      Result := Result + ColumnWidths[I] * sc;
  end;

  function GetFixedPrintHeight: Single;
  var
    I: Integer;
  begin
    Result := 0;
    for I := 0 to FixedRowCount - 1 do
      Result := Result + RowHeights[I] * sc;
  end;

  function GetScale: Single;
  var
    w, K: Integer;
  begin
    Result := AScale;
    if AFitToPage then
    begin
      w := 0;
      for K := 0 to ColumnCount - 1 do
        w := w + Round(ColumnWidths[K]);

      if w > 0 then
        Result := (ARect.Right - ARect.Left) / w;
    end;
  end;

  procedure GetCellMergeInfo(AColumn, ARow: Integer; var ABaseColumn, ABaseRow, AColumnSpan, ARowSpan: Integer);
  var
    mi: TTMSFNCDataGridCellMergeInfo;
  begin
    if HasMergeInfo[AColumn, ARow] then
    begin
      mi := MergeInfo[AColumn, ARow];
      ABaseColumn := c - mi.ColumnOffset;
      ABaseRow := r - mi.RowOffset;
      AColumnSpan := mi.ColumnSpan;
      ARowSpan := mi.RowSpan;
    end;
  end;

begin
  mcpp := TDictionary<TTMSFNCDataGridCellCoord, Integer>.Create;
  ExportNotification(gesExportStart,-1);
  try
    AGraphics.BitmapContainer := BitmapContainer;
    sc := GetScale;
    if Assigned(AOnNewPage) then
      AOnNewPage();

    needspage := False;

    x := ARect.Left;
    y := ARect.Top;

    rSt := ASelection.StartCell.Row;
    FFixedRowsSave := 0;
    FFixedColumnsSave := 0;
    cSave := -1;
    cSt := -1;
    FFixedRowGet := False;
    FFixedColGet := False;
    FSetRSave := True;
    FSetCSave := True;

    pw := GetFixedPrintWidth;
    ph := GetFixedPrintHeight;

    FSaveXBounds := ARect.Left;

    for I := ASelection.StartCell.Column to ASelection.StopCell.Column do
    begin
      if (CompareValue(Floor(FSaveXBounds + ColumnWidths[I] * sc), ARect.Right) = GreaterThanValue) then
        Break;

      FSaveXBounds := FSaveXBounds + ColumnWidths[I] * sc;
    end;

    FSaveYBounds := ARect.Top;

    for I := ASelection.StartCell.Row to ASelection.StopCell.Row do
    begin
      if (CompareValue(Floor(FSaveYBounds + RowHeights[I] * sc), ARect.Bottom) = GreaterThanValue) then
        Break;

      FSaveYBounds := FSaveYBounds + RowHeights[I] * sc;
    end;

    c := ASelection.StartCell.Column;

    FCSave := -1;
    while c <= ASelection.StopCell.Column do
    begin
      if cSt = -1 then
        cSt := c;

      if ARepeatFixedColumns and (FixedColumnCount > 0) then
      begin
        if (FFixedColumnsSave < FixedColumnCount) then
        begin
          FFixedColGet := True;
          if FSetCSave then
          begin
            FSetCSave := False;
            FCSave := cSt;
          end;

          cst := FFixedColumnsSave;
          c := cst;
          Inc(FFixedColumnsSave);
        end
        else if FFixedColGet then
        begin
          FFixedColGet := False;
          cSt := FCSave;
          c := FCSave;

          if cst < FixedColumnCount then
          begin
            cst := FixedColumnCount;
            c := cst;
          end;
        end;
      end;

      cw := ColumnWidths[c] * sc;

      r := rst;
      FRSave := rst;
      while r <= ASelection.StopCell.Row do
      begin
        if needspage then
        begin
          if Assigned(AOnNewPage) then
            AOnNewPage();

          needspage := False;
        end;

        if ARepeatFixedRows and (FixedRowCount > 0) then
        begin
          if (FFixedRowsSave < FixedRowCount) then
          begin
            FFixedRowGet := True;
            if FSetRSave then
            begin
              FSetRSave := False;
              FRSave := rSt;
            end;

            rSt := FFixedRowsSave;
            r := rst;
            Inc(FFixedRowsSave);
          end
          else if FFixedRowGet then
          begin
            FFixedRowGet := False;
            rSt := FRSave;
            r := FRSave;

            if rst < FixedRowCount then
            begin
              rst := FixedRowCount;
              r := rst;
            end;
          end;
        end;

        ExportNotification(gesExportNewRow, r);

        bc := c;
        br := r;
        cs := 0;
        rs := 0;

        rh := RowHeights[r] * sc;

        GetCellMergeInfo(c, r, bc, br, cs, rs);

        chk := (c = bc) and (r = br);

        if Assigned(AOnGetPageIndex) then
        begin
          pgi := AOnGetPageIndex();
          if chk then
            mcpp.AddOrSetValue(MakeCell(bc, br), pgi)
          else if (bc <> c) and (br <> r) then
            chk := mcpp.ContainsKey(MakeCell(bc, br)) and (mcpp[MakeCell(bc, br)] <> pgi);
        end;

        if chk then
        begin
          cellstr := Strings[bc, br];
          cwr := cw;
          rhr := rh;

          cwrt := 0;
          for I := bc to bc + cs - 1 do
            cwrt := cwrt + ColumnWidths[I] * sc;

          if cwrt > 0 then
            cwr := cwrt;

          rhrt := 0;
          for I := br to br + rs - 1 do
            rhrt := rhrt + RowHeights[I] * sc;

          if rhrt > 0 then
            rhr := rhrt;

          xr := 0;
          for I := bc to c - 1 do
            xr := xr + ColumnWidths[I] * sc;

          yr := 0;
          for I := br to r - 1 do
            yr := yr + RowHeights[I] * sc;

          xts := x - xr;
          yts := y - yr;
          xs := xts + cwr;
          ys := yts + rhr;

          if not ASkipSaveBounds then
          begin
            if FSaveXBounds > -1 then
              xs := Min(FSaveXBounds, xs);
          end;

          pgi := 0;
          if Assigned(AOnGetPageIndex) then
            pgi := AOnGetPageIndex;

          if ((pgi = 0) or ARepeatFixedColumns) and (c > FixedColumnCount) then
            xts := Max(ARect.Left + pw, xts)
          else
            xts := Max(ARect.Left, xts);

          if not ASkipSaveBounds then
          begin
            if FSaveYBounds > -1 then
              ys := Min(FSaveYBounds, ys);
          end;

          if ((pgi = 0) or ARepeatFixedRows) and (r > FixedRowCount) then
            yts := Max(ARect.Top + ph, yts)
          else
            yts := Max(ARect.Top, yts);

          if (bc = Options.Column.NodeIndex) then
          begin
            if RowTypes[br] = grtDefault then
              off := (20 * Max(0, (RowNodeLevel[br] - 1)))
            else
              off := (20 * Max(0, RowNodeLevel[br]));

            xts := xts + off;
          end;

          cellr := RectF(xts, yts, xs, ys);

          if IsCellDisplayed(MakeCell(bc, br)) then
          begin
            cls := GetBaseCellClass(MakeCell(bc, br));
            DoGetCellClass(bc, br, cls);
            if Assigned(cls) then
            begin
              ck := GetCellKind(MakeCell(bc, br));
              d := CellData[bc, br];
              ci := cls.Create(cellr, bc, br, d, ck, Self);

              if Assigned(ci) then
              begin
                ci.BeforeExport;
                try
                  ConfigureCell(ci);
                  ApplyCellScale(ci, sc);
                  DrawCell(AGraphics, ci);
                finally
                  ci.AfterExport;
                  ci.Free;
                end;
              end;
            end;
          end;
        end;

        y := y + rh;
        if CompareValue(Floor(y + RowHeights[r + 1] * sc), ARect.Bottom) = GreaterThanValue then
        begin
          FSaveYBounds := ARect.Bottom;
          Break;
        end;

        Inc(r);
      end;

      y := ARect.Top;
      x := x + cw;
      Inc(c);

      FFixedRowsSave := 0;

      if (bc + cs = ASelection.StopCell.Column) and (br + rs = ASelection.StopCell.Row) then
        Break;

      if (CompareValue(Floor(x + ColumnWidths[c] * sc) , ARect.Right) = GreaterThanValue) or (c = ASelection.StopCell.Column + 1) then
      begin
        FSaveXBounds := ARect.Right;

        rst := r + 1;

        if cSave = -1 then
          cSave := c;

        if r = ASelection.StopCell.Row + 1 then
        begin
          c := cSave;
          cst := -1;
          rst := ASelection.StartCell.Row;
          cSave := -1;
        end
        else
          c := cst;

        FFixedRowsSave := 0;
        FFixedColumnsSave := 0;
        FSetRSave := True;
        FSetCSave := True;

        if (c < ASelection.StopCell.Column + 1) then
        begin
          needspage := True;

          x := ARect.Left;
          y := ARect.Top;
        end;
      end;
    end;
  finally
    mcpp.Free;
    ExportNotification(gesExportDone,-1);
  end;
end;

procedure TTMSFNCDataGridRenderer.&Export(AGraphics: TTMSFNCGraphics);
begin
  &Export(AGraphics, RectF(0, 0, Width, Height), MakeCellRange(0, 0, ColumnCount - 1, RowCount - 1));
end;

procedure TTMSFNCDataGridRenderer.ExportNotification(
  AState: TTMSFNCDataGridExportState; ARow: Integer);
begin
  inherited;

  if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).ExportNotification(AState, ARow);
end;

procedure TTMSFNCDataGridRenderer.HandleDragEnd(
  AMouseInfo: TTMSFNCDataGridMouseInfo);
var
  b: Boolean;
  res: TTMSFNCDataGridCellCoord;
begin
  HandleDragBitmapDrop(AMouseInfo);

  res := XYToCell(AMouseInfo.X, AMouseInfo.Y);

  case FDraggingType of
    gdtSwap:
    begin
      if (res.Column <> -1) and (res.Row <> -1) then
      begin
        if FDraggingMode = gdmColumnDragging then
        begin
          b := True;
          DoCanDropColumn(FDragCell.Column, res.Column, b);
          if b then
          begin
            BeginUpdate;
            MoveColumn(FDragCell.Column, res.Column);
            EndUpdate;
            DoColumnDropped(FDragCell.Column, res.Column);
          end;
        end
        else
        if FDraggingMode = gdmRowDragging then
        begin
          b := True;
          DoCanDropRow(FDragCell.Row, res.Row, b);
          if b then
          begin
            BeginUpdate;
            MoveRow(FDragCell.Row, res.Row);
            EndUpdate;
            DoRowDropped(FDragCell.Row, res.Row);
          end;
        end;
      end;
    end;
    gdtInsert:
    begin
      if FDraggingMode = gdmColumnDragging then
      begin
        b := True;
        DoCanDropColumn(FDragCell.Column, res.Column, b);
        if b then
        begin
          BeginUpdate;
          UnhideColumn(FDragCell.Column);
          MoveColumn(FDragCell.Column, res.Column);
          EndUpdate;
          DoColumnDropped(FDragCell.Column, res.Column);
        end;
      end
      else
      if FDraggingMode = gdmRowDragging then
      begin
        b := True;
        DoCanDropRow(FDragCell.Row, res.Row, b);
        if b then
        begin
          BeginUpdate;
          UnhideRow(FDragCell.Row);
          MoveRow(FDragCell.Row, res.Row);
          EndUpdate;
          DoRowDropped(FDragCell.Row, res.Row);
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.StartDragging(AMouseInfo: TTMSFNCDataGridMouseInfo; ACanStartDrag: Boolean);
var
  Allow: Boolean;
begin
  Allow := Options.Mouse.ColumnDragging;
  if Allow then
    DoCanDragColumn(FDragCell.Column, Allow);

  if ((FDragCell.Row < FixedRowCount) or (FDragCell.Row > RowCount - 1 - FixedBottomRowCount)) and Allow then
  begin
    if not (gcdmReorder in Options.Mouse.ColumnDragModes) then
      Exit;
    
    FDraggingMode := gdmColumnDragging;

    UpdateCursor(crUpArrow);
    FDragCellTo := XYToCell(AMouseInfo.X, AMouseInfo.Y);
    if IsCellValid(FDragCellTo) then
      FDragCellTo := MakeCell(FDragCellTo.Column, 0)
    else
      FDragCellTo := MakeCell(-1, -1);

    HandleDragBitmapStart(AMouseInfo);
    Display;
    if ACanStartDrag then
      BeginDrag;
  end
  else
  begin
    Allow := Options.Mouse.RowDragging;
    if Allow then
      DoCanDragRow(FDragCell.Row, Allow);

    if ((FDragCell.Column < FixedColumnCount) or (FDragCell.Column > ColumnCount - 1 - FixedRightColumnCount)) and Allow then
    begin
      FDraggingMode := gdmRowDragging;

      UpdateCursor(crUpArrow);
      FDragCellTo := XYToCell(AMouseInfo.X, AMouseInfo.Y);
      if IsCellValid(FDragCellTo) then
        FDragCellTo := MakeCell(0, FDragCellTo.Row)
      else
        FDragCellTo := MakeCell(-1, -1);

      HandleDragBitmapStart(AMouseInfo);
      Display;
      if ACanStartDrag then
        BeginDrag;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.HandleDragging(AMouseInfo: TTMSFNCDataGridMouseInfo);
var
  newposx: Single;
  newposy: Single;
  r: TRectF;
begin
  FX := AMouseInfo.X;
  FY := AMouseInfo.Y;
  HandleDragBitmapOver(AMouseInfo);

  if ((FDragCell.Row < FixedRowCount) or (FDragCell.Row > RowCount - 1 - FixedBottomRowCount)) and Options.Mouse.ColumnDragging then
  begin
    r := GetContentClipRect;

    newposx := FX;
    if (newposx <= r.Right - r.Left) and (newposx >= 0) then
    begin
      DragTimer.Enabled := False;
      if (newposx > GetTotalFixedColumnWidth) and (newposx < (r.Right - r.Left) - GetTotalFixedRightColumnWidth) then
        FDragScrollCell := XYToCell(newposx, (r.Bottom - r.Top) / 2);
    end
    else if (newposx > r.Right - r.Left) then
      DragTimer.Enabled := True
    else if (newposx < 0) then
      DragTimer.Enabled := True;

    FDragCellTo := XYToCell(AMouseInfo.X, AMouseInfo.Y);
    if IsCellValid(FDragCellTo) then
      FDragCellTo := MakeCell(FDragCellTo.Column, 0)
    else
      FDragCellTo := MakeCell(-1, -1);

    Display;
  end
  else if ((FDragCell.Column < FixedColumnCount) or (FDragCell.Column > ColumnCount - 1 - FixedRightColumnCount)) and Options.Mouse.RowDragging then
  begin
    r := GetContentClipRect;

    newposy := FY;
    if (newposy <= r.Bottom - r.Top) and (newposy >= 0) then
    begin
      DragTimer.Enabled := False;
      if (newposy > GetTotalFixedRowHeight) and (newposy < (r.Bottom - r.Top) - GetTotalFixedBottomRowHeight) then
        FDragScrollCell := XYToCell((r.Right - r.Left) / 2, newposy);
    end
    else if (newposy > r.Bottom - r.Top) then
      DragTimer.Enabled := True
    else if (newposy < 0) then
      DragTimer.Enabled := True;

    FDragCellTo := XYToCell(AMouseInfo.X, AMouseInfo.Y);
    if IsCellValid(FDragCellTo) then
      FDragCellTo := MakeCell(0, FDragCellTo.Row)
    else
      FDragCellTo := MakeCell(-1, -1);

    Display;
  end;
end;

procedure TTMSFNCDataGridRenderer.HandleDragDrop(const Source: TObject;
  const Point: TPointF);
var
  m: TTMSFNCDataGridMouseInfo;
  df: TTMSFNCCustomControlDropFiles;
begin
  if IsSourceDropFiles(Source) then
  begin
    df := AsSourceDropFiles(Source);
    DoDropFiles(df);
  end
  else
  begin
    m := DefaultMouseInfo;
    m.Kind := gmkDragDrop;
    m.X := Point.X;
    m.Y := Point.Y;

    HandleDragEnd(m);
    ResetDrag;
    Display;
  end;
end;

procedure TTMSFNCDataGridRenderer.HandleDragOver(const Source: TObject;
  const Point: TPointF; var Accept: Boolean);
var
  m: TTMSFNCDataGridMouseInfo;
  rl: ITMSFNCDataGridRendererLink;
  r: TTMSFNCDataGridRenderer;
begin
  m := DefaultMouseInfo;
  m.Kind := gmkDragOver;
  m.X := Point.X;
  m.Y := Point.Y;

  if (Source is TTMSFNCCustomTreeView) and Assigned((Source as TTMSFNCCustomTreeView).DragNode) then
  begin
    Accept := ((Source as TTMSFNCCustomTreeView).DragNode.DataString = 'columns_editor');
    FDraggingType := gdtInsert;
    FDragCell := MakeCell((Source as TTMSFNCCustomTreeView).DragNode.DataInteger, 0);
  end
  else if IsSourceDropFiles(Source) then
    Accept := True
  else
  begin
    r := nil;
    if Supports(Source, ITMSFNCDataGridRendererLink, rl) then
      r := rl.Link;

    Accept := (r = Self);
    if Accept then
      FDraggingType := gdtSwap;
  end;

  if Accept and not IsSourceDropFiles(Source) then
  begin
    if (FDraggingMode = gdmNone) and (Options.Mouse.RowDragging or Options.Mouse.ColumnDragging) then
    begin
      StartDragging(m, False);
    end;

    if FDraggingMode <> gdmNone then
    begin
      HandleDragging(m);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.HandleDragBitmapDrop(
  AMouseInfo: TTMSFNCDataGridMouseInfo);
begin
  DestroyDragBitmap;
end;

procedure TTMSFNCDataGridRenderer.HandleDragBitmapOver(
  AMouseInfo: TTMSFNCDataGridMouseInfo);
begin
  if Assigned(FDragBitmap) then
    FDragBitmap.SetBounds(Round(AMouseInfo.X - SaveLeft), Round(AMouseInfo.Y - SaveTop), FDragBitmap.Width, FDragBitmap.Height);
end;

procedure TTMSFNCDataGridRenderer.HandleDragBitmapStart(
  AMouseInfo: TTMSFNCDataGridMouseInfo);
var
  img: TTMSFNCImage;
  offx, offy: Single;
  p: TTMSFNCDataGridCellParent;
begin
  p := GetParentHost;
  if Assigned(p) then
  begin
    CreateDragBitmap(AMouseInfo);
    if Assigned(FDragBitmap) then
    begin
      img := FDragBitmap;
      offx := img.Left;
      offy := img.Top;
      img.Parent := p;
      img.SetBounds(Round(offx), Round(offy), img.Width, img.Height);
      SaveLeft := (AMouseInfo.X - offx);
      SaveTop := (AMouseInfo.Y - offy);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.HandleEnter;
var
  cl: TTMSFNCDataGridCellCoord;
begin
  if (FocusedCell.Column = -1) and (FocusedCell.Row = -1) then
  begin
    if (FTabKey = gtkmNormal) then
      FocusedCell := MakeCell(FixedColumnCount, FixedRowCount)
    else if FTabKey = gtkmShift then
    begin
      cl.Column := ColumnCount - 1 - FixedRightColumnCount;
      cl.Row := RowCount - 1 - FixedBottomRowCount;
      FocusedCell := cl;
    end
    else
      Display;

    FTabKey := gtkmNone;
  end;
end;

procedure TTMSFNCDataGridRenderer.HandleExit;
begin
  ResetScrollBarCapture;
  FClearMouseDown := FClosing;
  FMouseDown := False;
  FMouseDblClick := False;
  FDragCell := MakeCell(-1, -1);
  FDragCellTo := MakeCell(-1, -1);
  Display;
end;

procedure TTMSFNCDataGridRenderer.DoDragTimer(Sender: TObject);
var
  contentr: TRectF;
begin
  if not Options.Mouse.AutoDragging then
  begin
    DragTimer.Enabled := False;
    Exit;
  end;

  contentr := GetContentRect;

  if (FX >= (contentr.Right - contentr.Left)) then
  begin
    if Options.Mouse.AutoScrollingSpeedMode = gasmPixels then
      FDragScrollCell.Column := FDragScrollCell.Column + Round(FX - (contentr.Right - contentr.Left)) * Options.Mouse.AutoScrollingSpeed
    else
      FDragScrollCell.Column := FDragScrollCell.Column + Options.Mouse.AutoScrollingSpeed;
    Navigate(FDragScrollCell);
  end
  else if FX <= 0 then
  begin
    if Options.Mouse.AutoScrollingSpeedMode = gasmPixels then
      FDragScrollCell.Column := FDragScrollCell.Column + Round(FX) * Options.Mouse.AutoScrollingSpeed
    else
      FDragScrollCell.Column := FDragScrollCell.Column - Options.Mouse.AutoScrollingSpeed;

    Navigate(FDragScrollCell);
  end;

  if (FY >= (contentr.Bottom - contentr.Top)) then
  begin
    if Options.Mouse.AutoScrollingSpeedMode = gasmPixels then
      FDragScrollCell.Row := FDragScrollCell.Row + Round(FY - (contentr.Bottom - contentr.Top)) * Options.Mouse.AutoScrollingSpeed
    else
      FDragScrollCell.Row := FDragScrollCell.Row + Options.Mouse.AutoScrollingSpeed;
    Navigate(FDragScrollCell);
  end
  else if FY <= 0 then
  begin
    if Options.Mouse.AutoScrollingSpeedMode = gasmPixels then
      FDragScrollCell.Row := FDragScrollCell.Row + Round(FY) * Options.Mouse.AutoScrollingSpeed
    else
      FDragScrollCell.Row := FDragScrollCell.Row - Options.Mouse.AutoScrollingSpeed;
    Navigate(FDragScrollCell);
  end;
end;

procedure TTMSFNCDataGridRenderer.DoDropFiles(
  ADropFiles: TTMSFNCCustomControlDropFiles);
begin
  if Assigned(OnDropFiles) then
    OnDropFiles(Self, ADropFiles);
end;

procedure TTMSFNCDataGridRenderer.DrawDragging(AGraphics: TTMSFNCGraphics);
var
  r: TRectF;
  pth: TTMSFNCGraphicsPath;
  sz: Single;
  cl: TTMSFNCDataGridCell;
begin
  if IsCellValid(FDragCellTo) then
  begin
    cl := GetCellObjectForCell(FDragCellTo);
    if not Assigned(cl) then
      Exit;

    sz := DragAppearance.Size;

    case FDraggingMode of
      gdmRowDragging:
      begin
        r := cl.Rect;
        if FDraggingType = gdtSwap then
          r := RectF(r.Right, r.Top + (r.Bottom - r.Top) / 2 - sz / 2, r.Right + sz, r.Top + (r.Bottom - r.Top) / 2 + sz / 2)
        else
          r := RectF(r.Right, r.Bottom - sz / 2, r.Right + sz, r.Bottom + sz / 2);

        AGraphics.Fill.Assign(DragAppearance.Fill);
        AGraphics.Stroke.Assign(DragAppearance.Stroke);
        pth := TTMSFNCGraphicsPath.Create;
        try
          pth.MoveTo(PointF(r.Left, r.Top + (r.Bottom - r.Top) / 2));
          pth.LineTo(PointF(r.Right, r.Top));
          pth.LineTo(PointF(r.Right, r.Bottom));
          pth.ClosePath;
          AGraphics.DrawPath(pth);
        finally
          pth.Free;
        end;
      end;
      gdmColumnDragging:
      begin
        r := cl.Rect;
        if FDraggingType = gdtSwap then
          r := RectF(r.Left + (r.Right - r.Left) / 2 - sz / 2, r.Bottom, r.Left + (r.Right - r.Left) / 2 + sz / 2, r.Bottom + sz)
        else
          r := RectF(r.Right - sz / 2, r.Bottom, r.Right + sz / 2, r.Bottom + sz);

        AGraphics.Fill.Assign(DragAppearance.Fill);
        AGraphics.Stroke.Assign(DragAppearance.Stroke);
        pth := TTMSFNCGraphicsPath.Create;
        try
          pth.MoveTo(PointF(r.Left + (r.Right - r.Left) / 2, r.Top));
          pth.LineTo(PointF(r.Right, r.Bottom));
          pth.LineTo(PointF(r.Left, r.Bottom));
          pth.ClosePath;
          AGraphics.DrawPath(pth);
        finally
          pth.Free;
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.DrawEmptySpaces(AGraphics: TTMSFNCGraphics);
var
  lr, fr, r: TRectF;
  vs, hs: TScrollBar;
  vsc, hsc: TTMSFNCScrollBar;
  vsb, hsb, a: Boolean;
begin
  if not StretchScrollBars then
  begin
    lr := GetContentClipRect;
    fr := GetFullRect;
    AGraphics.Fill.Assign(CellAppearance.FixedLayout.Fill);
    AGraphics.Stroke.Assign(Stroke);

    vsc := CustomVerticalScrollBar;
    hsc := CustomHorizontalScrollBar;
    vs := VerticalScrollBar;
    hs := HorizontalScrollBar;

    if HasCustomScrollBars then
      vsb := Assigned(vsc) and vsc.Visible
    else
      vsb := Assigned(vs) and vs.Visible;

    if HasCustomScrollBars then
      hsb := Assigned(hsc) and hsc.Visible
    else
      hsb := Assigned(hs) and hs.Visible;

    if vsb then
    begin
      r := RectF({$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Right - 1){$IFDEF FMXWEBLIB} + 0.5{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(fr.Top){$IFDEF FMXWEBLIB} + 0.5{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(fr.Right + 1){$IFDEF FMXWEBLIB} + 0.5{$ELSE} + 1{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(fr.Top + 1) {$IFDEF FMXWEBLIB} + 0.5{$ELSE}{$ENDIF} + TotalFixedRowHeight);
      if (r.Right - r.Left > 0) and (r.Bottom - r.Top > 0) then
      begin
        a := True;
        DoBeforeDrawEmptySpace(AGraphics, r, gekColumnTop, a);
        if a then
        begin
          AGraphics.DrawRectangle(r);
          DoAfterDrawEmptySpace(AGraphics, r, gekColumnTop);
        end;
      end;

      r := RectF({$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Right - 1){$IFDEF FMXWEBLIB} + 0.5{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Bottom){$IFDEF FMXWEBLIB} + 0.5{$ENDIF} - TotalFixedBottomRowHeight, {$IFDEF FMXWEBLIB}Int{$ENDIF}(fr.Right + 1){$IFDEF FMXWEBLIB} + 0.5{$ELSE} + 1{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Bottom) {$IFDEF FMXWEBLIB} + 0.5{$ELSE}{$ENDIF});

      if (r.Right - r.Left > 0) and (r.Bottom - r.Top > 0) then
      begin
        a := True;
        DoBeforeDrawEmptySpace(AGraphics, r, gekColumnBottom, a);
        if a then
        begin
          AGraphics.DrawRectangle(r);
          DoAfterDrawEmptySpace(AGraphics, r, gekColumnBottom);
        end;
      end;
    end;

    if hsb then
    begin
      r := RectF({$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Right){$IFDEF FMXWEBLIB} + 0.5{$ENDIF} - TotalFixedRightColumnWidth, {$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Bottom - 1){$IFDEF FMXWEBLIB} + 0.5{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Right){$IFDEF FMXWEBLIB} + 0.5{$ELSE}{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(fr.Bottom + 1) {$IFDEF FMXWEBLIB} + 0.5{$ELSE} + 1{$ENDIF});
      if (r.Right - r.Left > 0) and (r.Bottom - r.Top > 0) then
      begin
        a := True;
        DoBeforeDrawEmptySpace(AGraphics, r, gekRowRight, a);
        if a then
        begin
          AGraphics.DrawRectangle(r);
          DoAfterDrawEmptySpace(AGraphics, r, gekRowRight);
        end;
      end;

      r := RectF({$IFDEF FMXWEBLIB}Int{$ENDIF}(fr.Left){$IFDEF FMXWEBLIB} + 0.5{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Bottom - 1){$IFDEF FMXWEBLIB} + 0.5{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Left + 1){$IFDEF FMXWEBLIB} + 0.5{$ELSE}{$ENDIF} + TotalFixedColumnWidth, {$IFDEF FMXWEBLIB}Int{$ENDIF}(fr.Bottom + 1) {$IFDEF FMXWEBLIB} + 0.5{$ELSE} + 1{$ENDIF});
      if (r.Right - r.Left > 0) and (r.Bottom - r.Top > 0) then
      begin
        a := True;
        DoBeforeDrawEmptySpace(AGraphics, r, gekRowLeft, a);
        if a then
        begin
          AGraphics.DrawRectangle(r);
          DoAfterDrawEmptySpace(AGraphics, r, gekRowLeft);
        end;
      end;
    end;

    if hsb and vsb then
    begin
      r := RectF({$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Right - 1){$IFDEF FMXWEBLIB} + 0.5{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(lr.Bottom - 1){$IFDEF FMXWEBLIB} + 0.5{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(fr.Right + 1){$IFDEF FMXWEBLIB} + 0.5{$ELSE} + 1{$ENDIF}, {$IFDEF FMXWEBLIB}Int{$ENDIF}(fr.Bottom + 1) {$IFDEF FMXWEBLIB} + 0.5{$ELSE} + 1{$ENDIF});
      if (r.Right - r.Left > 0) and (r.Bottom - r.Top > 0) then
      begin
        a := True;
        DoBeforeDrawEmptySpace(AGraphics, r, gekColumnBottomRowRight, a);
        if a then
        begin
          AGraphics.DrawRectangle(r);
          DoAfterDrawEmptySpace(AGraphics, r, gekColumnBottomRowRight);
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.Draw(AGraphics: TTMSFNCGraphics);
var
  r: TRectF;
  st: TTMSFNCGraphicsSaveState;
begin
  st := AGraphics.SaveState;

  try
    r := GetContentClipRect;
    AGraphics.ClipRect(r);

    DrawDisplay(AGraphics, FNormalCellDisplay);
    DrawDisplay(AGraphics, FFixedColumnCellDisplay);
    DrawDisplay(AGraphics, FFixedRowCellDisplay);
    DrawDisplay(AGraphics, FFixedRootCellDisplay);

    DrawDragging(AGraphics);

    if not IsExporting then
    begin
      AGraphics.Fill.Kind := gfkNone;
      AGraphics.Stroke.Assign(Stroke);
      AGraphics.DrawRectangle(r);
    end;

    DoAfterDrawGrid(AGraphics, r);
  finally
    AGraphics.RestoreState(st);
  end;

  DrawEmptySpaces(AGraphics);
  DrawScrollBars(AGraphics);
end;

procedure TTMSFNCDataGridRenderer.DoAfterDrawGrid(AGraphics: TTMSFNCGraphics; ARect: TRectF);
begin
  if Assigned(OnAfterDrawGrid) then
    OnAfterDrawGrid(Self, AGraphics, ARect);
end;

procedure TTMSFNCDataGridRenderer.DoAfterLookup(ALookupString: string);
begin
  if Assigned(OnAfterLookup) then
    OnAfterLookup(Self, ALookupString);
end;

procedure TTMSFNCDataGridRenderer.DrawCell(AGraphics: TTMSFNCGraphics; ACache: TTMSFNCDataGridCell);
var
  e: Boolean;
begin
  e := IsEditing and (FEditingCell.Column = ACache.Column) and (FEditingCell.Row = ACache.Row);
  ACache.DrawElements := TTMSFNCDataGridCellOpen(ACache).GetDrawElements(e);
  TTMSFNCDataGridCellOpen(ACache).Draw(AGraphics);
end;

function TTMSFNCDataGridRenderer.GetCellAppearance(AState: TTMSFNCDataGridCellState;
  ACell: TTMSFNCDataGridCellCoord; ASkipCellLayout: Boolean = False): TTMSFNCDataGridCellLayout;
var
  c, cll: TTMSFNCDataGridCellLayout;
  ap: TTMSFNCDataGridCellAppearance;
  cl: TTMSFNCDataGridColumn;
  rr: Integer;
  b: Boolean;
begin
  cll := nil;
  if not ASkipCellLayout and HasLayout[ACell.Column, ACell.Row] then
    cll := Layouts[ACell.Column, ACell.Row];

  cl := GetColumn(ACell.Column);
  if Assigned(cl) and (gcsAppearance in cl.Settings) then
    ap := cl.Appearance
  else
    ap := CellAppearance;

  b := False;

  case AState of
    gcsNormal:
    begin
      rr := ACell.Row;
      if IsGrouped and IsRowNode(rr) then
        c := ap.GroupLayout
      else if IsGrouped and IsRowSummary(rr) then
        c := ap.SummaryLayout
      else
      begin
        if HasFilter and (gdfaApplyAppearance in Options.Filtering.Actions) and IsRowNormal(ACell.Row) then
        begin
          if not IsRowFiltered(ACell.Row) then
            c := ap.FilterMatchLayout
          else
            c := ap.FilterInverseMatchLayout;
        end
        else if Options.Banding.Enabled and IsRowBand(ACell.Row) then
          c := ap.BandLayout
        else
        begin
          c := ap.NormalLayout;
          b := True;
        end;
      end;
    end;
    gcsFocused: c := ap.FocusedLayout;
    gcsFixed: c := ap.FixedLayout;
    gcsFixedSelected: c := ap.FixedSelectedLayout;
    gcsSelected: c := ap.SelectedLayout;
    else
      c := nil;
  end;

  if not Assigned(FCellLayout) then
    FCellLayout := TTMSFNCDataGridCellLayout.Create;

  if Assigned(c) then
  begin
    FCellLayout.Assign(c);
    if Assigned(cll) then
    begin
      DoGetCellLayoutHasPriority(ACell, b);
      if b then
        FCellLayout.Assign(cll)
      else
      begin

        FCellLayout.Sides := cll.Sides;
        FCellLayout.Font.Color := cll.Font.Color;
        FCellLayout.Font.Name := cll.Font.Name;
        FCellLayout.Font.Size := cll.Font.Size;
        FCellLayout.Font.Style := cll.Font.Style;
        FCellLayout.TextAlign := cll.TextAlign;
        FCellLayout.TextAngle := cll.TextAngle;
        FCellLayout.VerticalTextAlign := cll.VerticalTextAlign;
        FCellLayout.WordWrapping := cll.WordWrapping;
        FCellLayout.Trimming := cll.Trimming;
      end;
    end;

    Result := FCellLayout;
  end
  else
    Result := nil;
end;

function TTMSFNCDataGridRenderer.GetCellObjectForCell(
  ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCell;
begin
  Result := nil;
  if (ACell.Column = -1) or (ACell.Row = -1) then
    Exit;

  if IsCellFixed(ACell) or IsCellFreeze(ACell) then
  begin
    if IsCellFixedRoot(ACell) or IsCellFreezeRoot(ACell) then
      Result := FFixedRootCellDisplay.GetItemForCell(ACell)
    else
    begin
      Result := FFixedColumnCellDisplay.GetItemForCell(ACell);
      if not Assigned(Result) then
        Result := FFixedRowCellDisplay.GetItemForCell(ACell);
    end;
  end
  else
    Result := FNormalCellDisplay.GetItemForCell(ACell);
end;

function TTMSFNCDataGridRenderer.GetCellState(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCellState;
begin
  if (Options.Selection.Mode <> gsmNone) and ((FocusedCell.Row = ACell.Row) and (FocusedCell.Column = ACell.Column)) and IsFocused then
    Result := gcsFocused
  else
  begin
    if IsCellFixed(ACell) then
    begin
      if (Options.Selection.Mode <> gsmNone) and Options.Selection.ShowSelectionInFixedCells and IsFixedCellSelected(MakeCell(ACell.Column, ACell.Row)) then
        Result := gcsFixedSelected
      else
        Result := gcsFixed;
    end
    else if (Options.Selection.Mode <> gsmNone) and IsCellSelected(MakeCell(ACell.Column, ACell.Row)) then
      Result := gcsSelected
    else
      Result := gcsNormal;
  end;
end;

function TTMSFNCDataGridRenderer.GetRadioGroupIndex(AColumn,
  ARow: Integer): Integer;
var
  cd: TTMSFNCDataGridCellItem;
begin
  Result := -1;
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) then
    Result := AsExtendedCell(cd).RadioGroupIndex;
end;

procedure TTMSFNCDataGridRenderer.SetLeftColumn(const Value: Integer);
var
  cl: TTMSFNCDataGridCellCoord;
begin
  cl.Row := Max(FixedRowCount, Min(StartRow, RowCount - 1 - FixedBottomRowCount));
  cl.Column := Max(FixedColumnCount, Min(Value, ColumnCount - 1 - FixedRightColumnCount));
  Navigate(cl,  True);
end;

procedure TTMSFNCDataGridRenderer.SetLocalRect(ARect: TRectF);
begin
  inherited;
  FLocalRectChanged := True;
end;

function TTMSFNCDataGridRenderer.GetBooleans(AColumn, ARow: Integer): Boolean;
var
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;
  if HasDataCheckBox[AColumn, ARow] or HasDataRadioButton[AColumn, ARow] then
  begin
    cl := GetColumn(AColumn);
    if Assigned(cl) then
      Result := Strings[AColumn, ARow] = cl.Binding.BooleanTrueValue;
  end
  else
    Result := inherited GetBooleans(AColumn, ARow);
end;

function TTMSFNCDataGridRenderer.GetBottomRow: Integer;
begin
  Result := StopRow;
end;

function TTMSFNCDataGridRenderer.GetRightColumn: Integer;
begin
  Result := StopColumn;
end;

function TTMSFNCDataGridRenderer.GetLayouts(AColumn,
  ARow: Integer): TTMSFNCDataGridCellLayout;
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  Result := nil;
  cd := CellDataExtended[AColumn, ARow];
  if Assigned(cd) then
  begin
    if not Assigned(TTMSFNCDataGridCellItemExtendedOpen(cd).Layout) then
    begin
      TTMSFNCDataGridCellItemExtendedOpen(cd).Layout := TTMSFNCDataGridCellLayout.Create;
      ConfigureLayout(MakeCell(AColumn, ARow), TTMSFNCDataGridCellItemExtendedOpen(cd).Layout, True);
      TTMSFNCDataGridCellItemExtendedOpen(cd).Layout.OnChange := @DoLayoutChanged;
    end;

    Result := TTMSFNCDataGridCellItemExtendedOpen(cd).Layout;
  end;
end;

function TTMSFNCDataGridRenderer.GetLeftColumn: Integer;
begin
  Result := StartColumn;
end;

function TTMSFNCDataGridRenderer.GetLookupTimer: TTimer;
begin
  if not Assigned(FLookupTimer) then
  begin
    FLookupTimer := TTimer.Create(nil);
    FLookupTimer.OnTimer := DoLookupTimer;
    FLookupTimer.Interval := Options.Lookup.ResetInterval;
    FLookupTimer.Enabled := False;
  end;

  Result := FLookupTimer;
end;

procedure TTMSFNCDataGridRenderer.SetTextAngles(AColumn, ARow: Integer;
  const Value: Double);
var
  l: TTMSFNCDataGridCellLayout;
begin
  l := Layouts[AColumn, ARow];
  if Assigned(l) then
    l.TextAngle := Value;
end;

procedure TTMSFNCDataGridRenderer.SetTopRow(const Value: Integer);
var
  cl: TTMSFNCDataGridCellCoord;
begin
  cl.Row := Max(FixedRowCount, Min(Value, RowCount - 1 - FixedBottomRowCount));
  cl.Column := Max(FixedColumnCount, Min(StartColumn, ColumnCount - 1 - FixedRightColumnCount));
  Navigate(cl, True);
end;

function TTMSFNCDataGridRenderer.GetScrollTimer: TTimer;
begin
  if not Assigned(FScrollTimer) then
  begin
    FScrollTimer := TTimer.Create(nil);
    FScrollTimer.OnTimer := DoScrollTimer;
    FScrollTimer.Interval := Options.Mouse.AutoScrollingInterval;
    FScrollTimer.Enabled := False;
  end;

  Result := FScrollTimer;
end;

function TTMSFNCDataGridRenderer.GetSelectedColumnDictionary: TTMSFNCDataGridBooleanDictionary;
begin
  if not Assigned(FSelectedColumnDictionary) then
    FSelectedColumnDictionary := TTMSFNCDataGridBooleanDictionary.Create;

  Result := FSelectedColumnDictionary;
end;

function TTMSFNCDataGridRenderer.GetSelectedCell(AColumn, ARow: Integer): Boolean;
begin
  case Options.Selection.Mode of
    gsmDisjunctRow: Result := SelectedRows[ARow];
    gsmDisjunctColumn: Result := SelectedColumns[AColumn];
    gsmDisjunctCell, gsmDisjunctCellRange:
    begin
      if SelectedCellDictionary.ContainsKey(MakeCell(AColumn, ARow)) then
        Result := SelectedCellDictionary[MakeCell(AColumn, ARow)]
      else
        Result := False;
    end
    else
    begin
      Result := (AColumn >= Selection.StartCell.Column) and (AColumn <= Selection.StopCell.Column)
        and (ARow >= Selection.StartCell.Row) and (ARow <= Selection.StopCell.Row);
    end;
  end;
end;

function TTMSFNCDataGridRenderer.GetSelectedCellDictionary: TTMSFNCDataGridSelectedCellDictionary;
begin
  if not Assigned(FSelectedCellDictionary) then
    FSelectedCellDictionary := TTMSFNCDataGridSelectedCellDictionary.Create;

  Result := FSelectedCellDictionary;
end;

function TTMSFNCDataGridRenderer.GetSelectedRowDictionary: TTMSFNCDataGridBooleanDictionary;
begin
  if not Assigned(FSelectedRowDictionary) then
    FSelectedRowDictionary := TTMSFNCDataGridBooleanDictionary.Create;

  Result := FSelectedRowDictionary;
end;

function TTMSFNCDataGridRenderer.GetSelectedRow(ARow: Integer): Boolean;
begin
  if Options.Selection.Mode in [gsmDisjunctRow, gsmDisjunctCell, gsmDisjunctCellRange] then
  begin
    if SelectedRowDictionary.ContainsKey(ARow) then
      Result := SelectedRowDictionary[ARow]
    else
      Result := False;
  end
  else
    Result := (ARow >= Selection.StartCell.Row) and (ARow <= Selection.StopCell.Row)
end;

function TTMSFNCDataGridRenderer.GetSelection: TTMSFNCDataGridCellCoordRange;
begin
  Result := Selection;
end;

function TTMSFNCDataGridRenderer.GetStates(AColumn,
  ARow: Integer): TTMSFNCDataGridCellState;
begin
  Result := GetCellState(MakeCell(AColumn, ARow));
end;

function TTMSFNCDataGridRenderer.GetSelectedColumn(AColumn: Integer): Boolean;
begin
  if Options.Selection.Mode in [gsmDisjunctColumn, gsmDisjunctCell, gsmDisjunctCellRange] then
  begin
    if SelectedColumnDictionary.ContainsKey(AColumn) then
      Result := SelectedColumnDictionary[AColumn]
    else
      Result := False;
  end
  else
    Result := (AColumn >= Selection.StartCell.Column) and (AColumn <= Selection.StopCell.Column)
end;

function TTMSFNCDataGridRenderer.GetReadOnlys(AColumn, ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;

  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsReadOnly in cl.Settings) then
    Result := cl.ReadOnly
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).ReadOnly;
  end;
end;

function TTMSFNCDataGridRenderer.GetReplaceDialog: TTMSFNCReplaceDialog;
begin
  if not Assigned(FReplaceDialog) then
  begin
    FReplaceDialog := TTMSFNCReplaceDialog.Create(nil);
    FReplaceDialog.Options := [rdoCaseSensitive,
      rdoFindEnabled, rdoFindNextEnabled, rdoReplaceAllEnabled, rdoReplaceEnabled,
      rdoCloseEnabled, rdoDown];
    FReplaceDialog.VisibleOptions := [rdovCaseSensitive, rdovExpression,
      rdovWholeWordOnly, rdovReplace, rdovReplaceAll, rdovFind, rdovFindNext,
      rdovClose, rdovFindCombo, rdovFindMemo, rdovReplaceCombo, rdovDirection];
    FReplaceDialog.OnFind := DoReplaceFind;
    FReplaceDialog.OnFindNext := DoReplaceFindNext;
    FReplaceDialog.OnReplace := DoReplace;
    FReplaceDialog.OnReplaceAll := DoReplaceAll;
  end;

  Result := FReplaceDialog;
end;

function TTMSFNCDataGridRenderer.GetTextAngles(AColumn, ARow: Integer): Double;
var
  l: TTMSFNCDataGridCellLayout;
begin
  Result := 0.0;
  l := GetCellAppearance(GetCellState(MakeCell(AColumn, ARow)), MakeCell(AColumn, ARow));
  if Assigned(l) then
    Result := l.TextAngle;
end;

function TTMSFNCDataGridRenderer.GetTopRow: Integer;
begin
  Result := StartRow;
end;

function TTMSFNCDataGridRenderer.GetOptions: TTMSFNCDataGridOptions;
begin
  Result := TTMSFNCDataGridOptions(inherited Options);
end;

function TTMSFNCDataGridRenderer.GetPageCount: Integer;
var
  PageSize: Integer;
begin
  PageSize := GetPageScrollSize;
  if PageSize > 0 then
    Result := ((RowCount - FixedBottomRowCount - FixedRowCount) + PageSize - 1) div PageSize
  else
    Result := 0;
end;

function TTMSFNCDataGridRenderer.GetPageIndex: Integer;
begin
  Result := GetPageIndexforRow(BottomRow);
end;

function TTMSFNCDataGridRenderer.GetPageIndexForRow(ARow: Integer): Integer;
var
  PageSize: Integer;
begin
  PageSize := GetPageScrollSize; // Number of rows per page
  if (PageSize > 0) and (RowCount > 0) then
    Result := ARow div PageSize
  else
    Result := 0; // Default to the first page if invalid
end;

function TTMSFNCDataGridRenderer.GetPageScrollSize: Integer;
var
  vm: Single;
begin
  vm := GetVMax;
  if (Options.Keyboard.PageScrollSize = 0) and (vm * RowCount > 0) then
    Result := Round(GetVViewPortSize / vm * RowCount)
  else
    Result := Options.Keyboard.PageScrollSize;
end;

function TTMSFNCDataGridRenderer.GetParentHost: TTMSFNCDataGridCellParent;
var
  h: TObject;
begin
  Result := nil;

  h := Host;

  if h is TTMSFNCDataGridCellParent then
  begin
    Result := h as TTMSFNCDataGridCellParent;
    Exit;
  end;

  while Assigned(h) and not (h is TTMSFNCDataGridCellParent) do
  begin
    if h is TTMSFNCDataGridRenderer then
      h := (h as TTMSFNCDataGridRenderer).Host;

    if h is TTMSFNCDataGridCellParent then
    begin
      Result := h as TTMSFNCDataGridCellParent;
      Break;
    end;
  end;
end;

function TTMSFNCDataGridRenderer.GetProgressValue(AColumn,
  ARow: Integer): Integer;
var
  cd: TTMSFNCDataGridCellItem;
begin
  Result := 0;
  if HasDataProgressBar[AColumn, ARow] then
    Result := Ints[AColumn, ARow]
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitProgressBar) then
      Result := AsExtendedCell(cd).IntegerValue;
  end;
end;

function TTMSFNCDataGridRenderer.GetCustomHorizontalScrollBar: TTMSFNCDataGridScrollBar;
begin
  Result := FCustomHorizontalScrollBar;
end;

function TTMSFNCDataGridRenderer.GetCustomVerticalScrollBar: TTMSFNCDataGridScrollBar;
begin
  Result := FCustomVerticalScrollBar;
end;

function TTMSFNCDataGridRenderer.GetDragTimer: TTimer;
begin
  if not Assigned(FDragTimer) then
  begin
    FDragTimer := TTimer.Create(nil);
    FDragTimer.OnTimer := DoDragTimer;
    FDragTimer.Interval := Options.Mouse.AutoScrollingInterval;
    FDragTimer.Enabled := False;
  end;

  Result := FDragTimer;
end;

function TTMSFNCDataGridRenderer.GetContentRect: TRectF;
begin
  Result := inherited GetContentRect;
  Result.Right := Result.Left + Max(0, Result.Right - Result.Left);
  Result.Bottom := Result.Top + Max(0, Result.Bottom - Result.Top);
  Result := ConfigureScrollBarsRect(Result);
end;

function TTMSFNCDataGridRenderer.GetControlAligns(AColumn,
  ARow: Integer): TTMSFNCDataGridCellControlAlign;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := gcaNone;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsControlAlign in cl.Settings) then
    Result := cl.ControlAlign
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).ControlAlign;
  end;
end;

function TTMSFNCDataGridRenderer.GetControlPositions(AColumn,
  ARow: Integer): TTMSFNCDataGridCellControlPosition;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := gcpCenterRight;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsControlPosition in cl.Settings) then
    Result := cl.ControlPosition
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).ControlPosition;
  end;
end;

function TTMSFNCDataGridRenderer.GetControlHeights(AColumn,
  ARow: Integer): Integer;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := -1;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsControlHeight in cl.Settings) then
    Result := cl.ControlHeight
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).ControlHeight;
  end;
end;

function TTMSFNCDataGridRenderer.GetControlMargins(AColumn,
  ARow: Integer): TTMSFNCMargins;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := nil;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsControlMargins in cl.Settings) then
    Result := cl.ControlMargins
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).ControlMargins;
  end;
end;

function TTMSFNCDataGridRenderer.GetControlTexts(AColumn,
  ARow: Integer): string;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := '';
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsControlText in cl.Settings) then
    Result := cl.ControlText
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).ControlText;
  end;
end;

function TTMSFNCDataGridRenderer.GetControlWidths(AColumn,
  ARow: Integer): Integer;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := -1;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsControlWidth in cl.Settings) then
    Result := cl.ControlWidth
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).ControlWidth;
  end;
end;

function TTMSFNCDataGridRenderer.GetControlWrapperList: TTMSFNCDataGridCellControlWrapperList;
begin
  if not Assigned(FControlWrapperList) then
    FControlWrapperList := TTMSFNCDataGridCellControlWrapperList.Create;

  Result := FControlWrapperList;
end;

function TTMSFNCDataGridRenderer.GetCalculationRect: TRectF;
begin
  Result := LocalRect;
  Result.Right := Result.Left + Max(0, Result.Right - Result.Left);
  Result.Bottom := Result.Top + Max(0, Result.Bottom - Result.Top);
  Result := ConfigureScrollBarsRect(Result);
end;

function TTMSFNCDataGridRenderer.GetHorizontalScrollPosition: Double;
var
  hVal, scrollh: Double;
begin
  hVal := GetHScrollValue;
  if ScrollMode = gsmCellScrolling then
  begin
    if GetHVisible then
      scrollh := ColumnPositions[Round(hval)]
    else
      scrollh := ColumnPositions[0];

    hVal := scrollh;
  end;

  Result := hVal;
end;

function TTMSFNCDataGridRenderer.GetTextAligns(AColumn, ARow: Integer): TTMSFNCGraphicsTextAlign;
var
  l: TTMSFNCDataGridCellLayout;
begin
  Result := gtaLeading;
  l := GetCellAppearance(GetCellState(MakeCell(AColumn, ARow)), MakeCell(AColumn, ARow));
  if Assigned(l) then
    Result := l.TextAlign;
end;

function TTMSFNCDataGridRenderer.GetHorizontalScrollBar: TScrollBar;
begin
  Result := FHorizontalScrollBar;
end;

function TTMSFNCDataGridRenderer.GetHViewPortSize: Single;
begin
  Result := 0;
  if HasCustomScrollBars and Assigned(CustomHorizontalScrollBar) then
    Result := CustomHorizontalScrollBar.PageSize
  else if Assigned(HorizontalScrollBar) then
  begin
    {$IFDEF FMXLIB}
    Result := HorizontalScrollBar.ViewportSize;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Result := HorizontalScrollBar.PageSize;
    {$ENDIF}
  end;
end;

function TTMSFNCDataGridRenderer.GetRowIndex(ARow: Integer): Integer;
var
  ri: TTMSFNCDataGridRowItem;
begin
  Result := ARow;
  ri := GetRowData(ARow);
  if Assigned(ri) then
    Result := ri.&Index;
end;

function TTMSFNCDataGridRenderer.GetRowViewPortSize: Double;
var
  I,cnt: Integer;
  h: Double;
  ch: Double;
  cr: TRectF;
begin
  cr := GetContentRect;
  ch := cr.Bottom - cr.Top;
  Result := 0;
  h := 0;
  cnt := 0;
  for I := RowCount - 1 downto 0 do
  begin
    h := h + RowHeights[I];
    if h > ch then
    begin
      Result := Max(1, cnt);
      Break;
    end;
    Inc(cnt);
  end;
end;

function TTMSFNCDataGridRenderer.GetHScrollValue: Single;
begin
  Result := FLocalHScrollValue;

  if HasCustomScrollBars and Assigned(CustomHorizontalScrollBar) then
    Result := Min(CustomHorizontalScrollBar.Max - CustomHorizontalScrollBar.PageSize, Max(0, CustomHorizontalScrollBar.Value))
  else if Assigned(HorizontalScrollBar) then
  begin
    {$IFDEF FMXLIB}
    Result := Min(HorizontalScrollBar.Max - HorizontalScrollBar.ViewportSize, Max(0, HorizontalScrollBar.Value));
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Result := Min(HorizontalScrollBar.Max - HorizontalScrollBar.PageSize, Max(0, Round(HorizontalScrollBar.Position)));
    {$ENDIF}
  end;
end;

function TTMSFNCDataGridRenderer.GetColors(AColumn: Integer; ARow: Integer): TTMSFNCGraphicsColor;
var
  l: TTMSFNCDataGridCellLayout;
begin
  Result := gcNull;
  l := GetCellAppearance(GetCellState(MakeCell(AColumn, ARow)), MakeCell(AColumn, ARow));
  if Assigned(l) then
    Result := l.Fill.Color;
end;

function TTMSFNCDataGridRenderer.GetColumn(
  AColumn: Integer): TTMSFNCDataGridColumn;
begin
  Result := nil;
  if (AColumn >= 0) and (AColumn <= Columns.Count - 1) then
    Result := Columns[AColumn];
end;

function TTMSFNCDataGridRenderer.GetColumnFilterName(AColumn: Integer): string;
var
  cl: TTMSFNCDataGridColumn;
begin
  Result := '';
  cl := GetColumn(AColumn);
  if Assigned(cl) then
    Result := cl.DisplayName;

  if Result = '' then
    Result := inherited GetColumnFilterName(AColumn);
end;

function TTMSFNCDataGridRenderer.GetColumnsClass: TTMSFNCDataGridColumnsClass;
begin
  Result := TTMSFNCDataGridColumns;
end;

function TTMSFNCDataGridRenderer.GetColumnsEditor: TObject;
begin
  if not Assigned(FColumnsEditor) then
  begin
    FColumnsEditor := TTMSFNCDataGridColumnsEditor.Create(nil);
    (FColumnsEditor as TTMSFNCDataGridColumnsEditor).Renderer := Self;
  end;

  Result := FColumnsEditor;
end;

function TTMSFNCDataGridRenderer.GetColumnViewPortSize: Double;
var
  I,cnt: Integer;
  w: Double;
  cw: Double;
  cr: TRectF;
begin
  cr := GetContentRect;
  cw := cr.Right - cr.Left;
  Result := 0;
  w := 0;
  cnt := 0;
  for I := ColumnCount - 1 downto 0 do
  begin
    w := w + ColumnWidths[I];
    if w > cw then
    begin
      Result := Max(1, cnt);
      Break;
    end;
    Inc(cnt);
  end;
end;

function TTMSFNCDataGridRenderer.GetCommentPopup: TTMSFNCCommentPopup;
begin
  if not Assigned(FCommentPopup) then
  begin
    FCommentPopup := TTMSFNCCommentPopup.Create(nil);
    FCommentPopup.Placement := ppAbsolute;
    FCommentPopup.OnPopupPaint := DoPaintCommentPopup;
  end;

  Result := FCommentPopup;
end;

function TTMSFNCDataGridRenderer.GetComments(AColumn, ARow: Integer): string;
var
  cd: TTMSFNCDataGridCellItem;
begin
  Result := '';
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) then
    Result := AsExtendedCell(cd).Comment;
end;

function TTMSFNCDataGridRenderer.GetHints(AColumn, ARow: Integer): string;
var
  cd: TTMSFNCDataGridCellItem;
begin
  Result := '';
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) then
    Result := AsExtendedCell(cd).Hint;
end;

function TTMSFNCDataGridRenderer.GetHintString: string;
begin
  Result := '';
  if IsCellValid(FHoverCell) then
  begin
    Result := Hints[FHoverCell.Column, FHoverCell.Row];
    DoGetCellHint(FHoverCell, Result);
  end;
end;

function TTMSFNCDataGridRenderer.CheckRange(ARange: TTMSFNCDataGridCellItemTypeRange; ARow: Integer): Boolean;
begin
  Result := True;
  case ARange of
    gcirNormal: Result := Result and ((ARow >= FixedRowCount) and (ARow <= RowCount - 1 - FixedBottomRowCount));
    gcirFixed: Result := Result and ((ARow < FixedRowCount) or (ARow > RowCount - 1 - FixedBottomRowCount));
  end;
end;

function TTMSFNCDataGridRenderer.GetHasDataCheckBox(AColumn,
  ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsType in cl.Settings) then
  begin
    Result := cl.&Type = gcitDataCheckBox;
    Result := Result and CheckRange(cl.TypeRange, ARow);
  end
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).&Type = gcitDataCheckBox;
  end;
end;

function TTMSFNCDataGridRenderer.GetHasCheckBox(AColumn,
  ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsType in cl.Settings) then
  begin
    Result := cl.&Type = gcitCheckBox;
    Result := Result and CheckRange(cl.TypeRange, ARow);
  end
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).&Type = gcitCheckBox;
  end;
end;

function TTMSFNCDataGridRenderer.GetHasButton(AColumn,
  ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsType in cl.Settings) then
  begin
    Result := cl.&Type = gcitButton;
    Result := Result and CheckRange(cl.TypeRange, ARow);
  end
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).&Type = gcitButton;
  end;
end;

function TTMSFNCDataGridRenderer.GetHasBitmap(AColumn,
  ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;

  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsType in cl.Settings) then
  begin
    Result := cl.&Type = gcitBitmap;
    Result := Result and CheckRange(cl.TypeRange, ARow);
  end
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).&Type = gcitBitmap;
  end;
end;

function TTMSFNCDataGridRenderer.GetHasProgressBar(AColumn,
  ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;

  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsType in cl.Settings) then
  begin
    Result := cl.&Type = gcitProgressBar;
    Result := Result and CheckRange(cl.TypeRange, ARow);
  end
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).&Type = gcitProgressBar;
  end;
end;

function TTMSFNCDataGridRenderer.GetHasDataProgressBar(AColumn,
  ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;

  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsType in cl.Settings) then
  begin
    Result := cl.&Type = gcitDataProgressBar;
    Result := Result and CheckRange(cl.TypeRange, ARow);
  end
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).&Type = gcitDataProgressBar;
  end;
end;

function TTMSFNCDataGridRenderer.GetHasRadioButton(AColumn,
  ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsType in cl.Settings) then
  begin
    Result := cl.&Type = gcitRadioButton;
    Result := Result and CheckRange(cl.TypeRange, ARow);
  end
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).&Type = gcitRadioButton;
  end;
end;

function TTMSFNCDataGridRenderer.GetHasDataRadioButton(AColumn,
  ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  cl: TTMSFNCDataGridColumn;
begin
  Result := False;
  cl := GetColumn(AColumn);
  if Assigned(cl) and (gcsType in cl.Settings) then
  begin
    Result := cl.&Type = gcitDataRadioButton;
    Result := Result and CheckRange(cl.TypeRange, ARow);
  end
  else
  begin
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
      Result := AsExtendedCell(cd).&Type = gcitDataRadioButton;
  end;
end;

function TTMSFNCDataGridRenderer.GetHasFilterEditor(AColumn,
  ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
begin
  Result := False;
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) then
    Result := Assigned(TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).FilterEditor);
end;

function TTMSFNCDataGridRenderer.GetHasLayout(AColumn, ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
begin
  Result := False;
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) then
    Result := Assigned(TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).Layout);
end;

function TTMSFNCDataGridRenderer.GetHasGrid(AColumn, ARow: Integer): Boolean;
var
  cd: TTMSFNCDataGridCellItem;
  o: TObject;
begin
  Result := False;
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) then
  begin
    o := TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).Renderer;
    if Assigned(o) and (o is TTMSFNCDataGridRenderer) then
      Result := True;
  end;
end;

function TTMSFNCDataGridRenderer.GetHMax: Single;
begin
  Result := 0;
  if HasCustomScrollBars and Assigned(CustomHorizontalScrollBar) then
    Result := CustomHorizontalScrollBar.Max
  else if Assigned(HorizontalScrollBar) then
    Result := HorizontalScrollBar.Max;
end;

function TTMSFNCDataGridRenderer.GetHVisible: Boolean;
begin
  Result := False;
  if HasCustomScrollBars and Assigned(CustomHorizontalScrollBar) then
    Result := CustomHorizontalScrollBar.Visible
  else if Assigned(HorizontalScrollBar) then
    Result := HorizontalScrollBar.Visible;
end;

function TTMSFNCDataGridRenderer.GetSelectedColumnCount: Integer;
var
  k: Integer;
begin
  Result := 0;
  if Options.Selection.Mode in [gsmDisjunctColumn, gsmDisjunctCell, gsmDisjunctCellRange] then
  begin
    for k in SelectedColumnDictionary.Keys do
    begin
      if IsColumnValid(k) then
        Inc(Result);
    end;
  end
  else if (Selection.StartCell.Row <> -1) and (Selection.StopCell.Row <> -1)
    and (Selection.StartCell.Column <> -1) and (Selection.StopCell.Column <> -1) then
  begin
    for k := Selection.StartCell.Column to Selection.StopCell.Column do
      Inc(Result);
  end;
end;

procedure TTMSFNCDataGridRenderer.SetSelectedCell(AColumn, ARow: Integer;
  const Value: Boolean);
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  if SelectedCellDictionary.ContainsKey(MakeCell(AColumn, ARow)) then
  begin
    if Value = False then
      SelectedCellDictionary.Remove(MakeCell(AColumn, ARow))
    else
      SelectedCellDictionary[MakeCell(AColumn, ARow)] := Value;
  end
  else if Value <> False then
    SelectedCellDictionary.Add(MakeCell(AColumn, ARow), Value);

  SelectedRows[ARow] := Value;
  SelectedColumns[AColumn] := Value;

  DoUpdate;
end;

procedure TTMSFNCDataGridRenderer.SetSelectedColumn(AColumn: Integer;
  const Value: Boolean);
begin
  if not IsColumnValid(AColumn) then
    Exit;

  if SelectedColumnDictionary.ContainsKey(AColumn) then
  begin
    if Value = False then
      SelectedColumnDictionary.Remove(AColumn)
    else
      SelectedColumnDictionary[AColumn] := Value;
  end
  else if Value <> False then
    SelectedColumnDictionary.Add(AColumn, Value);

  DoUpdate;
end;

procedure TTMSFNCDataGridRenderer.SetSelectedRow(ARow: Integer; const Value: Boolean);
begin
  if not IsRowValid(ARow) then
    Exit;

  if SelectedRowDictionary.ContainsKey(ARow) then
  begin
    if Value = False then
      SelectedRowDictionary.Remove(ARow)
    else
      SelectedRowDictionary[ARow] := Value;
  end
  else if Value <> False then
    SelectedRowDictionary.Add(ARow, Value);

  DoUpdate;
end;

function TTMSFNCDataGridRenderer.GetSelectedCellCount: Integer;
begin
  case Options.Selection.Mode of
    gsmDisjunctCell, gsmDisjunctCellRange: Result := SelectedCellDictionary.Count;
    else
      Result := SelectedRowCount * SelectedColumnCount;
  end;
end;

function TTMSFNCDataGridRenderer.GetSelectedRowCount: Integer;
var
  k: Integer;
begin
  Result := 0;
  if Options.Selection.Mode in [gsmDisjunctRow, gsmDisjunctCell, gsmDisjunctCellRange] then
  begin
    for k in SelectedRowDictionary.Keys do
    begin
      if IsRowValid(k) then
        Inc(Result);
    end;
  end
  else if (Selection.StartCell.Row <> -1) and (Selection.StopCell.Row <> -1)
    and (Selection.StartCell.Column <> -1) and (Selection.StopCell.Column <> -1) then
  begin
    for k := Selection.StartCell.Row to Selection.StopCell.Row do
      Inc(Result);
  end;
end;

function TTMSFNCDataGridRenderer.ColumnByHeader(
  AHeader: string): TTMSFNCDataGridColumn;
begin
  Result := Columns.ColumnByHeader(AHeader);
end;

function TTMSFNCDataGridRenderer.ColumnByName(
  AName: string): TTMSFNCDataGridColumn;
begin
  Result := Columns.ColumnByName(AName);
end;

function TTMSFNCDataGridRenderer.ColumnIndexByHeader(AHeader: string): Integer;
var
  c: TTMSFNCDataGridColumn;
begin
  Result := -1;
  c := ColumnByHeader(AHeader);
  if Assigned(c) then
    Result := c.Index;
end;

function TTMSFNCDataGridRenderer.ColumnIndexByName(AName: string): Integer;
var
  c: TTMSFNCDataGridColumn;
begin
  Result := -1;
  c := ColumnByName(AName);
  if Assigned(c) then
    Result := c.Index;
end;

function TTMSFNCDataGridRenderer.ColumnStretchingActive: Boolean;
begin
  Result := FColumnStretchingActive;
end;

function TTMSFNCDataGridRenderer.GetOptionsClass: TTMSFNCDataGridDataOptionsClass;
begin
  Result := TTMSFNCDataGridOptions;
end;

procedure TTMSFNCDataGridRenderer.AutoSizeColumns(const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5);
var
  i: Integer;
  g: TTMSFNCGraphics;
begin
  BeginUpdate;
  g := TTMSFNCGraphics.CreateBitmapCanvas;
  try
    g.BeginScene;
    for i := 0 to ColumnCount - 1 do
      InternalAutoSizeColumn(i, AMode, APadding, g);
    g.EndScene;
  finally
    g.Free;
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.AutoSizeGrid(const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APaddingColumn: Integer = 5; const APaddingRow: Integer = 5);
var
  g: TTMSFNCGraphics;
  i: Integer;
begin
  BeginUpdate;
  g := TTMSFNCGraphics.CreateBitmapCanvas;
  try
    g.BeginScene;

    for i := 0 to ColumnCount - 1 do
      InternalAutoSizeColumn(i, AMode, APaddingColumn, g);

    for i := 0 to ColumnCount - 1 do
      InternalAutoSizeRow(i, AMode, APaddingRow, g);

    g.EndScene;
  finally
    g.free;
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.AddButton(AColumn, ARow: Integer; AText: string = '');
begin
  SetButton(AColumn, ARow, AText);
end;

procedure TTMSFNCDataGridRenderer.AddBitmap(ACell: TTMSFNCDataGridCellCoord;
  AName: string);
begin
  SetBitmap(ACell, AName);
end;

procedure TTMSFNCDataGridRenderer.AddBitmap(AColumn, ARow: Integer;
  AName: string);
begin
  SetBitmap(AColumn, ARow, AName);
end;

procedure TTMSFNCDataGridRenderer.AddBitmap(ACell: TTMSFNCDataGridCellCoord;
  ABitmap: TTMSFNCBitmap);
begin
  SetBitmap(ACell, ABitmap);
end;

procedure TTMSFNCDataGridRenderer.AddBitmap(AColumn, ARow: Integer;
  ABitmap: TTMSFNCBitmap);
begin
  SetBitmap(AColumn, ARow, ABitmap);
end;

procedure TTMSFNCDataGridRenderer.AddBitmapColumn(AColumn: Integer;
  AName: string);
begin
  SetBitmapColumn(AColumn, AName);
end;

procedure TTMSFNCDataGridRenderer.AddBitmapColumn(AColumn: Integer;
  ABitmap: TTMSFNCBitmap);
begin
  SetBitmapColumn(AColumn, ABitmap);
end;

procedure TTMSFNCDataGridRenderer.AddButton(ACell: TTMSFNCDataGridCellCoord; AText: string = '');
begin
  SetButton(ACell, AText);
end;

procedure TTMSFNCDataGridRenderer.AddButtonColumn(AColumn: Integer; AText: string = '');
begin
  SetButtonColumn(AColumn, AText);
end;

procedure TTMSFNCDataGridRenderer.AddCellToDisplay(ACell: TTMSFNCDataGridCell;
  ADisplay: TTMSFNCDataGridDisplayList);
var
  x, y: Double;
  cell: TTMSFNCDataGridCellOpen;
  r, rc, rg, rcc: TRectF;
begin
  if (UpdateCount > 0) or GetIsDestroying or not Assigned(ACell) or not Assigned(ADisplay) then
    Exit;

  x := -GetHorizontalScrollPosition;
  y := -GetVerticalScrollPosition;
  r := GetContentClipRect;

  rc := RectF(r.Left + TotalFixedColumnWidth + 1, r.Top + TotalFixedRowHeight + 1, r.Right - TotalFixedRightColumnWidth - 1, r.Bottom - TotalFixedBottomRowHeight - 1);

  if FUseClipRect then
  begin
    rcc := FClipRect;
    rc := RectF(Max(rc.Left, rcc.Left), Max(rc.Top, rcc.Top), Min(rc.Right, rcc.Right), Min(rc.Bottom, rcc.Bottom));
  end;

  cell := TTMSFNCDataGridCellOpen(ACell);
  rg := cell.CalcRect;
  case cell.Kind of
    gckCell: OffsetRectEx(rg, {$IFDEF FMXWEBLIB}Int{$ENDIF}(x) + r.Left, {$IFDEF FMXWEBLIB}Int{$ENDIF}(y) + r.Top);
    gckFixedRowCell, gckFreezeRowCell: OffsetRectEx(rg, {$IFDEF FMXWEBLIB}Int{$ENDIF}(x) + r.Left, r.Top);
    gckFixedColumnCell, gckFreezeColumnCell: OffsetRectEx(rg, r.Left, {$IFDEF FMXWEBLIB}Int{$ENDIF}(y) + r.Top);
    gckFixedRootCell, gckFreezeRootCell, gckFreezeFixedRowCell, gckFreezeFixedColumnCell: OffsetRectEx(rg, r.Left, r.Top);
  end;

  if RectIntersectsWithEx(rg, r) and IsCellDisplayed(MakeCell(cell.Column, cell.Row)) then
  begin
    cell.Rect := rg;
    case cell.Kind of
      gckCell: cell.ClipRect := RectF(Max(rc.Left, rg.Left), Max(rc.Top, rg.Top), Min(rc.Right, rg.Right), Min(rc.Bottom, rg.Bottom));
      gckFixedRowCell, gckFreezeRowCell: cell.ClipRect := RectF(Max(rc.Left, rg.Left), rg.Top, Min(rc.Right, rg.Right), rg.Bottom);
      gckFixedColumnCell, gckFreezeColumnCell: cell.ClipRect := RectF(rg.Left, Max(rc.Top, rg.Top), rg.Right, Min(rc.Bottom, rg.Bottom));
      gckFixedRootCell, gckFreezeRootCell, gckFreezeFixedRowCell, gckFreezeFixedColumnCell: cell.Cliprect := rg;
    end;

    BeginUsingCellData(cell.Coordinate, cell.Data);
    try
      ConfigureCell(cell, gccmLayout);
    finally
      EndUsingCellData;
    end;

    ADisplay.Add(cell);
  end;
end;

procedure TTMSFNCDataGridRenderer.AddCheckBox(AColumn, ARow: Integer;
  AValue: Boolean);
begin
  SetCheckBox(AColumn, ARow, AValue);
end;

procedure TTMSFNCDataGridRenderer.AddCheckBox(ACell: TTMSFNCDataGridCellCoord;
  AValue: Boolean);
begin
  SetCheckBox(ACell, AValue);
end;

procedure TTMSFNCDataGridRenderer.AddCheckBoxColumn(AColumn: Integer;
  AValue: Boolean);
begin
  SetCheckBoxColumn(AColumn, AValue);
end;

procedure TTMSFNCDataGridRenderer.AddDataCheckBox(AColumn, ARow: Integer);
begin
  SetDataCheckBox(AColumn, ARow);
end;

procedure TTMSFNCDataGridRenderer.AddDataCheckBox(ACell: TTMSFNCDataGridCellCoord);
begin
  SetDataCheckBox(ACell);
end;

procedure TTMSFNCDataGridRenderer.AddDataCheckBoxColumn(AColumn: Integer);
begin
  SetDataCheckBoxColumn(AColumn);
end;

function TTMSFNCDataGridRenderer.AddGrid(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridRenderer;
begin
  Result := SetGrid(ACell);
end;

function TTMSFNCDataGridRenderer.AddGrid(AColumn, ARow: Integer): TTMSFNCDataGridRenderer;
begin
  Result := SetGrid(AColumn, ARow);
end;

procedure TTMSFNCDataGridRenderer.AddDataProgressBar(AColumn, ARow: Integer);
begin
  SetDataProgressBar(AColumn, ARow);
end;

procedure TTMSFNCDataGridRenderer.AddDataProgressBar(
  ACell: TTMSFNCDataGridCellCoord);
begin
  SetDataProgressBar(ACell);
end;

procedure TTMSFNCDataGridRenderer.AddDataProgressBarColumn(AColumn: Integer);
begin
  SetDataProgressBarColumn(AColumn);
end;

procedure TTMSFNCDataGridRenderer.AddProgressBar(AColumn, ARow,
  AValue: Integer);
begin
  SetProgressBar(AColumn, ARow, AValue);
end;

procedure TTMSFNCDataGridRenderer.AddProgressBar(
  ACell: TTMSFNCDataGridCellCoord; AValue: Integer);
begin
  SetProgressBar(ACell, AValue);
end;

procedure TTMSFNCDataGridRenderer.AddProgressBarColumn(AColumn,
  AValue: Integer);
begin
  SetProgressBarColumn(AColumn, AValue);
end;

procedure TTMSFNCDataGridRenderer.AddRadioButton(AColumn, ARow: Integer;
  AValue: Boolean = False; AGroupIndex: Integer = 0);
begin
  SetRadioButton(AColumn, ARow, AValue, AGroupIndex);
end;

procedure TTMSFNCDataGridRenderer.AddRadioButton(
  ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False; AGroupIndex: Integer = 0);
begin
  SetRadioButton(ACell, AValue, AGroupIndex);
end;

procedure TTMSFNCDataGridRenderer.AddRadioButtonColumn(AColumn: Integer;
  AValue: Boolean = False; AGroupIndex: Integer = 0);
begin
  SetRadioButtonColumn(AColumn, AValue, AGroupIndex);
end;

procedure TTMSFNCDataGridRenderer.AddDataRadioButton(AColumn, ARow: Integer;
  AValue: Boolean = False; AGroupIndex: Integer = 0);
begin
  SetDataRadioButton(AColumn, ARow, AValue, AGroupIndex);
end;

procedure TTMSFNCDataGridRenderer.AddDataRadioButton(
  ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False; AGroupIndex: Integer = 0);
begin
  SetDataRadioButton(ACell, AValue, AGroupIndex);
end;

procedure TTMSFNCDataGridRenderer.AddDataRadioButtonColumn(AColumn: Integer;
  AValue: Boolean = False; AGroupIndex: Integer = 0);
begin
  SetDataRadioButtonColumn(AColumn, AValue, AGroupIndex);
end;

{$HINTS OFF}
procedure TTMSFNCDataGridRenderer.AddFilterEditor(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItemExtended;
  f: TTMSFNCDataGridCellControl;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      f := FilterEditors[AColumn, ARow];
  finally
    EndUpdate;
  end;;
end;
{$HINTS ON}

procedure TTMSFNCDataGridRenderer.AddFilterEditor(
  ACell: TTMSFNCDataGridCellCoord);
begin
  AddFilterEditor(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.AfterExport;
begin
  inherited;
  FClipRect := FSaveClipRect;
end;

procedure TTMSFNCDataGridRenderer.Animate(Sender: TObject);
var
  dx, dy, posx, posy: Double;
  animh, animv: Boolean;
begin
  posy := GetVScrollValue;
  posx := GetHScrollValue;
  dx := Abs(FScrollHTo - posx) / Max(1, Abs(FSpX) * 6);
  dy := Abs(FScrollVTo - posy) / Max(1, Abs(FSpY) * 6);
  animv := False;
  if FAnimateVerticalPos then
    animv := AnimateDouble(posy, FScrollVTo, dy, 0.01);

  animh := False;
  if FAnimateHorizontalPos then
    animh := AnimateDouble(posx, FScrollHTo, dx, 0.01);

  FAnimating := animv or animh;
  if FAnimating then
    Scroll(posx, posy)
  else
  begin
    FAnimateVerticalPos := False;
    AnimateTimer.Enabled := False;
    FAnimateHorizontalPos := False;
  end;
end;

procedure TTMSFNCDataGridRenderer.ApplyExportScale(AScale: Single);
var
  I: Integer;
begin
  FScale := AScale;
  BeginUpdate;
  try
    for I := 0 to ColumnCount - 1 do
      ColumnWidths[I] := ColumnWidths[I] * AScale;

    for I := 0 to RowCount - 1 do
      RowHeights[I] := RowHeights[I] * AScale;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.ResetColumnWidths;
var
  I: Integer;
  cl: TTMSFNCDataGridColumn;
begin
  BeginUpdate;
  try
    for I := 0 to ColumnCount - 1 do
    begin
      cl := GetColumn(I);
      if Assigned(cl) then
        ColumnWidths[I] := cl.Width
      else
        ColumnWidths[I] := DefaultColumnWidth;        
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.ResetDrag;
begin
  FDragging := False;
  DragTimer.Enabled := False;
  FDraggingMode := gdmNone;
  FDragCell := MakeCell(-1, -1);
  FDragCellTo := MakeCell(-1, -1);
  FDraggingType := gdtNone;
  FDragFixed := False;
end;

procedure TTMSFNCDataGridRenderer.ResetExportScale;
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := 0 to ColumnCount - 1 do
      ColumnWidths[I] := ColumnWidths[I] / FScale;

    for I := 0 to RowCount - 1 do
      RowHeights[I] := RowHeights[I] / FScale;

    FScale := 1.0;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.ResetRowHeights;
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := 0 to RowCount - 1 do
      RowHeights[I] := DefaultRowHeight; 
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.ApplyCellScale(ACell: TTMSFNCDataGridCell;
  AScale: Single);
begin
  TTMSFNCDataGridCellOpen(ACell).ApplyScale(AScale);
end;

procedure TTMSFNCDataGridRenderer.ApplyStyle;
var
  c: TTMSFNCGraphicsColor;
  cs, vs: TTMSFNCDataGridScrollBar;
begin
  inherited;

  FStyleApplied := True;
  FIsStyling := True;
  BeginUpdate;
  try
    c := gcNull;
    if TTMSFNCStyles.GetStyleBackgroundFillColor(c) then
    begin
      CellAppearance.NormalLayout.Fill.Color := c;
      CellAppearance.NormalLayout.Fill.Kind := gfkSolid;
      FilterAppearance.Fill.Color := c;
      FilterAppearance.Fill.Kind := gfkSolid;
    end;

    c := gcNull;
    if TTMSFNCStyles.GetStyleLineFillColor(c) then
    begin
      Stroke.Color := c;
      CellAppearance.FixedLayout.Stroke.Color := c;
      CellAppearance.FixedSelectedLayout.Stroke.Color := c;
      CellAppearance.SelectedLayout.Stroke.Color := c;
      CellAppearance.NormalLayout.Stroke.Color := c;
      CellAppearance.FocusedLayout.Stroke.Color := c;
      CellAppearance.BandLayout.Stroke.Color := c;
      CellAppearance.GroupLayout.Stroke.Color := c;
      CellAppearance.SummaryLayout.Stroke.Color := c;
      FilterAppearance.Stroke.Color := c;
    end;

    c := gcNull;
    if TTMSFNCStyles.GetStyleHeaderFillColor(c) then
    begin
      CellAppearance.FixedLayout.Fill.Kind := gfkSolid;
      CellAppearance.FixedLayout.Fill.Color := c;
      CellAppearance.GroupLayout.Fill.Color := Darker(c, 15);
      CellAppearance.SummaryLayout.Fill.Color := Darker(c, 15);
      CellAppearance.GroupLayout.Fill.Kind := gfkSolid;
      CellAppearance.SummaryLayout.Fill.Kind := gfkSolid;
    end;

    c := gcNull;
    if TTMSFNCStyles.GetStyleHeaderFillColorTo(c) then
    begin
      CellAppearance.FixedLayout.Fill.Kind := gfkGradient;
      CellAppearance.FixedLayout.Fill.ColorTo := c;
    end;

    c := gcNull;
    if TTMSFNCStyles.GetStyleSelectionFillColor(c) then
    begin
      CellAppearance.FixedSelectedLayout.Fill.Color := c;
      CellAppearance.FocusedLayout.Fill.Color := c;
      CellAppearance.SelectedLayout.Fill.Color := c;
      CellAppearance.FixedSelectedLayout.Fill.Kind := gfkSolid;
      CellAppearance.FocusedLayout.Fill.Kind := gfkSolid;
      CellAppearance.SelectedLayout.Fill.Kind := gfkSolid;
    end;

    c := gcNull;
    if TTMSFNCStyles.GetStyleSelectionFillColorTo(c) then
    begin
      CellAppearance.FixedSelectedLayout.Fill.ColorTo := c;
      CellAppearance.FocusedLayout.Fill.ColorTo := c;
      CellAppearance.SelectedLayout.Fill.ColorTo := c;
      CellAppearance.FixedSelectedLayout.Fill.Kind := gfkGradient;
      CellAppearance.FocusedLayout.Fill.Kind := gfkGradient;
      CellAppearance.SelectedLayout.Fill.Kind := gfkGradient;
    end;

    c := gcNull;
    if TTMSFNCStyles.GetStyleTextFontColor(c) then
    begin
      CellAppearance.FixedLayout.Font.Color := c;
      CellAppearance.NormalLayout.Font.Color := c;
      CellAppearance.FixedSelectedLayout.Font.Color := c;
      CellAppearance.SelectedLayout.Font.Color := c;
      CellAppearance.FocusedLayout.Font.Color := c;
      CellAppearance.GroupLayout.Font.Color := c;
      CellAppearance.SummaryLayout.Font.Color := c;
      FilterAppearance.Font.Color := c;
    end;

    cs := CustomHorizontalScrollBar;
    if Assigned(cs) then
      cs.ApplyStyle;

    vs := CustomVerticalScrollBar;
    if Assigned(vs) then
      vs.ApplyStyle;

  finally
    EndUpdate;
    FIsStyling := False;
  end;
end;

procedure TTMSFNCDataGridRenderer.Assign(Source: TPersistent);
begin
  BeginUpdate;
  try
    inherited;
    if Source is TTMSFNCDataGridRenderer then
    begin
      FIcons.Assign((Source as TTMSFNCDataGridRenderer).Icons);
      FCellAppearance.Assign((Source as TTMSFNCDataGridRenderer).CellAppearance);
      FCustomScrollBars := (Source as TTMSFNCDataGridRenderer).CustomScrollBars;
      FDragAppearance.Assign((Source as TTMSFNCDataGridRenderer).DragAppearance);
      FFilterAppearance.Assign((Source as TTMSFNCDataGridRenderer).FilterAppearance);
      FGlobalFont.Assign((Source as TTMSFNCDataGridRenderer).GlobalFont);
      FHorizontalScrollBarVisible := (Source as TTMSFNCDataGridRenderer).HorizontalScrollBarVisible;
      FVerticalScrollBarVisible := (Source as TTMSFNCDataGridRenderer).VerticalScrollBarVisible;
      FScrollMode := (Source as TTMSFNCDataGridRenderer).ScrollMode;
      FScrollUpdate := (Source as TTMSFNCDataGridRenderer).ScrollUpdate;
      FStretchScrollBars := (Source as TTMSFNCDataGridRenderer).StretchScrollBars;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.InternalSaveToImageStream(AStream: TStream);
var
  g: TTMSFNCGraphics;
begin
  g := TTMSFNCGraphics.CreateBitmapCanvas(Round(TotalColumnWidth), Round(TotalRowHeight));
  try
    g.BeginScene;
    &Export(g, RectF(0, 0 ,TotalColumnWidth, TotalRowHeight), MakeCellRange(0, 0, ColumnCount - 1, RowCount - 1),
      False, False, True);
    g.EndScene;
    g.Bitmap.SaveToStream(AStream);
  finally
    g.Free;
  end;
end;

procedure TTMSFNCDataGridRenderer.InternalSaveToImage(AFileName: string);
var
  ms: TMemoryStream;
  procedure InternalOutputToImage;
  begin
    ms.Position := 0;
    InternalSaveToImageStream(ms);
  end;
begin
  ms := TMemoryStream.Create;
  try
    InternalOutputToImage;
    ms.SaveToFile(AFileName);
    if Options.IO.OpenAfterCreation then
      TTMSFNCUtils.OpenFile(AFileName);
  finally
    ms.Free;
  end;
end;

procedure TTMSFNCDataGridRenderer.InternalSaveToHTML(AFileName: string; AEncoding: TEncoding);
var
  ms: TMemoryStream;
  procedure InternalOutputToHTML;
  var
    d: string;
  begin
    d := ExtractFilePath(AFileName);
    d := StringReplace(d, '\', '/', [rfReplaceAll]);

    ms.Position := 0;
    InternalSaveToHTMLStream(ms, AEncoding, d);
  end;
begin
  ms := TMemoryStream.Create;
  try
    InternalOutputToHTML;
    ms.SaveToFile(AFileName);
    if Options.IO.OpenAfterCreation then
      TTMSFNCUtils.OpenFile(AFileName);
  finally
    ms.Free;
  end;
end;

procedure TTMSFNCDataGridRenderer.SaveToImageData(AFileName: string);
begin
  InternalSaveToImage(AFileName);
end;

procedure TTMSFNCDataGridRenderer.SaveToImageStreamData(AStream: TStream);
begin
  InternalSaveToImageStream(AStream);
end;

procedure TTMSFNCDataGridRenderer.SaveToHTMLData(AFileName: string; AEncoding: TEncoding);
begin
  InternalSaveToHTML(AFileName, AEncoding);
end;

procedure TTMSFNCDataGridRenderer.SaveToHTMLStreamData(AStream: TStream; AEncoding: TEncoding);
begin
  InternalSaveToHTMLStream(AStream, AEncoding);
end;

procedure TTMSFNCDataGridRenderer.SaveToHTMLData(AFileName: string);
begin
  InternalSaveToHTML(AFileName, TEncoding.Default);
end;

procedure TTMSFNCDataGridRenderer.SaveToHTMLStreamData(AStream: TStream);
begin
  InternalSaveToHTMLStream(AStream, TEncoding.Default);
end;

procedure TTMSFNCDataGridRenderer.AutoSizeColumn(AColumn: Integer; const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5);
var
  g: TTMSFNCGraphics;
begin
  BeginUpdate;
  g := TTMSFNCGraphics.CreateBitmapCanvas;
  try
    g.BeginScene;
    InternalAutoSizeColumn(AColumn, AMode, APadding, g);
    g.EndScene;
  finally
    g.Free;
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.AutoSizeRow(ARow: Integer; const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5);
var
  g: TTMSFNCGraphics;
begin
  BeginUpdate;
  g := TTMSFNCGraphics.CreateBitmapCanvas;
  try
    g.BeginScene;
    InternalAutoSizeRow(ARow, AMode, APadding, g);
    g.EndScene;
  finally
    g.Free;
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.InternalAutoSizeColumn(AColumn: Integer; const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5; const AGraphics: TTMSFNCGraphics = nil);
var
  i, k: integer;
  m: single;
  totalh: Single;
  rs: Integer;
  c: TTMSFNCDataGridCellCoord;
  cellr: TRectF;
  cls: TTMSFNCDataGridCellClass;
  ck: TTMSFNCDataGridCellKind;
  ci: TTMSFNCDataGridCell;
  bc, br: Integer;
  d: TTMSFNCDataGridCellItem;
  sz: TSizeF;
  sr, er: Integer;
begin
  m := 0;

  if AMode = gamVisibleCells then
  begin
    sr := StartRow;
    er := StopRow;
  end
  else
  begin
    sr := 0;
    er := RowCount - 1;
  end;

  for i := sr to er do
  begin
    c := MakeCell(AColumn, i);
    c := BaseCell(c);

    if not ((c.Column = AColumn) and (c.Row = i)) then
      Continue;

    rs := RowSpan(c);

    totalh := 0;
    if rs > 0 then
    begin
      for K := c.Row to c.Row + rs - 1 do
        totalh := totalh + RowHeights[K];
    end
    else
      totalh := RowHeights[c.Row];

    bc := c.Column;
    br := c.Row;

    cellr := RectF(0, 0, 10000, totalh - 4);

    cls := GetBaseCellClass(MakeCell(bc, br));
    DoGetCellClass(bc, br, cls);
    if Assigned(cls) then
    begin
      ck := GetCellKind(MakeCell(bc, br));
      d := CellData[bc, br];
      ci := cls.Create(cellr, bc, br, d, ck, Self);

      if Assigned(ci) then
      begin
        try
          ConfigureCell(ci);
          sz := TTMSFNCDataGridCellOpen(ci).GetRequiredSize(AGraphics);
          if sz.cx > m then
            m := sz.cx;
        finally
          ci.Free;
        end;
      end;
    end;
  end;

  ColumnWidths[AColumn] := m + APadding;
end;

procedure TTMSFNCDataGridRenderer.InternalAutoSizeRow(ARow: Integer; const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5; const AGraphics: TTMSFNCGraphics = nil);
var
  i, k: integer;
  m: single;
  totalw: Single;
  cs: Integer;
  c: TTMSFNCDataGridCellCoord;
  cellr: TRectF;
  cls: TTMSFNCDataGridCellClass;
  ck: TTMSFNCDataGridCellKind;
  ci: TTMSFNCDataGridCell;
  bc, br: Integer;
  d: TTMSFNCDataGridCellItem;
  sz: TSizeF;
  sc, ec: Integer;
begin
  m := 0;

  if AMode = gamVisibleCells then
  begin
    sc := StartColumn;
    ec := StopColumn;
  end
  else
  begin
    sc := 0;
    ec := ColumnCount - 1;
  end;

  for i := sc to ec do
  begin
    c := MakeCell(i, ARow);
    c := BaseCell(c);

    if not ((c.Column = i) and (c.Row = ARow)) then
      Continue;

    cs := ColumnSpan(c);

    totalw := 0;
    if cs > 0 then
    begin
      for K := c.Column to c.Column + cs - 1 do
        totalw := totalw + ColumnWidths[K];
    end
    else
      totalw := ColumnWidths[c.Column];

    bc := c.Column;
    br := c.Row;

    cellr := RectF(0, 0, totalw - 4, 10000);

    cls := GetBaseCellClass(MakeCell(bc, br));
    DoGetCellClass(bc, br, cls);
    if Assigned(cls) then
    begin
      ck := GetCellKind(MakeCell(bc, br));
      d := CellData[bc, br];
      ci := cls.Create(cellr, bc, br, d, ck, Self);

      if Assigned(ci) then
      begin
        try
          ConfigureCell(ci);
          sz := TTMSFNCDataGridCellOpen(ci).GetRequiredSize(AGraphics);
          if sz.cy > m then
            m := sz.cy;
        finally
          ci.Free;
        end;
      end;
    end;
  end;

  RowHeights[ARow] := m + APadding;
end;

procedure TTMSFNCDataGridRenderer.AutoSizeRows(const AMode: TTMSFNCDataGridAutoSizeMode = gamAllCells; const APadding: Integer = 5);
var
  i: Integer;
  g: TTMSFNCGraphics;
begin
  BeginUpdate;
  g := TTMSFNCGraphics.CreateBitmapCanvas;
  try
    g.BeginScene;
    for i := 0 to RowCount - 1 do
      InternalAutoSizeRow(i, AMode, APadding, g);
    g.EndScene;
  finally
    g.Free;
    EndUpdate;
  end;
end;

function TTMSFNCDataGridRenderer.XYToCell(X, Y: Double): TTMSFNCDataGridCellCoord;
var
  c: TTMSFNCDataGridCellCoord;

  function FindCell(ADisplayList: TTMSFNCDataGridDisplayList): TTMSFNCDataGridCellCoord;
  var
    cf: TTMSFNCDataGridCellCoord;
    I: Integer;
    cl: TTMSFNCDataGridCell;
  begin
    cf.Column := -1;
    cf.Row := -1;
    Result := cf;
    for I := 0 to ADisplayList.Count - 1 do
    begin
      cl := ADisplayList[I];
      if PtInRectEx(cl.Rect, PointF(X, Y)) then
      begin
        cf.Column := cl.Column;
        cf.Row := cl.Row;
        Result := cf;
        Break;
      end;
    end;
  end;
begin
  c.Column := -1;
  c.Row := -1;

  Result := c;

  c := FindCell(FFixedRootCellDisplay);
  if IsCellValid(c) and (IsCellFixed(c) or IsCellFreeze(c)) then
  begin
    Result := c;
    Exit;
  end;

  c := FindCell(FFixedRowCellDisplay);
  if IsCellValid(c) and (IsCellFixed(c) or IsCellFreeze(c)) then
  begin
    Result := c;
    Exit;
  end;

  c := FindCell(FFixedColumnCellDisplay);
  if IsCellValid(c) and (IsCellFixed(c) or IsCellFreeze(c)) then
  begin
    Result := c;
    Exit;
  end;

  c := FindCell(FNormalCellDisplay);
  if IsCellValid(c) and not (IsCellFixed(c) or IsCellFreeze(c)) then
  begin
    Result := c;
    Exit;
  end;
end;

function TTMSFNCDataGridRenderer.XYToColumn(X, Y: Double): Integer;
begin
  Result := XYToCell(X, Y).Column;
end;

function TTMSFNCDataGridRenderer.XYToRenderer(X,
  Y: Double): TTMSFNCDataGridRenderer;
var
  obj: TTMSFNCDataGridCell;
  pr, r: TTMSFNCDataGridRenderer;
begin
  obj := GetCellObjectForCell(XYToCell(X, Y));

  pr := nil;
  if Assigned(obj) and (obj is TTMSFNCDataGridRendererCell) then
  begin
    r := (obj as TTMSFNCDataGridRendererCell).Renderer;
    while Assigned(r) do
    begin
      pr := r;
      r := pr.XYToRenderer(X, Y);
    end;
  end;

  Result := pr;
end;

function TTMSFNCDataGridRenderer.XYToRow(X, Y: Double): Integer;
begin
  Result := XYToCell(X, Y).Row;
end;

function TTMSFNCDataGridRenderer.SaveToHTMLString(ARange: TTMSFNCDataGridCellCoordRange; AImageDirectory: string): string;
var
  i, j: Integer;
  s, tablestyle: string;
  slist: TStringlist;
  wraptxt, colwtxt, CellText, SpanTxt: string;
  Span: TPoint;
  cssval: string;
  cssidx: integer;
  CSSList: TStringList;
  res: string;
  Pic, bmp: TTMSFNCBitmap;
  images_counter: Integer;
  htmlhdr: string;
  summ: string;
  mi: TTMSFNCDataGridCellMergeInfo;
  v: TTMSFNCDataGridCellValue;
  l: TTMSFNCDataGridCellLayout;

  function HTMLAddImage(Pic: TTMSFNCBitmap; counter: Integer; dir: string): string;
  {$IFNDEF WEBLIB}
  var
    fname: string;
    tt: string;
  {$ENDIF}
  begin
    {$IFNDEF WEBLIB}
    if not DirectoryExists(dir + Options.IO.HTML.ImageFolder) then
      if not CreateDir(dir + Options.IO.HTML.ImageFolder) then
        raise Exception.Create(Format(sTMSFNCDataGridCreateDirectoryError, [dir]));

    tt := TTMSFNCUtils.GetImageType(Pic);
    if tt = '' then
      tt := '.svg';

    fname := dir + Options.IO.HTML.ImageFolder + '/' + Options.IO.HTML.ImageBaseName + inttostr(counter) + tt;
    Pic.SaveToFile(fname);
    Result := fname;
    {$ELSE}
    Result := '';
    {$ENDIF}
  end;

  function MakeHREF(s: string): string;
  begin
    Result := s;

//    if not URLshow then
//      Exit;

    if (Pos('://', s) > 0) and (Pos('</', s) = 0) then
    begin
//      if not URLFull then
//        Result := '<a href=' + s + '>' + copy(s, Pos('://', s) + 3, 255) + '</a>'
//      else
        Result := '<a href=' + s + '>' + s + '</a>';
    end;

    if (Pos('mailto:', s) > 0) and (Pos('</', s) = 0) then
    begin
//      if not URLFull then
//        Result := '<a href=' + s + '>' + copy(s, Pos('mailto:', s) + 7, 255) + '</a>'
//      else
        Result := '<a href=' + s + '>' + s + '</a>';
    end;
  end;

  procedure AppendStr(var s: string; newstr: string);
  begin
    if s = '' then
      s := newstr
    else
      s := s + ';' + newstr;
  end;

  function CSS(ALayout: TTMSFNCDataGridCellLayout): string;
  var
    res: string;
  begin
    res := '';

    if (ALayout.Fill.Color <> gcNull) and (ALayout.Fill.Kind <> gfkNone) and Options.IO.HTML.ExportColors then
      AppendStr(res,'background-color: '+ TTMSFNCGraphics.ColorToHTML(ALayout.Fill.Color)+'');

    if (ALayout.Font.Color <> gcNull) and Options.IO.HTML.ExportColors then
      AppendStr(res,'color: '+ TTMSFNCGraphics.ColorToHTML(ALayout.Font.Color)+'');

    AppendStr(res,'font-size:'+IntTostr(Round(ALayout.Font.Size))+'pt');

    if TFontStyle.fsItalic in ALayout.Font.Style then
      AppendStr(res,'font-style: italic');

    if TFontStyle.fsBold in ALayout.Font.Style then
      AppendStr(res,'font-weight: bold');

    AppendStr(res,'font-family: '+ALayout.Font.Name+'');

    case ALayout.TextAlign of
      gtaCenter: AppendStr(res,'text-align: center');
      gtaTrailing: AppendStr(res,'text-align: right');
    end;

    case ALayout.VerticalTextAlign of
      gtaLeading: AppendStr(res,'vertical-align: top');
      gtaCenter: AppendStr(res,'vertical-align: middle');
      gtaTrailing: AppendStr(res,'vertical-align: bottom');
    end;

    Result := res;
  end;

  procedure ExportImg(ACol, ARow: integer; lst: TStringList; celltext: string; Pic: TTMSFNCBitmap);
  var
    image: string;
  begin
    if Assigned(Pic) and not IsBitmapEmpty(Pic) then
    begin
      image := '<img src= "file://' + HTMLAddImage(Pic, images_counter, AImageDirectory)+'">';
      lst.Add('<td class="c'+inttostr(cssidx)+'"'+spantxt + wraptxt + colwtxt+'>' + s + image + '</td>');
      inc(images_counter);
    end
    else
      lst.Add('<td class="c'+inttostr(cssidx)+'"'+spantxt + wraptxt + colwtxt+'>' +s+'</td>');
  end;

begin
  SList := TStringlist.Create;
  SList.Sorted := False;
  CSSList := TStringList.Create;

  ExportNotification(gesExportStart, ARange.StartCell.Row);

  try

    htmlhdr := '';

    if Options.IO.HTML.XHTML then
    begin
      htmlhdr := htmlhdr + '<?xml version="1.0" encoding="utf-8"?>'#13#10
      +'<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'#13#10
      +'"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'#13#10
      +'<HTML xmlns="http://www.w3.org/1999/xhtml" xml:lang="en" lang="en">'#13#10;
    end;

    htmlhdr := htmlhdr + Options.IO.HTML.HeaderText;

    if Options.IO.HTML.PrefixTag <> '' then
      htmlhdr := htmlhdr + Options.IO.HTML.PrefixTag;

    if Options.IO.HTML.TableStyle <> '' then
      TableStyle := ' ' + Options.IO.HTML.TableStyle + ' '
    else
      TableStyle := '';

    if Options.IO.HTML.Summary <> '' then
      summ := 'summary="' + Options.IO.HTML.Summary + '" '
    else
      summ := '';

    SList.Add('<table border="'+IntToStr(Options.IO.HTML.TableBorderSize)+'" '+
        'cellspacing="'+IntToStr(Options.IO.HTML.TableCellSpacing)+'" ' +
        'cellpadding="'+IntToStr(Options.IO.HTML.TableCellPadding)+'" ' +
        summ +
        TableStyle +
        ' width="' + IntToStr(Options.IO.HTML.TableWidth) + '%">');

    images_counter := 1;

    for i := ARange.StartCell.Row to ARange.StopCell.Row do
    begin
      ExportNotification(gesExportNextRow, i);
      SList.Add('<tr>');

      for j := ARange.StartCell.Column to ARange.StopCell.Column do
      begin
        if IsCellBase(MakeCell(j, i)) and IsCellDisplayed(MakeCell(j, i)) then
        begin
          mi := MergeInfo[j, i];
          Span := Point(mi.ColumnSpan, mi.RowSpan);

          SpanTxt := '';

          if Span.X > 0 then
            SpanTxt := ' colspan="' + IntToStr(Span.X) + '"';

          if Span.Y > 0 then
            SpanTxt := SpanTxt + ' rowspan="' + IntToStr(Span.Y) + '"';

          v := Cells[j, i];

          DoSaveCellData(j, i, v);

          CellText := ValueToString(v);

          s := CellText;

          if Options.IO.HTML.ConvertSpecialChars then
            s := TTMSFNCUtils.FixMarkup(s);

          if Options.IO.HTML.NonBreakingText then
            s := FixNonBreaking(s);

          s := HTMLLineBreaks(s);
          s := MakeHREF(s);

          l := GetCellAppearance(GetCellState(MakeCell(j, i)), MakeCell(j, i));

          cssval := CSS(l);

          cssidx := CSSList.IndexOf(cssval);
          if cssidx = -1 then
            cssidx := CSSList.Add(cssval);

  //        if (FHTMLSettings.ColWidths.Count > j - strtcol) and not DoneColW then
  //          colwtxt := ' width=' + IntToStr(FHTMLSettings.ColWidths.Items[j - strtcol ])+'px'
  //        else
            colwtxt := '';

          if SysUtils.Trim(s) = '' then
            s := '&nbsp;';

          if l.WordWrapping then
            WrapTxt := ''
          else
            WrapTxt := ' nowrap="nowrap"';

          pic := nil;
          if Options.IO.HTML.ExportImages then
          begin
            bmp := Bitmaps[j, i];
            if Assigned(bmp) and not IsBitmapEmpty(bmp) then
              pic := bmp
            else if Assigned(BitmapContainer) and (BitmapNames[j, i] <> '') then
              pic := BitmapContainer.FindBitmap(BitmapNames[j, i]);
          end;

          ExportImg(j,i,SList, celltext, pic);
        end;
      end;

      SList.Add('</tr>');
    end;

    SList.Add('</table>');

    if Options.IO.HTML.SuffixTag <> '' then
      SList.Add(Options.IO.HTML.SuffixTag);

    if Options.IO.HTML.FooterText <> '' then
      SList.Add(Options.IO.HTML.FooterText);

    if Options.IO.HTML.XHTML then
      SList.Add('</HTML>');

    res := '<style>'#13#10;

    for cssidx := 0 to CSSList.Count - 1 do
      res := res + '.c'+inttostr(cssidx)+' {'+csslist[cssidx]+'}'#13#10;

    res := res + '</style>'#13#10;

    Result := htmlhdr + res + SList.Text;
  finally
    SList.Free;
    CSSList.Free;
    ExportNotification(gesExportDone, -1);
  end;
end;

procedure TTMSFNCDataGridRenderer.InternalSaveToHTMLStream(AStream: TStream; AEncoding: TEncoding; AImageDirectory: string = '');
var
  s: string;
  sl: TTMSFNCDataGridDataFileStringList;
begin
  sl := TTMSFNCDataGridDataFileStringList.Create;
  try
    s := SaveToHTMLString(MakeCellRange(Options.IO.StartColumn, Options.IO.StartRow, ColumnCount - 1,
      TTMSFNCUtils.IfElse<Integer>(Options.IO.MaxRows > -1, Options.IO.MaxRows, RowCount - 1)), AImageDirectory);

    sl.WriteLn(s);
    sl.SaveToStream(AStream, AEncoding);
  finally
    sl.Free;
  end;
end;

function TTMSFNCDataGridRenderer.IsBlocked: Boolean;
begin
  Result := FBlockScrollingUpdate;
end;

function TTMSFNCDataGridRenderer.IsCellDisplayList(
  ADisplay: TTMSFNCDataGridDisplayList): Boolean;
begin
  Result := (ADisplay is TTMSFNCDataGridNormalCellDisplayList) or
            (ADisplay is TTMSFNCDataGridFixedColumnCellDisplayList) or
            (ADisplay is TTMSFNCDataGridFixedRootCellDisplayList) or
            (ADisplay is TTMSFNCDataGridFixedRowCellDisplayList);
end;

function TTMSFNCDataGridRenderer.IsCellReadOnly(
  ACell: TTMSFNCDataGridCellCoord): Boolean;
begin
  Result := IsCellFixed(ACell) or ReadOnlys[ACell.Column, ACell.Row];
end;

function TTMSFNCDataGridRenderer.OnlyLastFullVisibleRow: Boolean;
begin
  Result := inherited OnlyLastFullVisibleRow;
  if Assigned(Adapter) and (ScrollMode = gsmCellScrolling) then
    Result := True;
end;

procedure TTMSFNCDataGridRenderer.OptionsChanged(Sender: TObject);
begin
  Display;
end;

procedure TTMSFNCDataGridRenderer.OptionsChangedRebuild(Sender: TObject);
begin
  Update;
end;

procedure TTMSFNCDataGridRenderer.RemoveLayout(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
  o: TObject;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
    begin
      o := TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).Layout;
      if Assigned(o) then
        TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).DestroyLayout;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveFilterEditor(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
  o: TObject;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
    begin
      o := TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).FilterEditor;
      if Assigned(o) then
        TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).DestroyFilterEditor;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveGrid(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
  o: TObject;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) then
    begin
      o := TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).Renderer;
      if Assigned(o) then
        TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).DestroyRenderer;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveCheckBox(
  ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveCheckBox(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RemoveDataCheckBox(
  ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveDataCheckBox(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RemoveDataCheckBox(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitDataCheckBox) then
      AsExtendedCell(cd).&Type := gcitNormal;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveDataProgressBar(
  ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveDataProgressBar(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RemoveDataProgressBar(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitDataProgressBar) then
      AsExtendedCell(cd).&Type := gcitNormal;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveCellControlFromCache(AColumn,
  ARow: Integer);
var
  cl: TTMSFNCDataGridCell;
begin
  inherited;
  cl := GetCellObjectForCell(MakeCell(AColumn, ARow));
  if Assigned(cl) then
    cl.ClearControlCache;
end;

procedure TTMSFNCDataGridRenderer.RemoveCheckBox(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitCheckBox) then
      AsExtendedCell(cd).&Type := gcitNormal;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveDataRadioButton(
  ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveDataRadioButton(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RemoveDataRadioButton(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitDataRadioButton) then
      AsExtendedCell(cd).&Type := gcitNormal;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveRadioButton(
  ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveRadioButton(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RemoveRadioButton(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitRadioButton) then
      AsExtendedCell(cd).&Type := gcitNormal;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveProgressBar(
  ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveProgressBar(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RemoveProgressBar(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitProgressBar) then
      AsExtendedCell(cd).&Type := gcitNormal;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveBitmap(ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveBitmap(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCDataGridColumn);
end;

procedure TTMSFNCDataGridRenderer.RemoveBitmap(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitBitmap) then
      AsExtendedCell(cd).&Type := gcitNormal;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveButton(
  ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveButton(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RemoveButton(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItem;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellData[AColumn, ARow];
    if Assigned(cd) and IsExtendedCell(cd) and (AsExtendedCell(cd).&Type = gcitButton) then
      AsExtendedCell(cd).&Type := gcitNormal;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RemoveFilterEditor(ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveFilterEditor(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RemoveLayout(ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveLayout(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.RemoveGrid(ACell: TTMSFNCDataGridCellCoord);
begin
  RemoveGrid(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.ResetScrollBarCapture;
begin
  if Assigned(FCapturedScrollbar) then
    FCapturedScrollbar.HandleMouseLeave;

  FCapturedScrollbar := nil;
end;

procedure TTMSFNCDataGridRenderer.ResetToDefaultStyle;
var
  cs, vs: TTMSFNCDataGridScrollBar;
begin
  FStyleApplied := False;

  BeginUpdate;
  try
    CellAppearance.BandLayout.Fill.Kind := gfkSolid;
    CellAppearance.BandLayout.Fill.Color := gcLightyellow;
    CellAppearance.FixedLayout.Fill.Kind := gfkSolid;
    CellAppearance.FixedLayout.Fill.Color := Lighter(MakeGraphicsColor(238, 238, 238), 10);
    CellAppearance.NormalLayout.Fill.Kind := gfkSolid;
    CellAppearance.NormalLayout.Fill.Color := gcWhite;
    CellAppearance.GroupLayout.Fill.Kind := gfkSolid;
    CellAppearance.GroupLayout.Fill.Color := Lighter(MakeGraphicsColor(238, 238, 238), 10);
    CellAppearance.SummaryLayout.Fill.Kind := gfkSolid;
    CellAppearance.SummaryLayout.Fill.Color := Lighter(MakeGraphicsColor(245, 245, 230), 10);
    CellAppearance.SelectedLayout.Fill.Kind := gfkSolid;
    CellAppearance.SelectedLayout.Fill.Color := Lighter(gcLightsteelblue, 80);
    CellAppearance.FocusedLayout.Fill.Kind := gfkSolid;
    CellAppearance.FocusedLayout.Fill.Color := Lighter(gcLightsteelblue, 40);
    CellAppearance.FixedSelectedLayout.Fill.Kind := gfkSolid;
    CellAppearance.FixedSelectedLayout.Fill.Color := Lighter(gcLightsteelblue, 80);

    CellAppearance.BandLayout.Font.Color := gcBlack;
    CellAppearance.FixedLayout.Font.Color := gcBlack;
    CellAppearance.NormalLayout.Font.Color := gcBlack;
    CellAppearance.GroupLayout.Font.Color := gcBlack;
    CellAppearance.SummaryLayout.Font.Color := gcBlack;
    CellAppearance.SelectedLayout.Font.Color := gcBlack;
    CellAppearance.FocusedLayout.Font.Color := gcBlack;
    CellAppearance.FixedSelectedLayout.Font.Color := gcBlack;

    FilterAppearance.Fill.Color := gcWhite;
    FilterAppearance.Fill.Kind := gfkSolid;
    FilterAppearance.Stroke.Color := gcSilver;
    FilterAppearance.Stroke.Kind := gskSolid;
    FilterAppearance.Font.Color := gcBlack;

    cs := CustomHorizontalScrollBar;
    if Assigned(cs) then
      cs.ApplyStyle;

    vs := CustomVerticalScrollBar;
    if Assigned(vs) then
      vs.ApplyStyle;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.RestoreScrollPosition;
begin
  Scroll(FSaveHScrollPos, FSaveVScrollPos);
end;

function TTMSFNCDataGridRenderer.RowStretchingActive: Boolean;
begin
  Result := FRowStretchingActive;
end;

procedure TTMSFNCDataGridRenderer.SaveScrollPosition;
begin
  FSaveHScrollPos := GetHScrollValue;
  FSaveVScrollPos := GetVScrollValue;
end;

procedure TTMSFNCDataGridRenderer.CutToClipboard(ASelectedCells: Boolean);
begin
  CopyToClipboard(ASelectedCells);
  if ASelectedCells then
    ClearCells(Selection)
  else
    Clear;
end;

procedure TTMSFNCDataGridRenderer.PaddingChanged(Sender: TObject);
begin
  Update;
end;

procedure TTMSFNCDataGridRenderer.PasteFromClipboard;
var
  cliptext: string;
  endofRow: Integer;
  cr: Integer;
  ct,line, clipt, ec:string;
  s,ns,z,tabpos: Integer;
  Allow: Boolean;
  nc: Boolean;
  v: TTMSFNCDataGridCellValue;
begin
  BeginUpdate;
  try
    cliptext := TTMSFNCClipBoard.GetText;

    s := Selection.StartCell.Column;
    z := Selection.StartCell.Row;

    if (s = -1) or (z = -1) then
      Exit;

    endofRow := Length(cliptext) + 1;

    repeat
      {$IFDEF WEBLIB}
      cr := Pos(#13, cliptext);
      {$ELSE}
      {$IFDEF MSWINDOWS}
      cr := Pos(#13, cliptext);
      {$ELSE}
      cr := Pos(#10, cliptext);
      {$ENDIF}
      {$ENDIF}

      if cr = 0 then
        cr := EndOfRow;
      Line := Copy(cliptext,1, cr - 1);

      if (Length(Line) > 0) and (Options.Clipboard.PasteAction = gpaInsert) then
        InsertRows(z, 1);

      TabPos := -1;
      while (TTMSFNCUtils.VarPos(#9,Line,TabPos) > 0) do
      begin
        ns := s;
        Inc(ns);

        if (ns > ColumnCount) and Options.Clipboard.AllowColumnGrow then
         ColumnCount := ns;

        ct := Copy(line,1,TabPos - 1);

        if (Pos(#10,ct) > 0) then
        begin
          if (1 > 0) then
          begin
            if Pos('"',ct)=1 then Delete(ct,1,1);
            if Pos('"',ct) = Length(ct) then
              Delete(ct,Length(ct),1);

            CSVToLineFeeds(ct);
          end;
        end;

        if (s <= ColumnCount) and (z <= RowCount) then
        begin
          if Options.Clipboard.IgnoreReadOnly or not IsCellReadOnly(MakeCell(s, z)) then
          begin
            Allow := True;

            if Allow then
            begin
              v := {$IFNDEF WEBLIB}TValueToCellValue{$ENDIF}(ct);
              DoLoadCellData(s, z, v);
              Cells[s,z] := v;
            end;
          end;
        end;

        Delete(line,1,tabpos);
        inc(s);
        if (s > ColumnCount) and Options.Clipboard.AllowColumnGrow then
          ColumnCount := s;
      end;

      nc := false;

      if (s <= ColumnCount) and (z <= RowCount) then
      begin
        if Options.Clipboard.IgnoreReadOnly or not IsCellReadOnly(MakeCell(s, z)) then
        begin
          if (cr <> EndOfRow) or (Line <> '') then
          begin
            nc := true;

            ns := s;

            if nc then
             Inc(ns);

            if (ns > ColumnCount) and Options.Clipboard.AllowColumnGrow then
             ColumnCount := ns;

            if (Pos(#10,Line) > 0) then
            begin
              if Pos('"',Line)=1 then Delete(Line,1,1);
              if Pos('"',Line) = Length(Line) then
                Delete(Line,Length(Line),1);
              CSVToLineFeeds(Line);
            end;

            Allow := True;
            if Allow and (s <= ColumnCount) and (z <= RowCount) then
            begin
              v := {$IFNDEF WEBLIB}TValueToCellValue{$ENDIF}(Line);
              DoLoadCellData(s, z, v);
              Cells[s,z] := v;
            end;
          end;
        end;
      end;

      if nc then
        Inc(s);

      if (s > ColumnCount) and Options.Clipboard.AllowColumnGrow then
        ColumnCount := s;

      clipt := Copy(cliptext, cr + 1, Length(cliptext) - cr);

      if Copy(clipt, Length(clipt), 1) = #10 then
        clipt := Copy(cliptext, cr + 2, Length(cliptext) - cr - 1);

      cliptext := clipt;

      s := Selection.StartCell.Column;

      ec := copy(cliptext, Length(cliptext), 1);

      if (ec <> #0) then
        Inc(z);

      if (z = RowCount) and (cr <> EndOfRow) and (ec <> '') and Options.Clipboard.AllowRowGrow then
        RowCount := RowCount + 1;

    until cr = EndOfRow;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.CopyColumnDataTo(AColumn,
  ADestinationColumn: Integer; ADestination: TTMSFNCDataGridData);
var
  cl, cld: TTMSFNCDataGridColumn;
begin
  inherited;
  if ADestination is TTMSFNCDataGridRenderer then
  begin
    cl := GetColumn(AColumn);
    if Assigned(cl) then
    begin
      cld := (ADestination as TTMSFNCDataGridRenderer).GetColumn(ADestinationColumn);
      if Assigned(cld) then
        cld.Assign(cl);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.CopyToClipboard(ASelectedCells: Boolean);
var
  s,z: Integer;
  ct, cliptext: string;
  ACellRange: TTMSFNCDataGridCellCoordRange;
  v: TTMSFNCDataGridCellValue;
begin
  if ASelectedCells then
    ACellRange := Selection
  else
    ACellRange := MakeCellRange(0, 0, ColumnCount - 1, RowCount - 1);

  if (ACellRange.StartCell.Row = -1) or (ACellRange.StartCell.Column = -1) or (ACellRange.StopCell.Row = -1) or (ACellRange.StopCell.Column = -1) then
    Exit;

  cliptext := '';

  for z := ACellRange.StartCell.Row to ACellRange.StopCell.Row do
  begin
    for s := ACellRange.StartCell.Column to ACellRange.StopCell.Column do
    begin
      v := Cells[s, z];

      DoSaveCellData(s, z, v);

      ct := ValueToString(v);

      if (Pos(#13,ct) > 0) then
      begin
        ct := '"' + CRToLF(ct) + '"';
      end;

      if (Pos('</',ct) > 0) then
        ct := TTMSFNCUtils.HTMLStrip(ct);

      if (LinesInText(ct,true)>1) then
        LineFeedsToCSV(ct);

      if s < ACellRange.StopCell.Column then
        cliptext := cliptext + ct + #9
      else
        cliptext := cliptext + ct;
    end;

    if ACellRange.StartCell.Row < ACellRange.StopCell.Row then
      cliptext := cliptext + #13#10;
  end;

  TTMSFNCClipBoard.SetText(cliptext);
end;

procedure TTMSFNCDataGridRenderer.LastPage;
begin
  GoToPage(PageCount - 1);
end;

function TTMSFNCDataGridRenderer.LocalRect: TRectF;
begin
  Result := inherited LocalRect;
  Result := RectF(Padding.Left + Result.Left, Padding.Top + Result.Top, Result.Right - Padding.Right, Result.Bottom - Padding.Bottom);
end;

function TTMSFNCDataGridRenderer.Lookup(AValue: string; AAllRows,
  AAutoGoto: Boolean): TTMSFNCDataGridCellCoord;
var
  I: Integer;
begin
  Result := MakeCell(-1, -1);
  for I := FocusedCell.Column to ColumnCount - 1 do
  begin
    Result := LookupInColumn(I, AValue, AAllRows, AAutoGoto);
    if (Result.Column <> -1) and (Result.Row <> -1) then
      Break;
  end;
end;

function TTMSFNCDataGridRenderer.LookupInColumn(AColumn: Integer; AValue: string;
  AAllRows: Boolean = False; AAutoGoto: Boolean = False): TTMSFNCDataGridCellCoord;
var
  sr: Integer;
begin
  if AAllRows then
    sr := 0
  else
    sr := FixedRowCount;

  Result := LookupInColumnFromRow(AColumn, sr, AValue, AAllRows, AAutoGoto);
end;

function TTMSFNCDataGridRenderer.LookupInColumnFromRow(AColumn, ARow: Integer; AValue: string;
  AAllRows: Boolean = False; AAutoGoto: Boolean = False): TTMSFNCDataGridCellCoord;
var
  sr, er, m, r: Integer;
  s, v: string;
begin
  Result := MakeCell(-1, -1);

  v := AValue;
  if not Options.Lookup.CaseSensitive then
    v := Uppercase(v);

  if AAllRows then
  begin
    sr := FixedRowCount;
    er := RowCount - 1;
  end
  else
  begin
    sr := ARow;
    er := RowCount - 1 - FixedBottomRowCount;
  end;

  r := -1;

  for m := sr to er do
  begin
    s := Strings[AColumn, m];
    if (Pos('</', s) > 0) then
      s := TTMSFNCUtils.HTMLStrip(s);

    if not Options.Lookup.CaseSensitive then
      s := UpperCase(s);

    if Pos(v, s) = 1  then
    begin
      r := m;
      Break;
    end;
  end;

  if r <> -1 then
  begin
    Result := MakeCell(AColumn, r);
    if AAutoGoto then
      FocusedCell := Result;
  end;
end;

procedure TTMSFNCDataGridRenderer.MarkCells(AHilightText: string;
  AOptions: TTMSFNCDataGridMarkOptions);
begin
  case AOptions.Mode of
    ghmCell: InternalMarkCells(AHilightText, 'e', AOptions.CaseSensitive, AOptions.Column, AOptions.Row, AOptions.Column, AOptions.Row, AOptions.FullText);
    ghmColumn:
    begin
      if AOptions.IncludeFixed then
        InternalMarkCells(AHilightText, 'e', AOptions.CaseSensitive, AOptions.Column, 0, AOptions.Column, RowCount - 1, AOptions.FullText)
      else
        InternalMarkCells(AHilightText, 'e', AOptions.CaseSensitive, AOptions.Column, FixedRowCount, AOptions.Column, RowCount - 1 - FixedBottomRowCount, AOptions.FullText);
    end;
    ghmRow:
    begin
      if AOptions.IncludeFixed then
        InternalMarkCells(AHilightText, 'e', AOptions.CaseSensitive, 0, AOptions.Row, ColumnCount - 1, AOptions.Row, AOptions.FullText)
      else
        InternalMarkCells(AHilightText, 'e', AOptions.CaseSensitive, FixedColumnCount, AOptions.Row, ColumnCount - 1 - FixedRightColumnCount, AOptions.Row, AOptions.FullText);
    end;
    ghmGrid:
    begin
      if AOptions.IncludeFixed then
        InternalMarkCells(AHilightText, 'e', AOptions.CaseSensitive, 0, 0, ColumnCount - 1, RowCount - 1, AOptions.FullText)
      else
        InternalMarkCells(AHilightText, 'e', AOptions.CaseSensitive, FixedColumnCount, FixedRowCount, ColumnCount - 1 - FixedRightColumnCount, RowCount - 1 - FixedBottomRowCount, AOptions.FullText);
    end;
  end;
end;

function TTMSFNCDataGridRenderer.MarkText(ACaseSensitive: Boolean; AValue,
  AText: string): string;
begin
  Result := Hilight(AValue, AText, 'e', ACaseSensitive, False);
end;

procedure TTMSFNCDataGridRenderer.MoveColumnData(AFromColumn,
  AToColumn: Integer);
var
  pb: TPair<Integer, Boolean>;
  pk: TPair<TTMSFNCDataGridCellCoord, Boolean>;
  R: Integer;
begin
  inherited;
  if SelectedColumnDictionary.ContainsKey(AFromColumn) then
  begin
    pb := SelectedColumnDictionary.ExtractPair(AFromColumn);
    SelectedColumns[AToColumn] := pb.Value;
    SelectedColumnDictionary.Remove(AFromColumn);

    if SelectedCellDictionary.Count > 0 then
    begin
      for R := 0 to RowCount - 1 do
      begin
        pk := SelectedCellDictionary.ExtractPair(MakeCell(AFromColumn, R));
        SelectedCells[AToColumn, R] := pk.Value;
        SelectedCellDictionary.Remove(MakeCell(AFromColumn, R));
      end;
    end;
  end;

  SynchronizeColumns;
  if (AFromColumn >= 0) and (AFromColumn <= Columns.Count - 1) and
    (AToColumn >= 0) and (AToColumn <= Columns.Count - 1) then
      Columns[AFromColumn].Index := AToColumn;
end;

procedure TTMSFNCDataGridRenderer.MoveRowData(AFromRow, AToRow: Integer);
var
  pb: TPair<Integer, Boolean>;
  pk: TPair<TTMSFNCDataGridCellCoord, Boolean>;
  C: Integer;
begin
  inherited;
  if SelectedRowDictionary.ContainsKey(AFromRow) then
  begin
    pb := SelectedRowDictionary.ExtractPair(AFromRow);
    SelectedRows[AToRow] := pb.Value;
    SelectedRowDictionary.Remove(AFromRow);

    if SelectedCellDictionary.Count > 0 then
    begin
      for C := 0 to ColumnCount - 1 do
      begin
        pk := SelectedCellDictionary.ExtractPair(MakeCell(C, AFromRow));
        SelectedCells[C, AToRow] := pk.Value;
        SelectedCellDictionary.Remove(MakeCell(C, AFromRow));
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.HandleKey(var AKeyInfo: TTMSFNCDataGridKeyInfo);
var
  psel, sel, real: TTMSFNCDataGridCellCoord;
  cs, rs{, i, j}: Integer;
  Allow: Boolean;
  obj: TTMSFNCDataGridCell;
  cl: Boolean;
  ce, cc: Boolean;
  s, r, c: Integer;
begin
  case AKeyInfo.Kind of
    gkkPress:
    begin
      if AKeyInfo.Key in [KEY_TAB] then
        Exit;

      if not Options.Editing.Enabled and Options.Lookup.Enabled then
      begin
        if AKeyInfo.Key in [KEY_ESCAPE,KEY_INSERT,KEY_DELETE,KEY_UP,KEY_DOWN,KEY_LEFT,KEY_RIGHT,KEY_HOME,KEY_END,KEY_PRIOR,KEY_NEXT,KEY_TAB] then
          FLookupString := ''
        else
        begin
          LookupTimer.Enabled := False;

          if AKeyInfo.KeyChar <> #0 then
          begin
            if Options.Lookup.Incremental then
              FLookupString := FLookupString + AKeyInfo.KeyChar
            else
              FLookupString := AKeyInfo.KeyChar;

            LookupTimer.Enabled := True;

            cl := True;

            DoBeforeLookup(FLookupString, cl);

            if cl then
            begin
              Lookup(FLookupString, True, True);
              DoAfterLookup(FLookupString);
            end;
          end;
        end;
      end;

      if Options.Editing.Enabled then
      begin
        Allow := True;
        DoCanEditCell(FocusedCell.Column, FocusedCell.Row, Allow);

        if Allow then
        begin
          if (AKeyInfo.Key >= 32) then
          begin
            EditCell(FocusedCell, gcsStart, True, AKeyInfo.KeyChar, AKeyInfo.Key);
            AKeyInfo.KeyChar := #0;
            Exit;
          end;
        end;
      end;
    end;
    gkkDown:
    begin
      if AKeyInfo.Key = KEY_TAB then
        Exit;

      if AKeyInfo.Key in [KEY_ESCAPE,KEY_INSERT,KEY_DELETE,KEY_UP,KEY_DOWN,KEY_LEFT,KEY_RIGHT,KEY_HOME,KEY_END,KEY_PRIOR,KEY_NEXT,KEY_TAB] then
        FLookupString := '';

      Allow := True;
      DoCanEditCell(FocusedCell.Column, FocusedCell.Row, Allow);

      if Allow then
      begin
        if (AKeyInfo.Key = KEY_F2) or (AKeyInfo.Key = KEY_RETURN) then
        begin
          EditCell(FocusedCell);
          Exit;
        end;
      end;

      if (AKeyInfo.Key = KEY_SPACE) then
      begin
        obj := GetCellObjectForCell(FocusedCell);
        if Assigned(obj) then
          obj.HandleKey(AKeyInfo);

        Exit;
      end;

      if (ssShift in AKeyInfo.Shift) and not (ssCtrl in AKeyInfo.Shift) {$IFDEF FMXLIB}and not (ssCommand in AKeyInfo.Shift){$ENDIF} and (not (ssAlt in AKeyInfo.Shift)) and
          (AKeyInfo.Key = KEY_INSERT) and not FEditing and Options.Clipboard.Enabled then
            PasteFromClipboard;

      if ((ssCtrl in AKeyInfo.Shift) {$IFDEF FMXLIB}or (ssCommand in AKeyInfo.Shift){$ENDIF}) and not (ssShift in AKeyInfo.Shift) and not (ssAlt in AKeyInfo.Shift) then
      begin
        case AKeyInfo.Key of
          Ord('M'):
          begin
            if Options.Keyboard.CellMergeShortcut then
            begin
              MergeRange(Selection);
              AKeyInfo.Key := 0;
            end;
          end;
          Ord('S'):
          begin
            if Options.Keyboard.CellMergeShortcut then
            begin
              SplitCell(Selection.StartCell);
              AKeyInfo.Key := 0;
            end;
          end;
          Ord('X'):
          begin
            if Options.Clipboard.Enabled and not FEditing then
            begin
              Allow := True;
              DoBeforeCutToClipboard(Allow);
              if Allow then
              begin
                CutToClipboard(True);
                DoAfterCutToClipboard;
              end;
            end;
          end;
          Ord('C'):
          begin
            if Options.Clipboard.Enabled and not FEditing then
            begin
              Allow := True;
              DoBeforeCopyToClipboard(Allow);
              if Allow then
              begin
                CopyToClipboard(True);
                DoAfterCopyToClipboard;
              end;
            end;
          end;
          Ord('V'):
          begin
            if Options.Clipboard.Enabled and not FEditing then
            begin
              Allow := True;
              DoBeforePasteFromClipboard(Allow);
              if Allow then
              begin
                PasteFromClipboard;
                DoAfterPasteFromClipboard;
              end;
            end;
          end;
          Ord('A'): SelectAllCells;
          Ord('F'):
          begin
            if Options.Keyboard.FindShortcut and not FEditing then
            begin
              AKeyInfo.Key := 0;
              ShowFindDialog;
            end;
          end;
          Ord('H'):
          begin
            if Options.Keyboard.ReplaceShortcut and not FEditing then
            begin
              AKeyInfo.Key := 0;
              ShowReplaceDialog;
            end;
          end;
          KEY_DELETE:
          begin
            if Options.Clipboard.Enabled then
              CutToClipboard;
          end;
          KEY_INSERT:
          begin
            if Options.Clipboard.Enabled then
              CopyToClipboard
          end;
          KEY_NEXT: TopRow := TopRow + GetPageScrollSize;
          KEY_PRIOR: TopRow := TopRow - GetPageScrollSize;
          KEY_UP:
          begin
            TopRow := TopRow - 1;
          end;
          KEY_DOWN:
          begin
            rs := RowSpan(MakeCell(LeftColumn, TopRow));
            if rs > 0 then
              TopRow := TopRow + rs
            else
              TopRow := TopRow + 1;
          end;
          KEY_LEFT:
          begin
            sel := FocusedCell;
            if IsRowNode(sel.Row) and (sel.Column = Options.Column.NodeIndex) then
            begin
              cc := True;
              DoCellBeforeNodeCollapse(sel, cc);
              if cc then
              begin
                CollapseNode(sel.Row);
                DoCellAfterNodeCollapse(sel);
              end;
            end
            else
              LeftColumn := LeftColumn - 1;
          end;
          KEY_RIGHT:
          begin
            sel := FocusedCell;
            if IsRowNode(sel.Row) and (sel.Column = Options.Column.NodeIndex) then
            begin
              ce := True;
              DoCellBeforeNodeExpand(sel, ce);
              if ce then
              begin
                ExpandNode(sel.Row);
                DoCellAfterNodeExpand(sel);
              end;
            end
            else
            begin
              cs := ColumnSpan(MakeCell(LeftColumn, TopRow));
              if cs > 0 then
                LeftColumn := LeftColumn + cs
              else
                LeftColumn := LeftColumn + 1;
            end;
          end;
          KEY_HOME:
          begin
            case Options.Keyboard.HomeKeyHandling of
              ghkhFirstColumn: LeftColumn := FixedColumnCount;
              ghkhFirstRow: TopRow := FixedRowCount;
            end;
          end;
          KEY_END:
          begin
            case Options.Keyboard.EndKeyHandling of
              genkhLastColumn: LeftColumn := ColumnCount - 1 - FixedRightColumnCount;
              genkhLastRow: TopRow := RowCount - 1 - FixedBottomRowCount;
            end;
          end;
        end;
      end
      else
      begin
        sel := FocusedCell;
        real := FRealCell;

        case AKeyInfo.Key of
          KEY_DELETE:
          begin
            if AKeyInfo.Shift = [] then
            begin
              if Options.Keyboard.DeleteKeyHandling = gdkhDeleteRow then
              begin
                if RowCount > FixedRowCount + FixedBottomRowCount then
                begin
                  Allow := true;
                  DoCanDeleteRow(sel.Row, Allow);
                  if Allow then
                  begin
                    DeleteRow(sel.Row);
                    s := sel.Row;
                    sel.Row := Max(FixedRowCount, Min(sel.Row, RowCount - 1 - FixedBottomRowCount));
                    DoDeleteRow(s);
                  end;
                end;
              end;
            end;
          end;
          KEY_INSERT:
          begin
            if AKeyInfo.Shift = [] then
            begin
              if sel.Row = -1 then
                sel.Row := FixedRowCount - 1;

              case Options.Keyboard.InsertKeyHandling of
                gikhInsertRowBefore:
                begin
                  Allow := true;
                  DoCanInsertRow(sel.Row,Allow);
                  if Allow then
                  begin
                    InsertRow(sel.Row);
                    s := sel.Row;
                    sel.Row := Max(FixedRowCount, Min(sel.Row, RowCount - 1 - FixedBottomRowCount));
                    DoInsertRow(s);
                  end;
                end;
                gikhInsertRowAfter:
                begin
                  Allow := true;
                  DoCanInsertRow(sel.Row,Allow);
                  if Allow then
                  begin
                    s := sel.Row + 1;
                    InsertRow(s);
                    sel.Row := Max(FixedRowCount, Min(sel.Row + 1, RowCount - 1 - FixedBottomRowCount));
                    DoInsertRow(s);
                  end;
                end;
              end;
            end;
          end;
          KEY_F3:
          begin
            if Options.Keyboard.FindShortcut then
            begin
              FindNext(not (ssShift in AKeyInfo.Shift));
              AKeyInfo.Key := 0;
            end;
          end;
          KEY_NEXT:
          begin
            psel := sel;
            sel := NextSelectableRow(sel.Column, Min(RowCount - FixedBottomRowCount - 1, sel.Row + GetPageScrollSize - 1));
            if IsCellDisabled(sel) then
              sel := psel;

            sel.Column := real.Column;
          end;
          KEY_PRIOR:
          begin
            psel := sel;
            sel := PreviousSelectableRow(sel.Column, Max(FixedRowCount, sel.Row - GetPageScrollSize + 1));
            if IsCellDisabled(sel) then
              sel := psel;

            sel.Column := real.Column;
          end;
          KEY_UP:
          begin
            sel := PreviousSelectableRow(sel.Column, sel.Row);
            sel.Column := real.Column;
          end;
          KEY_DOWN:
          begin
            r := sel.Row;
            sel := NextSelectableRow(sel.Column, sel.Row);
            if (sel.Row = r) and Options.Keyboard.AppendRowOnArrowKeyDown then
            begin
              Allow := True;
              sel.Row := sel.Row + 1;
              DoCanAppendRow(sel.Row, Allow);
              if Allow then
              begin
                InsertRow(sel.Row);
                DoAppendRow(sel.Row);
              end;
            end;

            sel.Column := real.Column;
          end;
          KEY_LEFT:
          begin
            sel := PreviousSelectableColumn(sel.Column, sel.Row);
            sel.Row := real.Row;
          end;
          KEY_RIGHT:
          begin
            c := sel.Column;
            sel := NextSelectableColumn(sel.Column, sel.Row);

            if (sel.Column = c) and Options.Keyboard.AppendColumnOnArrowKeyRight then
            begin
              Allow := True;
              sel.Column := sel.Column + 1;
              DoCanAppendColumn(sel.Column, Allow);
              if Allow then
              begin
                InsertColumn(sel.Column);
                DoAppendColumn(sel.Column);
              end;
            end;

            sel.Row := real.Row;
          end;
          KEY_HOME:
          begin
            if Options.Keyboard.HomeKeyHandling = ghkhFirstRow then
            begin
              sel.Row := FixedRowCount;
              sel.Column := real.Column;
              sel := NextSelectableRow(sel.Column, sel.Row - 1);
            end
            else if Options.Keyboard.HomeKeyHandling = ghkhFirstColumn then
            begin
              sel.Column := FixedColumnCount;
              sel.Row := real.Row;
              sel := NextSelectableColumn(sel.Column - 1, sel.Row);
            end;
          end;
          KEY_END:
          begin
            if Options.Keyboard.EndKeyHandling = genkhLastRow then
            begin
              sel.Row := RowCount - 1 - FixedBottomRowCount;
              sel.Column := real.Column;
              sel := PreviousSelectableRow(sel.Column, sel.Row + 1);
            end
            else if Options.Keyboard.EndKeyHandling = genkhLastColumn then
            begin
              sel.Column := ColumnCount - 1 - FixedRightColumnCount;
              sel.Row := real.Row;
              sel := PreviousSelectableColumn(sel.Column + 1, sel.Row);
            end;
          end;
        end;

        case AKeyInfo.Key of
          KEY_UP, KEY_LEFT, KEY_DOWN, KEY_RIGHT, KEY_HOME, KEY_END, KEY_NEXT, KEY_PRIOR, KEY_DELETE, KEY_INSERT:
          begin
            if (ssCtrl in AKeyInfo.Shift) {$IFDEF FMXLIB}or (ssCommand in AKeyInfo.Shift){$ENDIF} then
              Navigate(sel)
            else
              SelectCell(sel, AKeyInfo.Shift);

            AKeyInfo.Key := 0;
          end;
        end;
      end;
    end;
    gkkUp:
    begin
      if (AKeyInfo.Key = KEY_SPACE) then
      begin
        obj := GetCellObjectForCell(FocusedCell);
        if Assigned(obj) then
          obj.HandleKey(AKeyInfo);
      end;
    end;
    gkkDialog:
    begin
      FTabKey := gtkmNone;
      if (AKeyInfo.Key = KEY_TAB) and (Options.Keyboard.TabKeyHandling = gtkhMixed) then
      begin
        if ssShift in AKeyInfo.Shift then
          FTabKey := gtkmShift
        else
          FTabKey := gtkmNormal;
      end;

      if IsFocused or ((FInplaceEditor <> nil) and TTMSFNCDataGridInplaceEditorOpen(FInplaceEditor).IsFocused) then
      begin
        ProcessTab(AKeyInfo, Options.Keyboard.TabKeyDirection, Options.Keyboard.TabKeyHandling, Options.Keyboard.TabKeyDirectEdit);
      end;
    end;
  end;
end;

function TTMSFNCDataGridRenderer.ProcessEnterKey(
  ACell: TTMSFNCDataGridCellCoord; AKeyHandling: TTMSFNCDataGridEnterKeyHandling): TTMSFNCDataGridCellCoord;
var
  c, r: Integer;
  cl: TTMSFNCDataGridCellCoord;
  Allow: Boolean;
begin
  cl := ACell;
  case AKeyHandling of
    gekhNextColumn, gekhNextColumnInRow, gekhNextColumnAndAppend, gekhNextColumnAndRowAppend:
    begin
      c := cl.Column;

      cl := NextSelectableColumn(cl.Column, cl.Row);
      if cl.Column = c then
      begin
        case Options.Keyboard.EnterKeyHandling of
          gekhNextColumn, gekhNextColumnAndRowAppend:
          begin
            cl.Column := FixedColumnCount - 1;
            r := cl.Row;
            cl.Row := Min(RowCount - 1 - FixedBottomRowCount, cl.Row + 1);
            cl := NextSelectableColumn(cl.Column, cl.Row);

            if r = cl.Row then
            begin
              if (Options.Keyboard.EnterKeyHandling = gekhNextColumnAndRowAppend) then
              begin
                Allow := True;
                cl.Row := cl.Row + 1;
                DoCanAppendRow(cl.Row, Allow);
                if Allow then
                begin
                  InsertRow(cl.Row);
                  DoAppendRow(cl.Row);
                end;
              end
              else
              begin
                cl.Row := FixedRowCount;
                cl.Column := FixedColumnCount;
              end;
            end;
          end;
          gekhNextColumnInRow, gekhNextColumnAndAppend:
          begin
            if (Options.Keyboard.EnterKeyHandling = gekhNextColumnInRow) then
              cl.Column := FixedColumnCount - 1;

            r := cl.Row;
            c := cl.Column;
            cl := NextSelectableColumn(cl.Column, cl.Row);

            if (c = cl.Column) and (Options.Keyboard.EnterKeyHandling = gekhNextColumnAndAppend) then
            begin
              Allow := True;
              cl.Column := cl.Column + 1;
              DoCanAppendColumn(cl.Column, Allow);
              if Allow then
              begin
                InsertColumn(cl.Column);
                DoAppendColumn(cl.Column);
              end;
            end
            else if r = cl.Row then
              cl.Column := FixedColumnCount;
          end;
        end;

        if IsCellDisabled(cl) then
          cl := NextSelectableColumn(cl.Column, cl.Row);
      end;
    end;
    gekhNextRow, gekhNextRowInColumn, gekhNextRowAndAppend, gekhNextRowAndColumnAppend:
    begin
      r := cl.Row;

      cl := NextSelectableRow(cl.Column, cl.Row);
      if cl.Row = r then
      begin
        case Options.Keyboard.EnterKeyHandling of
          gekhNextRow, gekhNextRowAndColumnAppend:
          begin
            cl.Row := FixedRowCount - 1;
            c := cl.Column;
            cl.Column := Min(ColumnCount - 1 - FixedRightColumnCount, cl.Column + 1);
            cl := NextSelectableRow(cl.Column, cl.Row);

            if c = cl.Column then
            begin
              if (Options.Keyboard.EnterKeyHandling = gekhNextRowAndColumnAppend) then
              begin
                Allow := True;
                cl.Column := cl.Column + 1;
                DoCanAppendColumn(cl.Column, Allow);
                if Allow then
                begin
                  InsertColumn(cl.Column);
                  DoAppendColumn(cl.Column);
                end;
              end
              else
              begin
                cl.Row := FixedRowCount;
                cl.Column := FixedColumnCount;
              end;
            end;
          end;
          gekhNextRowInColumn, gekhNextRowAndAppend:
          begin
            if (Options.Keyboard.EnterKeyHandling = gekhNextRowInColumn) then
              cl.Row := FixedRowCount - 1;

            c := cl.Column;
            r := cl.Row;
            cl := NextSelectableRow(cl.Column, cl.Row);

            if (r = cl.Row) and (Options.Keyboard.EnterKeyHandling = gekhNextRowAndAppend) then
            begin
              Allow := True;
              cl.Row := cl.Row + 1;
              DoCanAppendRow(cl.Row, Allow);
              if Allow then
              begin
                InsertRow(cl.Row);
                DoAppendRow(cl.Row);
              end;
            end
            else if c = cl.Column then
              cl.Row := FixedRowCount;
          end;
        end;

        if IsCellDisabled(cl) then
          cl := NextSelectableColumn(cl.Column, cl.Row);
      end;
    end;
  end;

  Result := cl;
end;

procedure TTMSFNCDataGridRenderer.ProcessTab(var AKeyInfo: TTMSFNCDataGridKeyInfo; Mode: TTMSFNCDataGridTabKeyDirection; Handling: TTMSFNCDataGridTabKeyHandling; DirectEdit: Boolean; CellStart: TTMSFNCDataGridEditCellStart = gcsNone);
var
  cl, clc, rl: TTMSFNCDataGridCellCoord;
  c, r: integer;
  a, Allow: Boolean;
  SaveFocusCell: TTMSFNCDataGridCellCoord;
begin
  if (AKeyInfo.Key = KEY_TAB) and (RowCount > FixedRowCount + FixedBottomRowCount) and (ColumnCount > FixedColumnCount + FixedRightColumnCount) then
  begin
    SaveFocusCell := FocusedCell;
    a := StopEditing;
    if not a then
    begin
      AKeyInfo.Key := 0;
      Exit;
    end;

    FocusedCell := SaveFocusCell;
    if IsFocused then
    begin
      case Handling of
        gtkhNextCell: AKeyInfo.Key := 0;
        gtkhMixed:
        begin
          if ssShift in AKeyInfo.Shift then
          begin
            cl.Column := FixedColumnCount;
            cl.Row := FixedRowCount;

            if IsCellDisabled(cl) then
            begin
              case Mode of
                gtkdNextColumnCell: cl := NextSelectableColumn(cl.Column, cl.Row);
                gtkdNextRowCell: cl := NextSelectableRow(cl.Column, cl.Row);
              end;
            end;

            if (Handling = gtkhMixed) and not ((FocusedCell.Column = cl.Column) and (FocusedCell.Row = cl.Row)) then
              AKeyInfo.Key := 0;
          end
          else
          begin
            cl.Column := ColumnCount - 1 - FixedRightColumnCount;
            cl.Row := RowCount - 1 - FixedBottomRowCount;

            if IsCellDisabled(cl) then
            begin
              case Mode of
                gtkdNextColumnCell: cl := PreviousSelectableColumn(cl.Column, cl.Row);
                gtkdNextRowCell: cl := PreviousSelectableRow(cl.Column, cl.Row);
              end;
            end;

            if (Handling = gtkhMixed) and not ((FocusedCell.Column = cl.Column) and (FocusedCell.Row = cl.Row)) then
              AKeyInfo.Key := 0;
          end;
        end
      end;

      if AKeyInfo.Key = 0 then
      begin
        case Handling of
          gtkhNextCell, gtkhMixed:
          begin
            cl := FocusedCell;
            rl := FRealCell;
            cl := BaseCell(cl);

            if ssShift in AKeyInfo.Shift then
            begin
              clc := MakeCell(FixedColumnCount, FixedRowCount);
              if (FocusedCell.Column = clc.Column) and (FocusedCell.Row = clc.Row) then
              begin
                clc := MakeCell(ColumnCount - 1 - FixedRightColumnCount, RowCount - 1 - FixedBottomRowCount);
                FocusedCell := clc;
                Exit;
              end;

              case Mode of
                gtkdNextColumnCell:
                begin
                  c := cl.Column;
                  cl := PreviousSelectableColumn(cl.Column, cl.Row);
                  cl.Row := rl.Row;
                  if (c = cl.Column) then
                  begin
                    r := cl.row;
                    cl.Column := ColumnCount - 1 - FixedRightColumnCount;
                    cl := PreviousSelectableColumn(cl.Column, cl.Row);
                    if r = cl.Row then
                    begin
                      cl := PreviousSelectableColumn(ColumnCount - FixedRightColumnCount, cl.Row - 1);
                      while (cl.Column = ColumnCount - FixedRightColumnCount) and (cl.Row = r - 1) do
                      begin
                        r  := cl.Row;
                        cl := PreviousSelectableColumn(ColumnCount - FixedRightColumnCount, cl.Row - 1);
                      end;
                    end;
                    if (Handling = gtkhNextCell) and ((cl.Row < FixedRowCount) or (r = cl.row)) then
                    begin
                      cl.Column := ColumnCount - 1 - FixedRightColumnCount;
                      cl.Row := RowCount - 1 - FixedBottomRowCount;
                      cl := PreviousSelectableColumn(cl.Column, cl.Row);
                    end;
                  end;
                end;
                gtkdNextRowCell:
                begin
                  r := cl.Row;
                  cl := PreviousSelectableRow(cl.Column, cl.Row);
                  cl.Column := rl.Column;
                  if (r = cl.Row) then
                  begin
                    c := cl.Column;
                    cl.Row := RowCount - 1 - FixedBottomRowCount;
                    cl := PreviousSelectableRow(cl.Column, cl.Row);
                    if c = cl.Column then
                    begin
                      cl := PreviousSelectableRow(cl.Column - 1, RowCount - FixedBottomRowCount);
                      while (cl.Row = RowCount - FixedBottomRowCount) and (cl.Column = c - 1) do
                      begin
                        c  := cl.Column;
                        cl := PreviousSelectableRow(cl.Column - 1, RowCount - FixedBottomRowCount);
                      end;
                    end;
                    if (Handling = gtkhNextCell) and ((cl.Column < FixedColumnCount) or (c = cl.Column)) then
                    begin
                      cl.Column := ColumnCount - 1 - FixedRightColumnCount;
                      cl.Row := RowCount - 1 - FixedBottomRowCount;
                      cl := PreviousSelectableRow(cl.Column, cl.Row);
                    end;
                  end;
                end;
              end;
              SelectCell(cl);
              if DirectEdit then
              begin
                Allow := True;
                DoCanEditCell(FocusedCell.Column, FocusedCell.Row, Allow);
                if Allow then
                  EditCell(FocusedCell, CellStart);
              end;
            end
            else
            begin
              clc := MakeCell(ColumnCount - 1 - FixedRightColumnCount, RowCount - 1 - FixedBottomRowCount);
              if (FocusedCell.Column = clc.Column) and (FocusedCell.Row = clc.Row) then
              begin
                clc := MakeCell(FixedColumnCount, FixedRowCount);
                FocusedCell := clc;
                Exit;
              end;

              case Mode of
                gtkdNextColumnCell:
                begin
                  c := cl.Column;
                  cl := NextSelectableColumn(cl.Column, cl.Row);
                  cl.Row := rl.Row;
                  if (c = cl.Column) then
                  begin
                    r := cl.row;
                    cl.Column := FixedColumnCount;
                    cl := NextSelectableColumn(cl.Column, cl.Row);
                    if r = cl.Row then
                    begin
                      cl := NextSelectableColumn(FixedColumnCount - 1, cl.Row + 1);
                      while (cl.Column = FixedColumnCount - 1) and (cl.Row = r + 1) do
                      begin
                        r := cl.Row;
                        cl := NextSelectableColumn(FixedColumnCount - 1, cl.row + 1);
                      end;
                    end;

                    if (Handling = gtkhNextCell) and ((cl.Row > RowCount - 1 - FixedBottomRowCount) or (r = cl.row)) then
                    begin
                      cl.Column := FixedColumnCount;
                      cl.Row := FixedRowCount;
                      cl := NextSelectableColumn(cl.Column, cl.Row);
                    end;
                  end;
                end;
                gtkdNextRowCell:
                begin
                  r := cl.Row;
                  cl := NextSelectableRow(cl.Column, cl.Row);
                  cl.Column := rl.Column;
                  if (r = cl.Row) then
                  begin
                    c := cl.Column;
                    cl.Row := FixedRowCount;
                    cl := NextSelectableRow(cl.Column, cl.Row);
                    if c = cl.Column then
                    begin
                      cl := NextSelectableRow(cl.Column + 1, FixedRowCount - 1);
                      while (cl.Row = FixedRowCount - 1) and (cl.Column = c + 1) do
                      begin
                        c := cl.Column;
                        cl := NextSelectableRow(cl.Column + 1, FixedRowCount - 1);
                      end;
                    end;
                    if (Handling = gtkhNextCell) and ((cl.Column > ColumnCount - 1 - FixedRightColumnCount) or (c = cl.Column)) then
                    begin
                      cl.Column := FixedColumnCount;
                      cl.Row := FixedRowCount;
                      cl := NextSelectableRow(cl.Column, cl.Row);
                    end;
                  end;
                end;
              end;
              SelectCell(cl);
              if DirectEdit then
              begin
                Allow := True;
                DoCanEditCell(FocusedCell.Column, FocusedCell.Row, Allow);
                if Allow then
                  EditCell(FocusedCell, CellStart);
              end;
            end;
          end;
        end;
      end;
    end
    else
    begin
      if Handling <> gtkhNextControl then
      begin
        if ssShift in AKeyInfo.Shift then
        begin
          cl.Column := ColumnCount - 1 - FixedRightColumnCount;
          cl.Row := RowCount - 1 - FixedBottomRowCount;
          if IsCellDisabled(cl) then
          begin
            case Mode of
              gtkdNextColumnCell: cl := PreviousSelectableColumn(cl.Column, cl.Row);
              gtkdNextRowCell: cl := PreviousSelectableRow(cl.Column, cl.Row);
            end;
          end;
          SelectCell(cl);
        end
        else
        begin
          cl.Column := FixedColumnCount;
          cl.Row := FixedRowCount;
          if IsCellDisabled(cl) then
          begin
            case Mode of
              gtkdNextColumnCell: cl := NextSelectableColumn(cl.Column, cl.Row);
              gtkdNextRowCell: cl := NextSelectableRow(cl.Column, cl.Row);
            end;
          end;
          SelectCell(cl)
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.HandleMouse(
  var AMouseInfo: TTMSFNCDataGridMouseInfo);
var
  sel, psel, cl, cell, res: TTMSFNCDataGridCellCoord;
  obj: TTMSFNCDataGridCell;
  sx, sy: Single;
  cd: Boolean;
  newsz: Double;
  fxd, fixed, rowsz, colsz: Boolean;
  allow: Boolean;
  bctl: TTMSFNCDataGridMouseInfo;
  cr: TCursor;
  contentr: TRectF;
  hss, vss: Single;
  enablescroll, hld: Boolean;
  h, v, f: Single;
  tr: Integer;
  c: TTMSFNCDataGridScrollBar;
  cp: TPointF;
  sz: Double;
  csz: Boolean;
  {$IFNDEF WEBLIB}
  pt: TPointF;
  {$IFNDEF FMXLIB}
  ptx: TPoint;
  {$ENDIF}
  {$ENDIF}
  p: TTMSFNCDataGridCellParent;
  a: Boolean;

  procedure SetHoveredCell;
  begin
    if (res.Column <> FHoverCell.Column) or (res.Row <> FHoverCell.Row) then
    begin
      FHoverCell := res;
      {$IFNDEF WEBLIB}
      Application.CancelHint;
      {$ENDIF}
    end;
  end;
begin
  if (not PtInRectEx(GetContentClipRect, PointF(AMouseInfo.X, AMouseInfo.Y)) and not HasValidHost) or Assigned(FCapturedScrollbar) then
  begin
    c := nil;
    if not Assigned(FCapturedScrollbar) then
    begin
      if CustomHorizontalScrollBar.Visible and PtInRectEx(ConvertToRectF(CustomHorizontalScrollBar.BoundsRect), PointF(AMouseInfo.X, AMouseInfo.Y)) then
        c := CustomHorizontalScrollBar
      else if CustomVerticalScrollBar.Visible and PtInRectEx(ConvertToRectF(CustomVerticalScrollBar.BoundsRect), PointF(AMouseInfo.X, AMouseInfo.Y)) then
        c := CustomVerticalScrollBar;
    end
    else
      c := FCapturedScrollbar;

    if Assigned(c) then
    begin
      cp := PointF(AMouseInfo.X, AMouseInfo.Y);
      cp := PointF(cp.X - c.BoundsRect.Left, cp.Y - c.BoundsRect.Top);
      case AMouseInfo.Kind of
        gmkDown:
        begin
          c.HandleMouseDown(AMouseInfo.Button, AMouseInfo.Shift, cp.X, cp.Y);
          FCapturedScrollbar := c
        end;
        gmkMove: c.HandleMouseMove(AMouseInfo.Shift, cp.X, cp.Y);
        gmkUp:
        begin
          FCapturedScrollbar := nil;
          c.HandleMouseUp(AMouseInfo.Button, AMouseInfo.Shift, cp.X, cp.Y);
        end;
        gmkWheel: c.HandleMouseWheel(AMouseInfo.Shift, AMouseInfo.WheelDelta, hld);
        gmkEnter: c.HandleMouseEnter;
        gmkLeave: c.HandleMouseLeave;
      end;
    end;

    Exit;
  end;

  case AMouseInfo.Kind of
    gmkDown:
    begin
      if not FDblClick then
        Focus;

      if not (AMouseInfo.Button = {$IFNDEF WEBLIB}TTMSFNCMouseButton.{$ENDIF}mbLeft) then
        Exit;

      sx := AMouseInfo.X;
      sy := AMouseInfo.Y;

      cell := XYToCell(sx, sy);
      obj := GetCellObjectForCell(cell);
      if Assigned(obj) then
      begin
        cd := True;
        DoCanDragColumn(cell.Column, cd);
        if cd then
          FDragCell := cell;

        fixed := IsCellFixed(cell);

        if fixed then
        begin
          rowsz := Options.Mouse.FixedRowSizing;
          colsz := Options.Mouse.FixedColumnSizing;
        end
        else
        begin
          rowsz := Options.Mouse.RowSizing;
          colsz := Options.Mouse.ColumnSizing;
        end;

        if rowsz and (((cell.Row < RowCount - FixedBottomRowCount) and fixed) or not fixed) and (sy >= obj.Top + obj.Height - Options.Mouse.RowSizeMargin) and (sx > obj.Left + Options.Mouse.ColumnSizeMargin) and (sx < obj.Left + obj.Width - Options.Mouse.ColumnSizeMargin) then
        begin
          allow := True;
          sz := RowHeights[cell.Row];
          DoCanSizeRow(cell.Row, sz, allow);
          if allow then
          begin
            FMouseSizing := True;
            FSizeMode := gsmRowSizing;
          end;
        end
        else if rowsz and (((cell.Row > FixedRowCount) and fixed) or not fixed) and (sy <= obj.Top + Options.Mouse.RowSizeMargin) and (sx > obj.Left + Options.Mouse.ColumnSizeMargin) and (sx < obj.Left + obj.Width - Options.Mouse.ColumnSizeMargin) then
        begin
          Allow := True;
          sz := RowHeights[cell.Row - 1];
          DoCanSizeRow(cell.Row - 1, sz, allow);
          if allow then
          begin
            FMouseSizing := True;
            FSizeMode := gsmPreviousRowSizing;
          end;
        end
        else if colsz and (((cell.Column < ColumnCount - FixedRightColumnCount) and fixed) or not fixed) and (sx >= obj.Left + obj.Width - Options.Mouse.ColumnSizeMargin) and (sy > obj.Top + Options.Mouse.RowSizeMargin) and (sy < obj.Top + obj.Height - Options.Mouse.RowSizeMargin) then
        begin
          Allow := True;
          sz := ColumnWidths[cell.Column];
          DoCanSizeColumn(cell.Column, sz, allow);
          if allow then
          begin
            FMouseSizing := True;
            FSizeMode := gsmColumnSizing;
          end;
        end
        else if colsz and (((cell.Column > FixedColumnCount) and fixed) or not fixed) and (sx <= obj.Left - Options.Mouse.ColumnSizeMargin) and (sy > obj.Top + Options.Mouse.RowSizeMargin) and (sy < obj.Top + obj.Height - Options.Mouse.RowSizeMargin) then
        begin
          Allow := True;
          sz := ColumnWidths[cell.Column - 1];
          DoCanSizeColumn(cell.Column - 1, sz, allow);
          if Allow then
          begin
            FMouseSizing := True;
            FSizeMode := gsmPreviousColumnSizing;
          end;
        end
        else
        begin
          FMouseDown := True;
          FMouseUp := True;

          bctl := AMouseInfo;
          bctl.Blocked := False;
          obj.HandleMouse(bctl);
          if bctl.Blocked then
            Display;

          if not bctl.Blocked then
          begin
            if not IsCellFixed(Cell) then
            begin
              Cell := BaseCell(Cell);
              if ((Cell.Column = FocusedCell.Column) and (Cell.Row = FocusedCell.Row)) and not Options.Mouse.DirectEdit then
              begin
                FMouseUp := False;
                Allow := True;
                DoCanEditCell(FocusedCell.Column, FocusedCell.Row, Allow);
                FMouseUp := not Allow;

                if Allow then
                  EditCell(FocusedCell);
              end
              else
                bctl.Blocked := StopEditing;
            end
            else
            begin
              FDragFixed := (Options.Mouse.RowDragging and ((Cell.Column < FixedColumnCount) or (Cell.Column > ColumnCount - 1 - FixedRightColumnCount)));
              FDragFixed := FDragFixed or ((Options.Sorting.Enabled) or Options.Mouse.ColumnDragging) and ((Cell.Row < FixedRowCount) or (Cell.Row > RowCount - 1 - FixedBottomRowCount));
            end;
          end;
        end;
      end;

      FTouchScrolling := False;

      FPrevX := AMouseInfo.X;
      FPrevY := AMouseInfo.Y;

      FSizeX := FPrevX;
      FSizeY := FPrevY;

      FDownX := FPrevX;
      FDownY := FPrevY;

      FTouchX := FPrevX;
      FTouchY := FPrevY;

      FScrollX := FPrevX;
      FScrollY := FPrevY;

      FMouseX := FPrevX;
      FMouseY := FPrevY;

      if GetHVisible then
        FScrollHTo := GetHScrollValue
      else
        FScrollHTo := 0;

      if GetVVisible then
        FScrollVTo := GetVScrollValue
      else
        FScrollVTo := 0;

      FCellAnchor.Column := -1;
      FCellAnchor.Row := -1;
      FFirstCell.Column := -1;
      FFirstCell.Row := -1;
      FCellAnchorString := '';
      FDoubleSelection := not AnimateTimer.Enabled;
      FTimeStart := GetTickCountX;
      FTimeStop := FTimeStart;
      IsMouseDown := True;
      FMouseScrollingUp := False;
    end;
    gmkMove:
    begin
      if FInplaceEditorActive then
        Exit;

      if FClearMouseDown then
      begin
        FMouseDown := False;
        FIsMouseDown := False;
        FClearMouseDown := False;
      end;

      if FDblClick then
      begin
        FDblClick := False;
        FMouseDown := False;
      end;

      FCellAnchor := MakeCell(-1, -1);
      FCellAnchorString := '';

      FX := AMouseInfo.X;
      FY := AMouseInfo.Y;

      if FMouseDown and (((FX < FDownX - Options.Mouse.ClickMargin) or (FX > FDownX + Options.Mouse.ClickMargin))
        or ((FY < FDownY - Options.Mouse.ClickMargin) or (FY > FDownY + Options.Mouse.ClickMargin))) then
      begin
        if not FDragFixed then
        begin
          hss := GetHorizontalScrollPosition;
          vss := GetVerticalScrollPosition;
          contentr := GetContentRect;

          FDoTouchScroll := Options.Mouse.TouchScrolling and ((Options.Selection.Mode = gsmSingleCell) or (Options.Selection.Mode = gsmSingleRow) or (Options.Selection.Mode = gsmSingleColumn) or (Options.Selection.Mode = gsmNone));

          enablescroll := False;
          if (((-hss > 0) and (FX < GetTotalFixedColumnWidth))
           or ((-hss < TotalColumnWidth - GetTotalFixedRightColumnWidth) and (FX > contentr.Left + (contentr.Right - contentr.Left) - GetTotalFixedRightColumnWidth)))
           or (((-vss > 0) and (FY < GetTotalFixedRowHeight))
            or ((-vss < TotalRowHeight - GetTotalFixedBottomRowHeight) and (FY > contentr.Top + (contentr.Bottom - contentr.Top) - GetTotalFixedBottomRowHeight))) then
          enablescroll := Options.Mouse.AutoScrolling and not FDoTouchScroll;

          if (FX > contentr.Left + (contentr.Right - contentr.Left) - GetTotalFixedRightColumnWidth) then
            enablescroll := not (gfcsRow in Options.Mouse.FixedCellSelection) and not (gfcsRowRange in Options.Mouse.FixedCellSelection);

          if (FY > contentr.top + (contentr.Bottom - contentr.Top) - GetTotalFixedBottomRowHeight) then
            enablescroll := not (gfcsColumn in Options.Mouse.FixedCellSelection) and not (gfcsColumnRange in Options.Mouse.FixedCellSelection);

          ScrollTimer.Enabled := enablescroll;

          if not ScrollTimer.Enabled then
          begin
            if Options.Mouse.TouchScrolling and FDoTouchScroll then
            begin
              f := Options.Mouse.TouchScrollingSensitivity;
              if ScrollMode = gsmCellScrolling then
                f := f / 10;

              if (FTouchScrolling or (Abs(FMouseX - AMouseInfo.X) > 3) or (Abs(FMouseY - AMouseInfo.Y) > 3)) then
              begin
                if (Abs(AMouseInfo.X - FTouchX) > SCROLLINGDELAY) or (Abs(AMouseInfo.Y - FTouchY) > SCROLLINGDELAY) then
                begin
                  FTouchScrolling := True;
                  FDoubleSelection := False;
                  if IsMouseDown and not FMouseScrollingUp then
                  begin
                    if GetHVisible then
                      h := GetHScrollValue - (AMouseInfo.X - FTouchX) * f
                    else
                      h := 0;

                    if GetVVisible then
                      v := GetVScrollValue - (AMouseInfo.Y - FTouchY) * f
                    else
                      v := 0;

                    Scroll(h, v);
                    FTouchY := AMouseInfo.Y;
                    FTouchX := AMouseInfo.X;
                  end;
                end;
              end
            end
            else
            begin
              FMouseDragging := True;
              res := XYToCell(AMouseInfo.X, AMouseInfo.Y);
              if (res.Column <> -1) and (res.Row <> -1) then
              begin
                fxd := IsCellFixed(res);
                case Options.Selection.Mode of
                  gsmSingleRow: if (gfcsRow in Options.Mouse.FixedCellSelection) then fxd := False;
                  gsmSingleColumn: if (gfcsColumn in Options.Mouse.FixedCellSelection) then fxd := False;
                  gsmRowRange: if (gfcsRowRange in Options.Mouse.FixedCellSelection) then fxd := False;
                  gsmColumnRange: if (gfcsColumnRange in Options.Mouse.FixedCellSelection) then fxd := False;
                end;

                if not fxd then
                  SelectCell(res, AMouseInfo.Shift, FMouseDragging);
              end;
            end;
          end;
        end
        else
        begin
          if (FDragCell.Column <> -1) and (FDragCell.Row <> -1) then
          begin
            obj := GetCellObjectForCell(FDragCell);
            if Assigned(obj) and (FDraggingMode = gdmNone) then
            begin
              FDraggingType := gdtSwap;
              StartDragging(AMouseInfo, Options.Mouse.DragMode = gdmDrag)
            end
            else
            begin
              HandleDragging(AMouseInfo);

              if PtInRectEx(LocalRect, PointF(AMouseInfo.X, AMouseInfo.Y)) then
                UpdateCursor(crUpArrow)
              else
                UpdateCursor(crNoDrop);
            end;
          end;
        end;
      end
      else if not FMouseSizing then
      begin
        sx := AMouseInfo.X;
        sy := AMouseInfo.Y;

        res := XYToCell(AMouseInfo.X, AMouseInfo.Y);
        if (res.Column <> -1) and (res.Row <> -1) then
        begin
          obj := GetCellObjectForCell(res);
          if Assigned(obj) then
          begin
            fixed := IsCellFixed(res);

//            if Assigned(ToolBarPopup) and (ToolBarPopupMode <> tpmNone) then
//            begin
//              if ToolBarPopupMode = tpmActiveCell then
//              begin
//                if (res.Col = FocusedCell.Col) and (res.Row = FocusedCell.Row) and not ToolBarPopup.Activated then
//                  ShowToolBar;
//
//                if ((res.Col <> FocusedCell.Col) or (res.Row <> FocusedCell.Row)) and Assigned(ToolBarPopup) and ToolBarPopup.Activated and not ToolBarPopup.DropDownActive then
//                  ToolBarPopup.Deactivate;
//              end;
//
//              if (ToolBarPopupMode in [tpmHoverCell, tpmHoverNormalCell]) then
//              begin
//                if ((res.Col <> FToolBarPopupCell.Col) or (res.Row <> FToolBarPopupCell.Row)) and not ToolBarPopup.Activated then
//                begin
//                  if not fixed or (ToolBarPopupMode = tpmHoverCell) then
//                    ShowToolBar;
//                end;
//
//                if ((res.Col <> FToolBarPopupCell.Col) or (res.Row <> FToolBarPopupCell.Row)) and ToolBarPopup.Activated and not ToolBarPopup.DropDownActive then
//                  ToolBarPopup.Deactivate;
//              end;
//            end;

            if fixed then
            begin
              rowsz := Options.Mouse.FixedRowSizing;
              colsz := Options.Mouse.FixedColumnSizing;
            end
            else
            begin
              rowsz := Options.Mouse.RowSizing;
              colsz := Options.Mouse.ColumnSizing;
            end;

            if rowsz and (res.Row > FixedRowCount) and (sy <= obj.Top + Options.Mouse.RowSizeMargin) and (sx > obj.Left + Options.Mouse.ColumnSizeMargin) and (sx < obj.Left + obj.Width - Options.Mouse.ColumnSizeMargin) then
            begin
              allow := True;
              sz := RowHeights[res.Row - 1];
              DoCanSizeRow(res.Row - 1, sz, allow);
              if allow then
                UpdateCursor(crSizeNS)
            end
            else if rowsz and (((res.Row < RowCount - FixedRowCount) and fixed) or not fixed) and (sy >= obj.Top + obj.Height - Options.Mouse.RowSizeMargin) and (sx > obj.Left + Options.Mouse.ColumnSizeMargin) and (sx < obj.Left + obj.Width - Options.Mouse.ColumnSizeMargin) then
            begin
              allow := True;
              sz := RowHeights[res.Row];
              DoCanSizeRow(res.Row, sz, allow);
              if allow then
                UpdateCursor(crSizeNS)
            end
            else if colsz and (res.Column > FixedColumnCount) and (sx <= obj.Left - Options.Mouse.ColumnSizeMargin) and (sy > obj.Top + Options.Mouse.RowSizeMargin) and (sy < obj.Top + obj.Height - Options.Mouse.RowSizeMargin) then
            begin
              allow := True;
              sz := ColumnWidths[res.Column - 1];
              DoCanSizeColumn(res.Column - 1, sz, allow);
              if allow then
                UpdateCursor(crSizeWE)
            end
            else if colsz and (((res.Column < ColumnCount - FixedColumnCount) and fixed) or not fixed) and (sx >= obj.Left + obj.Width - Options.Mouse.ColumnSizeMargin) and (sy > obj.Top + Options.Mouse.RowSizeMargin) and (sy < obj.Top + obj.Height - Options.Mouse.RowSizeMargin) then
            begin
              allow := True;
              sz := ColumnWidths[res.Column];
              DoCanSizeColumn(res.Column, sz, allow);
              if allow then
                UpdateCursor(crSizeWE)
            end
            else
            begin
              bctl := AMouseInfo;
              bctl.Blocked := False;
              cr := FOldCursor;
              bctl.Cursor := cr;
              obj.HandleMouse(bctl);
              if bctl.Blocked then
              begin
                UpdateCursor(bctl.Cursor);
                Display;
              end;

              if not bctl.Blocked then
              begin
                if obj.IsHTML then
                  FCellAnchorString := obj.XYToAnchor(AMouseInfo.X, AMouseInfo.Y)
                else
                begin
                  FCellAnchorString := obj.Text;
                  if not IsUrl(FCellAnchorString) or (not Options.URL.AutoDetect) then
                    FCellAnchorString := '';
                end;

                if (FCellAnchorString <> '') and Options.URL.AutoDetect then
                  UpdateCursor(crHandPoint)
                else
                begin
                  SetHoveredCell;
                  UpdateCursor(FOldCursor);
                end;
              end;
            end;
          end;
        end
        else
        begin
          SetHoveredCell;
          UpdateCursor(FOldCursor);
        end;
      end
      else
      begin
        if (FDragCell.Column <> -1) and (FDragCell.Column <> -1) then
        begin
          case FSizeMode of
            gsmColumnSizing:
            begin
              newsz := ColumnWidths[FDragCell.Column] + (FX - FSizeX);
              csz := True;
              DoCanSizeColumn(FDragCell.Column, newsz, csz);
              if csz then
              begin
                ColumnWidths[FDragCell.Column] := newsz;
                DoSizeColumn(FDragCell.Column, newsz);
              end;
            end;
            gsmRowSizing:
            begin
              newsz := RowHeights[FDragCell.Row] + (FY - FSizeY);
              csz := True;
              DoCanSizeRow(FDragCell.Row, newsz, csz);
              if csz then
              begin
                RowHeights[FDragCell.Row] := newsz;
                DoSizeRow(FDragCell.Row, newsz);
              end;
            end;
            gsmPreviousColumnSizing:
            begin
              newsz := ColumnWidths[FDragCell.Column - 1] + (FX - FSizeX);
              csz := True;
              DoCanSizeColumn(FDragCell.Column - 1, newsz, csz);
              if csz then
              begin
                ColumnWidths[FDragCell.Column - 1] := newsz;
                DoSizeColumn(FDragCell.Column - 1, newsz);
              end;
            end;
            gsmPreviousRowSizing:
            begin
              newsz := RowHeights[FDragCell.Row - 1] + (FY - FSizeY);
              csz := True;
              DoCanSizeRow(FDragCell.Row - 1, newsz, csz);
              if csz then
              begin
                RowHeights[FDragCell.Row - 1] := newsz;
                DoSizeRow(FDragCell.Row - 1, newsz);
              end;
            end;
          end;

          FSizeX := FX;
          FSizeY := FY;
          Update;
          FSizing := True;
        end;
      end;
    end;
    gmkUp:
    begin
      if FInplaceEditorActive then
        Exit;

      if not (AMouseInfo.Button = {$IFNDEF WEBLIB}TTMSFNCMouseButton.{$ENDIF}mbLeft) then
      begin
        if AMouseInfo.Button = {$IFNDEF WEBLIB}TTMSFNCMouseButton.{$ENDIF}mbRight then
        begin
          res := XYToCell(AMouseInfo.X, AMouseInfo.Y);
          if (res.Column <> -1) and (res.Row <> -1) then
          begin
            DoCellRightClick(res.Column, res.Row);

            p := GetParentHost;
            if Assigned(FCellPopupMenu) and Assigned(p) and (p is TTMSFNCDataGridCellControl) then
            begin
              a := True;
              DoCellBeforeShowPopupMenu(res, FCellPopupMenu, a);
              if a then
              begin
                {$IFNDEF WEBLIB}
                FCellPopupMenu.PopupComponent := p;

                pt := PointF(AMouseInfo.X, AMouseInfo.Y);

                {$IFDEF FMXLIB}
                pt := TTMSFNCDataGridCellControlOpen(p as TTMSFNCDataGridCellControl).LocalToScreen(pt);
                {$ELSE}
                ptx := (p as TTMSFNCDataGridCellControl).ClientToScreen(Point(Round(pt.X), Round(pt.Y)));
                pt := PointF(ptx.X, ptx.Y);
                {$ENDIF}

                FCellPopupMenu.Popup(Round(pt.X), Round(pt.Y));
                {$ENDIF}
              end;
            end;
          end;
        end;
        Exit;
      end;

      if not IsMouseDown then
        Exit;

      FMouseScrollingUp := True;
      IsMouseDown := False;
      ScrollTimer.Enabled := False;
      DragTimer.Enabled := False;

      if FSizing then
      begin
        case FSizeMode of
          gsmColumnSizing: DoColumnSized(FDragCell.Column, ColumnWidths[FDragCell.Column]);
          gsmRowSizing: DoRowSized(FDragCell.Row, RowHeights[FDragCell.Row]);
          gsmPreviousColumnSizing: DoColumnSized(FDragCell.Column - 1, ColumnWidths[FDragCell.Column - 1]);
          gsmPreviousRowSizing: DoRowSized(FDragCell.Row - 1, RowHeights[FDragCell.Row - 1]);
        end;
        Update;
      end;

      if not FDoubleSelection and Options.Mouse.TouchScrolling and FDoTouchScroll then
      begin
        f := Options.Mouse.TouchScrollingSensitivity;
        if ScrollMode = gsmCellScrolling then
          f := f / 10;

        FTimeStop := GetTickCountX;
        if ((FTimeStop - FTimeStart) < SWIPECOUNT) and ((FTimeStop - FTimeStart) > 0) then
        begin
          FSpY := Abs(AMouseInfo.Y - FScrollY) / (FTimeStop - FTimeStart);
          if (FSpY > 0) then
          begin
            if GetVVisible then
            begin
              if (AMouseInfo.Y - FScrollY) > 0 then
                FScrollVTo := Max(0, Min(GetVMax - GetVViewportSize, FScrollVTo - Round(Abs(AMouseInfo.Y - FScrollY) * FSpY * f * 3)))
              else
                FScrollVTo := Max(0, Min(GetVMax - GetVViewportSize, FScrollVTo + Round(Abs(AMouseInfo.Y - FScrollY) * FSpY * f * 3)));
            end
            else
              FScrollVTo := 0;

            FAnimateVerticalPos := True;
            AnimateTimer.Enabled := True;
          end;

          FSpX := Abs(AMouseInfo.X - FScrollX) / (FTimeStop - FTimeStart);
          if (FSpX > 0) then
          begin
            if GetHVisible then
            begin
              if (AMouseInfo.X - FScrollX) > 0 then
                FScrollHTo := Max(0, Min(GetHMax - GetHViewportSize, FScrollHTo - Round(Abs(AMouseInfo.X - FScrollX) * FSpX * f * 3)))
              else
                FScrollHTo := Max(0, Min(GetHMax - GetHViewportSize, FScrollHTo + Round(Abs(AMouseInfo.X - FScrollX) * FSpX * f * 3)));
            end
            else
              FScrollHTo := 0;

            FAnimateHorizontalPos := True;
            AnimateTimer.Enabled := True;
          end;
        end;
      end;

      bctl := AMouseInfo;
      bctl.Blocked := not (FDraggingMode = gdmNone) or FDblClick;
      if FMouseUp then
      begin
        res := XYToCell(AMouseInfo.X, AMouseInfo.Y);
        if (res.Column <> -1) and (res.Row <> -1) then
        begin
          obj := GetCellObjectForCell(res);
          if Assigned(obj) then
          begin
            FCellAnchor.Column := -1;
            FCellAnchor.Row := -1;
            if not FMouseDragging then
            begin
              obj.HandleMouse(bctl);
              if bctl.Blocked then
                Display;

              if not bctl.Blocked then
              begin
                if obj.IsHTML then
                  FCellAnchorString := obj.XYToAnchor(AMouseInfo.X, AMouseInfo.Y)
                else
                begin
                  FCellAnchorString := obj.Text;
                  if not IsUrl(FCellAnchorString) or not Options.URL.AutoDetect then
                    FCellAnchorString := '';
                end;

                if FCellAnchorString <> '' then
                  FCellAnchor := res;
              end;
            end;
          end;

          if not bctl.Blocked then
          begin
            if (FCellAnchor.Column = -1) and (FCellAnchor.Row = -1) and (FCellAnchorString = '') then
            begin
              fxd := IsCellFixed(res);
              case Options.Selection.Mode of
                gsmCellRange:
                begin
                  if (gfcsAll in Options.Mouse.FixedCellSelection) and (res.Column < FixedColumnCount) and (res.Row < FixedRowCount) then
                    fxd := False;
                end;
                gsmSingleRow: if (gfcsRow in Options.Mouse.FixedCellSelection) then fxd := False;
                gsmSingleColumn: if (gfcsColumn in Options.Mouse.FixedCellSelection) then fxd := False;
                gsmRowRange: if (gfcsRowRange in Options.Mouse.FixedCellSelection) then fxd := False;
                gsmColumnRange: if (gfcsColumnRange in Options.Mouse.FixedCellSelection) then fxd := False;
                gsmDisjunctRow: if (gfcsDisjunctRow in Options.Mouse.FixedCellSelection) then fxd := False;
                gsmDisjunctColumn: if (gfcsDisjunctColumn in Options.Mouse.FixedCellSelection) then fxd := False;
              end;

              if not fxd and not FDragFixed and not FTouchScrolling then
              begin
                SelectCell(res, AMouseInfo.Shift, FMouseDragging);

                if not FMouseDragging and Options.Mouse.DirectEdit then
                begin
                  Allow := True;
                  DoCanEditCell(FocusedCell.Column, FocusedCell.Row, Allow);
                  if Allow then
                    EditCell(FocusedCell);
                end;
              end;

              DoCellClick(res, AMouseInfo);
            end
            else
              DoCellAnchorClick(FCellAnchor.Column, FCellAnchor.Row, FCellAnchorString);
          end
          else
          begin
            HandleDragEnd(AMouseInfo);
          end;
        end;
      end;

      if not FDragging then
      begin
        FDraggingMode := gdmNone;
        FDragCell := MakeCell(-1, -1);
        FDragCellTo := MakeCell(-1, -1);
        FDragFixed := False;
        FDraggingType := gdtNone;
      end;

      FTouchScrolling := False;
      FFirstCell.Row := -1;
      FFirstCell.Column := -1;
      FMouseDown := False;
      FMouseUp := False;
      FMouseDragging := False;
      FMouseDblClick := FMouseSizing;
      FMouseSizing := False;
      FSizing := False;
    end;
    gmkDouble:
    begin
      FDblClick := True;
      FIsMouseDown := False;

      cell := XYToCell(AMouseInfo.X, AMouseInfo.Y);
      if (cell.Column <> -1) and (cell.Row <> -1) then
      begin
        if FMouseDblClick then
        begin
          FMouseDblClick := False;
          UpdateCursor(crHourGlass);
          try
            case FSizeMode of
              gsmPreviousColumnSizing, gsmColumnSizing:
              begin
                if Options.Mouse.ColumnAutoSizeOnDblClick then
                begin
                  AutoSizeColumn(cell.Column);
                  DoColumnSized(cell.Column, ColumnWidths[cell.Column]);
                end;
              end;
              gsmPreviousRowSizing, gsmRowSizing:
              begin
                if Options.Mouse.RowAutoSizeOnDblClick then
                begin
                  AutoSizeRow(cell.Row);
                  DoRowSized(cell.Row, RowHeights[cell.Row]);
                end;
              end;
            end;
          finally
            UpdateCursor(FOldCursor);
          end;
        end;

        DoCellDblClick(cell.Column, cell.Row);
        FClearMouseDown := True;
      end;
    end;
    gmkWheel:
    begin
      if AMouseInfo.Handled then
        Exit;

      if ((ssCtrl in AMouseInfo.Shift) {$IFDEF FMXLIB}or (ssCommand in AMouseInfo.Shift){$ENDIF} or (Options.Mouse.WheelScrollKeepSelection)) and not Assigned(Adapter) then
      begin
        if AMouseInfo.WheelDelta > 0 then
          tr := TopRow - Options.Mouse.WheelScrollSize
        else
          tr := TopRow + Options.Mouse.WheelScrollSize;

        if tr < FixedRowCount then
          tr := FixedRowCount
        else if tr > RowCount - 1 - FixedBottomRowCount then
          tr := RowCount - 1 - FixedBottomRowCount;

        cl := MakeCell(0, tr);

        if not IsCellDisplayed(cl) then
        begin
          if AMouseInfo.WheelDelta > 0 then
            cl := PreviousVisibleRow(cl.Column, cl.Row)
          else
            cl := NextVisibleRow(cl.Column, cl.Row);
        end;

        Navigate(cl, True, True);
      end
      else
      begin
        sel := FocusedCell;
        psel := sel;

        if AMouseInfo.WheelDelta > 0 then
          sel.Row := Max(FixedRowCount, sel.Row - Options.Mouse.WheelScrollSize)
        else
          sel.Row := Min(RowCount - FixedBottomRowCount - 1, sel.Row + Options.Mouse.WheelScrollSize);

        cell := BaseCell(sel);
        sel := cell;

        if IsCellDisabled(sel) then
        begin
          if AMouseInfo.WheelDelta > 0 then
            sel := PreviousSelectableRow(sel.Column, sel.Row)
          else
            sel := NextSelectableRow(sel.Column, sel.Row);
        end;

        if IsCellDisabled(sel) then
          sel := psel;

        SelectCell(sel, AMouseInfo.Shift);
      end;

      AMouseInfo.Handled := True;
    end;
    gmkEnter:;
    gmkLeave:
    begin
      FHoverCell := MakeCell(-1, -1);
//      if Assigned(ToolBarPopup) and ToolBarPopup.Activated and not Editing then
//      begin
//        p := TTMSFNCUtils.GetMousePos;
//        if not ToolBarPopup.PointInPopup(p) and not ToolBarPopup.DropDownActive then
//          ToolBarPopup.Deactivate;
//      end;
    end;
  end;
end;

function TTMSFNCDataGridRenderer.HasCustomScrollBars: Boolean;
begin
  Result := ((CustomScrollBars and HasValidHost) or not HasValidHost) and not IsExporting
end;

function TTMSFNCDataGridRenderer.HasHint: Boolean;
var
  h: string;
begin
  Result := IsCellValid(FHoverCell);
  if Result then
  begin
    h := Hints[FHoverCell.Column, FHoverCell.Row];
    DoGetCellHint(FHoverCell, h);
    Result := (h <> '');
  end;
end;

function TTMSFNCDataGridRenderer.HasValidHost: Boolean;
begin
  Result := False;
  if Assigned(Host) then
    Result := Host is TTMSFNCDataGridCellParent;
end;

procedure TTMSFNCDataGridRenderer.SetStartCell(AColumn, ARow: Integer);
var
  stc: TTMSFNCDataGridCellCoord;
begin
  stc.Column := AColumn;
  stc.Row := ARow;

  stc.Column := Max(FixedColumnCount, Min(ColumnCount - 1 - FixedRightColumnCount, stc.Column));
  stc.Row := Max(FixedRowCount, Min(RowCount - 1 - FixedBottomRowCount, stc.Row));

  Selection := MakeCellRange(stc.Column, stc.Row, Selection.StopCell.Column, Selection.StopCell.Row);
end;

procedure TTMSFNCDataGridRenderer.SetStopCell(AColumn, ARow: Integer);
var
  stc: TTMSFNCDataGridCellCoord;
begin
  stc.Column := AColumn;
  stc.Row := ARow;

  stc.Column := Max(FixedColumnCount, Min(ColumnCount - 1 - FixedRightColumnCount, stc.Column));
  stc.Row := Max(FixedRowCount, Min(RowCount - 1 - FixedBottomRowCount, stc.Row));

  Selection := MakeCellRange(Selection.StartCell.Column, Selection.StartCell.Row, stc.Column, stc.Row);
end;

procedure TTMSFNCDataGridRenderer.SelectAllCells(AIncludeHidden: Boolean = True);
var
  i, j: Integer;
begin
  if (Options.Selection.Mode in [gsmCellRange, gsmRowRange, gsmColumnRange, gsmDisjunctCell, gsmDisjunctCellRange, gsmDisjunctColumn, gsmDisjunctRow]) then
  begin
    SetStartCell(FixedColumnCount, FixedRowCount);
    SetStopCell(ColumnCount - 1 - FixedRightColumnCount, RowCount - 1 - FixedBottomRowCount);
    SetFocusCell(FixedColumnCount, FixedRowCount);
  end;

  if (Options.Selection.Mode in [gsmDisjunctRow]) then
  begin
    IncUpdateCount;
    for i := FixedRowCount to RowCount - FixedBottomRowCount - 1 do
    begin
      if (not AIncludeHidden and IsRowDisplayed(i)) or AIncludeHidden then
        SelectedRows[i] := True;
    end;
    DecUpdateCount;
  end;

  if (Options.Selection.Mode in [gsmDisjunctColumn]) then
  begin
    IncUpdateCount;
    for i := FixedColumnCount to ColumnCount - 1 - FixedRightColumnCount do
      if (not AIncludeHidden and IsColumnDisplayed(i)) or AIncludeHidden then
        SelectedColumns[i] := True;
    DecUpdateCount;
  end;

  if (Options.Selection.Mode in [gsmDisjunctCell, gsmDisjunctCellRange]) then
  begin
    IncUpdateCount;
    for i := FixedColumnCount to ColumnCount - 1 - FixedRightColumnCount do
      for j := FixedRowCount to RowCount - FixedBottomRowCount - 1 do
        if (not AIncludeHidden and IsCellDisplayed(MakeCell(i, j))) or AIncludeHidden then
          SelectedCells[i, j] := True;
    DecUpdateCount;
  end;

  Navigate(FocusedCell);
  DoSelectCell(Selection.StartCell, Selection.StopCell);
end;

procedure TTMSFNCDataGridRenderer.SelectCell(ACell: TTMSFNCDataGridCellCoord; AShift: TShiftState = []; AMouseDragging: Boolean = False);
var
  sta, stc: TTMSFNCDataGridCellCoord;
  rs, cs, rsstart, csstart: Integer;
  bs, ff, fc: TTMSFNCDataGridCellCoord;
  cst, rst: Integer;
  ic, ir: Integer;
  I, J: Integer;
  doUpdate: Boolean;
  Allow: Boolean;
  cntr, cntc, cntcl: Integer;
  g: TTMSFNCDataGridRenderer;
  OldStartCell, OldStopCell, OldFocusCell: TTMSFNCDataGridCellCoord;
  SelectionChanged: Boolean;
begin
  inherited;

  OldStartCell := Selection.StartCell;
  OldStopCell := Selection.StopCell;
  OldFocusCell := FocusedCell;

  if (ACell.Row < FixedRowCount) and (ACell.Column < FixedColumnCount) and (gfcsAll in Options.Mouse.FixedCellSelection) then
  begin
    SelectAllCells;
    Exit;
  end;

  ACell.Row := Max(FixedRowCount, Min(ACell.Row, RowCount - 1 - FixedBottomRowCount));
  ACell.Column := Max(FixedColumnCount, Min(ACell.Column, ColumnCount - 1 - FixedRightColumnCount));

  Allow := True;
  DoSelectingCell(ACell, ACell, Allow);

  if not Allow then
    Exit;

  FRealCell := ACell;
  ACell := BaseCell(ACell);
  SetFocusCell(ACell.Column, ACell.Row);

  case Options.Selection.Mode of
    gsmSingleCell:
    begin
      SetStartCell(FocusedCell.Column, FocusedCell.Row);
      SetStopCell(FocusedCell.Column, FocusedCell.Row);
    end;
    gsmSingleRow:
    begin
      SetStartCell(FixedColumnCount, FocusedCell.Row);
      SetStopCell(ColumnCount - 1 - FixedRightColumnCount, FocusedCell.Row);
    end;
    gsmSingleColumn:
    begin
      SetStartCell(FocusedCell.Column, FixedRowCount);
      SetStopCell(FocusedCell.Column, RowCount - 1 - FixedBottomRowCount);
    end;
    gsmCellRange, gsmRowRange, gsmColumnRange, gsmDisjunctRow, gsmDisjunctColumn, gsmDisjunctCell, gsmDisjunctCellRange:
    begin
      doUpdate := True;
      if (not AMouseDragging or (FFirstCell.Row = -1) or (FFirstCell.Column = -1)) and not (ssShift in AShift) and not (ssCtrl in AShift) {$IFDEF FMXLIB}and not (ssCommand in AShift){$ENDIF} then
      begin
        SetStartCell(FRealCell.Column, FocusedCell.Row);
        SetStopCell(FocusedCell.Column, FocusedCell.Row);
        FFirstCell := Selection.StartCell;
        FSaveCell := Selection.StartCell;
      end
      else if (ssShift in AShift) and ((FSaveCell.Row = -1) or (FSaveCell.Column = -1)) then
      begin
        SetStartCell(FocusedCell.Column, FocusedCell.Row);
        SetStopCell(FocusedCell.Column, FocusedCell.Row);
        FSaveCell := Selection.StartCell;
      end
      else if (ssCtrl in AShift) {$IFDEF FMXLIB}or (ssCommand in AShift){$ENDIF} and (Options.Selection.Mode in [gsmDisjunctRow, gsmDisjunctColumn, gsmDisjunctCell, gsmDisjunctCellRange]) then
      begin
        case Options.Selection.Mode of
          gsmDisjunctRow:
          begin
            if FocusedCell.Row < Selection.StartCell.Row then
            begin
              SetStartCell(FRealCell.Column, FocusedCell.Row);
              FFirstCell := Selection.StopCell;
              FSaveCell := Selection.StopCell;
            end
            else if FocusedCell.Row > Selection.StopCell.Row then
            begin
              SetStopCell(FocusedCell.Column, FocusedCell.Row);
              FFirstCell := Selection.StartCell;
              FSaveCell := Selection.StartCell;
            end
            else
              doUpdate := False;
          end;
          gsmDisjunctColumn:
          begin
            if FocusedCell.Column < Selection.StartCell.Column then
            begin
              SetStartCell(FocusedCell.Column, FRealCell.Row);
              FFirstCell := Selection.StopCell;
              FSaveCell := Selection.StopCell;
            end
            else if FocusedCell.Column > Selection.StopCell.Column then
            begin
              SetStopCell(FocusedCell.Column, FocusedCell.Row);
              FFirstCell := Selection.StartCell;
              FSaveCell := Selection.StartCell;
            end
            else
              doUpdate := False;
          end;
          gsmDisjunctCell, gsmDisjunctCellRange:
          begin
            doUpdate := False;
            if FocusedCell.Column < Selection.StartCell.Column then
            begin
              if FocusedCell.Row < Selection.StartCell.Row then
                SetStartCell(FocusedCell.Column, FocusedCell.Row)
              else if FocusedCell.Row > Selection.StopCell.Row then
                SetStopCell(FocusedCell.Column, FocusedCell.Row)
              else if (FocusedCell.Row >= Selection.StartCell.Row) or (FocusedCell.Row <= Selection.StopCell.Row) then
                SetStartCell(FocusedCell.Column, Selection.StartCell.Row);
            end
            else if FocusedCell.Column > Selection.StopCell.Column then
            begin
              if FocusedCell.Row < Selection.StartCell.Row then
                SetStartCell(FocusedCell.Column, FocusedCell.Row)
              else if FocusedCell.Row > Selection.StopCell.Row then
                SetStopCell(FocusedCell.Column, FocusedCell.Row)
              else if (FocusedCell.Row >= Selection.StartCell.Row) or (FocusedCell.Row >= Selection.StopCell.Row) then
                SetStopCell(FocusedCell.Column, Selection.StopCell.Row);
            end
            else if (FocusedCell.Column >= Selection.StartCell.Column) and (FocusedCell.Column <= Selection.StopCell.Column) then
            begin
              if FocusedCell.Row < Selection.StartCell.Row then
                SetStartCell(Selection.StartCell.Column, FocusedCell.Row)
              else if FocusedCell.Row > Selection.StopCell.Row then
                SetStopCell(Selection.StopCell.Column, FocusedCell.Row);
            end
          end;
        end;
      end;

      if (ssShift in AShift) or (ssCtrl in AShift) then
        FFirstCell := FSaveCell;

      if doUpdate then
      begin
        if (FocusedCell.Column < FFirstCell.Column) then
        begin
          SetStartCell(FocusedCell.Column, Selection.StartCell.Row);
          SetStopCell(FFirstCell.Column, Selection.StopCell.Row);
        end
        else
        begin
          SetStopCell(FocusedCell.Column, Selection.StopCell.Row);
          SetStartCell(FFirstCell.Column, Selection.StartCell.Row);
        end;

        if (FocusedCell.Row < FFirstCell.Row) then
        begin
          SetStartCell(Selection.StartCell.Column, FocusedCell.Row);
          SetStopCell(Selection.StopCell.Column, FFirstCell.Row);
        end
        else
        begin
          SetStopCell(Selection.StopCell.Column, FocusedCell.Row);
          SetStartCell(Selection.StartCell.Column, FFirstCell.Row);
        end;
      end;

      case Options.Selection.Mode of
        gsmDisjunctRow, gsmDisjunctColumn, gsmDisjunctCell, gsmDisjunctCellRange:
        begin
          if not (ssCtrl in AShift) {$IFDEF FMXLIB}and not (ssCommand in AShift){$ENDIF} and not (ssShift in AShift) then
          begin
            SetStartCell(FocusedCell.Column, FocusedCell.Row);
            SetStopCell(FocusedCell.Column, FocusedCell.Row);
            FSaveCell := FocusedCell;
          end;
        end;
      end;

      case Options.Selection.Mode of
        gsmRowRange, gsmDisjunctRow:
        begin
          SetStartCell(FixedColumnCount, Selection.StartCell.Row);
          SetStopCell(ColumnCount - 1 - FixedRightColumnCount, Selection.StopCell.Row);
        end;
        gsmColumnRange, gsmDisjunctColumn:
        begin
          SetStartCell(Selection.StartCell.Column, FixedRowCount);
          SetStopCell(Selection.StopCell.Column, RowCount - 1 - FixedBottomRowCount);
        end;
      end;
    end;
  end;

  stc := Selection.StopCell;
  sta := Selection.StartCell;

  if Selection.StopCell.Column < Selection.StartCell.Column then
  begin
    SetStopCell(sta.Column, Selection.StopCell.Row);
    SetStartCell(stc.Column, Selection.StartCell.Row);
  end;

  if Selection.StopCell.Row < Selection.StartCell.Row then
  begin
    SetStopCell(Selection.StopCell.Column, sta.Row);
    SetStartCell(Selection.StartCell.Column, stc.Row);
  end;

  cs := Selection.StopCell.Column;
  csstart := Selection.StartCell.Column;
  rs := Selection.StopCell.Row;
  rsstart := Selection.StartCell.Row;
  for ic := Max(StartColumn, csstart) to Min(StopColumn, cs) do
  begin
    for ir := Max(StartRow, rsstart) to Min(StopRow, rs) do
    begin
      bs := BaseCell(MakeCell(ic, ir));
      cst := ColumnSpan(bs);
      if bs.Column + cst - 1 > cs then
        cs := bs.Column + cst - 1;

      if bs.Column < csstart then
        csstart := bs.Column;

      rst := RowSpan(bs);
      if bs.Row + rst - 1 > rs then
        rs := bs.Row + rst - 1;

      if bs.Row < rsstart then
        rsstart := bs.Row;
    end;
  end;

  SetStopCell(cs,rs);
  SetStartCell(csstart, rsstart);

  case Options.Selection.Mode of
    gsmDisjunctRow:
    begin
      IncUpdateCount;

      if not (ssCtrl in AShift) {$IFDEF FMXLIB}and not (ssCommand in AShift){$ENDIF} then
        SelectedRowDictionary.Clear;

      if ssShift in AShift then
      begin
        for I := Selection.StartCell.Row to Selection.StopCell.Row do
          SelectedRows[I] := not SelectedRows[I];
      end
      else
      begin
        SelectedRows[FocusedCell.Row] := not SelectedRows[FocusedCell.Row];
        cntr := GetSelectedRowCount;
        if not SelectedRows[FocusedCell.Row] and (cntr = 0) then
          SelectedRows[FocusedCell.Row] := True;
      end;

      if not SelectedRows[FocusedCell.Row] then
        for I := Selection.StartCell.Row to Selection.StopCell.Row do
          if (I <> FocusedCell.Row) and (SelectedRows[I]) then
            SetFocusCell(FocusedCell.Column, I);

      DecUpdateCount;
    end;
    gsmDisjunctColumn:
    begin
      IncUpdateCount;

      if not (ssCtrl in AShift) {$IFDEF FMXLIB}and not (ssCommand in AShift){$ENDIF} then
        SelectedColumnDictionary.Clear;

      if ssShift in AShift then
      begin
        for I := Selection.StartCell.Column to Selection.StopCell.Column do
          SelectedColumns[I] := not SelectedColumns[I];
      end
      else
      begin
        SelectedColumns[FocusedCell.Column] := not SelectedColumns[FocusedCell.Column];
        cntc := GetSelectedColumnCount;
        if not SelectedColumns[FocusedCell.Column] and (cntc = 0) then
          SelectedColumns[FocusedCell.Column] := True;
      end;

      if not SelectedColumns[FocusedCell.Column] then
        for I := Selection.StartCell.Column to Selection.StopCell.Column do
          if (I <> FocusedCell.Column) and (SelectedColumns[I]) then
            SetFocusCell(I, FocusedCell.Row);

      DecUpdateCount;
    end;
    gsmDisjunctCell, gsmDisjunctCellRange:
    begin
      IncUpdateCount;

      if not (ssCtrl in AShift) {$IFDEF FMXLIB}and not (ssCommand in AShift){$ENDIF} then
      begin
        SelectedCellDictionary.Clear;
        SelectedColumnDictionary.Clear;
        SelectedRowDictionary.Clear;
      end;

      if ssShift in AShift then
      begin
        case Options.Selection.Mode of
          gsmDisjunctCell:
          begin
            for I := Selection.StartCell.Column to Selection.StopCell.Column do
              for J := Selection.StartCell.Row to Selection.StopCell.Row do
                SelectedCells[I, J] := not SelectedCells[I, J];
          end;
          gsmDisjunctCellRange:
          begin
            if FocusedCell.Row > FFirstCell.Row then
            begin
              ff := FFirstCell;
              fc := FocusedCell;
            end
            else
            begin
              fc := FFirstCell;
              ff := FocusedCell;
            end;

            for I := FixedColumnCount to ColumnCount - 1 - FixedRightColumnCount do
            begin
              for J := Selection.StartCell.Row to Selection.StopCell.Row do
              begin
                if (J = Selection.StartCell.Row) and (J = Selection.StopCell.Row) and (I >= Selection.StartCell.Column) and (I <= Selection.StopCell.Column) then
                  SelectedCells[I, J] := not SelectedCells[I, J]
                else if (J = Selection.StartCell.Row) and (J < Selection.StopCell.Row) and (I >= ff.Column) then
                  SelectedCells[I, J] := not SelectedCells[I, J]
                else if (J > Selection.StartCell.Row) and (J < Selection.StopCell.Row) then
                  SelectedCells[I, J] := not SelectedCells[I, J]
                else if (J = Selection.StopCell.Row) and (J > Selection.StartCell.Row) and (I <= fc.Column) then
                  SelectedCells[I, J] := not SelectedCells[I, J];
              end;
            end;
          end;
        end;
      end
      else
      begin
        SelectedCells[FocusedCell.Column, FocusedCell.Row] := not SelectedCells[FocusedCell.Column, FocusedCell.Row];
        cntcl := GetSelectedCellCount;
        if not SelectedCells[FocusedCell.Column, FocusedCell.Row] and (cntcl = 0) then
          SelectedCells[FocusedCell.Column, FocusedCell.Row] := True;
      end;

      if not SelectedCells[FocusedCell.Column, FocusedCell.Row] then
        for I := Selection.StartCell.Column to Selection.StopCell.Column do
          for J := Selection.StartCell.Row to Selection.StopCell.Row do
            if (I <> FocusedCell.Column) and (J <> FocusedCell.Row) and SelectedCells[I, J] then
              SetFocusCell(I, J);

      DecUpdateCount;
    end;
  end;

  Navigate(FocusedCell);

  SelectionChanged := not OldFocusCell.IsEqualTo(FocusedCell) or not OldStartCell.IsEqualTo(Selection.StartCell) or not OldStopCell.IsEqualTo(Selection.StopCell);

  if Allow and SelectionChanged and Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).SelectCell(FocusedCell);

  if HasGrid[FocusedCell.Column, FocusedCell.Row] then
  begin
    g := Grids[FocusedCell.Column, FocusedCell.Row];
    if Assigned(g) then
    begin
      g.Focus;
      g.FTabKey := FTabKey;
      g.HandleEnter;
    end;
  end;

  if Allow and SelectionChanged then
    DoSelectCell(Selection.StartCell, Selection.StopCell);
end;

procedure TTMSFNCDataGridRenderer.SelectColumns(AFromColumn,
  AToColumn: Integer);
var
  i: Integer;
begin
  if Options.Selection.Mode = gsmColumnRange then
    Selection := MakeCellRange(AFromColumn, 0, AToColumn, 0)
  else
  if Options.Selection.Mode = gsmSingleColumn then
    Selection := MakeCellRange(AFromColumn, 0, AFromColumn, 0)
  else
  if Options.Selection.Mode = gsmDisjunctColumn then
    for i := AFromColumn to AToColumn do
      SelectedColumns[i] := True;
end;

procedure TTMSFNCDataGridRenderer.SelectRows(AFromRow, AToRow: Integer);
var
  i: Integer;
begin
  if Options.Selection.Mode = gsmRowRange then
    Selection := MakeCellRange(0, AFromRow, 0, AToRow)
  else
  if Options.Selection.Mode = gsmSingleRow then
    Selection := MakeCellRange(0, AFromRow, 0, AFromRow)
  else
  if Options.Selection.Mode = gsmDisjunctRow then
    for i := AFromRow to AToRow do
      SelectedRows[i] := true;
end;

procedure TTMSFNCDataGridRenderer.Navigate(ACell: TTMSFNCDataGridCellCoord; AForceScroll: Boolean = False; AIgnoreColumn: Boolean = False; AIgnoreRow: Boolean = False);
var
  hs, vs, rhs, rvs, vss, hss: Double;
  cw, ch: Double;
  totalh, totalw: Double;
  cs, rs: Integer;
  toth, totw: Double;
  cl: TTMSFNCDataGridCellCoord;
  cr: TRectF;
  c, r: Integer;
begin
  cr := GetContentClipRect;
  cw := cr.Right -  cr.Left;
  ch := cr.Bottom - cr.Top;
  vs := GetVScrollValue;
  hs := GetHScrollValue;

  vss := vs;
  hss := hs;

  if ScrollMode = gsmCellScrolling then
  begin
    vss := GetVerticalScrollPosition;
    hss := GetHorizontalScrollPosition;
  end;

  totalw := 0;
  totalh := 0;
  ACell := BaseCell(ACell);
  cs := ColumnSpan(ACell);
  rs := RowSpan(ACell);
  if cs > 0 then
  begin
    for c := ACell.Column to ACell.Column + cs - 1 do
      totalw := totalw + ColumnWidths[c];
  end
  else
    totalw := ColumnWidths[ACell.Column];

  if rs > 0 then
  begin
    for r := ACell.Row to ACell.Row + rs - 1 do
      totalh := totalh + RowHeights[r];
  end
  else
    totalh := RowHeights[ACell.Row];

  rvs := RowPositions[ACell.Row];
  if AForceScroll then
  begin
    case ScrollMode of
      gsmPixelScrolling: vs := rvs - GetTotalFixedRowHeight;
      gsmCellScrolling: vs := ACell.Row - FixedRowCount - FreezeRowCount;
    end;
  end
  else
  begin
    if (rvs < vss + GetTotalFixedRowHeight) then
    begin
      case ScrollMode of
        gsmPixelScrolling: vs := rvs - GetTotalFixedRowHeight;
        gsmCellScrolling: vs := ACell.Row - FixedRowCount - FreezeRowCount;
      end;
    end
    else
    begin
      if totalh < ch - GetTotalFixedBottomRowHeight then
      begin
        case ScrollMode of
          gsmPixelScrolling:
          begin
            if (rvs + totalh > vss + ch - GetTotalFixedBottomRowHeight) then
              vs := rvs + totalh - ch - 1 + GetTotalFixedBottomRowHeight;
          end;
          gsmCellScrolling:
          begin
            while (rvs + totalh > vss + ch - GetTotalFixedBottomRowHeight) do
            begin
              vs := vs + 1;
              cl := BaseCell(MakeCell(ACell.Column, Round(vs)));
              rs := RowSpan(cl);
              if rs > 0 then
                toth := RowPositions[cl.Row + rs - 1] - RowPositions[cl.Row]
              else
              begin
                rs := 1;
                toth := RowHeights[cl.Row];
              end;

              vs := vs + rs - 1;
              vss := vss + toth;
            end;
          end;
        end;
      end;
    end;
  end;

  rhs := ColumnPositions[ACell.Column];
  if AForceScroll then
  begin
    case ScrollMode of
      gsmPixelScrolling: hs := rhs - GetTotalFixedColumnWidth;
      gsmCellScrolling: hs := ACell.Column - FixedColumnCount - FreezeColumnCount;
    end;
  end
  else
  begin
    if (rhs < hss + GetTotalFixedColumnWidth) then
    begin
      case ScrollMode of
        gsmPixelScrolling: hs := rhs - GetTotalFixedColumnWidth;
        gsmCellScrolling: hs := ACell.Column - FixedColumnCount - FreezeColumnCount;
      end;
    end
    else
    begin
      if (totalw < cw - GetTotalFixedRightColumnWidth) then
      begin
        case ScrollMode of
          gsmPixelScrolling:
          begin
            if (rhs + totalw > hss + cw - GetTotalFixedRightColumnWidth) then
              hs := rhs + totalw - cw - 1 + GetTotalFixedRightColumnWidth;
          end;
          gsmCellScrolling:
          begin
            while (rhs + totalw > hss + cw - GetTotalFixedRightColumnWidth) do
            begin
              hs := hs + 1;
              cl := BaseCell(MakeCell(Round(hs), ACell.Row));
              cs := ColumnSpan(cl);
              if cs > 0 then
                totw := ColumnPositions[cl.Column] - ColumnPositions[cl.Column + cs - 1]
              else
              begin
                cs := 1;
                totw := ColumnWidths[cl.Column];
              end;

              hs := hs + cs - 1;
              hss := hss + totw;
            end;
          end;
        end;
      end;
    end;
  end;

  if AIgnoreColumn then
    Scroll(GetHorizontalScrollPosition, vs)
  else if AIgnoreRow then
    Scroll(hs, GetVerticalScrollPosition)
  else
    Scroll(hs, vs);
end;

procedure TTMSFNCDataGridRenderer.Scroll(AHorizontalPos, AVerticalPos: Double);
var
  h, v: Single;
  hv: Boolean;
begin
  FBlockScrollingUpdate := True;
  h := GetHScrollValue;
  SetHScrollValue(AHorizontalPos);
  v := GetVScrollValue;
  SetVScrollValue(AVerticalPos);

  hv := v <> GetVScrollValue;
  if hv then
    DoVScroll(GetVScrollValue);

  if h <> GetHScrollValue then
    DoHScroll(GetHScrollValue);

  FBlockScrollingUpdate := False;
  Update;

  if hv and Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    (Adapter as TTMSFNCDataGridRendererDataAdapter).Scroll;
end;

procedure TTMSFNCDataGridRenderer.SetCellAppearance(
  const Value: TTMSFNCDataGridCellAppearance);
begin
  if FCellAppearance <> Value then
    FCellAppearance.Assign(Value);
end;

procedure TTMSFNCDataGridRenderer.SetIcons(
  const Value: TTMSFNCDataGridIcons);
begin
  if FIcons <> Value then
    FIcons.Assign(Value);
end;

procedure TTMSFNCDataGridRenderer.SetDataCheckBox(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.&Type := gcitDataCheckBox;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetCheckBox(AColumn, ARow: Integer; AValue: Boolean = False);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
    begin
      cd.&Type := gcitCheckBox;
      cd.BooleanValue := AValue;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetCheckBox(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False);
begin
  SetCheckBox(ACell.Column, ACell.Row, AValue);
end;

procedure TTMSFNCDataGridRenderer.SetCheckBoxColumn(AColumn: Integer; AValue: Boolean = False);
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := FixedRowCount to RowCount - 1 - FixedBottomRowCount do
      SetCheckBox(AColumn, I, AValue);
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetDataCheckBox(ACell: TTMSFNCDataGridCellCoord);
begin
  SetDataCheckBox(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.SetDataCheckBoxColumn(AColumn: Integer);
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := FixedRowCount to RowCount - 1 - FixedBottomRowCount do
      SetDataCheckBox(AColumn, I);
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetRadioGroupIndex(AColumn, ARow: Integer;
  const Value: Integer);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.RadioGroupIndex := Value;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetClipRect(ARect: TRectF);
begin
  FClipRect := ARect;
  FUseClipRect := True;
end;

procedure TTMSFNCDataGridRenderer.SetColors(AColumn, ARow: Integer;
  const Value: TTMSFNCGraphicsColor);
var
  l: TTMSFNCDataGridCellLayout;
begin
  l := Layouts[AColumn, ARow];
  if Assigned(l) then
    l.Fill.Color := Value;
end;

procedure TTMSFNCDataGridRenderer.SetColumns(
  const Value: TTMSFNCDataGridColumns);
begin
  FColumns.Assign(Value);
end;

procedure TTMSFNCDataGridRenderer.SetComments(AColumn, ARow: Integer;
  const Value: string);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.Comment := Value;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetHints(AColumn, ARow: Integer;
  const Value: string);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.Hint := Value;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetControlAligns(AColumn, ARow: Integer;
  const Value: TTMSFNCDataGridCellControlAlign);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.ControlAlign := Value;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetControlPositions(AColumn, ARow: Integer;
  const Value: TTMSFNCDataGridCellControlPosition);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.ControlPosition := Value;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetControlHeights(AColumn, ARow: Integer;
  const Value: Integer);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.ControlHeight := Value;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetControlTexts(AColumn, ARow: Integer;
  const Value: string);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.ControlText := Value;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetControlWidths(AColumn, ARow: Integer;
  const Value: Integer);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.ControlWidth := Value;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetPadding(const Value: TTMSFNCMargins);
begin
  if FPadding <> Value then
    FPadding.Assign(Value);
end;

procedure TTMSFNCDataGridRenderer.SetPageIndex(const Value: Integer);
begin
  if Value <> GetPageIndex then
    GoToPage(Value);
end;

procedure TTMSFNCDataGridRenderer.SetDataProgressBar(AColumn, ARow: Integer);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
      cd.&Type := gcitDataProgressBar;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetDataProgressBar(ACell: TTMSFNCDataGridCellCoord);
begin
  SetDataProgressBar(ACell.Column, ACell.Row);
end;

procedure TTMSFNCDataGridRenderer.SetDataProgressBarColumn(AColumn: Integer);
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := FixedRowCount to RowCount - 1 - FixedBottomRowCount do
      SetDataProgressBar(AColumn, I);
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetProgressBar(AColumn, ARow: Integer; AValue: Integer = 0);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
    begin
      cd.&Type := gcitProgressBar;
      cd.IntegerValue := AValue;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetProgressBar(ACell: TTMSFNCDataGridCellCoord; AValue: Integer = 0);
begin
  SetProgressBar(ACell.Column, ACell.Row, AValue);
end;

procedure TTMSFNCDataGridRenderer.SetProgressBarColumn(AColumn: Integer; AValue: Integer = 0);
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := FixedRowCount to RowCount - 1 - FixedBottomRowCount do
      SetProgressBar(AColumn, I, AValue);
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetRadioButton(AColumn, ARow: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
    begin
      cd.&Type := gcitRadioButton;
      cd.BooleanValue := AValue;
      cd.RadioGroupIndex := AGroupIndex;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetRadioButton(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False; AGroupIndex: Integer = 0);
begin
  SetRadioButton(ACell.Column, ACell.Row, AValue, AGroupIndex);
end;

procedure TTMSFNCDataGridRenderer.SetRadioButtonColumn(AColumn: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0);
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := FixedRowCount to RowCount - 1 - FixedBottomRowCount do
      SetRadioButton(AColumn, I, AValue, AGroupIndex);
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetDataRadioButton(AColumn, ARow: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
    begin
      cd.&Type := gcitDataRadioButton;
      cd.RadioGroupIndex := AGroupIndex;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetDataRadioButton(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean = False; AGroupIndex: Integer = 0);
begin
  SetDataRadioButton(ACell.Column, ACell.Row, AValue, AGroupIndex);
end;

procedure TTMSFNCDataGridRenderer.SetDataRadioButtonColumn(AColumn: Integer; AValue: Boolean = False; AGroupIndex: Integer = 0);
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := FixedRowCount to RowCount - 1 - FixedBottomRowCount do
      SetDataRadioButton(AColumn, I, AValue, AGroupIndex);
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetDragAppearance(
  const Value: TTMSFNCDataGridDragAppearance);
begin
  FDragAppearance.Assign(Value);
end;

procedure TTMSFNCDataGridRenderer.SetButton(AColumn, ARow: Integer; AText: string = '');
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
    begin
      cd.&Type := gcitButton;
      cd.ControlText := AText;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetAdaptToStyle(const Value: Boolean);
begin
  FAdaptToStyle := Value;
  if AdaptToStyle then
  begin
    FAdaptedToStyle := True;
    ApplyStyle;
  end
  else if FAdaptedToStyle then
  begin
    ResetToDefaultStyle;
    FAdaptedToStyle := False;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetBitmap(AColumn, ARow: Integer;
  AName: string);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
    begin
      cd.&Type := gcitBitmap;
      cd.BitmapName := AName;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetBitmap(ACell: TTMSFNCDataGridCellCoord;
  ABitmap: TTMSFNCBitmap);
begin
  SetBitmap(ACell.Column, ACell.Row, ABitmap);
end;

procedure TTMSFNCDataGridRenderer.SetBitmap(AColumn, ARow: Integer;
  ABitmap: TTMSFNCBitmap);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
    begin
      cd.&Type := gcitBitmap;
      cd.Bitmap.Assign(ABitmap);
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetBitmap(ACell: TTMSFNCDataGridCellCoord;
  AName: string);
begin
  SetBitmap(ACell.Column, ACell.Row, AName);
end;

procedure TTMSFNCDataGridRenderer.SetBitmapColumn(AColumn: Integer;
  ABitmap: TTMSFNCBitmap);
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := FixedRowCount to RowCount - 1 - FixedBottomRowCount do
      SetBitmap(AColumn, I, ABitmap);
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetBitmapColumn(AColumn: Integer;
  AName: string);
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := FixedRowCount to RowCount - 1 - FixedBottomRowCount do
      SetBitmap(AColumn, I, AName);
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetBitmapContainer(
  const Value: TTMSFNCBitmapContainer);
begin
  FBitmapContainer := Value;
  Display;
end;

procedure TTMSFNCDataGridRenderer.SetBooleans(AColumn, ARow: Integer;
  const Value: Boolean);
var
  cl: TTMSFNCDataGridColumn;

  procedure UpdateCell(ACell: TTMSFNCDataGridCellCoord; AValue: Boolean);
  var
    cll: TTMSFNCDataGridCell;
    v: TTMSFNCDataGridCellValue;
  begin
    cll := GetCellObjectForCell(ACell);
    if Assigned(cll) then
    begin
      TTMSFNCDataGridCellOpen(cll).UpdateData(CellData[ACell.Column, ACell.Row]);
      if cll is TTMSFNCDataGridCheckedCell then
        (cll as TTMSFNCDataGridCheckedCell).Checked := AValue;
      TTMSFNCDataGridCellOpen(cll).CreateControlCache;

      if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
      begin
        v := AValue;
        (Adapter as TTMSFNCDataGridRendererDataAdapter).EditSetData(ACell, nil, v);
      end;
    end;
  end;

begin
  if HasDataCheckBox[AColumn, ARow] or HasDataRadioButton[AColumn, ARow] then
  begin
    cl := GetColumn(AColumn);
    if Assigned(cl) then
    begin
      if Value then
        Cells[AColumn, ARow] := cl.Binding.BooleanTrueValue
      else
        Cells[AColumn, ARow] := cl.Binding.BooleanFalseValue
    end;
  end
  else
    inherited SetBooleans(AColumn, ARow, Value);

  UpdateCell(MakeCell(AColumn, ARow), Value);
end;

procedure TTMSFNCDataGridRenderer.SetButton(ACell: TTMSFNCDataGridCellCoord; AText: string = '');
begin
  SetButton(ACell.Column, ACell.Row, AText);
end;

procedure TTMSFNCDataGridRenderer.SetButtonColumn(AColumn: Integer; AText: string = '');
var
  I: Integer;
begin
  BeginUpdate;
  try
    for I := FixedRowCount to RowCount - 1 - FixedBottomRowCount do
      SetButton(AColumn, I, AText);
  finally
    EndUpdate;
  end;
end;

function TTMSFNCDataGridRenderer.GetFilterClearButton: TTMSFNCToolBarButton;
begin
  if not Assigned(FFilterClearButton) then
  begin
    FFilterClearButton := TTMSFNCToolBarButton.Create(FilterContainer);
    FFilterClearButton.Parent := FilterContainer;
    FFilterClearButton.Appearance.FlatStyle := True;
    FFilterClearButton.Width := 25;
    FFilterClearButton.Left := 5;
    FFilterClearButton.Top := 5 + FilterTypeComboBox.Height;
    FFilterClearButton.Height := 22;
    FFilterClearButton.Text := '';
    FFilterClearButton.HorizontalTextAlign := gtaLeading;
    FFilterClearButton.Appearance.NormalFill.Color := gcWhite;
    FFilterClearButton.Appearance.NormalStroke.Color := gcWhite;
    FFilterClearButton.Hint := Options.Localization.FilterClearButtonHint;
    FFilterClearButton.ShowHint := True;
    FFilterClearButton.OnClick := DoFilterClearClick;

    FilterClearButton.AdaptToStyle := AdaptToStyle;
  end;

  FFilterClearButton.Bitmaps.Clear;
  FFilterClearButton.Bitmaps.AddBitmap(Icons.FilterClearIcon);
  Result := FFilterClearButton;
end;

function TTMSFNCDataGridRenderer.GetFilterContainer: TTMSFNCCustomControl;
begin
  if not Assigned(FFilterContainer) then
    FFilterContainer := TTMSFNCCustomControl.Create(nil);

  Result := FFilterContainer;
end;

function TTMSFNCDataGridRenderer.GetFilterDialog: TTMSFNCFilterDialog;
begin
  if not Assigned(FFilterDialog) then
  begin
    FFilterDialog := TTMSFNCFilterDialog.Create(nil);
    FFilterDialog.OnApplyButtonClicked := DoFilterBuilderApplyButtonClicked;
    FFilterDialog.OnOKButtonClicked := DoFilterBuilderApplyButtonClicked;
    FFilterDialog.OnClose := DoFilterBuilderClose;
    FFilterDialog.Options.Buttons := FFilterDialog.Options.Buttons + [fdbOK];
    FFilterDialog.FilterBuilder := FilterBuilder;
  end;

  Result := FFilterDialog;
end;

function TTMSFNCDataGridRenderer.GetFilterListBox: TTMSFNCCheckedListBox;
begin
  if not Assigned(FFilterListBox) then
  begin
    FFilterListBox := TTMSFNCCheckedListBox.Create(FilterContainer);
    FFilterListBox.Parent := FilterContainer;
    FFilterListBox.ControlAlignment := caClient;
    {$IFNDEF FMXLIB}
    FFilterListBox.AlignWithMargins := True;
    {$ENDIF}
    FFilterListBox.Margins.Left := 5;
    FFilterListBox.Margins.Top := 5;
    FFilterListBox.Margins.Right := 5;
    FFilterListBox.Margins.Bottom := 5;
    FFilterListBox.OnItemCheckChanged := DoFilterListBoxItemCheckChanged;
    FFilterListBox.AdaptToStyle := AdaptToStyle;
  end;

  Result := FFilterListBox;
end;

function TTMSFNCDataGridRenderer.GetFilterPopup: TTMSFNCPopup;
{$IFDEF WEBLIB}
var
  p: TTMSFNCDataGridCellParent;
{$ENDIF}
begin
  if not Assigned(FFilterPopup) then
  begin
    {$IFDEF WEBLIB}
    p := GetParentHost;
    FFilterPopup := TTMSFNCPopup.Create(p);
    {$ELSE}
    FFilterPopup := TTMSFNCPopup.Create(nil);
    {$ENDIF}
    FFilterPopup.Placement := ppAbsolute;
    FFilterPopup.AdaptToStyle := AdaptToStyle;
  end;

  Result := FFilterPopup;
end;

function TTMSFNCDataGridRenderer.GetFilterEdit: TTMSFNCEdit;
begin
  if not Assigned(FFilterEdit) then
  begin
    FFilterEdit := TTMSFNCEdit.Create(FilterContainer);
    FFilterEdit.Parent := FilterContainer;
    FFilterEdit.OnEnter := @DoFilterEnter;
    {$IFDEF FMXLIB}
    FFilterEdit.TextPrompt := Options.Localization.FilterEditPrompt;
    FFilterEdit.Align := TAlignLayout.Top;
    FFilterEdit.OnChangeTracking := DoFilterEditChange;
    {$ELSE}
    FFilterEdit.TextHint := Options.Localization.FilterEditPrompt;
    FFilterEdit.Align := alTop;
    FFilterEdit.AlignWithMargins := True;
    FFilterEdit.OnChange := @DoFilterEditChange;
    {$ENDIF}
    FFilterEdit.Margins.Left := 35;
    FFilterEdit.Margins.Top := 5;
    FFilterEdit.Margins.Right := 5;
    FFilterEdit.Margins.Bottom := 0;
  end;

  Result := FFilterEdit;
end;

function TTMSFNCDataGridRenderer.GetFilterEditors(AColumn,
  ARow: Integer): TTMSFNCDataGridCellControl;
var
  cd: TTMSFNCDataGridCellItem;
begin
  Result := nil;
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) then
  begin
    if not Assigned(TTMSFNCDataGridCellItemExtendedOpen(cd).FilterEditor) then
      TTMSFNCDataGridCellItemExtendedOpen(cd).FilterEditor := CreateFilterEditor(MakeCell(AColumn, ARow));

    Result := TTMSFNCDataGridCellItemExtendedOpen(cd).FilterEditor;
  end;
end;

function TTMSFNCDataGridRenderer.GetFilterExitTimer: TTimer;
begin
  if not Assigned(FFilterExitTimer) then
  begin
    FFilterExitTimer := TTimer.Create(nil);
    FFilterExitTimer.OnTimer := DoFilterExitTimer;
    FFilterExitTimer.Interval := 100;
    FFilterExitTimer.Enabled := False;
  end;

  Result := FFilterExitTimer;
end;

function TTMSFNCDataGridRenderer.GetFilterSortAscendingButton: TTMSFNCToolBarButton;
begin
  if not Assigned(FFilterSortAscendingButton) then
  begin
    FFilterSortAscendingButton := TTMSFNCToolBarButton.Create(FilterContainer);
    FFilterSortAscendingButton.Parent := FilterContainer;
    {$IFDEF FMXLIB}
    FFilterSortAscendingButton.Align := TAlignLayout.Bottom;
    {$ELSE}
    FFilterSortAscendingButton.Align := alBottom;
    FFilterSortAscendingButton.AlignWithMargins := True;
    {$ENDIF}
    FFilterSortAscendingButton.Appearance.FlatStyle := True;
    FFilterSortAscendingButton.Text := Options.Localization.FilterSortButtonAscendingText;
    FFilterSortAscendingButton.HorizontalTextAlign := gtaLeading;
    FFilterSortAscendingButton.Appearance.NormalFill.Color := gcWhite;
    FFilterSortAscendingButton.Appearance.NormalStroke.Color := gcWhite;
    FFilterSortAscendingButton.Hint := Options.Localization.FilterSortButtonAscendingHint;
    FFilterSortAscendingButton.ShowHint := True;
    FFilterSortAscendingButton.Margins.Left := 5;
    FFilterSortAscendingButton.Margins.Top := 0;
    FFilterSortAscendingButton.Margins.Right := 5;
    FFilterSortAscendingButton.Margins.Bottom := 5;
    FFilterSortAscendingButton.DataString := 'asc';
    FFilterSortAscendingButton.OnClick := DoFilterSortClick;

    FFilterSortAscendingButton.AdaptToStyle := AdaptToStyle;
  end;

  FFilterSortAscendingButton.Bitmaps.Clear;
  FFilterSortAscendingButton.Bitmaps.AddBitmap(Icons.SortAscendingIcon);
  Result := FFilterSortAscendingButton;
end;

function TTMSFNCDataGridRenderer.GetFilterSortDescendingButton: TTMSFNCToolBarButton;
begin
  if not Assigned(FFilterSortDescendingButton) then
  begin
    FFilterSortDescendingButton := TTMSFNCToolBarButton.Create(FilterContainer);
    FFilterSortDescendingButton.Parent := FilterContainer;
    {$IFDEF FMXLIB}
    FFilterSortDescendingButton.Align := TAlignLayout.Bottom;
    {$ELSE}
    FFilterSortDescendingButton.Align := alBottom;
    FFilterSortDescendingButton.AlignWithMargins := True;
    {$ENDIF}
    FFilterSortDescendingButton.Appearance.FlatStyle := True;
    FFilterSortDescendingButton.Text := Options.Localization.FilterSortButtonDescendingText;
    FFilterSortDescendingButton.HorizontalTextAlign := gtaLeading;
    FFilterSortDescendingButton.Appearance.NormalFill.Color := gcWhite;
    FFilterSortDescendingButton.Appearance.NormalStroke.Color := gcWhite;
    FFilterSortDescendingButton.Hint := Options.Localization.FilterSortButtonDescendingHint;
    FFilterSortDescendingButton.ShowHint := True;
    FFilterSortDescendingButton.Margins.Left := 5;
    FFilterSortDescendingButton.Margins.Top := 0;
    FFilterSortDescendingButton.Margins.Right := 5;
    FFilterSortDescendingButton.Margins.Bottom := 5;
    FFilterSortDescendingButton.DataString := 'desc';
    FFilterSortDescendingButton.OnClick := DoFilterSortClick;

    FFilterSortDescendingButton.AdaptToStyle := AdaptToStyle;
  end;

  FFilterSortDescendingButton.Bitmaps.Clear;
  FFilterSortDescendingButton.Bitmaps.AddBitmap(Icons.SortDescendingIcon);
  Result := FFilterSortDescendingButton;
end;

function TTMSFNCDataGridRenderer.GetFilterTimer: TTimer;
begin
  if not Assigned(FFilterTimer) then
  begin
    FFilterTimer := TTimer.Create(nil);
    FFilterTimer.OnTimer := DoFilterTimer;
    FFilterTimer.Interval := 1;
    FFilterTimer.Enabled := False;
  end;

  Result := FFilterTimer;
end;

function TTMSFNCDataGridRenderer.GetFilterTypeComboBox: TComboBoxSafe;
var
  I: TTMSFNCDataGridDataFilterType;
  a: TArray<String>;
begin
  if not Assigned(FFilterTypeComboBox) then
  begin
    FFilterTypeComboBox := TComboBoxSafe.Create(FilterContainer);
    FFilterTypeComboBox.Parent := FilterContainer;
    {$IFDEF FMXLIB}
    FFilterTypeComboBox.Align := TAlignLayout.Top;
    {$ELSE}
    FFilterTypeComboBox.Align := alTop;
    FFilterTypeComboBox.AlignWithMargins := True;
    {$ENDIF}
    {$IFDEF VCLLIB}
    FFilterTypeComboBox.Style := csDropDownList;
    {$ENDIF}
    FFilterTypeComboBox.Margins.Left := 5;
    FFilterTypeComboBox.Margins.Top := 5;
    FFilterTypeComboBox.Margins.Right := 5;
    FFilterTypeComboBox.Margins.Bottom := 0;

    SetLength(a, 0);
    for I := Low(TTMSFNCDataGridDataFilterType) to High(TTMSFNCDataGridDataFilterType) do
    begin
      SetLength(a, Length(a) + 1);
      a[Length(a) - 1] := GetFilterTypeName(I);
    end;

    FFilterTypeComboBox.SafeItems := a;
    FFilterTypeComboBox.OnChange := @DoFilterTypeChange;
  end;

  Result := FFilterTypeComboBox;
end;

function TTMSFNCDataGridRenderer.GetFilterTypeName(
  AType: TTMSFNCDataGridDataFilterType): string;
begin
  case AType of
    gftEmpty: Result := Options.Localization.FilterTypeEmptyText;
    gftNotEmpty: Result := Options.Localization.FilterTypeNotEmptyText;
    gftStartsWith: Result := Options.Localization.FilterTypeStartsWithText;
    gftEndsWith: Result := Options.Localization.FilterTypeEndsWithText;
    gftContains: Result := Options.Localization.FilterTypeContainsText;
    gftNotContains: Result := Options.Localization.FilterTypeNotContainsText;
    gftEqual: Result := Options.Localization.FilterTypeEqualText;
    gftNotEqual: Result := Options.Localization.FilterTypeNotEqualText;
    gftLargerThan: Result := Options.Localization.FilterTypeLargerThanText;
    gftSmallerThan: Result := Options.Localization.FilterTypeSmallerThanText;
    gftLargerOrEqualThan: Result := Options.Localization.FilterTypeLargerOrEqualThanText;
    gftSmallerOrEqualThan: Result := Options.Localization.FilterTypeSmallerOrEqualThanText;
  end;
end;

function TTMSFNCDataGridRenderer.GetFindDialog: TTMSFNCFindDialog;
begin
  if not Assigned(FFindDialog) then
  begin
    FFindDialog := TTMSFNCFindDialog.Create(nil);
    FFindDialog.Options := [fdoCaseSensitive, fdoNextEnabled, fdoFindEnabled,
      fdoCloseEnabled, fdoDown];
    FFindDialog.VisibleOptions := [fdovCaseSensitive, fdovExpression, fdovCloseIfFound,
    fdovWholeWordOnly, fdovNext, fdovFind,
       fdovClose, fdovFindCombo, fdovFindMemo, fdovDirection];
    FFindDialog.OnFind := DoFind;
    FFindDialog.OnFindNext := DoFindNext;
  end;

  Result := FFindDialog;
end;

function TTMSFNCDataGridRenderer.GetFocusedCell: TTMSFNCDataGridCellCoord;
begin
  Result := FFocusedCell;
end;

function TTMSFNCDataGridRenderer.GetFontColors(AColumn, ARow: Integer): TTMSFNCGraphicsColor;
var
  l: TTMSFNCDataGridCellLayout;
begin
  Result := gcNull;
  l := GetCellAppearance(GetCellState(MakeCell(AColumn, ARow)), MakeCell(AColumn, ARow));
  if Assigned(l) then
    Result := l.Font.Color;
end;

function TTMSFNCDataGridRenderer.GetFontNames(AColumn, ARow: Integer): string;
var
  l: TTMSFNCDataGridCellLayout;
begin
  Result := '';
  l := GetCellAppearance(GetCellState(MakeCell(AColumn, ARow)), MakeCell(AColumn, ARow));
  if Assigned(l) then
    Result := l.Font.Name;
end;

function TTMSFNCDataGridRenderer.GetFontSizes(AColumn, ARow: Integer): Single;
var
  l: TTMSFNCDataGridCellLayout;
begin
  Result := 0;
  l := GetCellAppearance(GetCellState(MakeCell(AColumn, ARow)), MakeCell(AColumn, ARow));
  if Assigned(l) then
    Result := l.Font.Size;
end;

function TTMSFNCDataGridRenderer.GetFontStyles(AColumn, ARow: Integer): TFontStyles;
var
  l: TTMSFNCDataGridCellLayout;
begin
  Result := [];
  l := GetCellAppearance(GetCellState(MakeCell(AColumn, ARow)), MakeCell(AColumn, ARow));
  if Assigned(l) then
    Result := l.Font.Style;
end;

function TTMSFNCDataGridRenderer.GetFullRect: TRectF;
begin
  Result := inherited GetContentRect;

  if not IsExporting then
  begin
    if HasCustomScrollBars then
    begin
      if Assigned(CustomHorizontalScrollBar) and CustomHorizontalScrollBar.Visible then
        Result.Bottom := CustomHorizontalScrollBar.Top + CustomHorizontalScrollBar.Height;

      if Assigned(CustomVerticalScrollBar) and CustomVerticalScrollBar.Visible then
        Result.Right := CustomVerticalScrollBar.Left + CustomVerticalScrollBar.Width;
    end
    else
    begin
      if Assigned(HorizontalScrollBar) and HorizontalScrollBar.Visible then
      begin
        {$IFDEF FMXLIB}
        Result.Bottom := HorizontalScrollBar.Position.Y;
        {$ELSE}
        Result.Bottom := HorizontalScrollBar.Top;
        {$ENDIF}

        Result.Bottom := Result.Bottom + HorizontalScrollBar.Height;
      end;

      if Assigned(VerticalScrollBar) and VerticalScrollBar.Visible then
      begin
        {$IFDEF FMXLIB}
        Result.Right := VerticalScrollBar.Position.X;
        {$ELSE}
        Result.Right := VerticalScrollBar.Left;
        {$ENDIF}

        Result.Right := Result.Right + VerticalScrollBar.Width;
      end;
    end;
  end;
end;

function TTMSFNCDataGridRenderer.GetGrids(AColumn,
  ARow: Integer): TTMSFNCDataGridRenderer;
var
  cd: TTMSFNCDataGridCellItem;
  o: TObject;
begin
  Result := nil;
  cd := CellData[AColumn, ARow];
  if Assigned(cd) and IsExtendedCell(cd) then
  begin
    o := TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(cd)).Renderer;
    if Assigned(o) and (o is TTMSFNCDataGridRenderer) then
      Result := (o as TTMSFNCDataGridRenderer);
  end;

  if not Assigned(Result) then
    raise Exception.Create(sTMSFNCDataGridNotAvailableError);
end;

procedure TTMSFNCDataGridRenderer.ConfigureLayout(ACell: TTMSFNCDataGridCellCoord; ALayout: TTMSFNCDataGridCellLayout; ASkipCellLayout: Boolean = False);
begin
  ALayout.Assign(GetCellAppearance(GetCellState(ACell), ACell, ASkipCellLayout))
end;

function TTMSFNCDataGridRenderer.ConfigureScrollBarsRect(ARect: TRectF): TRectF;
begin
  Result := ARect;

  if not IsExporting then
  begin
    if HasCustomScrollBars then
    begin
      if Assigned(CustomHorizontalScrollBar) and CustomHorizontalScrollBar.Visible then
        Result.Bottom := CustomHorizontalScrollBar.Top;

      if Assigned(CustomVerticalScrollBar) and CustomVerticalScrollBar.Visible then
        Result.Right := CustomVerticalScrollBar.Left;
    end
    else
    begin
      if Assigned(HorizontalScrollBar) and HorizontalScrollBar.Visible then
      begin
        {$IFDEF FMXLIB}
        Result.Bottom := HorizontalScrollBar.Position.Y;
        {$ELSE}
        Result.Bottom := HorizontalScrollBar.Top;
        {$ENDIF}
      end;

      if Assigned(VerticalScrollBar) and VerticalScrollBar.Visible then
      begin
        {$IFDEF FMXLIB}
        Result.Right := VerticalScrollBar.Position.X;
        {$ELSE}
        Result.Right := VerticalScrollBar.Left;
        {$ENDIF}
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetLayout(ACell: TTMSFNCDataGridCell);
begin
  if Assigned(ACell) then
    ConfigureLayout(ACell.Coordinate, ACell.Layout, False);
end;

procedure TTMSFNCDataGridRenderer.SetOptions(
  const Value: TTMSFNCDataGridOptions);
begin
  Options.Assign(Value);
end;

procedure TTMSFNCDataGridRenderer.SetCustomScrollBars(const Value: Boolean);
begin
  if FCustomScrollBars <> Value then
  begin
    FCustomScrollBars := Value;
    Update;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetTextAligns(AColumn, ARow: Integer;
  const Value: TTMSFNCGraphicsTextAlign);
var
  l: TTMSFNCDataGridCellLayout;
begin
  l := Layouts[AColumn, ARow];
  if Assigned(l) then
    l.TextAlign := Value;
end;

procedure TTMSFNCDataGridRenderer.SetHorizontalScrollBarVisible(
  const Value: Boolean);
begin
  if FHorizontalScrollBarVisible <> Value then
  begin
    FHorizontalScrollBarVisible := Value;
    Update;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetHScrollValue(AValue: Single);
begin
  FLocalHScrollValue := AValue;

  if HasCustomScrollBars and Assigned(CustomHorizontalScrollBar) then
  begin
    if CustomHorizontalScrollBar.PageSize > 0 then
      CustomHorizontalScrollBar.Value := Min(CustomHorizontalScrollBar.Max - CustomHorizontalScrollBar.PageSize, Max(0, AValue));
  end
  else if Assigned(HorizontalScrollBar) then
  begin
    {$IFDEF FMXLIB}
    if HorizontalScrollBar.ViewportSize > 0 then
      HorizontalScrollBar.Value := Min(HorizontalScrollBar.Max - HorizontalScrollBar.ViewportSize, Max(0, AValue));
    {$ENDIF}
    {$IFDEF VCLLIB}
    if HorizontalScrollBar.PageSize > 0 then
      HorizontalScrollBar.Position := Min(HorizontalScrollBar.Max - HorizontalScrollBar.PageSize, Max(0, Round(AValue)));
    {$ENDIF}
    {$IFDEF WEBLIB}
    if HorizontalScrollBar.PageSize > 0 then
      HorizontalScrollBar.Position := Round(Min(HorizontalScrollBar.Max - HorizontalScrollBar.PageSize, Max(0, AValue)));
    {$ENDIF}
  end;
end;

procedure TTMSFNCDataGridRenderer.SetScrollMode(
  const Value: TTMSFNCDataGridScrollMode);
begin
  if FScrollMode <> Value then
  begin
    FScrollMode := Value;
    if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
      (Adapter as TTMSFNCDataGridRendererDataAdapter).UpdateScrollMode;
    Update;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetScrollUpdate(
  const Value: TTMSFNCDataGridScrollUpdate);
begin
  if FScrollUpdate <> Value then
  begin
    FScrollUpdate := Value;
    if Assigned(FCustomVerticalScrollBar) then
      FCustomVerticalScrollBar.Tracking := ScrollUpdate = gsuContinuous;

    if Assigned(FCustomHorizontalScrollBar) then
      FCustomHorizontalScrollBar.Tracking := ScrollUpdate = gsuContinuous;

    Update;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetStretchScrollBars(const Value: Boolean);
begin
  if FStretchScrollBars <> Value then
  begin
    FStretchScrollBars := Value;
    Update;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetVerticalTextAligns(AColumn, ARow: Integer;
  const Value: TTMSFNCGraphicsTextAlign);
var
  l: TTMSFNCDataGridCellLayout;
begin
  l := Layouts[AColumn, ARow];
  if Assigned(l) then
    l.VerticalTextAlign := Value;
end;

procedure TTMSFNCDataGridRenderer.SetVerticalScrollBarVisible(
  const Value: Boolean);
begin
  if FVerticalScrollBarVisible <> Value then
  begin
    FVerticalScrollBarVisible := Value;
    Update;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetReadOnlys(AColumn, ARow: Integer;
  const Value: Boolean);
var
  cd: TTMSFNCDataGridCellItemExtended;
begin
  if not IsCellValid(AColumn, ARow) then
    Exit;

  cd := CellDataExtended[AColumn, ARow];
  if Assigned(cd) then
  begin
    cd.ReadOnly := Value;
    DoUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetRowIndex(ARow: Integer;
  const Value: Integer);
var
  ri: TTMSFNCDataGridRowItem;
begin
  if not IsRowValid(ARow) then
    Exit;

  ri := GetRowData(ARow);
  if Assigned(ri) then
    ri.&Index := Value;
end;

procedure TTMSFNCDataGridRenderer.SetVScrollValue(AValue: Single);
begin
  FLocalVScrollValue := AValue;

  if HasCustomScrollBars and Assigned(CustomVerticalScrollBar) then
  begin
    if CustomVerticalScrollBar.PageSize > 0 then
      CustomVerticalScrollBar.Value := Min(CustomVerticalScrollBar.Max - CustomVerticalScrollBar.PageSize, Max(0, AValue));
  end
  else if Assigned(VerticalScrollBar) then
  begin
    {$IFDEF FMXLIB}
    if VerticalScrollBar.ViewportSize > 0 then
      VerticalScrollBar.Value := Min(VerticalScrollBar.Max - VerticalScrollBar.ViewportSize, Max(0, AValue));
    {$ENDIF}
    {$IFDEF VCLLIB}
    if VerticalScrollBar.PageSize > 0 then
      VerticalScrollBar.Position := Min(VerticalScrollBar.Max - VerticalScrollBar.PageSize, Max(0, Round(AValue)));
    {$ENDIF}
    {$IFDEF WEBLIB}
    if VerticalScrollBar.PageSize > 0 then
      VerticalScrollBar.Position := Round(Min(VerticalScrollBar.Max - VerticalScrollBar.PageSize, Max(0, AValue)));
    {$ENDIF}
  end;
end;

procedure TTMSFNCDataGridRenderer.SetWordWrapping(AColumn, ARow: Integer;
  const Value: Boolean);
var
  l: TTMSFNCDataGridCellLayout;
begin
  l := Layouts[AColumn, ARow];
  if Assigned(l) then
    l.WordWrapping := Value;
end;

procedure TTMSFNCDataGridRenderer.ShowColumnsEditor;
var
  o: TObject;
begin
  o := ColumnsEditor;
  if Assigned(o) and (o is TTMSFNCDataGridColumnsEditor) then
    (o as TTMSFNCDataGridColumnsEditor).Execute({$IFDEF WEBLIB}nil,{$ENDIF}False);
end;

procedure TTMSFNCDataGridRenderer.ShowFilterDialog;
var
  a: Boolean;
  f: TTMSFNCFilterDialog;
begin
  if not Options.Filtering.Advanced then
    raise Exception.Create(sTMSFNCDataGridAdvancedFilteringError);

  a := True;
  f := FilterDialog;
  if Assigned(f) then
  begin
    DoBeforeShowFilterDialog(f, a);
    if a then
    begin
      UpdateFilterBuilderColumns;
      f.Execute({$IFDEF WEBLIB}nil, {$ENDIF}False);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.ShowFindDialog;
var
  a: Boolean;
  f: TTMSFNCFindDialog;
begin
  a := True;
  f := FindDialog;
  if Assigned(f) then
  begin
    DoBeforeShowFindDialog(f, a);
    if a then
    begin
      f.Execute;
      DoAfterShowFindDialog(f);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.ShowReplaceDialog;
var
  a: Boolean;
  r: TTMSFNCReplaceDialog;
begin
  a := True;
  r := ReplaceDialog;
  if Assigned(r) then
  begin
    DoBeforeShowReplaceDialog(r, a);
    if a then
    begin
      r.Execute;
      DoAfterShowReplaceDialog(r);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.StopAnimationTimer;
begin
  AnimateTimer.Enabled := False;
  FAnimating := False;
end;

function TTMSFNCDataGridRenderer.StopEditing: Boolean;
begin
  Result := True;
  if FInplaceEditorActive then
    Result := CloseInplaceEditor(False);
end;

procedure TTMSFNCDataGridRenderer.SwapColumnData(AFromColumn,
  AToColumn: Integer);
var
  sc, sct: Boolean;
  R: Integer;
  cFrom, cTo: TTMSFNCDataGridColumn;
begin
  inherited;
  sc := SelectedColumns[AFromColumn];
  sct := SelectedColumns[AToColumn];

  SelectedColumns[AFromColumn] := sct;
  SelectedColumns[AToColumn] := sc;

  if SelectedCellDictionary.Count > 0 then
  begin
    for R := 0 to RowCount - 1 do
    begin
      sc := SelectedCells[AFromColumn, R];
      sct := SelectedCells[AToColumn, R];
      SelectedCells[AFromColumn, R] := sct;
      SelectedCells[AToColumn, R] := sc;
    end;
  end;

  if FFocusedCell.Column = AFromColumn then
    FFocusedCell.Column := AToColumn
  else if FFocusedCell.Column = AToColumn then
    FFocusedCell.Column := AFromColumn;

  SynchronizeColumns;
  if (AFromColumn >= 0) and (AFromColumn <= Columns.Count - 1) and
    (AToColumn >= 0) and (AToColumn <= Columns.Count - 1) then
  begin
    cFrom := TTMSFNCDataGridColumn.Create(nil);
    cTo := TTMSFNCDataGridColumn.Create(nil);
    try
      cFrom.Assign(Columns[AFromColumn]);
      cTo.Assign(Columns[AToColumn]);

      Columns[AFromColumn].Assign(cTo);
      Columns[AToColumn].Assign(cFrom);
    finally
      cTo.Free;
      cFrom.Free;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.SwapRowData(AFromRow, AToRow: Integer);
var
  sr, srt: Boolean;
  C: Integer;
begin
  inherited;
  sr := SelectedRows[AFromRow];
  srt := SelectedRows[AToRow];

  SelectedRows[AFromRow] := srt;
  SelectedRows[AToRow] := sr;

  if SelectedCellDictionary.Count > 0 then
  begin
    for C := 0 to ColumnCount - 1 do
    begin
      sr := SelectedCells[C, AFromRow];
      srt := SelectedCells[C, AToRow];
      SelectedCells[C, AFromRow] := srt;
      SelectedCells[C, AToRow] := sr;
    end;
  end;

  if FFocusedCell.Row = AFromRow then
    FFocusedCell.Row := AToRow
  else if FFocusedCell.Row = AToRow then
    FFocusedCell.Row := AFromRow;
end;

procedure TTMSFNCDataGridRenderer.SynchronizeColumns(ACollectionUpdate: Boolean = False);
begin
  if GetIsDestroying or FBlockSynchronizeColumns then
    Exit;

  FBlockSynchronizeColumns := True;
  IncUpdateCount;
  if ACollectionUpdate then
    ColumnCount := Columns.Count
  else
  begin
    while Columns.Count > ColumnCount do
      Columns.Delete(Columns.Count - 1);

    while Columns.Count < ColumnCount do
      Columns.Add;
  end;

  DecUpdateCount;
  FBlockSynchronizeColumns := False;

  inherited;
end;

procedure TTMSFNCDataGridRenderer.SetProperties(ACell: TTMSFNCDataGridCell);
var
  idx: TTMSFNCDataGridSortIndex;
  c: string;
  w, h: Integer;
  t: string;
  ctx: TRttiContext;
  rt: TRttiType;
  prop: TRttiProperty;
  val: TValue;
  fe, rf: Boolean;
  rs: TTMSFNCDataGridRowNodestate;
  cl: TTMSFNCDataGridColumn;
  ci: TTMSFNCDataGridCellItem;
  eci: TTMSFNCDataGridCellItemExtended;
  ctl: TTMSFNCDataGridCellControl;
  ctla: TTMSFNCDataGridCellControlAlign;
  ctlp: TTMSFNCDataGridCellControlPosition;
  ctlm: TTMSFNCMargins;
  ctlw, ctlh: Integer;
  cf, ctltxt: string;
  hf: Boolean;
begin
  if not Assigned(ACell) then
    Exit;

  ci := ACell.Data;
  cl := GetColumn(ACell.Column);

  eci := nil;
  ctl := nil;

  if IsExtendedCell(ci) then
  begin
    eci := AsExtendedCell(ci);
    ctl := eci.Control;
  end;

  ctla := gcaNone;
  if Assigned(cl) and (gcsControlAlign in cl.Settings) then
    ctla := cl.ControlAlign
  else if Assigned(eci) then
    ctla := eci.ControlAlign;

  ctlp := gcpCenterRight;
  if Assigned(cl) and (gcsControlPosition in cl.Settings) then
    ctlp := cl.ControlPosition
  else if Assigned(eci) then
    ctlp := eci.ControlPosition;

  ctlm := nil;
  if Assigned(cl) and (gcsControlMargins in cl.Settings) then
    ctlm := cl.ControlMargins
  else if Assigned(eci) then
    ctlm := eci.ControlMargins;

  ctlw := -1;
  if Assigned(cl) and (gcsControlWidth in cl.Settings) then
    ctlw := cl.ControlWidth
  else if Assigned(eci) then
    ctlw := eci.ControlWidth;

  ctlh := -1;
  if Assigned(cl) and (gcsControlHeight in cl.Settings) then
    ctlh := cl.ControlHeight
  else if Assigned(eci) then
    ctlh := eci.ControlHeight;

  ctltxt := '';
  if Assigned(cl) and (gcsControlText in cl.Settings) then
    ctltxt := cl.ControlText
  else if Assigned(eci) then
    ctltxt := eci.ControlText;

  fe := False;
  rf := False;

  if Options.Filtering.Enabled and (ACell.Row = Options.Filtering.Row) and (ACell.Column >= FixedColumnCount)
    and (ACell.Column <= ColumnCount - FixedRightColumnCount - 1) then
  begin
    if Assigned(cl) and (gcsFilterButton in cl.Settings) then
      ACell.FilterButton := cl.FilterButton
    else
      ACell.FilterButton := gfcButton in Options.Filtering.Controls;

    if not Assigned(ctl) and not Options.Filtering.Advanced then
    begin
      if Assigned(cl) and (gcsFilterEditor in cl.Settings) then
        fe := cl.FilterEditor
      else
        fe := gfcEditor in Options.Filtering.Controls;
    end;

    rf := True;
  end;

  if not fe and not rf and not Options.Filtering.Advanced then
    fe := HasFilterEditor[ACell.Column, ACell.Row];

  if fe then
  begin
    ctl := FilterEditors[ACell.Column, ACell.Row];
    if Assigned(ctl) then
      ctla := gcaClient;
  end;

  ACell.BitmapContainer := BitmapContainer;

  if ACell is TTMSFNCDataGridBitmapCell then
  begin
    (ACell as TTMSFNCDataGridBitmapCell).Bitmap.Assign(Bitmaps[ACell.Column, ACell.Row]);
    (ACell as TTMSFNCDataGridBitmapCell).BitmapName := BitmapNames[ACell.Column, ACell.Row];
  end;

  ACell.Control := ctl;
  ACell.ControlAlign := ctla;
  ACell.ControlPosition := ctlp;
  ACell.ControlMargins.Assign(ctlm);

  c := '';
  if Assigned(eci) then
    c := eci.Comment;

  ACell.CommentIndicator := c <> '';
  ACell.Comment := c;

  if Assigned(ACell.Control) then
  begin
    w := ctlw;
    h := ctlh;
    t := ctltxt;

    if w <> -1 then
      ACell.Control.Width := w;

    if h <> -1 then
      ACell.Control.Height := h;

    if t <> '' then
    begin
      ctx := TRttiContext.Create;
      try
        rt := ctx.GetType(ACell.Control.ClassInfo);
        {$IFDEF FMXLIB}
        prop := rt.GetProperty('Text');
        {$ELSE}
        prop := rt.GetProperty('Caption');
        {$ENDIf}
        if Assigned(Prop) and Prop.IsWritable then
        begin
          val := CellValuetoTValue(t);
          prop.SetValue(ACell.Control, val);
        end;
      finally
        ctx.Free;
      end;
    end;
  end;

  if Options.Filtering.Advanced then
  begin
    cf := StringReplace(FilterBuilder.ParseFormat.ColumnFormat, '#COLUMN', GetColumnDataName(ACell.Column), [rfReplaceAll]);
    hf := Pos(cf, FilterBuilder.FilterText) > 0;
  end
  else
    hf := Filter.HasFilter(ACell.Column);

  if hf then
    TTMSFNCDataGridCellOpen(ACell).FilterIcon := Icons.FilterActiveIcon
  else
    TTMSFNCDataGridCellOpen(ACell).FilterIcon := Icons.FilterIcon;

  TTMSFNCDataGridCellOpen(ACell).SortDescendingIcon := Icons.SortDescendingIcon;
  TTMSFNCDataGridCellOpen(ACell).SortAscendingIcon := Icons.SortAscendingIcon;

  TTMSFNCDataGridCellOpen(ACell).OnFilterButtonClick := DoCellFilterButtonClick;
  TTMSFNCDataGridCellOpen(ACell).OnCommentIndicatorClick := DoCellCommentIndicatorClick;
  TTMSFNCDataGridCellOpen(ACell).OnBeforeDraw := DoCellBeforeDraw;
  TTMSFNCDataGridCellOpen(ACell).OnAfterDraw := DoCellAfterDraw;

  if Options.Sorting.Enabled and (SortIndexList.Count > 0) and (ACell.Row = Options.Sorting.Row) then
  begin
    idx := nil;
    if SortIndexList.Find(ACell.Column, idx) then
    begin
      case idx.Direction of
        gsdAscending: ACell.SortIndicator := gsiAscending;
        gsdDescending: ACell.SortIndicator := gsiDescending;
      end;
    end;
  end;

  if ACell is TTMSFNCDataGridNodeCell then
  begin
    rs := RowNodeState[ACell.Row];
    (ACell as TTMSFNCDataGridNodeCell).State := rs;

    TTMSFNCDataGridNodeCellOpen(ACell as TTMSFNCDataGridNodeCell).CollapseIcon := Icons.CollapseIcon;
    TTMSFNCDataGridNodeCellOpen(ACell as TTMSFNCDataGridNodeCell).ExpandIcon := Icons.ExpandIcon;

    (ACell as TTMSFNCDataGridNodeCell).OnCollapse := DoCellNodeCollapse;
    (ACell as TTMSFNCDataGridNodeCell).OnExpand := DoCellNodeExpand;
  end
  else if ACell is TTMSFNCDataGridCheckedCell then
  begin
    (ACell as TTMSFNCDataGridCheckedCell).Checked := Booleans[ACell.Column, ACell.Row];
    (ACell as TTMSFNCDataGridCheckedCell).OnChange := @DoCellCheckChange;
  end
  else if ACell is TTMSFNCDataGridProgressBarCell then
    (ACell as TTMSFNCDataGridProgressBarCell).Value := ProgressValue[ACell.Column, ACell.Row]
  else if ACell is TTMSFNCDataGridButtonCell then
    (ACell as TTMSFNCDataGridButtonCell).OnClick := DoCellButtonClick;
end;

procedure TTMSFNCDataGridRenderer.UnhilightCells(
  AOptions: TTMSFNCDataGridHilightOptions);
begin
  case AOptions.Mode of
    ghmCell: InternalUnmarkCells('hi', AOptions.Column, AOptions.Row, AOptions.Column, AOptions.Row);
    ghmColumn:
    begin
      if AOptions.IncludeFixed then
        InternalUnmarkCells('hi', AOptions.Column, 0, AOptions.Column, RowCount - 1)
      else
        InternalUnmarkCells('hi', AOptions.Column, FixedRowCount, AOptions.Column, RowCount - 1 - FixedBottomRowCount);
    end;
    ghmRow:
    begin
      if AOptions.IncludeFixed then
        InternalUnmarkCells('hi', 0, AOptions.Row, ColumnCount - 1, AOptions.Row)
      else
        InternalUnmarkCells('hi', FixedColumnCount, AOptions.Row, ColumnCount - 1 - FixedRightColumnCount, AOptions.Row);
    end;
    ghmGrid:
    begin
      if AOptions.IncludeFixed then
        InternalUnmarkCells('hi', 0, 0, ColumnCount - 1, RowCount - 1)
      else
        InternalUnmarkCells('hi', FixedColumnCount, FixedRowCount, ColumnCount - 1 - FixedRightColumnCount, RowCount - 1 - FixedBottomRowCount);
    end;
  end;
end;

function TTMSFNCDataGridRenderer.UnhilightText(ACaseSensitive: Boolean;
  AValue: string): string;
begin
  Result := Unhilight(AValue, 'hi');
end;

procedure TTMSFNCDataGridRenderer.UnmarkCells(
  AOptions: TTMSFNCDataGridMarkOptions);
begin
  case AOptions.Mode of
    ghmCell: InternalUnmarkCells('e', AOptions.Column, AOptions.Row, AOptions.Column, AOptions.Row);
    ghmColumn:
    begin
      if AOptions.IncludeFixed then
        InternalUnmarkCells('e', AOptions.Column, 0, AOptions.Column, RowCount - 1)
      else
        InternalUnmarkCells('e', AOptions.Column, FixedRowCount, AOptions.Column, RowCount - 1 - FixedBottomRowCount);
    end;
    ghmRow:
    begin
      if AOptions.IncludeFixed then
        InternalUnmarkCells('e', 0, AOptions.Row, ColumnCount - 1, AOptions.Row)
      else
        InternalUnmarkCells('e', FixedColumnCount, AOptions.Row, ColumnCount - 1 - FixedRightColumnCount, AOptions.Row);
    end;
    ghmGrid:
    begin
      if AOptions.IncludeFixed then
        InternalUnmarkCells('e', 0, 0, ColumnCount - 1, RowCount - 1)
      else
        InternalUnmarkCells('e', FixedColumnCount, FixedRowCount, ColumnCount - 1 - FixedRightColumnCount, RowCount - 1 - FixedBottomRowCount);
    end;
  end;
end;

function TTMSFNCDataGridRenderer.UnmarkText(AValue: string): string;
begin
  Result := Unhilight(AValue, 'e');
end;

procedure TTMSFNCDataGridRenderer.Update;
begin
  if Assigned(OnBeforeCalculate) then
    OnBeforeCalculate(Self);

  UpdateScrollBars;
  inherited;
  UpdateVisualRange;
  UpdateBounds;
  Calculate;

  if Assigned(OnCalculate) then
    OnCalculate(Self);
end;

procedure TTMSFNCDataGridRenderer.UpdateAutoSizing;
begin
  if Assigned(FHost) and (FHost is TComponent) then
  begin
    if (csReading in (FHost as TComponent).ComponentState) then
      Exit;
  end;

  if Options.Column.Stretching.Enabled then
  begin
    FColumnStretchingActive := StretchColumns(Options.Column.Stretching.Mode, Options.Column.Stretching.Range, Options.Column.Stretching.&Index);
    FColumnStretchingApplied := True;
  end
  else if FColumnStretchingApplied then
  begin
    FColumnStretchingActive := False;
    FColumnStretchingApplied := False;
    ResetColumnWidths;
  end;

  if Options.Row.Stretching.Enabled then
  begin
    FRowStretchingActive := StretchRows(Options.Row.Stretching.Mode, Options.Row.Stretching.Range, Options.Row.Stretching.&Index);
    FRowStretchingApplied := True;
  end
  else if FRowStretchingApplied then
  begin
    FRowStretchingActive := False;
    FRowStretchingApplied := False;
    ResetRowHeights;
  end;
end;

procedure TTMSFNCDataGridRenderer.UpdateBounds;
begin
  if (UpdateCount > 0) or GetIsDestroying then
    Exit;

  if FLocalRectChanged and not IsBlocked then
  begin
    if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
      (Adapter as TTMSFNCDataGridRendererDataAdapter).UpdateBounds;

    FLocalRectChanged := False;
  end;
end;

procedure TTMSFNCDataGridRenderer.UpdateCursor(ACursor: TCursor);
begin
  if Assigned(OnUpdateCursor) then
    OnUpdateCursor(Self, ACursor);
end;

procedure TTMSFNCDataGridRenderer.UpdateFilterList(AColumn: Integer);
var
  sl, fsl: TStringList;
  s, sc, fs, sf: string;
  k, i: Integer;
  it: TTMSFNCListBoxItem;
  f: TTMSFNCDataGridDataFilterData;
  fdt: TTMSFNCDataGridDataFilterType;
  cl: TTMSFNCDataGridColumn;
  c: Integer;
  b, a, an: Boolean;
  obj: TObject;
  e: TTMSFNCDataGridCellControl;
begin
  if Options.Filtering.Advanced then
    Exit;

  sl := TStringList.Create;
  try
    sl.Duplicates := dupIgnore;
    sl.Sorted := True;
    sl.Add(Options.Localization.FilterAllText);

    c := AColumn;
    if Filter.Count > 0 then
      c := Filter[0].Column;

    a := True;
    if Assigned(Adapter) and (Adapter is TTMSFNCDataGridRendererDataAdapter) then
    begin
      case (Adapter as TTMSFNCDataGridRendererDataAdapter).FilterMode of
        afmNone: Exit;
        afmAdapter:
        begin
          (Adapter as TTMSFNCDataGridRendererDataAdapter).GetFilterData(AColumn, sl);
          a := False;
        end;
      end;
    end;

    an := False;

    if a then
    begin
      for i := FixedRowCount to RowCount - FixedBottomRowCount - 1 do
      begin
        if IsRowNormal(i) and ((Options.Filtering.MultiColumn and ((not IsRowFilteredDisplay(i) and (c <> AColumn)) or (c = AColumn))) or not Options.Filtering.MultiColumn) then
        begin
          sf := Trim(Strings[AColumn, i]);
          if sf <> '' then
            sl.AddObject(sf, Filter.CommonDoubleQuotedItem)
          else
            an := True;
        end;
      end;
    end;

    if an then
    begin
      sl.AddObject(Options.Localization.FilterEmptyText, Filter.CommonItem);
      sl.AddObject(Options.Localization.FilterNotEmptyText, Filter.CommonItem);
    end;

    DoNeedFilterDropDownData(AColumn, sl);

    FLoadFilter := True;

    FilterListBox.BeginUpdate;
    try
      if not FStyleApplied then
      begin
        FilterListBox.Fill.Assign(FilterAppearance.Fill);
        FilterListBox.Stroke.Assign(FilterAppearance.Stroke);
        FilterListBox.DefaultItem.TextColor := FilterAppearance.Font.Color;
        FilterListBox.ItemsAppearance.Font.Assign(FilterAppearance.Font);
      end;

      FilterListBox.Items.Clear;
      for I := 0 to sl.Count - 1 do
      begin
        it := FilterListBox.Items.Add;
        it.Text := sl[I];
        it.DataObject := sl.Objects[I];
      end;

      FilterListBox.ItemIndex := -1;
      FilterListBox.Tag := AColumn;
      FilterListBox.CheckAll;

      fdt := gftEqual;
      cl := GetColumn(AColumn);
      if Assigned(cl) and (gcsFilterDefaultType in cl.Settings) then
        fdt := cl.FilterDefaultType;

      {$IFDEF FMXLIB}
      FilterEdit.Text := '';
      FilterTypeComboBox.SafeItemIndex := Integer(fdt);
      {$ELSE}
      FilterTypeComboBox.SafeItemIndex := Integer(fdt);
      FilterEdit.Text := '';
      {$ENDIF}

      e := nil;
      if HasFilterEditor[AColumn, Options.Filtering.Row] then
      begin
        e := FilterEditors[AColumn, Options.Filtering.Row];
        if Assigned(e) and (e is TTMSFNCDataGridFilterPanel) then
          (e as TTMSFNCDataGridFilterPanel).Reset;
      end;

      if not FStyleApplied then
      begin
        {$IFDEF FMXLIB}
        FilterEdit.StyledSettings := FilterEdit.StyledSettings - [TStyledSetting.FontColor];
        FilterEdit.FontColor := FilterAppearance.Font.Color;
        FilterEdit.OnApplyStyleLookup := DoFilterEditApplyStyleLookup;
        {$ENDIF}
        {$IFNDEF FMXLIB}
        FilterEdit.Color := FilterAppearance.Fill.Color;
        FilterEdit.Font.Color := FilterAppearance.Font.Color;
        {$ENDIF}
      end;

      if Filter.HasFilter(AColumn) then
      begin
        f := Filter.ColumnFilter[AColumn];
        FilterEdit.Text := f.Condition;
        FilterTypeComboBox.SafeItemIndex := Integer(f.&Type);

        if Assigned(e) and (e is TTMSFNCDataGridFilterPanel) then
          (e as TTMSFNCDataGridFilterPanel).SetFilter(f);

        fsl := TStringList.Create;
        try
          fsl.QuoteChar := '''';
          TTMSFNCUtils.Split('|', f.Condition, fsl);
          b := False;

          for I := 0 to FilterListBox.Items.Count - 1 do
          begin
            s := FilterListBox.Items[I].Text;
            FilterListBox.Checked[I] := False;

            if s = Options.Localization.FilterAllText then
              Continue;

            case f.&Type of
              gftEmpty:
                FilterListBox.Checked[I] := (s = Options.Localization.FilterEmptyText);

              gftNotEmpty:
                FilterListBox.Checked[I] := (s = Options.Localization.FilterNotEmptyText);

              gftEqual:
              begin
                for K := 0 to fsl.Count - 1 do
                begin
                  fs := Trim(fsl[K]);
                  obj := FilterListBox.Items[I].DataObject;

                  if (s = Options.Localization.FilterEmptyText) and (fs = '""') then
                  begin
                    FilterListBox.Checked[I] := True;
                    Break;
                  end;

                  if Assigned(obj) and (obj is TTMSFNCDataGridDataFilterItem) and (obj as TTMSFNCDataGridDataFilterItem).DoubleQuotes then
                    sc := '"' + s + '"'
                  else
                    sc := s;

                  if fs = sc then
                  begin
                    FilterListBox.Checked[I] := True;
                    Break;
                  end;
                end;
              end;
            end;

            if not FilterListBox.Checked[I] then
              b := True;
          end;

          for I := 0 to FilterListBox.Items.Count - 1 do
          begin
            if FilterListBox.Items[I].Text = Options.Localization.FilterAllText then
            begin
              FilterListBox.Checked[I] := not b;
              Break;
            end;
          end;
        finally
          fsl.Free;
        end;
      end;

    finally
      FilterListBox.EndUpdate;
    end;
  finally
    sl.Free;
  end;

  FLoadFilter := False;
end;

procedure TTMSFNCDataGridRenderer.DoFilterListBoxItemCheckChanged(
  Sender: TObject; AItem: TTMSFNCCheckedListBoxItem);
var
  I: Integer;
  cl: TTMSFNCCheckedListBox;
  ItemAll, ItemEmpty, ItemNotEmpty: TTMSFNCCheckedListBoxItem;
  IsAllChecked: Boolean;
begin
  if not (Sender is TTMSFNCCheckedListBox) then
    Exit;

  cl := TTMSFNCCheckedListBox(Sender);

  ItemAll := nil;
  ItemEmpty := nil;
  ItemNotEmpty := nil;

  for I := 0 to cl.Items.Count - 1 do
  begin
    if cl.Items[I].Text = Options.Localization.FilterAllText then
      ItemAll := cl.Items[I] as TTMSFNCCheckedListBoxItem
    else if cl.Items[I].Text = Options.Localization.FilterEmptyText then
      ItemEmpty := cl.Items[I] as TTMSFNCCheckedListBoxItem
    else if cl.Items[I].Text = Options.Localization.FilterNotEmptyText then
      ItemNotEmpty := cl.Items[I] as TTMSFNCCheckedListBoxItem;
  end;

  if AItem = ItemAll then
  begin
    if ItemAll.Checked then
      cl.CheckAll
    else
      cl.UncheckAll;
  end
  else if AItem = ItemEmpty then
  begin
    if ItemEmpty.Checked then
    begin
      if Assigned(ItemAll) then
        ItemAll.Checked := False;
      if Assigned(ItemNotEmpty) then
        ItemNotEmpty.Checked := False;
    end
    else
    begin
      if Assigned(ItemNotEmpty) and ItemNotEmpty.Checked then
      begin
        if Assigned(ItemAll) then
          ItemAll.Checked := False;

        for I := 0 to cl.Items.Count - 1 do
          if cl.Items[I] <> ItemNotEmpty then
            cl.Items[I].Checked := False;
      end;
    end;
  end
  else if AItem = ItemNotEmpty then
  begin
    if ItemNotEmpty.Checked then
    begin
      if Assigned(ItemEmpty) then
        ItemEmpty.Checked := False;
      if Assigned(ItemAll) then
        ItemAll.Checked := False;

      for I := 0 to cl.Items.Count - 1 do
        if cl.Items[I] <> ItemNotEmpty then
          cl.Items[I].Checked := False;
    end;
  end
  else
  begin
    if AItem.Checked then
    begin
      if Assigned(ItemAll) then
        ItemAll.Checked := False;
      if Assigned(ItemNotEmpty) then
        ItemNotEmpty.Checked := False;
    end
    else
    begin
      if Assigned(ItemNotEmpty) and ItemNotEmpty.Checked then
        ItemNotEmpty.Checked := False;
    end;
  end;

  if Assigned(ItemAll) then
  begin
    IsAllChecked := True;
    for I := 0 to cl.Items.Count - 1 do
    begin
      if cl.Items[I] = ItemAll then
        Continue;
      if not cl.Items[I].Checked then
      begin
        IsAllChecked := False;
        Break;
      end;
    end;

    if ItemAll.Checked <> IsAllChecked then
      ItemAll.Checked := IsAllChecked;
  end;

  FFilterEditMode := gfemList;
  FFilterTime := 0;
  FilterTimer.Enabled := True;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCDataGridRenderer.DoFilterEditApplyStyleLookup(Sender: TObject);
var
  r: TRectangle;
  b: TFmxObject;
begin
  if FStyleApplied then
    Exit;
  b := (Sender as TFmxObject).FindStyleResource('background');
  if Assigned(b) then
  begin
    r := TRectangle.Create(b);
    r.Align := TAlignLayout.Client;
    r.HitTest := False;
    r.Parent := b;

    case FilterAppearance.Fill.Kind of
      gfkSolid:
      begin
        r.Fill.Kind := TBrushKind.Solid;
        r.Fill.Color := FilterAppearance.Fill.Color;
      end;
      gfkGradient:
      begin
        r.Fill.Kind := TBrushKind.Gradient;
        r.Fill.Gradient.Color := FilterAppearance.Fill.Color;
        r.Fill.Gradient.Color1 := FilterAppearance.Fill.ColorTo;
      end
      else
        r.Fill.Kind := TBrushKind.None;
    end;

    r.Stroke.Color := FilterAppearance.Stroke.Color;

    if FilterAppearance.Stroke.Kind <> gskSolid then
      r.Stroke.Kind := TBrushKind.None
    else
      r.Stroke.Kind := TBrushKind.Solid;
  end;
end;
{$ENDIF}

procedure TTMSFNCDataGridRenderer.DoFilterBuilderApplyButtonClicked(Sender: TObject; AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean);
begin
  ApplyFilterFromBuilder;
end;

procedure TTMSFNCDataGridRenderer.DoFilterBuilderClose(Sender: TObject);
begin
  DoAfterShowFilterDialog(FilterDialog);
end;

procedure TTMSFNCDataGridRenderer.DoFilterClearClick(Sender: TObject);
var
  btn: TTMSFNCToolBarButton;
  c: Integer;
  b: Boolean;
begin
  if (Sender is TTMSFNCToolBarButton) then
  begin
    btn := (Sender as TTMSFNCToolBarButton);
    c := btn.DataInteger;
    b := False;
    if Filter.HasFilter(c) then
    begin
      Filter.RemoveColumnFilter(c);
      b := True;
    end;

    if Filter.Count = 0 then
      ClearFilter
    else
    begin
      IncUpdateCount;
      RemoveFilter;
      DecUpdateCount;
      ApplyFilter;
    end;

    if b then
      DoRemoveFilter(c);

    UpdateFilterList(c);
  end;
end;

procedure TTMSFNCDataGridRenderer.DoFilterEditChange(Sender: TObject);
begin
  if FLoadFilter then
    Exit;

  FFilterEditMode := gfemEdit;
  FFilterTime := 0;
  FilterTimer.Enabled := True;
end;

procedure TTMSFNCDataGridRenderer.DoFilterEnter(Sender: TObject);
begin
  FilterEdit.SelectAll;
end;

procedure TTMSFNCDataGridRenderer.DoFilterExitTimer(Sender: TObject);
{$IFDEF FMXMOBILE}
var
  f: Boolean;
{$ENDIF}
begin
  {$IFDEF FMXMOBILE}
  f := FilterListBox.IsFocused or FilterListBox.TreeView.IsFocused or FilterEdit.IsFocused or FilterClearButton.IsFocused or FilterSortAscendingButton.IsFocused or
    FilterSortDescendingButton.IsFocused or FilterContainer.IsFocused;

  if not f then
  begin
    FilterExitTimer.Enabled := False;
    FilterPopup.IsOpen := False;
  end;
  {$ELSE}
  FilterExitTimer.Enabled := False;
  {$ENDIF}
end;

procedure TTMSFNCDataGridRenderer.DoFilterSortClick(Sender: TObject);
var
  btn: TTMSFNCToolBarButton;
  c: Integer;
begin
  if (Sender is TTMSFNCToolBarButton) then
  begin
    btn := (Sender as TTMSFNCToolBarButton);
    c := btn.DataInteger;
    if btn.DataString = 'asc' then
    begin
      if IsGrouped then
        GroupSort(c, gsdAscending)
      else
        Sort(c, gsdAscending)
    end
    else if btn.DataString = 'desc' then
    begin
      if IsGrouped then
        GroupSort(c, gsdDescending)
      else
        Sort(c, gsdDescending);
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoFilterTimer(Sender: TObject);
var
  fd: TTMSFNCDataGridDataFilterData;
  cnd: string;
  b: Boolean;
  cli: Integer;
  obj: TObject;
  f: Boolean;
  i, filtercol: Integer;
  c: Boolean;
  fdt: TTMSFNCDataGridDataFilterType;
  cl: TTMSFNCDataGridColumn;
  e: TTMSFNCDataGridCellControl;
  useEmpty: Boolean;
begin
  Inc(FFilterTime);
  if FFilterTime >= FILTERDELAY then
  begin
    FilterTimer.Enabled := False;

    if Options.Filtering.Advanced then
      Exit;

    if Assigned(FilterListBox) then
    begin
      filtercol := FilterListBox.Tag;
      fd := nil;

      if Options.Filtering.MultiColumn then
      begin
        if Filter.HasFilter(filtercol) then
          fd := Filter.ColumnFilter[filtercol];
      end
      else
        Filter.Clear;

      fdt := gftEqual;
      cl := GetColumn(filtercol);
      if Assigned(cl) and (gcsFilterDefaultType in cl.Settings) then
        fdt := cl.FilterDefaultType;

      if FilterTypeComboBox.Visible and (FilterTypeComboBox.ItemIndex <> -1) then
        fdt := TTMSFNCDataGridDataFilterType(FilterTypeComboBox.ItemIndex);

      f := False;

      if (FFilterEditMode = gfemEdit) and ((Assigned(FilterEdit) and FilterEdit.Visible and (FilterEdit.Text <> '')) or (fdt in [gftEmpty, gftNotEmpty])) then
      begin
        if not Assigned(fd) then
          fd := Filter.Add;

        fd.Column := filtercol;
        fd.&Type := fdt;
        fd.Condition := FilterEdit.Text;
        cnd := fd.FilterCondition;
        f := True;
      end
      else if FilterListBox.Visible and (FFilterEditMode = gfemList) then
      begin
        if not Assigned(fd) then
          fd := Filter.Add;

        fd.Column := filtercol;
        fd.&Type := gftEqual;
        cnd := '';
        useEmpty := False;

        for i := 0 to FilterListBox.Items.Count - 1 do
        begin
          if FilterListBox.Checked[i] then
          begin
            if FilterListBox.Items[i].Text = Options.Localization.FilterAllText then
            begin
              cnd := Options.Localization.FilterAllText;
              f := True;
              Break;
            end
            else if FilterListBox.Items[i].Text = Options.Localization.FilterEmptyText then
            begin
              useEmpty := True;
              f := True;
            end
            else if FilterListBox.Items[i].Text = Options.Localization.FilterNotEmptyText then
            begin
              fd.&Type := gftNotEmpty;
              cnd := '!';
              f := True;
              Break;
            end
            else
            begin
              if cnd <> '' then
                cnd := cnd + '|';

              b := False;
              obj := FilterListBox.Items[i].DataObject;
              if Assigned(obj) and (obj is TTMSFNCDataGridDataFilterItem) then
                b := (obj as TTMSFNCDataGridDataFilterItem).DoubleQuotes;

              if b then
                cnd := cnd + '"' + FilterListBox.Items[i].Text + '"'
              else
                cnd := cnd + FilterListBox.Items[i].Text;

              f := True;
            end;
          end;
        end;

        if useEmpty and (fd.&Type = gftEqual) then
        begin
          if cnd <> '' then
            cnd := cnd + '|';
          cnd := cnd + '""';
        end;

        fd.FilterCondition := cnd;
      end;

      e := nil;
      if HasFilterEditor[filtercol, Options.Filtering.Row] then
      begin
        e := FilterEditors[filtercol, Options.Filtering.Row];
        if Assigned(e) and (e is TTMSFNCDataGridFilterPanel) then
          (e as TTMSFNCDataGridFilterPanel).Reset;
      end;

      cli := -1;
      b := False;
      if Assigned(fd) and ((cnd = Options.Localization.FilterAllText) or not f) then
      begin
        cli := fd.Column;
        b := True;
        FreeAndNil(fd);
      end;

      c := True;
      if Assigned(fd) then
        DoBeforeApplyFilter(fd.Column, cnd, c);

      if c then
      begin
        if Assigned(fd) then
        begin
          fd.FilterCondition := cnd;
          if Assigned(e) and (e is TTMSFNCDataGridFilterPanel) then
            (e as TTMSFNCDataGridFilterPanel).SetFilter(fd);
        end;

        if Filter.Count = 0 then
          ClearFilter
        else
        begin
          IncUpdateCount;
          RemoveFilter;
          DecUpdateCount;
          ApplyFilter;
        end;

        if b then
          DoRemoveFilter(cli);

        if Assigned(fd) then
          DoAfterApplyFilter(fd.Column, cnd);
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoFilterTypeChange(Sender: TObject);
begin
  if FLoadFilter then
    Exit;

  FFilterEditMode := gfemEdit;
  FFilterTime := 0;
  FilterTimer.Enabled := True;
end;

function FindOptionsToParameters(AOptions: TTMSFNCFindDialogOptions): TTMSFNCDataGridDataFindParameters;
var
  p: TTMSFNCDataGridDataFindParameters;
begin
  p := [gfnIgnoreHTMLTags, gfnAutoGoTo, gfnDirectionLeftRight];
  if fdoCaseSensitive in AOptions then
    p := p + [gfnMatchCase];

  if fdoWholeWordOnly in AOptions then
    p := p + [gfnMatchFull];

  if fdoExpression in AOptions then
    p := p + [gfnMatchRegular];

  Result := p;
end;

function ReplaceOptionsToParameters(AOptions: TTMSFNCReplaceDialogOptions): TTMSFNCDataGridDataFindParameters;
var
  p: TTMSFNCDataGridDataFindParameters;
begin
  p := [gfnIgnoreHTMLTags, gfnAutoGoTo, gfnDirectionLeftRight];
  if rdoCaseSensitive in AOptions then
    p := p + [gfnMatchCase];

  if rdoWholeWordOnly in AOptions then
    p := p + [gfnMatchFull];

  if rdoExpression in AOptions then
    p := p + [gfnMatchRegular];

  Result := p;
end;

procedure TTMSFNCDataGridRenderer.DoFind(Sender: TObject; AFindText: string;
  var AFound: Boolean);
var
  p: TTMSFNCDataGridDataFindParameters;
  f: TTMSFNCFindDialog;
begin
  if (Sender is TTMSFNCFindDialog) then
  begin
    f := (Sender as TTMSFNCFindDialog);
    p := FindOptionsToParameters(f.Options);
    AFound := IsCellValid(Find(AFindText, p));
  end;
end;

procedure TTMSFNCDataGridRenderer.DoFindNext(Sender: TObject; AFindText: string;
  var AFound: Boolean);
var
  p: TTMSFNCDataGridDataFindParameters;
  f: TTMSFNCFindDialog;
begin
  if (Sender is TTMSFNCFindDialog) then
  begin
    f := (Sender as TTMSFNCFindDialog);
    p := FindOptionsToParameters(f.Options);

    if not (fdoDown in f.Options) then
      p := p + [gfnBackward];

    AFound := IsCellValid(Find(AFindText, p, FocusedCell));
  end;
end;

procedure TTMSFNCDataGridRenderer.DoRemoveFilter(AColumn: Integer);
begin
  if Assigned(OnRemoveFilter) then
    OnRemoveFilter(Self, AColumn);
end;

procedure TTMSFNCDataGridRenderer.DoReplace(Sender: TObject; AFindText,
  AReplaceText: string);
var
  c: TTMSFNCDataGridCellCoord;
  ov: string;
  nv: string;
begin
  c := FocusedCell;
  if (c.Column <> -1) and (c.Row <> -1) then
  begin
    ov := Strings[c.Column, c.Row];
    nv := StringReplace(ov, AFindText, AReplaceText, [rfReplaceAll, rfIgnoreCase]);
    Cells[c.Column, c.Row] := nv;
  end;
end;

procedure TTMSFNCDataGridRenderer.DoReplaceAll(Sender: TObject; AFindText,
  AReplaceText: string);
var
  p: TTMSFNCDataGridDataFindParameters;
  r: TTMSFNCReplaceDialog;
begin
  if (Sender is TTMSFNCReplaceDialog) then
  begin
    r := (Sender as TTMSFNCReplaceDialog);
    p := ReplaceOptionsToParameters(r.Options);
    Replace(AFindText, AReplaceText, p);
  end;
end;

procedure TTMSFNCDataGridRenderer.DoReplaceFind(Sender: TObject; AReplaceText: string);
var
  p: TTMSFNCDataGridDataFindParameters;
  r: TTMSFNCReplaceDialog;
begin
  if (Sender is TTMSFNCReplaceDialog) then
  begin
    r := (Sender as TTMSFNCReplaceDialog);
    p := ReplaceOptionsToParameters(r.Options);
    Find(AReplaceText, p);
  end;
end;

procedure TTMSFNCDataGridRenderer.DoReplaceFindNext(Sender: TObject;
  AFindText: string);
var
  p: TTMSFNCDataGridDataFindParameters;
  f: TTMSFNCReplaceDialog;
begin
  if (Sender is TTMSFNCReplaceDialog) then
  begin
    f := (Sender as TTMSFNCReplaceDialog);
    p := ReplaceOptionsToParameters(f.Options);

    if not (rdoDown in f.Options) then
      p := p + [gfnBackward];

    Find(AFindText, p, FocusedCell);
  end;
end;

procedure TTMSFNCDataGridRenderer.FirstPage;
begin
  PageIndex := 0;
end;

procedure TTMSFNCDataGridRenderer.Focus;
begin
  if Assigned(OnFocus) then
    OnFocus(Self);
end;

procedure TTMSFNCDataGridRenderer.UpdateScrollBars(AUpdate: Boolean = True; ACalculate: Boolean = True);
var
  vs, hs: TScrollBar;
  vsc, hsc: TTMSFNCScrollBar;
  w, h, ww, hh: Double;
  cw, ch: Double;
  cr: TRectF;
  vmgr: TTMSFNCMargins;
  hmgr: TTMSFNCMargins;
  lr: TRectF;
  {$IFDEF CMNWEBLIB}
  p: TTMSFNCDataGridCellParent;
  {$ENDIF}
begin
  if (FBlockScrollingUpdate) or (UpdateCount > 0) or GetIsDestroying then
    Exit;

  FBlockScrollingUpdate := True;

  vs := VerticalScrollBar;
  hs := HorizontalScrollBar;
  vsc := CustomVerticalScrollBar;
  hsc := CustomHorizontalScrollBar;

  if ACalculate then
  begin
    UpdateAutoSizing;
    UpdateColumnRowCalculations;
  end;

  if AUpdate then
    cr := GetCalculationRect
  else
    cr := GetContentRect;

  cw := cr.Right - cr.Left;
  ch := cr.Bottom - cr.Top;
  w := TotalColumnWidth;
  h := TotalRowHeight;

  lr := LocalRect;

  ww := lr.Right;
  hh := lr.Bottom;

  if Assigned(vs) then
    vs.Visible := (h > 0) and (CompareValueEx(h, ch, 1) = 1) and VerticalScrollBarVisible and not RowStretchingActive and not HasCustomScrollBars and not IsExporting;

  if Assigned(hs) then
    hs.Visible := (w > 0) and (CompareValueEx(w, cw, 1) = 1) and HorizontalScrollBarVisible and not ColumnStretchingActive and not HasCustomScrollBars and not IsExporting;

  if Assigned(vsc) then
    vsc.Visible := (h > 0) and (CompareValueEx(h, ch, 1) = 1) and VerticalScrollBarVisible and not RowStretchingActive and HasCustomScrollBars and not IsExporting;

  if Assigned(hsc) then
  begin
    if Assigned(vsc) and vsc.Visible and ((Assigned(Host) and (Host is TTMSFNCDataGridRenderer)) or not Assigned(Host)) then
      hsc.Visible := (w > 0) and (CompareValueEx(w, cw - vsc.Width, 1) = 1) and HorizontalScrollBarVisible and not ColumnStretchingActive and HasCustomScrollBars and not IsExporting
    else
      hsc.Visible := (w > 0) and (CompareValueEx(w, cw, 1) = 1) and HorizontalScrollBarVisible and not ColumnStretchingActive and HasCustomScrollBars and not IsExporting
  end;

  {$IFDEF CMNWEBLIB}
  if HasValidHost then
  begin
    p := Host as TTMSFNCDataGridCellParent;

    if Assigned(vsc) then
    begin
      if vsc.Visible and HasCustomScrollBars then
        vsc.Parent := p
      else
        vsc.Parent := nil;
    end;

    if Assigned(hsc) then
    begin
      if hsc.Visible and HasCustomScrollBars then
        hsc.Parent := p
      else
        hsc.Parent := nil;
    end;

    if Assigned(vs) then
    begin
      if vs.Visible and not HasCustomScrollBars then
        vs.Parent := p
      else
        vs.Parent := nil;
    end;

    if Assigned(hs) then
    begin
      if hs.Visible and not HasCustomScrollBars then
        hs.Parent := p
      else
        hs.Parent := nil;
    end;
  end;
  {$ENDIF}

  vmgr := TTMSFNCMargins.Create;
  hmgr := TTMSFNCMargins.Create;

  if HasCustomScrollBars then
  begin
    if Assigned(vsc) and vsc.Visible then
      hmgr.Right := vsc.Width + 1
  end
  else
  begin
    if Assigned(vs) and vs.Visible then
      hmgr.Right := vs.Width + 1{$IFDEF CMNWEBLIB} + 1{$ENDIF}
    else
      hmgr.Right := 1{$IFDEF CMNWEBLIB} + 1{$ENDIF};
  end;

  vmgr.Top := 1;
  if HasCustomScrollBars then
  begin
    vmgr.Right := 1;
    hmgr.Bottom := 1;
  end
  else
  begin
    vmgr.Right := 1{$IFDEF CMNWEBLIB} + 1{$ENDIF};
    hmgr.Bottom := 1{$IFDEF CMNWEBLIB} + 1{$ENDIF};
  end;
  hmgr.Left := 1;

  if HasCustomScrollBars then
  begin
    if Assigned(hsc) and hsc.Visible then
      vmgr.Bottom := hsc.Height + 1
  end
  else
  begin
    if Assigned(hs) and hs.Visible then
      vmgr.Bottom := hs.Height + 1{$IFDEF CMNWEBLIB} + 1{$ENDIF}
    else
      vmgr.Bottom := 1{$IFDEF CMNWEBLIB} + 1{$ENDIF};
  end;

  vmgr.Top := vmgr.Top + LocalRect.Top;
  hmgr.Left := hmgr.Left + LocalRect.Left;

  if not StretchScrollBars then
  begin
    hmgr.Left := hmgr.Left + TotalFixedColumnWidth;
    hmgr.Right := hmgr.Right + TotalFixedRightColumnWidth;
    vmgr.Top := vmgr.Top + TotalFixedRowHeight;
    vmgr.Bottom := vmgr.Bottom + TotalFixedBottomRowHeight;
  end;

  {$IFDEF FMXLIB}
  if Assigned(hs) and Assigned(vs) then
  begin
    hs.Position.X := hmgr.Left;
    hs.Position.Y := hh - hmgr.Bottom - hs.Height;
    vs.Position.X := ww - vmgr.Right - vs.Width;
    vs.Position.Y := vmgr.Top;
    hs.Width := ww - hmgr.Right - hmgr.Left;
    vs.Height := hh - vmgr.Bottom - vmgr.Top;
  end;

  if Assigned(hsc) and Assigned(vsc) then
  begin
    hsc.Position.X := hmgr.Left;
    hsc.Position.Y := hh - hmgr.Bottom - hsc.Height;
    vsc.Position.X := ww - vmgr.Right - vsc.Width;
    vsc.Position.Y := vmgr.Top;
    hsc.Width := ww - hmgr.Right - hmgr.Left;
    vsc.Height := hh - vmgr.Bottom - vmgr.Top;
  end;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  if Assigned(hs) and Assigned(vs) then
  begin
    hs.Left := Round(hmgr.Left);
    hs.Top := Round(hh - hmgr.Bottom - hs.Height);
    vs.Left := Round(ww - vmgr.Right - vs.Width);
    vs.Top := Round(vmgr.Top);
    hs.Width := Round(Max(0, ww - hmgr.Right - hmgr.Left));
    {$IFDEF MSWINDOWS}
    vs.Width := GetSystemMetrics(SM_CYVSCROLL);
    hs.Height := GetSystemMetrics(SM_CYHSCROLL);
    {$ENDIF}
    vs.Height := Round(Max(0, hh - vmgr.Bottom - vmgr.Top));
  end;

  if Assigned(hsc) and Assigned(vsc) then
  begin
    hsc.Left := Round(hmgr.Left);
    hsc.Top := Round(hh - hmgr.Bottom - hsc.Height);
    vsc.Left := Round(ww - vmgr.Right - vsc.Width);
    vsc.Top := Round(vmgr.Top);
    hsc.Width := Round(Max(0, ww - hmgr.Right - hmgr.Left));
    vsc.Height := Round(Max(0, hh - vmgr.Bottom - vmgr.Top));
  end;
  {$ENDIF}

  hmgr.Free;
  vmgr.Free;

  cr := GetContentRect;
  cw := cr.Right - cr.Left;
  ch := cr.Bottom - cr.Top;

  {$IFDEF FMXLIB}
  if Assigned(vs) then
  begin
    if ScrollMode = gsmCellScrolling then
    begin
      vs.ViewportSize := GetRowViewPortSize;
      vs.Max := RowCount;
      vs.SmallChange := 1;
    end
    else
    begin
      vs.ViewPortSize := Min(h, ch);
      vs.Max := h;
      vs.SmallChange := Round(DefaultRowHeight);
    end;

    vs.Value := Min(vs.Value, vs.Max - vs.ViewportSize);
  end;

  if Assigned(hs) then
  begin
    if ScrollMode = gsmCellScrolling then
    begin
      hs.ViewportSize := GetColumnViewPortSize;
      hs.Max := ColumnCount;
      hs.SmallChange := 1;
    end
    else
    begin
      hs.ViewPortSize := Min(w, cw);
      hs.Max := w;
      hs.SmallChange := Round(DefaultColumnWidth);
    end;

    hs.Value := Min(hs.Value, hs.Max - hs.ViewportSize);
  end;

  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  if Assigned(vs) then
  begin
    if ScrollMode = gsmCellScrolling then
    begin
      vs.PageSize := Round(Max(0, GetRowViewPortSize));
      vs.Max := Max(vs.PageSize, RowCount);
      vs.SmallChange := 1;
    end
    else
    begin
      vs.PageSize := Round(Max(0, Min(h, ch)));
      vs.Max := Round(Max(0, h));
      vs.SmallChange := Round(DefaultRowHeight);
    end;

    vs.LargeChange := Min(High(TScrollBarInc), Max(1, vs.PageSize));
    vs.Position := Min(vs.Position, vs.Max);
  end;

  if Assigned(hs) then
  begin
    if ScrollMode = gsmCellScrolling then
    begin
      hs.PageSize := Round(Max(0, GetColumnViewPortSize));
      hs.Max := Max(hs.PageSize, ColumnCount);
      hs.SmallChange := 1;
    end
    else
    begin
      hs.PageSize := Round(Max(0, Min(w, cw)));
      hs.Max := Round(Max(0, w));
      hs.SmallChange := Round(DefaultColumnWidth);
    end;

    hs.LargeChange := Min(High(TScrollBarInc), Max(1, hs.PageSize));
    hs.Position := Min(hs.Position, hs.Max);
  end;
  {$ENDIF}

  if Assigned(vsc) then
  begin
    if ScrollMode = gsmCellScrolling then
    begin
      vsc.PageSize := GetRowViewPortSize;
      vsc.Max := RowCount;
      vsc.SmallChange := 1;
    end
    else
    begin
      vsc.PageSize := Min(h, ch);
      vsc.Max := h;
      vsc.SmallChange := Round(DefaultRowHeight);
    end;

    vsc.LargeChange := Max(1, vsc.PageSize);
    vsc.Value := Min(vsc.Value, vsc.Max - vsc.PageSize);
  end;

  if Assigned(hsc) then
  begin
    if ScrollMode = gsmCellScrolling then
    begin
      hsc.PageSize := GetColumnViewPortSize;
      hsc.Max := ColumnCount;
      hsc.SmallChange := 1;
    end
    else
    begin
      hsc.PageSize := Min(w, cw);
      hsc.Max := w;
      hsc.SmallChange := Round(DefaultColumnWidth);
    end;

    hsc.LargeChange := Max(1, hsc.PageSize);
    hsc.Value := Min(hsc.Value, hsc.Max - hsc.PageSize);
  end;

  FBlockScrollingUpdate := False;

  if AUpdate then
    UpdateScrollBars(False);
end;

procedure TTMSFNCDataGridRenderer.SetFilterAppearance(const Value: TTMSFNCDataGridFilterAppearance);
begin
  FFilterAppearance.Assign(Value);
end;

procedure TTMSFNCDataGridRenderer.SetFocusCell(ACol, ARow: Integer);
begin
  FFocusedCell.Column := ACol;
  FFocusedCell.Row := ARow;
  FFocusedCell.Column := Max(FixedColumnCount, Min(ColumnCount - 1 - FixedRightColumnCount, FFocusedCell.Column));
  FFocusedCell.Row := Max(FixedRowCount, Min(RowCount - 1 - FixedBottomRowCount, FFocusedCell.Row));
end;

procedure TTMSFNCDataGridRenderer.SetFocusedCell(
  const Value: TTMSFNCDataGridCellCoord);
var
  val: TTMSFNCDataGridCellCoord;
begin
  SetFocusCell(Value.Column, Value.Row);
  if IsCellDisabled(Value) then
  begin
    val := NextSelectableColumn(FocusedCell.Column, FocusedCell.Row);
    SetFocusCell(val.Column, val.Row);
  end;
  SelectCell(FFocusedCell, []);
end;

procedure TTMSFNCDataGridRenderer.SetFontColors(AColumn, ARow: Integer;
  const Value: TTMSFNCGraphicsColor);
var
  l: TTMSFNCDataGridCellLayout;
begin
  l := Layouts[AColumn, ARow];
  if Assigned(l) then
    l.Font.Color := Value;
end;

procedure TTMSFNCDataGridRenderer.SetFontNames(AColumn, ARow: Integer;
  const Value: string);
var
  l: TTMSFNCDataGridCellLayout;
begin
  l := Layouts[AColumn, ARow];
  if Assigned(l) then
    l.Font.Name := Value;
end;

procedure TTMSFNCDataGridRenderer.SetFonts(ASetType: TTMSFNCAppearanceGlobalFontType);
var
  I: Integer;
  c: TTMSFNCDataGridColumn;
  p: TTMSFNCDataGridCellParent;
  fi: ITMSFNCAppearanceGlobalFont;
begin
  BeginUpdate;
  try
    p := GetParentHost;
    if Assigned(p) and Supports(p, ITMSFNCAppearanceGlobalFont, fi) then
      fi.SetFonts(ASetType);

    GlobalFont.ApplyChange(CellAppearance.FixedLayout.Font, ASetType);
    GlobalFont.ApplyChange(CellAppearance.FocusedLayout.Font, ASetType);
    GlobalFont.ApplyChange(CellAppearance.NormalLayout.Font, ASetType);
    GlobalFont.ApplyChange(CellAppearance.GroupLayout.Font, ASetType);
    GlobalFont.ApplyChange(CellAppearance.SummaryLayout.Font, ASetType);
    GlobalFont.ApplyChange(CellAppearance.SelectedLayout.Font, ASetType);
    GlobalFont.ApplyChange(CellAppearance.FixedSelectedLayout.Font, ASetType);
    GlobalFont.ApplyChange(CellAppearance.BandLayout.Font, ASetType);
    GlobalFont.ApplyChange(CellAppearance.FilterInverseMatchLayout.Font, ASetType);
    GlobalFont.ApplyChange(CellAppearance.FilterMatchLayout.Font, ASetType);

    for I := 0 to Columns.Count - 1 do
    begin
      c := Columns[I];
      GlobalFont.ApplyChange(c.Appearance.FixedLayout.Font, ASetType);
      GlobalFont.ApplyChange(c.Appearance.FocusedLayout.Font, ASetType);
      GlobalFont.ApplyChange(c.Appearance.NormalLayout.Font, ASetType);
      GlobalFont.ApplyChange(c.Appearance.GroupLayout.Font, ASetType);
      GlobalFont.ApplyChange(c.Appearance.SummaryLayout.Font, ASetType);
      GlobalFont.ApplyChange(c.Appearance.SelectedLayout.Font, ASetType);
      GlobalFont.ApplyChange(c.Appearance.FixedSelectedLayout.Font, ASetType);
      GlobalFont.ApplyChange(c.Appearance.BandLayout.Font, ASetType);
      GlobalFont.ApplyChange(c.Appearance.FilterMatchLayout.Font, ASetType);
      GlobalFont.ApplyChange(c.Appearance.FilterInverseMatchLayout.Font, ASetType);
    end;

  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.SetFontSizes(AColumn, ARow: Integer;
  const Value: Single);
var
  l: TTMSFNCDataGridCellLayout;
begin
  l := Layouts[AColumn, ARow];
  if Assigned(l) then
    l.Font.Size := {$IFNDEF FMXLIB}Round{$ENDIF}(Value);
end;

procedure TTMSFNCDataGridRenderer.SetFontStyles(AColumn, ARow: Integer;
  const Value: TFontStyles);
var
  l: TTMSFNCDataGridCellLayout;
begin
  l := Layouts[AColumn, ARow];
  if Assigned(l) then
    l.Font.Style := Value;
end;

procedure TTMSFNCDataGridRenderer.SetGlobalFont(const Value: TTMSFNCAppearanceGlobalFont);
begin
  FGlobalFont.Assign(Value);
end;

function TTMSFNCDataGridRenderer.SetGrid(ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridRenderer;
begin
  Result := SetGrid(ACell.Column, ACell.Row);
end;

function TTMSFNCDataGridRenderer.SetGrid(AColumn, ARow: Integer): TTMSFNCDataGridRenderer;
var
  cd: TTMSFNCDataGridCellItemExtended;
  o: TObject;
  r: TTMSFNCDataGridRenderer;
begin
  Result := nil;
  if not IsCellValid(AColumn, ARow) then
    Exit;

  BeginUpdate;
  try
    cd := CellDataExtended[AColumn, ARow];
    if Assigned(cd) then
    begin
      o := TTMSFNCDataGridCellItemExtendedOpen(cd).Renderer;
      if not Assigned(o) then
      begin
        r := TTMSFNCDataGridRenderer.Create(Self);
        TTMSFNCDataGridCellItemExtendedOpen(cd).Renderer := r;
        Result := r;
      end
      else if o is TTMSFNCDataGridRenderer then
        Result := o as TTMSFNCDataGridRenderer;
    end;
  finally
    EndUpdate;
  end;
end;

procedure TTMSFNCDataGridRenderer.Calculate;
var
  c, r, vr: Integer;
  sdx, sdy, dx, dy: Double;
  offsetx, offsety: Double;
  ac, ar: Integer;
  rc, rclip: TRectF;
  fcc, rcc, rcnt, ccnt: Integer;

  procedure SetCellRectLeftRight;
  begin
    sdx := dx;
    dx := dx + ColumnWidths[c];
  end;

  procedure SetCellRectTopBottom;
  begin
    sdy := dy;
    dy := dy + RowHeights[r];
  end;

  procedure AddCellWithKind(AKind: TTMSFNCDataGridCellKind);
  var
    d: TTMSFNCDataGridCellItem;
    sz: TSizeF;
    bc, cl: TTMSFNCDataGridCellCoord;
    cx, cy: Single;
    cc: Integer;
    rr, off: Integer;
    cell: TTMSFNCDataGridCell;
    cls: TTMSFNCDataGridCellClass;
  begin
    cl := MakeCell(c, r);
    d := CellData[cl.Column, cl.Row];
    BeginUsingCellData(cl, d);
    try
      if IsCellMerged(cl) then
      begin
        bc := BaseCell(cl);
        if FMergedCells.Contains(bc) then
          Exit
        else
          FMergedCells.Add(bc);

        cl := bc;
        EndUsingCellData;
        d := CellData[cl.Column, cl.Row];
        BeginUsingCellData(cl, d);
      end;

      sz := GetCellSize(cl);

      cx := sdx;
      cy := sdy;

      if AKind = gckCell then
      begin
        for cc := cl.Column to StartColumn - 1 do
          cx := cx - ColumnWidths[cc];

        for rr := cl.Row to StartRow - 1 do
          cy := cy - RowHeights[rr];

        if (cl.Column = Options.Column.NodeIndex) then
        begin
          if RowTypes[cl.Row] = grtDefault then
            off := (20 * Max(0, (RowNodeLevel[cl.Row] - 1)))
          else
            off := (20 * Max(0, RowNodeLevel[cl.Row]));

          cx := cx + off;
          sz.cx := sz.cx - off;
        end;
      end;

      rc.Left := {$IFDEF FMXWEBLIB}Int{$ENDIF}(cx){$IFDEF FMXWEBLIB} + 0.5{$ENDIF};
      rc.Right := {$IFDEF FMXWEBLIB}Int{$ENDIF}(cx + sz.cx){$IFDEF FMXWEBLIB} + 0.5{$ELSE} + 1{$ENDIF};
      rc.Top := {$IFDEF FMXWEBLIB}Int{$ENDIF}(cy){$IFDEF FMXWEBLIB} + 0.5{$ENDIF};
      rc.Bottom := {$IFDEF FMXWEBLIB}Int{$ENDIF}(cy + sz.cy){$IFDEF FMXWEBLIB} + 0.5{$ELSE} + 1{$ENDIF};

      cls := GetBaseCellClass(cl);
      DoGetCellClass(cl.Column, cl.Row, cls);
      if Assigned(cls) then
      begin
        cell := cls.Create(rc, cl.Column, cl.Row, d, AKind, Self);

        ConfigureCell(cell, gccmProperties);

        case AKind of
          gckCell:
          begin
            FNormalCellList.Add(cell);
            AddCellToDisplay(cell, FNormalCellDisplay);
          end;
          gckFreezeFixedRowCell, gckFreezeFixedColumnCell, gckFreezeRootCell, gckFixedRootCell:
          begin
            FFixedRootCellList.Add(cell);
            AddCellToDisplay(cell, FFixedRootCellDisplay);
          end;
          gckFreezeRowCell, gckFixedRowCell:
          begin
            FFixedRowCellList.Add(cell);
            AddCellToDisplay(cell, FFixedRowCellDisplay);
          end;
          gckFreezeColumnCell, gckFixedColumnCell:
          begin
            FFixedColumnCellList.Add(cell);
            AddCellToDisplay(cell, FFixedColumnCellDisplay);
          end;
        end;
      end;
    finally
      EndUsingCellData;
    end;
  end;

  procedure AddFreezeRootCell;
  begin
    AddCellWithKind(gckFreezeRootCell);
  end;

  procedure AddFixedRootCell;
  begin
    AddCellWithKind(gckFixedRootCell);
  end;

  procedure AddFixedRowCell;
  begin
    AddCellWithKind(gckFixedRowCell);
  end;

  procedure AddCell;
  begin
    AddCellWithKind(gckCell);
  end;

  procedure AddFreezeRowCell;
  begin
    AddCellWithKind(gckFreezeRowCell);
  end;

  procedure AddFreezeColumnCell;
  begin
    AddCellWithKind(gckFreezeColumnCell);
  end;

  procedure AddFixedColumnCell;
  begin
    AddCellWithKind(gckFixedColumnCell);
  end;

  procedure AddFreezeFixedColumnCell;
  begin
    AddCellWithKind(gckFreezeFixedColumnCell);
  end;

  procedure AddFreezeFixedRowCell;
  begin
    AddCellWithKind(gckFreezeFixedRowCell);
  end;

  procedure IncVisibleRowIndex;
  begin
    if IsRowDisplayed(r) and IsRowNormal(r) then
    begin
      RowIndex[r] := vr;
      Inc(vr);
    end;
  end;

begin
  if (UpdateCount > 0) or GetIsDestroying then
    Exit;

  FMergedCells.Clear;

  FNormalCellDisplay.Clear;
  FFixedColumnCellDisplay.Clear;
  FFixedRowCellDisplay.Clear;
  FFixedRootCellDisplay.Clear;

  FNormalCellList.Clear;
  FFixedRowCellList.Clear;
  FFixedColumnCellList.Clear;
  FFixedRootCellList.Clear;

  if (ColumnCount > 0) and (RowCount > 0) then
  begin
    offsetx := TotalColumnOffset;
    offsety := TotalRowOffset;
    ac := StartColumn;
    ar := StartRow;
    rcnt := Min(StopRow, RowCount - 1 - FixedBottomRowCount);
    ccnt := Min(StopColumn, ColumnCount - 1 - FixedRightColumnCount);
    fcc := FixedColumnCount + FreezeColumnCount;
    rcc := FixedRowCount + FreezeRowCount;

    rclip := GetContentClipRect;

    dx := rclip.Right - rclip.Left;
    for c := ColumnCount - FixedRightColumnCount to ColumnCount - 1 do
      dx := dx - ColumnWidths[c];

    for c := ColumnCount - FixedRightColumnCount to ColumnCount - 1 do
    begin
      SetCellRectLeftRight;

      dy := rclip.Bottom - rclip.Top;
      for r := RowCount - FixedBottomRowCount to RowCount - 1 do
        dy := dy - RowHeights[r];

      vr := 0;
      for r := RowCount - FixedBottomRowCount to RowCount - 1 do
      begin
        IncVisibleRowIndex;

        SetCellRectTopBottom;
        if IsCellFixedRoot(MakeCell(c, r)) then
          AddFixedRootCell;
      end;

      dy := offsety;
      r := ar;
      vr := 0;
      while r <= rcnt do
      begin
        IncVisibleRowIndex;

        SetCellRectTopBottom;
        if not IsCellFreezeFixed(MakeCell(c, r)) and not IsCellFixedRoot(MakeCell(c, r)) and (r >= FixedRowCount) then
        begin
          if IsCellFreeze(MakeCell(c, r)) then
            AddFreezeColumnCell
          else if not IsCellFreezeFixed(MakeCell(c, r)) then
            AddFixedColumnCell;
        end;

        if IsRowNode(r) and (RowNodeState[r] = grnsCollapsed) then
          r := r + RowNodeChildCount[r];

        Inc(r);
      end;

      dy := 0;
      vr := 0;
      for r := 0 to rcc - 1 do
      begin
        IncVisibleRowIndex;

        SetCellRectTopBottom;
        if IsCellFreezeFixed(MakeCell(c, r)) and (r >= FixedRowCount) then
          AddFreezeFixedColumnCell
        else if IsCellFixedRoot(MakeCell(c, r)) then
          AddFixedRootCell;
      end;
    end;

    dx := 0;
    for c := 0 to fcc - 1 do
    begin
      SetCellRectLeftRight;

      dy := 0;
      vr := 0;
      for r := 0 to rcc - 1 do
      begin
        IncVisibleRowIndex;

        SetCellRectTopBottom;
        if IsCellFreezeRoot(MakeCell(c, r)) then
          AddFreezeRootCell
        else if IsCellFreezeFixed(MakeCell(c, r)) and (r >= FixedRowCount) and (c < FixedColumnCount) then
          AddFreezeFixedColumnCell
        else if IsCellFreezeFixed(MakeCell(c, r)) and (c >= FixedColumnCount) and (r < FixedRowCount) then
          AddFreezeFixedRowCell
        else if IsCellFixedRoot(MakeCell(c, r)) then
          AddFixedRootCell;
      end;

      dy := offsety;
      r := ar;
      vr := 0;
      while r <= rcnt do
      begin
        IncVisibleRowIndex;
        SetCellRectTopBottom;
        if not IsCellFreezeFixed(MakeCell(c, r)) and not IsCellFixedRoot(MakeCell(c, r)) and (r >= FixedRowCount) then
        begin
          if IsCellFreeze(MakeCell(c, r)) then
            AddFreezeColumnCell
          else if not IsCellFreezeFixed(MakeCell(c, r)) then
            AddFixedColumnCell
        end;

        if IsRowNode(r) and (RowNodeState[r] = grnsCollapsed) then
          r := r + RowNodeChildCount[r];

        Inc(r);
      end;

      dy := rclip.Bottom - rclip.Top;
      for r := RowCount - FixedBottomRowCount to RowCount - 1 do
        dy := dy - RowHeights[r];

      vr := 0;
      for r := RowCount - FixedBottomRowCount to RowCount - 1 do
      begin
        IncVisibleRowIndex;
        SetCellRectTopBottom;
        if IsCellFreezeFixed(MakeCell(c, r)) and (c >= FixedColumnCount) then
          AddFreezeFixedRowCell
        else if IsCellFixedRoot(MakeCell(c, r)) then
          AddFixedRootCell;
      end;
    end;

    dx := offsetx;
    for c := ac to ccnt do
    begin
      SetCellRectLeftRight;

      dy := 0;
      vr := 0;
      for r := 0 to rcc - 1 do
      begin
        IncVisibleRowIndex;
        SetCellRectTopBottom;
        if not IsCellFreezeFixed(MakeCell(c, r)) and not IsCellFixedRoot(MakeCell(c, r)) and (c >= FixedColumnCount) then
        begin
          if IsCellFreeze(MakeCell(c, r)) then
            AddFreezeRowCell
          else if not IsCellFreezeFixed(MakeCell(c, r)) then
            AddFixedRowCell
        end;
      end;

      dy := offsety;
      r := ar;
      vr := 0;
      while r <= rcnt do
      begin
        while IsRowFilteredDisplay(r) do
          Inc(r);

        IncVisibleRowIndex;
        SetCellRectTopBottom;
        if not IsCellFixed(MakeCell(c, r)) and not IsCellFreeze(MakeCell(c, r)) and not IsCellFreezeFixed(MakeCell(c, r)) then
          AddCell;

        if IsRowNode(r) and (RowNodeState[r] = grnsCollapsed) then
          r := r + RowNodeChildCount[r];

        Inc(r);
      end;

      dy := rclip.Bottom - rclip.top;
      for r := RowCount - FixedBottomRowCount to RowCount - 1 do
        dy := dy - RowHeights[r];

      vr := 0;
      for r := RowCount - FixedBottomRowCount to RowCount - 1 do
      begin
        IncVisibleRowIndex;
        SetCellRectTopBottom;
        if not IsCellFreezeFixed(MakeCell(c, r)) and not IsCellFixedRoot(MakeCell(c, r)) then
          AddFixedRowCell;
      end;
    end;
  end;

  UpdateInplaceEditorPosition;
  DoDisplay;
end;

function TTMSFNCDataGridRenderer.CancelEditing: Boolean;
begin
  Result := True;
  if FInplaceEditorActive then
    Result := CloseInplaceEditor(True);
end;

function TTMSFNCDataGridRenderer.CanRegisterRuntimeClasses: Boolean;
begin
  Result := True;
  if Assigned(FHost) and (FHost is TComponent) then
    Result := not (csDesigning in (FHost as TComponent).ComponentState);
end;

{ TTMSFNCDataGridCellAppearance }

procedure TTMSFNCDataGridCellAppearance.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridCellAppearance) then
  begin
    FBandLayout.Assign((Source as TTMSFNCDataGridCellAppearance).BandLayout);
    FFilterInverseMatchLayout.Assign((Source as TTMSFNCDataGridCellAppearance).FilterInverseMatchLayout);
    FFilterMatchLayout.Assign((Source as TTMSFNCDataGridCellAppearance).FilterMatchLayout);
    FFixedSelectedLayout.Assign((Source as TTMSFNCDataGridCellAppearance).FixedSelectedLayout);
    FFixedLayout.Assign((Source as TTMSFNCDataGridCellAppearance).FixedLayout);
    FNormalLayout.Assign((Source as TTMSFNCDataGridCellAppearance).NormalLayout);
    FGroupLayout.Assign((Source as TTMSFNCDataGridCellAppearance).GroupLayout);
    FSummaryLayout.Assign((Source as TTMSFNCDataGridCellAppearance).SummaryLayout);
    FSelectedLayout.Assign((Source as TTMSFNCDataGridCellAppearance).SelectedLayout);
    FFocusedLayout.Assign((Source as TTMSFNCDataGridCellAppearance).FocusedLayout);
    FShowFocus := (Source as TTMSFNCDataGridCellAppearance).ShowFocus;
  end;
end;

constructor TTMSFNCDataGridCellAppearance.Create;
begin
  FFilterMatchLayout := TTMSFNCDataGridCellLayout.Create(MakeGraphicsColor(193, 232, 153));
  FFilterInverseMatchLayout := TTMSFNCDataGridCellLayout.Create;
  FBandLayout := TTMSFNCDataGridCellLayout.Create(gcLightyellow);
  FFixedLayout := TTMSFNCDataGridCellLayout.Create(Lighter(MakeGraphicsColor(238, 238, 238), 10));
  FNormalLayout := TTMSFNCDataGridCellLayout.Create;
  FGroupLayout := TTMSFNCDataGridCellLayout.Create(Lighter(MakeGraphicsColor(238, 238, 238), 10));
  FSummaryLayout := TTMSFNCDataGridCellLayout.Create(Lighter(MakeGraphicsColor(245, 245, 230), 10));
  FSelectedLayout := TTMSFNCDataGridCellLayout.Create(Lighter(gcLightsteelblue, 80));
  FFocusedLayout := TTMSFNCDataGridCellLayout.Create(Lighter(gcLightsteelblue, 40));
  FFixedSelectedLayout := TTMSFNCDataGridCellLayout.Create(Lighter(gcLightsteelblue, 80));

  FShowFocus := True;

  FFilterMatchLayout.OnChange := @LayoutChanged;
  FFilterInverseMatchLayout.OnChange := @LayoutChanged;
  FBandLayout.OnChange := @LayoutChanged;
  FFixedLayout.OnChange := @LayoutChanged;
  FNormalLayout.OnChange := @LayoutChanged;
  FGroupLayout.OnChange := @LayoutChanged;
  FSummaryLayout.OnChange := @LayoutChanged;
  FSelectedLayout.OnChange := @LayoutChanged;
  FFocusedLayout.OnChange := @LayoutChanged;
  FFixedSelectedLayout.OnChange := @LayoutChanged;
end;

destructor TTMSFNCDataGridCellAppearance.Destroy;
begin
  FFilterInverseMatchLayout.Free;
  FFilterMatchLayout.Free;
  FBandLayout.Free;
  FFixedLayout.Free;
  FNormalLayout.Free;
  FGroupLayout.Free;
  FSummaryLayout.Free;
  FSelectedLayout.Free;
  FFocusedLayout.Free;
  FFixedSelectedLayout.Free;
  inherited;
end;

procedure TTMSFNCDataGridCellAppearance.LayoutChanged(Sender: TObject);
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

procedure TTMSFNCDataGridCellAppearance.SetBandLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FBandLayout.Assign(Value);
end;

procedure TTMSFNCDataGridCellAppearance.SetFilterMatchLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FFilterMatchLayout.Assign(Value);
end;

procedure TTMSFNCDataGridCellAppearance.SetFilterInverseMatchLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FFilterInverseMatchLayout.Assign(Value);
end;

procedure TTMSFNCDataGridCellAppearance.SetFixedLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FFixedLayout.Assign(Value);
end;

procedure TTMSFNCDataGridCellAppearance.SetFixedSelectedLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FFixedSelectedLayout.Assign(Value);
end;

procedure TTMSFNCDataGridCellAppearance.SetFocusedLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FFocusedLayout.Assign(Value);
end;

procedure TTMSFNCDataGridCellAppearance.SetGroupLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FGroupLayout.Assign(Value);
end;

procedure TTMSFNCDataGridCellAppearance.SetNormalLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FNormalLayout.Assign(Value);
end;

procedure TTMSFNCDataGridCellAppearance.SetSelectedLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FSelectedLayout.Assign(Value);
end;

procedure TTMSFNCDataGridCellAppearance.SetShowFocus(const Value: Boolean);
begin
  if FShowFocus <> Value then
  begin
    FShowFocus := Value;
    LayoutChanged(Self);
  end;
end;

procedure TTMSFNCDataGridCellAppearance.SetSummaryLayout(
  const Value: TTMSFNCDataGridCellLayout);
begin
  FSummaryLayout.Assign(Value);
end;

{ TTMSFNCDataGridIcons }

procedure TTMSFNCDataGridIcons.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridIcons) then
  begin
    FCloseIcon.Assign((Source as TTMSFNCDataGridIcons).CloseIcon);
    FExpandIcon.Assign((Source as TTMSFNCDataGridIcons).ExpandIcon);
    FCollapseIcon.Assign((Source as TTMSFNCDataGridIcons).CollapseIcon);
    FFilterIcon.Assign((Source as TTMSFNCDataGridIcons).FilterIcon);
    FFilterClearIcon.Assign((Source as TTMSFNCDataGridIcons).FilterClearIcon);
    FFilterTypeIcon.Assign((Source as TTMSFNCDataGridIcons).FilterTypeIcon);
    FFilterActiveIcon.Assign((Source as TTMSFNCDataGridIcons).FilterActiveIcon);
    FSortAscendingIcon.Assign((Source as TTMSFNCDataGridIcons).SortAscendingIcon);
    FSortDescendingIcon.Assign((Source as TTMSFNCDataGridIcons).SortDescendingIcon);
  end;
end;

constructor TTMSFNCDataGridIcons.Create;
begin
  FCloseIcon := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDCLOSE, HInstance));
  FExpandIcon := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDEXPAND, HInstance));
  FCollapseIcon := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDCOLLAPSE, HInstance));
  FFilterIcon := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDFILTER, HInstance));
  FFilterClearIcon := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDFILTERCLEAR, HInstance));
  FFilterTypeIcon := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDFILTERTYPE, HInstance));
  FFilterActiveIcon := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDFILTERACTIVE, HInstance));
  FSortAscendingIcon := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDSORTASC, HInstance));
  FSortDescendingIcon := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDSORTDESC, HInstance));

  FCloseIcon.OnChange := @IconChanged;
  FExpandIcon.OnChange := @IconChanged;
  FCollapseIcon.OnChange := @IconChanged;
  FFilterIcon.OnChange := @IconChanged;
  FFilterClearIcon.OnChange := @IconChanged;
  FFilterTypeIcon.OnChange := @IconChanged;
  FFilterActiveIcon.OnChange := @IconChanged;
  FSortAscendingIcon.OnChange := @IconChanged;
  FSortDescendingIcon.OnChange := @IconChanged;
end;

destructor TTMSFNCDataGridIcons.Destroy;
begin
  FCloseIcon.Free;
  FExpandIcon.Free;
  FCollapseIcon.Free;
  FFilterIcon.Free;
  FFilterClearIcon.Free;
  FFilterTypeIcon.Free;
  FFilterActiveIcon.Free;
  FSortDescendingIcon.Free;
  FSortAscendingIcon.Free;
  inherited;
end;

procedure TTMSFNCDataGridIcons.IconChanged(Sender: TObject);
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

procedure TTMSFNCDataGridIcons.SetFilterIcon(
  const Value: TTMSFNCBitmap);
begin
  if FFilterIcon <> Value then
    FFilterIcon.Assign(Value);
end;

procedure TTMSFNCDataGridIcons.SetFilterActiveIcon(
  const Value: TTMSFNCBitmap);
begin
  if FFilterActiveIcon <> Value then
    FFilterActiveIcon.Assign(Value);
end;

procedure TTMSFNCDataGridIcons.SetFilterClearIcon(
  const Value: TTMSFNCBitmap);
begin
  if FFilterClearIcon <> Value then
    FFilterClearIcon.Assign(Value);
end;

procedure TTMSFNCDataGridIcons.SetFilterTypeIcon(
  const Value: TTMSFNCBitmap);
begin
  if FFilterTypeIcon <> Value then
    FFilterTypeIcon.Assign(Value);
end;

procedure TTMSFNCDataGridIcons.SetCloseIcon(const Value: TTMSFNCBitmap);
begin
  if FCloseIcon <> Value then
    FCloseIcon.Assign(Value);
end;

procedure TTMSFNCDataGridIcons.SetCollapseIcon(
  const Value: TTMSFNCBitmap);
begin
  if FCollapseIcon <> Value then
    FCollapseIcon.Assign(Value);
end;

procedure TTMSFNCDataGridIcons.SetExpandIcon(
  const Value: TTMSFNCBitmap);
begin
  if FExpandIcon <> Value then
    FExpandIcon.Assign(Value);
end;

procedure TTMSFNCDataGridIcons.SetSortAscendingIcon(
  const Value: TTMSFNCBitmap);
begin
  if FSortAscendingIcon <> Value then
    FSortAscendingIcon.Assign(Value);
end;

procedure TTMSFNCDataGridIcons.SetSortDescendingIcon(
  const Value: TTMSFNCBitmap);
begin
  if FSortDescendingIcon <> Value then
    FSortDescendingIcon.Assign(Value);
end;

{ TTMSFNCDataGridCellList }

function TTMSFNCDataGridCellList.GetItemForCell(
  ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCell;
var
  it: TTMSFNCDataGridCell;
  I: Integer;
begin
  Result := nil;
  for I := 0 to Count - 1 do
  begin
    it := Items[I];
    if (it.Column = ACell.Column) and (it.Row = ACell.Row) then
    begin
      Result := it;
      Break;
    end;
  end;
end;

{ TTMSFNCDataGridDisplayList }

function TTMSFNCDataGridDisplayList.GetItemForCell(
  ACell: TTMSFNCDataGridCellCoord): TTMSFNCDataGridCell;
var
  it: TTMSFNCDataGridCell;
  I: Integer;
begin
  Result := nil;
  for I := 0 to Count - 1 do
  begin
    it := Items[I];
    if (it.Column = ACell.Column) and (it.Row = ACell.Row) then
    begin
      Result := it;
      Break;
    end;
  end;
end;

{ TTMSFNCDataGridColumnRowOptions }

procedure TTMSFNCDataGridColumnRowOptions.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridColumnRowOptions then
  begin
    FStretching.Assign((Source as TTMSFNCDataGridColumnRowOptions).Stretching);
  end;
end;

constructor TTMSFNCDataGridColumnRowOptions.Create;
begin
  FStretching := TTMSFNCDataGridStretchingOptions.Create;
  FStretching.OnChangeRebuild := DoStretchingChanged;
end;

destructor TTMSFNCDataGridColumnRowOptions.Destroy;
begin
  FreeAndNil(FStretching);
  inherited;
end;

procedure TTMSFNCDataGridColumnRowOptions.DoStretchingChanged(Sender: TObject);
begin
  if Assigned(OnChangeRebuild) then
    OnChangeRebuild(Self);
end;

procedure TTMSFNCDataGridColumnRowOptions.SetStretching(
  const Value: TTMSFNCDataGridStretchingOptions);
begin
  if FStretching <> Value then
    FStretching.Assign(Value);
end;

{ TTMSFNCDataGridOptions }

procedure TTMSFNCDataGridOptions.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCDataGridOptions then
  begin
    FColumn.Assign((Source as TTMSFNCDataGridOptions).Column);
    FRow.Assign((Source as TTMSFNCDataGridOptions).Row);
    FBanding.Assign((Source as TTMSFNCDataGridOptions).Banding);
    FClipboard.Assign((Source as TTMSFNCDataGridOptions).Clipboard);
    FKeyboard.Assign((Source as TTMSFNCDataGridOptions).Keyboard);
    FMouse.Assign((Source as TTMSFNCDataGridOptions).Mouse);
    FEditing.Assign((Source as TTMSFNCDataGridOptions).Editing);
    FLookup.Assign((Source as TTMSFNCDataGridOptions).Lookup);
    FLocalization.Assign((Source as TTMSFNCDataGridOptions).Localization);
  end;
end;

constructor TTMSFNCDataGridOptions.Create;
begin
  inherited;
  FColumn := TTMSFNCDataGridColumnOptions.Create;
  FColumn.OnChangeRebuild := DoColumnChangedRebuild;
  FRow := TTMSFNCDataGridRowOptions.Create;
  FRow.OnChangeRebuild := DoRowChangedRebuild;
  FSelection :=  TTMSFNCDataGridSelectionOptions.Create;
  FSelection.OnChangeRebuild := DoSelectionChangedRebuild;
  FSelection.OnChange := @DoSelectionChanged;
  FBanding := TTMSFNCDataGridBandingOptions.Create;
  FBanding.OnChange := @DoBandingChanged;
  FClipboard := TTMSFNCDataGridClipboardOptions.Create;
  FKeyboard := TTMSFNCDataGridKeyboardOptions.Create;
  FMouse := TTMSFNCDataGridMouseOptions.Create;
  FEditing := TTMSFNCDataGridEditingOptions.Create;
  FLookup := TTMSFNCDataGridLookupOptions.Create;
  FLocalization := TTMSFNCDataGridLocalizationOptions.Create;
end;

destructor TTMSFNCDataGridOptions.Destroy;
begin
  FLocalization.Free;
  FLookup.Free;
  FEditing.Free;
  FMouse.Free;
  FKeyboard.Free;
  FClipboard.Free;
  FBanding.Free;
  FSelection.Free;
  FColumn.Free;
  FRow.Free;
  inherited;
end;

procedure TTMSFNCDataGridOptions.DoCellsChangedRebuild(Sender: TObject);
begin
  if Assigned(OnChangeRebuild) then
    OnChangeRebuild(Self);
end;

procedure TTMSFNCDataGridOptions.DoColumnChangedRebuild(Sender: TObject);
begin
  if Assigned(OnChangeRebuild) then
    OnChangeRebuild(Self);
end;

procedure TTMSFNCDataGridOptions.SetBanding(
  const Value: TTMSFNCDataGridBandingOptions);
begin
  if FBanding <> Value then
    FBanding.Assign(Value);
end;

procedure TTMSFNCDataGridOptions.SetClipboard(
  const Value: TTMSFNCDataGridClipboardOptions);
begin
  if FClipboard <> Value then
    FClipboard.Assign(Value);
end;

procedure TTMSFNCDataGridOptions.SetColumn(
  const Value: TTMSFNCDataGridColumnOptions);
begin
  if FColumn <> Value then
    FColumn.Assign(Value);
end;

procedure TTMSFNCDataGridOptions.SetEditing(
  const Value: TTMSFNCDataGridEditingOptions);
begin
  if FEditing <> Value then
    FEditing.Assign(Value);
end;

procedure TTMSFNCDataGridOptions.SetIO(const Value: TTMSFNCDataGridIOOptions);
begin
  inherited IO := Value;
end;

procedure TTMSFNCDataGridOptions.SetKeyboard(
  const Value: TTMSFNCDataGridKeyboardOptions);
begin
  if FKeyboard <> Value then
    FKeyboard.Assign(Value);
end;

procedure TTMSFNCDataGridOptions.SetLocalization(
  const Value: TTMSFNCDataGridLocalizationOptions);
begin
  if FLocalization <> Value then
    FLocalization.Assign(Value);
end;

procedure TTMSFNCDataGridOptions.SetLookup(
  const Value: TTMSFNCDataGridLookupOptions);
begin
  if FLookup <> Value then
    FLookup := Value;
end;

procedure TTMSFNCDataGridOptions.SetMouse(
  const Value: TTMSFNCDataGridMouseOptions);
begin
  if FMouse <> Value then
    FMouse.Assign(Value);
end;

procedure TTMSFNCDataGridOptions.DoRowChangedRebuild(Sender: TObject);
begin
  if Assigned(OnChangeRebuild) then
    OnChangeRebuild(Self);
end;

procedure TTMSFNCDataGridOptions.DoBandingChanged(Sender: TObject);
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

procedure TTMSFNCDataGridOptions.DoSelectionChanged(Sender: TObject);
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

procedure TTMSFNCDataGridOptions.DoSelectionChangedRebuild(Sender: TObject);
begin
  if Assigned(OnChangeRebuild) then
    OnChangeRebuild(Self);
end;

function TTMSFNCDataGridOptions.GetIO: TTMSFNCDataGridIOOptions;
begin
  Result := TTMSFNCDataGridIOOptions(inherited IO);
end;

function TTMSFNCDataGridOptions.GetIOOptionsClass: TTMSFNCDataGridDataIOOptionsClass;
begin
  Result := TTMSFNCDataGridIOOptions;
end;

procedure TTMSFNCDataGridOptions.SetRow(
  const Value: TTMSFNCDataGridRowOptions);
begin
  if FRow <> Value then
    FRow.Assign(Value);
end;

procedure TTMSFNCDataGridOptions.SetSelection(
  const Value: TTMSFNCDataGridSelectionOptions);
begin
  if FSelection <> Value then
    FSelection.Assign(Value);
end;

{ TTMSFNCDataGridSelectionOptions }

procedure TTMSFNCDataGridSelectionOptions.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridSelectionOptions) then
  begin
    FMode := (Source as TTMSFNCDataGridSelectionOptions).Mode;
    FShowSelectionInFixedCells := (Source as TTMSFNCDataGridSelectionOptions).ShowSelectionInFixedCells;
  end;
end;

procedure TTMSFNCDataGridSelectionOptions.Changed;
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

procedure TTMSFNCDataGridSelectionOptions.ChangedRebuild;
begin
  if Assigned(FOnChangeRebuild) then
    FOnChangeRebuild(Self);
end;

constructor TTMSFNCDataGridSelectionOptions.Create;
begin
  FMode := gsmSingleCell;
end;

procedure TTMSFNCDataGridSelectionOptions.SetMode(const Value: TTMSFNCDataGridSelectionMode);
begin
  if FMode <> Value then
  begin
    FMode := Value;
    ChangedRebuild;
  end;
end;

procedure TTMSFNCDataGridSelectionOptions.SetShowSelectionInFixedCells(
  const Value: Boolean);
begin
  if FShowSelectionInFixedCells <> Value then
  begin
    FShowSelectionInFixedCells := Value;
    Changed;
  end;
end;

{ TTMSFNCDataGridBandingOptions }

procedure TTMSFNCDataGridBandingOptions.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridBandingOptions) then
  begin
    FEnabled := (Source as TTMSFNCDataGridBandingOptions).Enabled;
  end;
end;

procedure TTMSFNCDataGridBandingOptions.Changed;
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

constructor TTMSFNCDataGridBandingOptions.Create;
begin
  inherited Create;
  FEnabled := False;
  FNormalRowCount := 1;
  FBandRowCount := 1;
end;

procedure TTMSFNCDataGridBandingOptions.SetBandRowCount(const Value: integer);
begin
  if (Value > 0) and (FBandRowCount <> Value) then
  begin
    FBandRowCount := Value;
    FTotalRowCount := FNormalRowCount + FBandRowCount;
    Changed;
  end;
end;

procedure TTMSFNCDataGridBandingOptions.SetEnabled(const Value: Boolean);
begin
  if (FEnabled <> Value) then
  begin
    FEnabled := Value;
    Changed;
  end;
end;

procedure TTMSFNCDataGridBandingOptions.SetNormalRowCount(const Value: integer);
begin
  if (Value > 0) and (FNormalRowCount <> Value) then
  begin
    FNormalRowCount := Value;
    FTotalRowCount := FNormalRowCount + FBandRowCount;
    Changed;
  end;
end;

{ TTMSFNCDataGridClipboardOptions }

procedure TTMSFNCDataGridClipboardOptions.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridClipboardOptions then
  begin
    FPasteAction := (Source as TTMSFNCDataGridClipboardOptions).PasteAction;
    FIgnoreReadOnly := (Source as TTMSFNCDataGridClipboardOptions).IgnoreReadOnly;
    FEnabled := (Source as TTMSFNCDataGridClipboardOptions).Enabled;
    FAllowRowGrow := (Source as TTMSFNCDataGridClipboardOptions).AllowRowGrow;
    FAllowColumnGrow := (Source as TTMSFNCDataGridClipboardOptions).AllowColumnGrow;
  end;
end;

constructor TTMSFNCDataGridClipboardOptions.Create;
begin
  FPasteAction := gpaReplace;
  FIgnoreReadOnly := False;
  FEnabled := True;
  FAllowRowGrow := False;
  FAllowColumnGrow := False;
end;

{ TTMSFNCDataGridMouseOptions }

procedure TTMSFNCDataGridMouseOptions.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridMouseOptions) then
  begin
    FDirectEdit := (Source as TTMSFNCDataGridMouseOptions).DirectEdit;
    FWheelScrollSize := (Source as TTMSFNCDataGridMouseOptions).WheelScrollSize;
    FColumnSizing := (Source as TTMSFNCDataGridMouseOptions).ColumnSizing;
    FRowSizing := (Source as TTMSFNCDataGridMouseOptions).RowSizing;
    FFixedColumnSizing := (Source as TTMSFNCDataGridMouseOptions).FixedColumnSizing;
    FFixedRowSizing := (Source as TTMSFNCDataGridMouseOptions).FixedRowSizing;
    FColumnDragging := (Source as TTMSFNCDataGridMouseOptions).ColumnDragging;
    FRowDragging := (Source as TTMSFNCDataGridMouseOptions).RowDragging;
    FAutoScrolling := (Source as TTMSFNCDataGridMouseOptions).AutoScrolling;
    FAutoDragging := (Source as TTMSFNCDataGridMouseOptions).AutoDragging;
    FAutoScrollingSpeed := (Source as TTMSFNCDataGridMouseOptions).AutoScrollingSpeed;
    FAutoScrollingInterval := (Source as TTMSFNCDataGridMouseOptions).AutoScrollingInterval;
    FTouchScrolling := (Source as TTMSFNCDataGridMouseOptions).TouchScrolling;
    FTouchScrollingSensitivity := (Source as TTMSFNCDataGridMouseOptions).TouchScrollingSensitivity;
    FFixedCellSelection := (Source as TTMSFNCDataGridMouseOptions).FixedCellSelection;
    FRowAutoSizeOnDblClick := (Source as TTMSFNCDataGridMouseOptions).RowAutoSizeOnDblClick;
    FColumnAutoSizeOnDblClick := (Source as TTMSFNCDataGridMouseOptions).ColumnAutoSizeOnDblClick;
    FWheelScrollKeepSelection := (Source as TTMSFNCDataGridMouseOptions).WheelScrollKeepSelection;
    FColumnSizeMargin := (Source as TTMSFNCDataGridMouseOptions).ColumnSizeMargin;
    FClickMargin := (Source as TTMSFNCDataGridMouseOptions).ClickMargin;
    FRowSizeMargin := (Source as TTMSFNCDataGridMouseOptions).RowSizeMargin;
    FAutoScrollingSpeedMode  := (Source as TTMSFNCDataGridMouseOptions).AutoScrollingSpeedMode;
    FDragMode := (Source as TTMSFNCDataGridMouseOptions).DragMode;
    FColumnDragModes := (Source as TTMSFNCDataGridMouseOptions).ColumnDragModes;
  end;
end;

constructor TTMSFNCDataGridMouseOptions.Create;
begin
  FTouchScrollingSensitivity := 1;
  FTouchScrolling := False;
  FDirectEdit := False;
  FWheelScrollSize := 4;
  FColumnSizing := False;
  FRowSizing := False;
  FDragMode := gdmReorder;
  FFixedColumnSizing := False;
  FFixedRowSizing := False;
  FColumnDragging := False;
  FRowDragging := False;
  FAutoScrolling := True;
  FAutoDragging := True;
  FAutoScrollingSpeed := 1;
  FAutoScrollingInterval := 100;
  FFixedCellSelection := [];
  FRowAutoSizeOnDblClick := True;
  FColumnAutoSizeOnDblClick := True;
  FWheelScrollKeepSelection := True;
  FColumnSizeMargin := 6;
  FRowSizeMargin := 6;
  FClickMargin := 2;
  FAutoScrollingSpeedMode := gasmPixels;
  FColumnDragModes := [gcdmReorder, gcdmVisualGrouping];
end;

function TTMSFNCDataGridMouseOptions.IsTouchScrollingSensitivityStored: Boolean;
begin
  Result := TouchScrollingSensitivity <> 1;
end;

procedure TTMSFNCDataGridMouseOptions.SetAutoScrollingInterval(
  const Value: Integer);
begin
  if FAutoScrollingInterval <> Value then
    FAutoScrollingInterval := Value;
end;

procedure TTMSFNCDataGridMouseOptions.SetClickMargin(const Value: Integer);
begin
  if FClickMargin <> Value then
    FClickMargin := Value;
end;

procedure TTMSFNCDataGridMouseOptions.SetColumnDragModes(
  const Value: TTMSFNCDataGridColumnDragModes);
begin
  if FColumnDragModes <> Value then
    FColumnDragModes := Value;
end;

procedure TTMSFNCDataGridMouseOptions.SetColumnSizeMargin(const Value: Integer);
begin
  if FColumnSizeMargin <> Value then
    FColumnSizeMargin := Value;
end;

procedure TTMSFNCDataGridMouseOptions.SetRowSizeMargin(const Value: Integer);
begin
  if FRowSizeMargin <> Value then
    FRowSizeMargin := Value;
end;

procedure TTMSFNCDataGridMouseOptions.SetTouchScrolling(const Value: Boolean);
begin
  if FTouchScrolling <> Value then
    FTouchScrolling := Value;
end;

procedure TTMSFNCDataGridMouseOptions.SetWheelScrollKeepSelection(
  const Value: Boolean);
begin
  if FWheelScrollKeepSelection <> Value then
    FWheelScrollKeepSelection := Value;
end;

procedure TTMSFNCDataGridMouseOptions.SetWheelScrollSize(const Value: Integer);
begin
  if FWheelScrollSize <> Value then
    FWheelScrollSize := Value;
end;

{ TTMSFNCDataGridKeyboardOptions }

procedure TTMSFNCDataGridKeyboardOptions.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridKeyboardOptions) then
  begin
    FTabKeyDirection := (Source as TTMSFNCDataGridKeyboardOptions).TabKeyDirection;
    FTabKeyHandling := (Source as TTMSFNCDataGridKeyboardOptions).TabKeyHandling;
    FEnterKeyHandling := (Source as TTMSFNCDataGridKeyboardOptions).EnterKeyHandling;
    FDeleteKeyHandling := (Source as TTMSFNCDataGridKeyboardOptions).DeleteKeyHandling;
    FInsertKeyHandling := (Source as TTMSFNCDataGridKeyboardOptions).InsertKeyHandling;
    FEnterKeyDirectEdit := (Source as TTMSFNCDataGridKeyboardOptions).EnterKeyDirectEdit;
    FTabKeyDirectEdit := (Source as TTMSFNCDataGridKeyboardOptions).TabKeyDirectEdit;
    FArrowKeyDirectEdit := (Source as TTMSFNCDataGridKeyboardOptions).ArrowKeyDirectEdit;
    FCellMergeShortcut := (Source as TTMSFNCDataGridKeyboardOptions).CellMergeShortcut;
    FFindShortcut := (Source as TTMSFNCDataGridKeyboardOptions).FindShortcut;
    FReplaceShortcut := (Source as TTMSFNCDataGridKeyboardOptions).ReplaceShortcut;
    FAppendRowOnArrowKeyDown := (Source as TTMSFNCDataGridKeyboardOptions).AppendRowOnArrowKeyDown;
    FAppendColumnOnArrowKeyRight := (Source as TTMSFNCDataGridKeyboardOptions).AppendColumnOnArrowKeyRight;
    FHomeKeyHandling := (Source as TTMSFNCDataGridKeyboardOptions).HomeKeyHandling;
    FEndKeyHandling := (Source as TTMSFNCDataGridKeyboardOptions).EndKeyHandling;
  end;
end;

constructor TTMSFNCDataGridKeyboardOptions.Create;
begin
  FAppendRowOnArrowKeyDown := False;
  FAppendColumnOnArrowKeyRight := False;
  FFindShortcut := True;
  FReplaceShortcut := True;
  FTabKeyDirection := gtkdNextColumnCell;
  FTabKeyHandling := gtkhMixed;
  FPageScrollSize := 0;
  FEnterKeyHandling := gekhNone;
  FDeleteKeyHandling := gdkhNone;
  FInsertKeyHandling := gikhNone;
  FEnterKeyDirectEdit := False;
  FArrowKeyDirectEdit := False;
  FTabKeyDirectEdit := False;
  FCellMergeShortcut := False;
  FHomeKeyHandling := ghkhFirstColumn;
  FEndKeyHandling := genkhLastColumn;
end;

procedure TTMSFNCDataGridKeyboardOptions.SetPageScrollSize(const Value: Integer);
begin
  FPageScrollSize := Value;
end;

{ TTMSFNCDataGridRendererCell }

procedure TTMSFNCDataGridRendererCell.AfterExport;
begin
  inherited;
  FreeAndNil(FExportRenderer);
end;

procedure TTMSFNCDataGridRendererCell.ApplyScale(AScale: Single);
begin
  inherited;
  if Assigned(FExportRenderer) then
    FExportRenderer.ApplyExportScale(AScale);
end;

procedure TTMSFNCDataGridRendererCell.BeforeExport;
var
  r: TTMSFNCDataGridRenderer;
begin
  inherited;
  FreeAndNil(FExportRenderer);
  r := Renderer;
  if Assigned(r) then
  begin
    FExportRenderer := TTMSFNCDataGridRenderer.Create(r.Host);
    FExportRenderer.Assign(r);
  end;
end;

constructor TTMSFNCDataGridRendererCell.Create(ARect: TRectF; AColumn,
  ARow: Integer; AData: TTMSFNCDataGridCellItem;
  AKind: TTMSFNCDataGridCellKind; ARoot: TObject = nil);
begin
  inherited;
  FRenderRect := EmptyRect;
end;

destructor TTMSFNCDataGridRendererCell.Destroy;
var
  r: TTMSFNCDataGridRenderer;
  d: TNotifyEvent;
begin
  FreeAndNil(FExportRenderer);

  r := Renderer;
  if Assigned(r) then
  begin
    if Assigned(r.Host) then
    begin
      if Assigned(r.VerticalScrollBar) then
        r.VerticalScrollBar.Visible := False;
      if Assigned(r.HorizontalScrollBar) then
        r.HorizontalScrollBar.Visible := False;

      if Assigned(r.CustomVerticalScrollBar) then
        r.CustomVerticalScrollBar.Visible := False;
      if Assigned(r.CustomHorizontalScrollBar) then
        r.CustomHorizontalScrollBar.Visible := False;
    end;

    d := r.OnDisplay;
    r.OnDisplay := nil;
    r.Update;
    r.OnDisplay := d;
  end;

  inherited;
end;

procedure TTMSFNCDataGridRendererCell.DrawContent(AGraphics: TTMSFNCGraphics);
var
  r: TTMSFNCDataGridRenderer;
  d: TNotifyEvent;
  rd: TRectF;

  procedure FixRect;
  begin
    {$IFDEF FMXWEBLIB}
    rd := RectF(rd.Left - 0.5, rd.Top - 0.5, rd.Right + 0.5, rd.Bottom + 0.5);
    {$ENDIF}
  end;
begin
  inherited;

  if IsExporting then
    r := FExportRenderer
  else
    r := Renderer;

  if Assigned(r) then
  begin
    d := r.OnDisplay;
    r.OnDisplay := nil;

    if IsExporting then
      r.BeforeExport;

    try
      rd := GetRendererRect;

      if RectIsEmpty(FRenderRect) or ((rd.Left <> FRenderRect.Left) or (rd.Top <> FRenderRect.Top)
        or (rd.Bottom <> FRenderRect.Bottom) or (rd.Right <> FRenderRect.Right)) then
      begin
        r.BeginUpdate;
        FRenderRect := rd;

        FixRect;

        r.SetLocalRect(rd);
        r.SetClipRect(ClipRect);
        r.EndUpdate;
      end
      else
        FixRect;

      r.Draw(AGraphics);
    finally
      r.OnDisplay := d;
      if IsExporting then
        r.AfterExport;
    end;
  end;
end;

function TTMSFNCDataGridRendererCell.GetDrawElements(
  AIsEditing: Boolean): TTMSFNCDataGridCellDrawElements;
begin
  Result := [gcdControl];
end;

function TTMSFNCDataGridRendererCell.GetRenderer: TTMSFNCDataGridRenderer;
begin
  Result := nil;
  if Assigned(Data) and IsExtendedCell(Data) and Assigned(TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(Data)).Renderer) then
    Result := TTMSFNCDataGridCellItemExtendedOpen(AsExtendedCell(Data)).Renderer as TTMSFNCDataGridRenderer;
end;

function TTMSFNCDataGridRendererCell.GetRendererRect: TRectF;
var
  r, rct, res: TRectF;
begin
  r := Rect;
  res := r;

  if IsControlAssigned then
  begin
    rct := GetControlRectInternal(True);

    case ControlAlign of
      gcaTop: res := RectF(r.Left, rct.Bottom, r.Right, r.Bottom);
      gcaBottom: res := RectF(r.Left, r.Top, r.Right, rct.Top);
      gcaLeft: res := RectF(rct.Right, r.Top, r.Right, r.Bottom);
      gcaRight: res := RectF(r.Left, r.Top, rct.Left, r.Bottom);
      gcaNone:
      begin
        case ControlPosition of
          gcpTopLeft, gcpTopCenter, gcpTopRight: res := RectF(r.Left, rct.Bottom, r.Right, r.Bottom);
          gcpCenterLeft: res := RectF(rct.Right, r.Top, r.Right, r.Bottom);
          gcpCenterRight: res := RectF(r.Left, r.Top, rct.Left, r.Bottom);
          gcpBottomLeft, gcpBottomCenter, gcpBottomRight: res := RectF(r.Left, r.Top, r.Right, rct.Top);
        end;
      end;
    end;
  end;

  Result := res;
end;

function TTMSFNCDataGridRendererCell.GetRequiredSize(AGraphics: TTMSFNCGraphics = nil): TSizeF;
var
  r: TRectF;
begin
  if Assigned(Renderer) then
  begin
    r := Renderer.LocalRect;
    Result.cx := r.Right - r.Left;
    Result.cy := r.Bottom - r.Top;
  end
  else
  begin
    Result.cx := 0;
    Result.cy := 0;
  end;
end;

{ TTMSFNCDataGridScrollBar }

procedure TTMSFNCDataGridScrollBar.DrawEx(AGraphics: TTMSFNCGraphics);
var
  r: TRectF;
begin
  r := ConvertToRectF(BoundsRect);
  Self.DrawBackground(AGraphics, r);
  Self.Export(AGraphics, r);
end;

{ TTMSFNCDataGridEdit }

constructor TTMSFNCDataGridEdit.Create(AOwner: TComponent);
begin
  inherited;
  AutoClose := False;
  {$IFDEF FMXLIB}
  TextAlign := TTextAlign.Leading;
  DisableFocusEffect := True;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  BorderStyle := bsNone;
  {$IFDEF VCLLIB}
  ParentCtl3D := False;
  Ctl3D := False;
  {$ENDIF}
  {$IFDEF WEBLIB}
  ShowFocus := False;
  {$ENDIF}
  TabStop := False;
  DoubleBuffered := False;
  {$ENDIF}
end;

{$IFDEF FMXLIB}
function TTMSFNCDataGridEdit.GetDefaultStyleLookupName: string;
begin
  Result := 'textcellstyle';
end;
{$ENDIF}

{$IFDEF VCLLIB}
procedure TTMSFNCDataGridEdit.WMGetDlgCode(var Message: TWMGetDlgCode);
begin
  inherited;
  Message.Result := Message.Result or DLGC_WANTTAB;
end;
{$ENDIF}

{ TTMSFNCDataGridRendererDataAdapter }

function TTMSFNCDataGridRendererDataAdapter.GetRenderer: TTMSFNCDataGridRenderer;
begin
  if Assigned(DataInstance) and (DataInstance is TTMSFNCDataGridRenderer) then
    Result := DataInstance as TTMSFNCDataGridRenderer
  else
    Result := nil;
end;

procedure TTMSFNCDataGridRendererDataAdapter.SetRenderer(
  const Value: TTMSFNCDataGridRenderer);
begin
  DataInstance := Value;
end;

{ TTMSFNCDataGridEditingOptions }

procedure TTMSFNCDataGridEditingOptions.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridEditingOptions) then
  begin
    FEnabled := (Source as TTMSFNCDataGridEditingOptions).Enabled;
    FDirectDropDown := (Source as TTMSFNCDataGridEditingOptions).DirectDropDown;
    FAutoComplete.Assign((Source as TTMSFNCDataGridEditingOptions).AutoComplete);
  end;
end;

constructor TTMSFNCDataGridEditingOptions.Create;
begin
  FEnabled := True;
  FDirectDropDown := False;
  FAutoComplete := TTMSFNCDataGridAutoCompleteOptions.Create;
end;

destructor TTMSFNCDataGridEditingOptions.Destroy;
begin
  FreeAndNil(FAutoComplete);
  inherited;
end;

procedure TTMSFNCDataGridEditingOptions.SetAutoComplete(
  const Value: TTMSFNCDataGridAutoCompleteOptions);
begin
  if FAutoComplete <> Value then
    FAutoComplete.Assign(Value);
end;

{ TTMSFNCDataGridLookupOptions }

procedure TTMSFNCDataGridLookupOptions.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridLookupOptions) then
  begin
    FCaseSensitive := (Source as TTMSFNCDataGridLookupOptions).CaseSensitive;
    FIncremental := (Source as TTMSFNCDataGridLookupOptions).Incremental;
    FEnabled := (Source as TTMSFNCDataGridLookupOptions).Enabled;
    FResetInterval := (Source as TTMSFNCDataGridLookupOptions).ResetInterval;
  end;
end;

constructor TTMSFNCDataGridLookupOptions.Create;
begin
  inherited;
  FCaseSensitive := False;
  FIncremental := True;
  FEnabled := False;
  FResetInterval := 4000;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCDataGridDatePicker.KeyDown(var Key: Word; var KeyChar: Char; Shift: TShiftState);
var
  IsReturnKey: Boolean;
begin
  IsReturnKey := Key = vkReturn;
  inherited;
  if IsReturnKey and Assigned(OnKeyDown) then
  begin
    Key := vkReturn;
    OnKeyDown(Self, Key, KeyChar, Shift);
  end;
end;
{$ENDIF}

{ TTMSFNCDataGridAutoCompleteOptions }

procedure TTMSFNCDataGridAutoCompleteOptions.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridAutoCompleteOptions then
  begin
    FType := (Source as TTMSFNCDataGridAutoCompleteOptions).&Type;
    FItems.Assign((Source as TTMSFNCDataGridAutoCompleteOptions).Items);
    FCaseSensitive := (Source as TTMSFNCDataGridAutoCompleteOptions).CaseSensitive;
  end;
end;

constructor TTMSFNCDataGridAutoCompleteOptions.Create;
begin
  FType := gactDisabled;
  FCaseSensitive := False;
  FItems := TStringList.Create;
end;

destructor TTMSFNCDataGridAutoCompleteOptions.Destroy;
begin
  FreeAndNil(FItems);
  inherited;
end;

procedure TTMSFNCDataGridAutoCompleteOptions.SetItems(const Value: TStringList);
begin
  if FItems <> Value then
  begin
    FItems.Assign(Value);
  end;
end;

{ TTMSFNCDataGridColumns }

function TTMSFNCDataGridColumns.Add: TTMSFNCDataGridColumn;
begin
  Result := TTMSFNCDataGridColumn(inherited Add);
end;

procedure TTMSFNCDataGridColumns.ClearColumn(AIndex: Integer);
begin
  if Assigned(FRenderer) then
  begin
    FRenderer.ClearDataForColumn(AIndex);
    FRenderer.ClearColumnInfo(AIndex);
  end;
end;

function TTMSFNCDataGridColumns.ColumnByHeader(
  AHeader: string): TTMSFNCDataGridColumn;
var
  i: integer;
begin
  Result := nil;
  for i := 0 to Count - 1 do
  begin
    if (Items[i].Header = AHeader) then
    begin
      Result := Items[i];
      Break;
    end;
  end;
end;

function TTMSFNCDataGridColumns.ColumnByName(AName: string): TTMSFNCDataGridColumn;
var
  i: integer;
begin
  Result := nil;
  for i := 0 to Count - 1 do
  begin
    if (Items[i].Name = AName) then
    begin
      Result := Items[i];
      Break;
    end;
  end;
end;

constructor TTMSFNCDataGridColumns.Create(AHost: TPersistent; ARenderer: TTMSFNCDataGridRenderer);
begin
  inherited Create(AHost, GetColumnClass);
  FRenderer := ARenderer;
end;

function TTMSFNCDataGridColumns.GetColumnClass: TTMSFNCDataGridColumnClass;
begin
  Result := TTMSFNCDataGridColumn;
end;

function TTMSFNCDataGridColumns.GetItem(Index: integer): TTMSFNCDataGridColumn;
begin
  Result := TTMSFNCDataGridColumn(inherited Items[Index]);
end;

function TTMSFNCDataGridColumns.Insert(Index: integer): TTMSFNCDataGridColumn;
begin
  Result := TTMSFNCDataGridColumn(inherited Insert(Index));
end;

procedure TTMSFNCDataGridColumns.SetItem(Index: integer;
  const Value: TTMSFNCDataGridColumn);
begin
  inherited Items[Index] := Value;
end;

procedure TTMSFNCDataGridColumns.UpdateColumns;
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

{ TTMSFNCDataGridColumn }

procedure TTMSFNCDataGridColumn.AddSetting(
  ASetting: TTMSFNCDataGridColumnSetting);
begin
  Settings := Settings + [ASetting];
end;

procedure TTMSFNCDataGridColumn.AppearanceChanged(Sender: TObject);
begin
  UpdateSettings(gcsAppearance);
  UpdateColumn;
end;

procedure TTMSFNCDataGridColumn.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridColumn then
  begin
    FAppearance.Assign((Source as TTMSFNCDataGridColumn).Appearance);
    FSettings := (Source as TTMSFNCDataGridColumn).Settings;
    FType := (Source as TTMSFNCDataGridColumn).&Type;
    FEditor := (Source as TTMSFNCDataGridColumn).Editor;
    FEditorTarget := (Source as TTMSFNCDataGridColumn).EditorTarget;
    FFormatting.Assign((Source as TTMSFNCDataGridColumn).Formatting);
    FBinding.Assign((Source as TTMSFNCDataGridColumn).Binding);
    FEditorItems.Assign((Source as TTMSFNCDataGridColumn).EditorItems);
    FReadOnly := (Source as TTMSFNCDataGridColumn).ReadOnly;
    FTypeRange := (Source as TTMSFNCDataGridColumn).TypeRange;
    FControlText := (Source as TTMSFNCDataGridColumn).ControlText;
    FControlWidth := (Source as TTMSFNCDataGridColumn).ControlWidth;
    FControlHeight := (Source as TTMSFNCDataGridColumn).ControlHeight;
    FControlAlign := (Source as TTMSFNCDataGridColumn).ControlAlign;
    FControlPosition := (Source as TTMSFNCDataGridColumn).ControlPosition;
    FControlMargins.Assign((Source as TTMSFNCDataGridColumn).ControlMargins);
    FFilterButton := (Source as TTMSFNCDataGridColumn).FilterButton;
    FFilterEditor := (Source as TTMSFNCDataGridColumn).FilterEditor;
    FFilterEditorType := (Source as TTMSFNCDataGridColumn).FilterEditorType;
    FFilterDefaultType := (Source as TTMSFNCDataGridColumn).FilterDefaultType;
    FName := (Source as TTMSFNCDataGridColumn).Name;
    FWidth := (Source as TTMSFNCDataGridColumn).FWidth;
    FHeader := (Source as TTMSFNCDataGridColumn).FHeader;
    FVisible := (Source as TTMSFNCDataGridColumn).FVisible;
  end;
end;

procedure TTMSFNCDataGridColumn.BindingChanged(Sender: TObject);
begin
  UpdateColumn;
end;

procedure TTMSFNCDataGridColumn.UpdateColumn;
begin
  if Assigned(FColumns) then
    FColumns.UpdateColumns;
end;

procedure TTMSFNCDataGridColumn.UpdateSettings(ASetting: TTMSFNCDataGridColumnSetting);
begin
  if Assigned(FColumns) and Assigned(FColumns.Renderer) and FColumns.Renderer.IsDesigntime and not FColumns.Renderer.FIsStyling then
    FSettings := FSettings + [ASetting];
end;

procedure TTMSFNCDataGridColumn.ClearColumn;
begin
  if Assigned(FColumns) then
    FColumns.ClearColumn(Index);
end;

constructor TTMSFNCDataGridColumn.Create(ACollection: TCollection);
begin
  inherited;
  FColumns := nil;
  if Collection is TTMSFNCDataGridColumns then
    FColumns := Collection as TTMSFNCDataGridColumns;

  FTypeRange := gcirAll;
  FFilterDefaultType := gftEqual;
  FVisible := True;
  FFilterButton := True;
  FFilterEditor := False;
  FFilterEditorType := gfetAutomatic;
  FFormatting := TTMSFNCDataGridColumnFormatting.Create;
  FFormatting.OnChange := @FormattingChanged;
  FBinding := TTMSFNCDataGridColumnBinding.Create;
  FBinding.OnChange := @BindingChanged;
  FAppearance := TTMSFNCDataGridCellAppearance.Create;
  FAppearance.OnChange := @AppearanceChanged;
  FSettings := [];
  FType := gcitNormal;
  FEditor := getEdit;
  FEditorTarget := getCellValue;
  FEditorItems := TStringList.Create;
  FEditorItems.OnChange := @EditorItemsChanged;
  FControlText := '';
  FControlWidth := -1;
  FControlHeight := -1;
  FControlMargins := TTMSFNCMargins.Create;
  FControlMargins.OnChange := @MarginsChanged;
  if Assigned(Renderer) then
    FWidth := Renderer.ColumnWidths[Index]
  else
    FWidth := 75;
  FHeader := '';
  FControlAlign := gcaNone;
  FControlPosition := gcpCenterRight;
  UpdateColumn;
end;

destructor TTMSFNCDataGridColumn.Destroy;
begin
  FBinding.Free;
  FFormatting.Free;
  FAppearance.Free;
  FEditorItems.Free;
  FControlMargins.Free;
  ClearColumn;
  inherited;
  UpdateColumn;
  FColumns := nil;
end;

procedure TTMSFNCDataGridColumn.EditorItemsChanged(Sender: TObject);
begin
  UpdateSettings(gcsEditorItems);
end;

procedure TTMSFNCDataGridColumn.FormattingChanged(Sender: TObject);
begin
  UpdateSettings(gcsFormatting);
  UpdateColumn;
end;

function TTMSFNCDataGridColumn.GetDisplayName: string;
begin
  if Header = '' then
  begin
    if Name = '' then
      Result := 'Column ' + IntToStr(Index)
    else
      Result := Name;
  end
  else
    Result := Header;
end;

function TTMSFNCDataGridColumn.GetHeader: string;
begin
  Result := FHeader;
  if Assigned(Renderer) then
    Result := Renderer.Strings[Index, 0];
end;

function TTMSFNCDataGridColumn.GetRenderer: TTMSFNCDataGridRenderer;
begin
  Result := nil;
  if Assigned(Collection) and (Collection is TTMSFNCDataGridColumns) then
    Result := (Collection as TTMSFNCDataGridColumns).Renderer;
end;

function TTMSFNCDataGridColumn.GetValueType: TTypeKind;
var
  v: TTMSFNCDataGridCellValue;
begin
  Result := TTypeKind.tkUnknown;
  if Assigned(FColumns) and Assigned(FColumns.FRenderer) then
  begin
    v := FColumns.FRenderer.Cells[Index, FColumns.FRenderer.FixedRowCount];
    Result := TTMSFNCDataGridData.TypeOfValue(v);
  end;
end;

function TTMSFNCDataGridColumn.GetVisible: Boolean;
begin
  Result := FVisible;
end;

function TTMSFNCDataGridColumn.GetWidth: Single;
begin
  Result := FWidth;
end;

function TTMSFNCDataGridColumn.IsControlHeightStored: Boolean;
begin
  Result := ControlHeight <> -1;
end;

function TTMSFNCDataGridColumn.IsControlTextStored: Boolean;
begin
  Result := ControlText <> '';
end;

function TTMSFNCDataGridColumn.IsControlWidthStored: Boolean;
begin
  Result := ControlWidth <> -1;
end;

function TTMSFNCDataGridColumn.IsHeaderStored: Boolean;
begin
  Result := Header <> '';
end;

function TTMSFNCDataGridColumn.IsWidthStored: Boolean;
begin
  Result := Width <> 75;
end;

procedure TTMSFNCDataGridColumn.MarginsChanged(Sender: TObject);
begin
  UpdateSettings(gcsControlMargins);
  UpdateColumn;
end;

procedure TTMSFNCDataGridColumn.RemoveSetting(
  ASetting: TTMSFNCDataGridColumnSetting);
begin
  Settings := Settings - [ASetting];
end;

procedure TTMSFNCDataGridColumn.SetAppearance(
  const Value: TTMSFNCDataGridCellAppearance);
begin
  FAppearance.Assign(Value);
end;

procedure TTMSFNCDataGridColumn.SetBinding(
  const Value: TTMSFNCDataGridColumnBinding);
begin
  if FBinding <> Value then
    FBinding.Assign(Value);
end;

procedure TTMSFNCDataGridColumn.SetControlAlign(
  const Value: TTMSFNCDataGridCellControlAlign);
begin
  if FControlAlign <> Value then
  begin
    FControlAlign := Value;
    UpdateSettings(gcsControlAlign);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetControlHeight(const Value: Integer);
begin
  if FControlHeight <> Value then
  begin
    FControlHeight := Value;
    UpdateSettings(gcsControlHeight);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetControlMargins(const Value: TTMSFNCMargins);
begin
  if FControlMargins <> Value then
  begin
    FControlMargins.Assign(Value);
    UpdateSettings(gcsControlMargins);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetControlPosition(
  const Value: TTMSFNCDataGridCellControlPosition);
begin
  if FControlPosition <> Value then
  begin
    FControlPosition := Value;
    UpdateSettings(gcsControlPosition);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetControlText(const Value: string);
begin
  if FControlText <> Value then
  begin
    FControlText := Value;
    UpdateSettings(gcsControlText);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetControlWidth(const Value: Integer);
begin
  if FControlWidth <> Value then
  begin
    FControlWidth := Value;
    UpdateSettings(gcsControlWidth);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetHeader(const Value: string);
begin
  FHeader := Value;
  if Assigned(Renderer) then
    Renderer.Cells[Index, 0] := Value;
end;

procedure TTMSFNCDataGridColumn.SetIndex(Value: Integer);
begin
  if Assigned(Renderer) then
  begin
    if Assigned(Renderer.Adapter) and (Renderer.Adapter is TTMSFNCDataGridRendererDataAdapter) then
      (Renderer.Adapter as TTMSFNCDataGridRendererDataAdapter).MoveColumn(Index, Value)
    else
      Renderer.MoveColumn(Index, Value);
  end;
end;

procedure TTMSFNCDataGridColumn.SetTypeRange(
  const Value: TTMSFNCDataGridCellItemTypeRange);
begin
  if FTypeRange <> Value then
  begin
    FTypeRange := Value;
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetVisible(const Value: Boolean);
begin
  FVisible := Value;
  if Assigned(Renderer) then
  begin
    if FVisible then
      Renderer.UnhideColumn(Index)
    else
      Renderer.HideColumn(Index);
  end;
end;

procedure TTMSFNCDataGridColumn.SetReadOnly(const Value: Boolean);
begin
  if FReadOnly <> Value then
  begin
    FReadOnly := Value;
    UpdateSettings(gcsReadOnly);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetSettings(
  const Value: TTMSFNCDataGridColumnSettings);
begin
  if FSettings <> Value then
  begin
    FSettings := Value;
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetType(const Value: TTMSFNCDataGridCellItemType);
begin
  if FType <> Value then
  begin
    FType := Value;
    UpdateSettings(gcsType);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetEditor(
  const Value: TTMSFNCDataGridInplaceEditorType);
begin
  if FEditor <> Value then
  begin
    FEditor := Value;
    if FEditor = getColorPicker then
    begin
      if Assigned(FColumns) and Assigned(FColumns.Renderer) and FColumns.Renderer.IsDesigntime then
        FEditorTarget := getFillColor;

      UpdateSettings(gcsEditorTarget);
    end;
    UpdateSettings(gcsEditor);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetEditorItems(const Value: TStringList);
begin
  FEditorItems.Assign(Value);
end;

procedure TTMSFNCDataGridColumn.SetEditorTarget(
  const Value: TTMSFNCDataGridInplaceEditorTarget);
begin
  if FEditorTarget <> Value then
  begin
    FEditorTarget := Value;
    UpdateSettings(gcsEditorTarget);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetFilterEditor(const Value: Boolean);
begin
  if FFilterEditor <> Value then
  begin
    FFilterEditor := Value;
    UpdateSettings(gcsFilterEditor);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetFilterEditorType(
  const Value: TTMSFNCDataGridFilterEditorType);
begin
  if FFilterEditorType <> Value then
  begin
    FFilterEditorType := Value;
    UpdateSettings(gcsFilterEditorType);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetFilterButton(const Value: Boolean);
begin
  if FFilterButton <> Value then
  begin
    FFilterButton := Value;
    UpdateSettings(gcsFilterButton);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetFilterDefaultType(
  const Value: TTMSFNCDataGridDataFilterType);
begin
  if FFilterDefaultType <> Value then
  begin
    FFilterDefaultType := Value;
    UpdateSettings(gcsFilterDefaultType);
    UpdateColumn;
  end;
end;

procedure TTMSFNCDataGridColumn.SetFormatting(
  const Value: TTMSFNCDataGridColumnFormatting);
begin
  FFormatting.Assign(Value);
end;

procedure TTMSFNCDataGridColumn.SetWidth(const Value: Single);
begin
  FWidth := Value;
  if Assigned(Renderer) then
  begin
    Renderer.BlockWidthChange := True;
    Renderer.ColumnWidths[Index] := Value;
    Renderer.BlockWidthChange := False;
  end;
end;

{ TTMSFNCDataGridColumnFormatting }

procedure TTMSFNCDataGridColumnFormatting.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridColumnFormatting then
  begin
    FFormat := (Source as TTMSFNCDataGridColumnFormatting).Format;
    FType := (Source as TTMSFNCDataGridColumnFormatting).&Type;
    FBooleanFalseText := (Source as TTMSFNCDataGridColumnFormatting).BooleanFalseText;
    FBooleanTrueText := (Source as TTMSFNCDataGridColumnFormatting).BooleanTrueText;
  end;
end;

constructor TTMSFNCDataGridColumnFormatting.Create;
begin
  FType := gdftDefault;
  FFormat := '';
  FConvertSettings := FormatSettings;
  FBooleanFalseText := '';
  FBooleanTrueText := '';
end;

function TTMSFNCDataGridColumnFormatting.IsBooleanFalseTextStored: Boolean;
begin
  Result := BooleanFalseText <> '';
end;

function TTMSFNCDataGridColumnFormatting.IsBooleanTrueTextStored: Boolean;
begin
  Result := BooleanTrueText <> '';
end;

function TTMSFNCDataGridColumnFormatting.IsFormatStored: Boolean;
begin
  Result := Format <> '';
end;

procedure TTMSFNCDataGridColumnFormatting.SetFormat(const Value: string);
begin
  if FFormat <> Value then
  begin
    FFormat := Value;
    UpdateColumnFormatting;
  end;
end;

procedure TTMSFNCDataGridColumnFormatting.SetType(
  const Value: TTMSFNCDataGridDataFormattingType);
begin
  if FType <> Value then
  begin
    FType := Value;
    UpdateColumnFormatting;
  end;
end;

procedure TTMSFNCDataGridColumnFormatting.UpdateColumnFormatting;
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

{ TTMSFNCDataGridIOHTMLOptions }

procedure TTMSFNCDataGridIOHTMLOptions.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridIOHTMLOptions then
  begin
    FExportColors := (Source as TTMSFNCDataGridIOHTMLOptions).ExportColors;
    FExportImages := (Source as TTMSFNCDataGridIOHTMLOptions).ExportImages;
    FImageBaseName := (Source as TTMSFNCDataGridIOHTMLOptions).ImageBaseName;
    FImageFolder := (Source as TTMSFNCDataGridIOHTMLOptions).ImageFolder;
    FTableBorderSize := (Source as TTMSFNCDataGridIOHTMLOptions).TableBorderSize;
    FTableCellSpacing := (Source as TTMSFNCDataGridIOHTMLOptions).TableCellSpacing;
    FTableCellPadding := (Source as TTMSFNCDataGridIOHTMLOptions).TableCellPadding;
    FConvertSpecialChars := (Source as TTMSFNCDataGridIOHTMLOptions).ConvertSpecialChars;
    FFooterFile := (Source as TTMSFNCDataGridIOHTMLOptions).FooterFile;
    FFooterText := (Source as TTMSFNCDataGridIOHTMLOptions).FooterText;
    FHeaderFile := (Source as TTMSFNCDataGridIOHTMLOptions).HeaderFile;
    FHeaderText := (Source as TTMSFNCDataGridIOHTMLOptions).HeaderText;
    FNonBreakingText := (Source as TTMSFNCDataGridIOHTMLOptions).NonBreakingText;
    FPrefixTag := (Source as TTMSFNCDataGridIOHTMLOptions).PrefixTag;
    FSuffixTag := (Source as TTMSFNCDataGridIOHTMLOptions).SuffixTag;
    FSummary := (Source as TTMSFNCDataGridIOHTMLOptions).Summary;
    FTableStyle := (Source as TTMSFNCDataGridIOHTMLOptions).TableStyle;
    FTableWidth := (Source as TTMSFNCDataGridIOHTMLOptions).TableWidth;
    FXHTML := (Source as TTMSFNCDataGridIOHTMLOptions).XHTML;
  end;
end;

constructor TTMSFNCDataGridIOHTMLOptions.Create;
begin
  FExportImages := True;
  FExportColors := True;
  FImageBaseName := 'img';
  FImageFolder := 'images';
  FTableBorderSize := 1;
  FTableCellSpacing := 0;
  FTableCellPadding := 0;
  FConvertSpecialChars := False;
  FFooterFile := '';
  FFooterText := '';
  FHeaderFile := '';
  FHeaderText := '';
  FNonBreakingText := False;
  FPrefixTag := '';
  FSuffixTag := '';
  FSummary := '';
  FTableStyle := '';
  FTableWidth := 100;
  FXHTML := False;
end;

function TTMSFNCDataGridIOHTMLOptions.IsImageBaseNameStored: Boolean;
begin
  Result := ImageBaseName <> 'img';
end;

function TTMSFNCDataGridIOHTMLOptions.IsImageFolderStored: Boolean;
begin
  Result := ImageFolder <> 'images';
end;

{ TTMSFNCDataGridIOOptions }

procedure TTMSFNCDataGridIOOptions.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCDataGridIOOptions then
  begin
    FHTML.Assign((Source as TTMSFNCDataGridIOOptions).HTML);
  end;
end;

constructor TTMSFNCDataGridIOOptions.Create;
begin
  inherited;
  FHTML := TTMSFNCDataGridIOHTMLOptions.Create;
end;

destructor TTMSFNCDataGridIOOptions.Destroy;
begin
  FreeAndNil(FHTML);
  inherited;
end;

procedure TTMSFNCDataGridIOOptions.SetHTML(
  const Value: TTMSFNCDataGridIOHTMLOptions);
begin
  if FHTML <> Value then
    FHTML.Assign(Value);
end;

{ TTMSFNCDataGridFilterAppearance }

procedure TTMSFNCDataGridFilterAppearance.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridFilterAppearance) then
  begin
    FFill.Assign((Source as TTMSFNCDataGridFilterAppearance).Fill);
    FStroke.Assign((Source as TTMSFNCDataGridFilterAppearance).Stroke);
    FFont.Assign((Source as TTMSFNCDataGridFilterAppearance).Font);
  end
  else
    inherited;
end;

constructor TTMSFNCDataGridFilterAppearance.Create;
begin
  FFill := TTMSFNCGraphicsFill.Create(gfkSolid, gcWhite);
  FFill.OnChanged := @DoFillChanged;
  FStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcSilver);
  FStroke.OnChanged := @DoStrokeChanged;
  FFont := TTMSFNCGraphicsFont.Create;
  FFont.OnChanged := @DoFontChanged;
end;

destructor TTMSFNCDataGridFilterAppearance.Destroy;
begin
  FFont.Free;
  FStroke.Free;
  FFill.Free;
  inherited;
end;

procedure TTMSFNCDataGridFilterAppearance.DoChange(Sender: TObject);
begin

end;

procedure TTMSFNCDataGridFilterAppearance.DoFillChanged(Sender: TObject);
begin
  DoChange(Self);
end;

procedure TTMSFNCDataGridFilterAppearance.DoFontChanged(Sender: TObject);
begin
  DoChange(Self);
end;

procedure TTMSFNCDataGridFilterAppearance.DoStrokeChanged(Sender: TObject);
begin
  DoChange(Self);
end;

procedure TTMSFNCDataGridFilterAppearance.SetFill(const Value: TTMSFNCGraphicsFill);
begin
  FFill.Assign(Value);
  DoFillChanged(FFill);
end;

procedure TTMSFNCDataGridFilterAppearance.SetFont(const Value: TTMSFNCGraphicsFont);
begin
  FFont.Assign(Value);
  DoFontChanged(FFont);
end;

procedure TTMSFNCDataGridFilterAppearance.SetStroke(const Value: TTMSFNCGraphicsStroke);
begin
  FStroke.Assign(Value);
end;

{ TTMSFNCDataGridDragAppearance }

procedure TTMSFNCDataGridDragAppearance.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCDataGridDragAppearance) then
  begin
    FFill.Assign((Source as TTMSFNCDataGridDragAppearance).Fill);
    FStroke.Assign((Source as TTMSFNCDataGridDragAppearance).Stroke);
    FSize := (Source as TTMSFNCDataGridDragAppearance).Size;
  end
  else
    inherited;
end;

constructor TTMSFNCDataGridDragAppearance.Create;
begin
  FFill := TTMSFNCGraphicsFill.Create(gfkSolid, Lighter(gcSteelblue, 30));
  FFill.OnChanged := @DoFillChanged;
  FStroke := TTMSFNCGraphicsStroke.Create(gskSolid, Lighter(gcSteelblue, 30));
  FStroke.OnChanged := @DoStrokeChanged;
  FSize := 12;
end;

destructor TTMSFNCDataGridDragAppearance.Destroy;
begin
  FStroke.Free;
  FFill.Free;
  inherited;
end;

procedure TTMSFNCDataGridDragAppearance.DoChange(Sender: TObject);
begin

end;

procedure TTMSFNCDataGridDragAppearance.DoFillChanged(Sender: TObject);
begin
  DoChange(Self);
end;

procedure TTMSFNCDataGridDragAppearance.DoStrokeChanged(Sender: TObject);
begin
  DoChange(Self);
end;

function TTMSFNCDataGridDragAppearance.IsSizeStored: Boolean;
begin
  Result := Size <> 12;
end;

procedure TTMSFNCDataGridDragAppearance.SetFill(const Value: TTMSFNCGraphicsFill);
begin
  FFill.Assign(Value);
  DoFillChanged(FFill);
end;

procedure TTMSFNCDataGridDragAppearance.SetSize(const Value: Single);
begin
  if FSize <> Value then
  begin
    FSize := Value;
    DoChange(Self);
  end;
end;

procedure TTMSFNCDataGridDragAppearance.SetStroke(const Value: TTMSFNCGraphicsStroke);
begin
  FStroke.Assign(Value);
end;

{ TTMSFNCDataGridColumnBinding }

procedure TTMSFNCDataGridColumnBinding.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridColumnBinding then
  begin
    FBooleanFalseValue := (Source as TTMSFNCDataGridColumnBinding).BooleanFalseValue;
    FBooleanTrueValue := (Source as TTMSFNCDataGridColumnBinding).BooleanTrueValue;
  end;
end;

constructor TTMSFNCDataGridColumnBinding.Create;
begin
  FBooleanFalseValue := 'False';
  FBooleanTrueValue := 'True';
end;

function TTMSFNCDataGridColumnBinding.IsBooleanFalseValueStored: Boolean;
begin
  Result :=  BooleanFalseValue <> 'False';
end;

function TTMSFNCDataGridColumnBinding.IsBooleanTrueValueStored: Boolean;
begin
  Result :=  BooleanTrueValue <> 'True';
end;

procedure TTMSFNCDataGridColumnBinding.SetBooleanFalseValue(
  const Value: string);
begin
  if FBooleanFalseValue <> '' then
  begin
    FBooleanFalseValue := Value;
    UpdateColumnBinding;
  end;
end;

procedure TTMSFNCDataGridColumnBinding.SetBooleanTrueValue(const Value: string);
begin
  if FBooleanTrueValue <> '' then
  begin
    FBooleanTrueValue := Value;
    UpdateColumnBinding;
  end;
end;

procedure TTMSFNCDataGridColumnBinding.UpdateColumnBinding;
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

{ TTMSFNCDataGridStretchingOptions }

procedure TTMSFNCDataGridStretchingOptions.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridStretchingOptions then
  begin
    FEnabled := (Source as TTMSFNCDataGridStretchingOptions).Enabled;
    FIndex := (Source as TTMSFNCDataGridStretchingOptions).&Index;
    FMode := (Source as TTMSFNCDataGridStretchingOptions).Mode;
    FRange := (Source as TTMSFNCDataGridStretchingOptions).Range;
  end;
end;

constructor TTMSFNCDataGridStretchingOptions.Create;
begin
  FEnabled := False;
  FIndex := -1;
  FMode := gstmAll;
  FRange := gstrNormal;
end;

procedure TTMSFNCDataGridStretchingOptions.SetEnabled(const Value: Boolean);
begin
  if FEnabled <> Value then
  begin
    FEnabled := Value;
    if Assigned(FOnChangeRebuild) then
      FOnChangeRebuild(Self);
  end;
end;

procedure TTMSFNCDataGridStretchingOptions.SetIndex(const Value: Integer);
begin
  if FIndex <> Value then
  begin
    FIndex := Value;
    if Assigned(FOnChangeRebuild) then
      FOnChangeRebuild(Self);
  end;
end;

procedure TTMSFNCDataGridStretchingOptions.SetMode(
  const Value: TTMSFNCDataGridStretchingMode);
begin
  if FMode <> Value then
  begin
    FMode := Value;
    if Assigned(FOnChangeRebuild) then
      FOnChangeRebuild(Self);
  end;
end;

procedure TTMSFNCDataGridStretchingOptions.SetRange(
  const Value: TTMSFNCDataGridStretchingRange);
begin
  if FRange <> Value then
  begin
    FRange := Value;
    if Assigned(FOnChangeRebuild) then
      FOnChangeRebuild(Self);
  end;
end;

{ TTMSFNCDataGridColumnOptions }

procedure TTMSFNCDataGridColumnOptions.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCDataGridColumnOptions then
  begin
    FFixedAutoCheckAll := (Source as TTMSFNCDataGridColumnOptions).FixedAutoCheckAll;
    FNodeIndex := (Source as TTMSFNCDataGridColumnOptions).NodeIndex;
  end;
end;

constructor TTMSFNCDataGridColumnOptions.Create;
begin
  inherited;
  FFixedAutoCheckAll := True;
  FNodeIndex := 0;
end;

procedure TTMSFNCDataGridColumnOptions.SetNodeIndex(const Value: Integer);
begin
  if FNodeIndex <> Value then
  begin
    FNodeIndex := Value;
    if Assigned(OnChangeRebuild) then
      OnChangeRebuild(Self);
  end;
end;

{ TTMSFNCDataGridFilterPanel }

constructor TTMSFNCDataGridFilterPanel.Create(AOwner: TComponent; ARenderer: TTMSFNCDataGridRenderer; ACell: TTMSFNCDataGridCellCoord; AType: TTMSFNCDataGridFilterEditorType);
var
  it: TTMSFNCListBoxItem;
  I: TTMSFNCDataGridDataFilterType;
begin
  inherited Create(AOwner);

  DisableBackground;
  TabStop := False;

  FAutoHideControls := True;
  FCell := ACell;
  FType := AType;
  FRenderer := ARenderer;

  FTypeButton := TTMSFNCToolBarButton.Create(Self);
  FTypeButton.Stored := False;
  FTypeButton.Parent := Self;
  FTypeButton.TabStop := False;
  FTypeButton.Appearance.FlatStyle := True;
  FTypeButton.Width := 25;
  FTypeButton.Height := 22;
  FTypeButton.Text := '';
  FTypeButton.HorizontalTextAlign := gtaLeading;
  FTypeButton.Appearance.NormalFill.Color := gcWhite;
  FTypeButton.Appearance.NormalStroke.Color := gcWhite;
  FTypeButton.ShowHint := True;
  if Assigned(FRenderer) then
  begin
    FTypeButton.Hint := FRenderer.Options.Localization.FilterTypeButtonHint;
    FTypeButton.Bitmaps.AddBitmap(FRenderer.Icons.FilterTypeIcon);
  end;

  FTypeButton.AdaptToStyle := AdaptToStyle;
  FTypeButton.DataInteger := FCell.Column;  

  FTypeListBox := TTMSFNCListBox.Create(Self);
  FTypeListBox.OnItemSelected := DoTypeListBoxSelected;

  case AType of
    gfetString:
    begin
      for I := Low(TTMSFNCDataGridDataFilterTextType) to High(TTMSFNCDataGridDataFilterTextType) do
      begin
        it := FTypeListBox.Items.Add;
        it.DataInteger := Integer(I);
        if Assigned(FRenderer) then
          it.Text := FRenderer.GetFilterTypeName(I);
      end;
    end;
    gfetNumber, gfetFloat, gfetDateTime, gfetBoolean:
    begin
      for I := Low(TTMSFNCDataGridDataFilterNumberType) to High(TTMSFNCDataGridDataFilterNumberType) do
      begin
        it := FTypeListBox.Items.Add;
        it.DataInteger := Integer(I);
        if Assigned(FRenderer) then
          it.Text := FRenderer.GetFilterTypeName(I);
      end;
    end;
    gfetCustom:
    begin
      for I := Low(TTMSFNCDataGridDataFilterType) to High(TTMSFNCDataGridDataFilterType) do
      begin
        it := FTypeListBox.Items.Add;
        it.DataInteger := Integer(I);
        if Assigned(FRenderer) then
          it.Text := FRenderer.GetFilterTypeName(I);
      end;
    end;
  end;

  FTypeListBox.ItemIndex := ItemIndexByType(GetDefaultFilterType(FType));
  FTypeListBox.Height := Round(FTypeListBox.Items.Count * FTypeListBox.ItemsAppearance.FixedHeight) + 4;
  FTypeListBox.Width := 150;
  FTypeButton.DropDownControl := FTypeListBox;
  FTypeButton.OnClick := DoTypeButtonClick;
  
  FTypeListBox.AdaptToStyle := AdaptToStyle;
  FTypeListBox.DataInteger := FCell.Column;     

  FClearButton := TTMSFNCToolBarButton.Create(Self);
  FClearButton.Stored := False;
  FClearButton.TabStop := False;
  FClearButton.Parent := Self;
  FClearButton.Appearance.FlatStyle := True;
  FClearButton.Width := 25;
  FClearButton.Height := 22;
  FClearButton.Text := '';
  FClearButton.HorizontalTextAlign := gtaLeading;
  FClearButton.Appearance.NormalFill.Color := gcWhite;
  FClearButton.Appearance.NormalStroke.Color := gcWhite;
  FClearButton.ShowHint := True;
  if Assigned(FRenderer) then
  begin
    FClearButton.Bitmaps.AddBitmap(FRenderer.Icons.FilterClearIcon);
    FClearButton.Hint := FRenderer.Options.Localization.FilterClearButtonHint;
  end;

  if Assigned(FRenderer) then
    FClearButton.OnClick := DoClearClick;

  FClearButton.AdaptToStyle := AdaptToStyle;
  FClearButton.DataInteger := FCell.Column;

  case AType of
    gfetString: FEditor := TTMSFNCEdit.Create(Self);
    gfetBoolean:
    begin
      FEditor := TCheckBox.Create(Self);
      (FEditor as TCheckBox).Width := 20;
    end;
    gfetDateTime:
    begin
      FEditor := TTMSFNCDataGridDatePicker.Create(Self);
      {$IFDEF FMXLIB}
      (FEditor as TTMSFNCDataGridDatePicker).IsEmpty := True;
      {$ELSE}
      (FEditor as TTMSFNCDataGridDatePicker).Date := 0;
      {$ENDIF}
    end;
    gfetFloat: FEditor := TTMSFNCDataGridSpinBox.Create(Self);
    gfetNumber: FEditor := TTMSFNCDataGridSpinBox.Create(Self);
  end;

  if Assigned(FEditor) then
  begin
    {$IFDEF FMXLIB}
    FEditor.Stored := False;
    {$ENDIF}

    FEditor.Parent := Self;

    if FEditor is TTMSFNCEdit then
    begin
      {$IFDEF FMXLIB}
      (FEditor as TTMSFNCEdit).OnChangeTracking := DoEditorChange
      {$ELSE}
      (FEditor as TTMSFNCEdit).OnChange := @DoEditorChange
      {$ENDIF}
    end
    else if FEditor is TCheckBox then
    begin
      {$IFDEF FMXLIB}
      (FEditor as TCheckBox).OnChange := @DoEditorChange
      {$ELSE}
      (FEditor as TCheckBox).OnClick := DoEditorChange
      {$ENDIF}
    end
    else if FEditor is TTMSFNCDataGridDatePicker then
      (FEditor as TTMSFNCDataGridDatePicker).OnChange := @DoEditorChange
    else if FEditor is TTMSFNCDataGridSpinBox then
    begin
      {$IFDEF FMXLIB}
      (FEditor as TTMSFNCDataGridSpinBox).OnChangeTracking := DoEditorChange;
      {$ELSE}
      (FEditor as TTMSFNCDataGridSpinBox).OnChange := @DoEditorChange;
      {$ENDIF}
    end;

    FEditor.TabOrder := FCell.Column;

    if FEditor is TTMSFNCCustomControl then
      (FEditor as TTMSFNCCustomControl).AdaptToStyle := AdaptToStyle;
  end;
end;

destructor TTMSFNCDataGridFilterPanel.Destroy;
begin
  FreeAndNil(FEditorTimer);
  FreeAndNil(FEditor);
  FreeAndNil(FTypeListBox);
  FreeAndNil(FClearButton);
  FreeAndNil(FTypeButton);
  FreeAndNil(FTypeListBox);
  inherited;
end;

procedure TTMSFNCDataGridFilterPanel.DoClearClick(Sender: TObject);
begin
  if not Assigned(FRenderer) then
    Exit;

  if Assigned(FEditor) then
  begin
    FBlockChange := True;
    if FEditor is TTMSFNCEdit then
      (FEditor as TTMSFNCEdit).Text := ''
    else if FEditor is TTMSFNCDataGridCheckBox then
    begin
      {$IFDEF FMXLIB}
      (FEditor as TTMSFNCDataGridCheckBox).IsChecked := False;
      {$ELSE}
      (FEditor as TTMSFNCDataGridCheckBox).Checked := False;
      {$ENDIF}
    end
    else if FEditor is TTMSFNCDataGridDatePicker then
    begin
      {$IFDEF FMXLIB}
      (FEditor as TTMSFNCDataGridDatePicker).IsEmpty := True;
      {$ELSE}
      (FEditor as TTMSFNCDataGridDatePicker).Date := 0;
      {$ENDIF}
    end
    else if FEditor is TTMSFNCDataGridSpinBox then
    begin
      (FEditor as TTMSFNCDataGridSpinBox).Text := '';
    end;

    FBlockChange := False;
  end;

  FRenderer.DoFilterClearClick(Sender);
end;

procedure TTMSFNCDataGridFilterPanel.DoEditorChange(Sender: TObject);
begin
  if FBlockChange then
    Exit;

  FEditorTime := 0;
  EditorTimer.Enabled := True;
end;

procedure TTMSFNCDataGridFilterPanel.DoEditorTimerChanged(Sender: TObject);
var
  v: TTMSFNCDataGridCellValue;
  fdt: TTMSFNCDataGridDataFilterType;
begin
  Inc(FEditorTime);
  if FEditorTime >= FILTERDELAY then
  begin
    FEditorTimer.Enabled := False;

    if not Assigned(FRenderer) or not Assigned(FEditor) or FBlockChange then
      Exit;

    if FEditor is TTMSFNCDataGridSpinBox then
      v := GetObjectValue(FEditor, 'Text')
    else
      v := GetObjectValue(FEditor);

    fdt := gftContains;
    if Assigned(FTypeButton) and FTypeButton.Visible and (FTypeListBox.ItemIndex <> -1) then
      fdt := TTMSFNCDataGridDataFilterType(FTypeListBox.Items[FTypeListBox.ItemIndex].DataInteger);

    FRenderer.ApplyFilterFromValue(FCell.Column, v, fdt);
  end;
end;

procedure TTMSFNCDataGridFilterPanel.DoTypeButtonClick(Sender: TObject);
begin
  if Assigned(FTypeButton) then
    FTypeButton.DropDown;
end;

procedure TTMSFNCDataGridFilterPanel.DoTypeListBoxSelected(Sender: TObject; AItem: TTMSFNCListBoxItem);
begin
  if Assigned(FTypeButton) then
    FTypeButton.CloseDropDown;

  DoEditorChange(Sender);
end;

function TTMSFNCDataGridFilterPanel.GetDefaultFilterType(
  AType: TTMSFNCDataGridFilterEditorType): TTMSFNCDataGridDataFilterType;
var
  cl: TTMSFNCDataGridColumn;
begin
  if Assigned(FRenderer) then
  begin
    cl := FRenderer.GetColumn(FCell.Column);
    if Assigned(cl) and (gcsFilterDefaultType in cl.Settings) then
    begin
      Result := cl.FilterDefaultType;
      Exit;
    end;
  end;

  case AType of
    gfetString, gfetCustom: Result := gftContains;
    gfetBoolean, gfetDateTime, gfetFloat, gfetNumber: Result := gftEqual;
    else
      Result := gftContains;
  end;
end;

function TTMSFNCDataGridFilterPanel.GetEditorTimer: TTimer;
begin
  if not Assigned(FEditorTimer) then
  begin
    FEditorTimer := TTimer.Create(nil);
    FEditorTimer.Enabled := False;
    FEditorTimer.Interval := 1;
    FEditorTimer.OnTimer := DoEditorTimerChanged;
  end;

  Result := FEditorTimer;
end;

function TTMSFNCDataGridFilterPanel.ItemIndexByType(
  AType: TTMSFNCDataGridDataFilterType): Integer;
var
  I: Integer;
  d: Integer;
begin
  Result := -1;
  for I := 0 to TypeListBox.Items.Count - 1 do
  begin
    d := TypeListBox.Items[I].DataInteger;
    if d = Integer(AType) then
    begin
      Result := I;
      break;
    end;
  end;
end;

procedure TTMSFNCDataGridFilterPanel.Notification(AComponent: TComponent;
  Operation: TOperation);
begin
  inherited;
  if (Operation = opRemove) and not (csDestroying in ComponentState) then
  begin
    if (AComponent = FClearButton) then
      FClearButton := nil;

    if (AComponent = FTypeButton) then
      FTypeButton := nil;

    if (AComponent = FEditor) then
      FEditor := nil;

    if (AComponent = FTypeListBox) then
      FTypeListBox := nil;
  end;
end;

procedure TTMSFNCDataGridFilterPanel.Reset;
begin
  FBlockChange := True;
  if Assigned(FTypeListBox) then
    FTypeListBox.ItemIndex := ItemIndexByType(GetDefaultFilterType(FType));

  if Assigned(FEditor) then
    SetObjectValue(FEditor, TValueToCellValue(TValue.Empty));

  FBlockChange := False;
end;

procedure TTMSFNCDataGridFilterPanel.SetFilter(
  AFilter: TTMSFNCDataGridDataFilterData);
begin
  if Assigned(AFilter) then
  begin
    FBlockChange := True;
    if Assigned(FTypeListBox) then
      FTypeListBox.ItemIndex := ItemIndexByType(AFilter.&Type);

    if Assigned(FEditor) then
      SetObjectValue(FEditor, AFilter.Condition);

    FBlockChange := False;
  end;
end;

procedure TTMSFNCDataGridFilterPanel.UpdateControlAfterResize;
begin
  inherited;

  if Assigned(FTypeButton) then
  begin
    FTypeButton.Left := 5;
    FTypeButton.Top := Round((Height - FTypeButton.Height) / 2);
  end;

  if Assigned(FClearButton) then
  begin
    FClearButton.Left := Width - FClearButton.Width - 5;
    FClearButton.Top := Round((Height - FClearButton.Height) / 2);
  end;

  if Assigned(FEditor) then
  begin
    {$IFDEF FMXLIB}
    FEditor.Position.X := 5;
    FEditor.Position.Y := Round((Height - FEditor.Height) / 2);
    {$ELSE}
    FEditor.Left := 5;
    FEditor.Top := (Height - FEditor.Height) div 2;
    {$ENDIF}

    if Assigned(FClearButton) and AutoHideControls then
      FClearButton.Visible := Width - FClearButton.Width - 15 > 85;

    if Assigned(FClearButton) and FClearButton.Visible then
      FEditor.Width := Width - FClearButton.Width - 15
    else
      FEditor.Width := Width - 5;

    if Assigned(FTypeButton) and AutoHideControls then
      FTypeButton.Visible := FEditor.Width > 85;

    if Assigned(FTypeButton) and FTypeButton.Visible then
    begin
      {$IFDEF FMXLIB}
      FEditor.Position.X := FEditor.Position.X + FTypeButton.Width + 5;
      {$ELSE}
      FEditor.Left := FEditor.Left + FTypeButton.Width + 5;
      {$ENDIF}
      FEditor.Width := FEditor.Width - FTypeButton.Width - 5;
    end;
  end;
end;

{ TComboBoxSafe }

constructor TComboBoxSafe.Create(AOwner: TComponent);
begin
  inherited;
  {$IFDEF VCLLIB}
  FSafeItemIndex := -1;
  {$ENDIF}
end;

{$IFDEF VCLLIB}
procedure TComboBoxSafe.CreateWnd;
var
  LOnChange: TNotifyEvent;
  I: Integer;
begin
  inherited;
  LOnChange := OnChange;
  OnChange := nil;
  try
    Items.Clear;
    for I := 0 to Length(FSafeItems) - 1 do
      Items.Add(FSafeItems[I]);
    ItemIndex := FSafeItemIndex;
  finally
    OnChange := LOnChange;
  end;
end;

procedure TComboBoxSafe.DestroyWnd;
begin
  FSafeItemIndex := ItemIndex;
  FSafeItems := Items.ToStringArray;
  inherited;
end;
{$ENDIF}

function TComboBoxSafe.GetSafeItemIndex: Integer;
begin
  {$IFDEF VCLLIB}
  if WindowHandle <> 0 then
  {$ENDIF}
    Result := ItemIndex
  {$IFDEF VCLLIB}
  else
    Result := FSafeItemIndex;
  {$ENDIF}
end;

function TComboBoxSafe.GetSafeItems: TArray<string>;
begin
  {$IFDEF VCLLIB}
  if WindowHandle <> 0 then
  {$ENDIF}
    Result := Items.ToStringArray
  {$IFDEF VCLLIB}
  else
    Result := FSafeItems;
  {$ENDIF}
end;

procedure TComboBoxSafe.SetSafeItemIndex(const AValue: Integer);
begin
  {$IFDEF VCLLIB}
  if WindowHandle <> 0 then
  {$ENDIF}
    ItemIndex := AValue
  {$IFDEF VCLLIB}
  else
    FSafeItemIndex := AValue;
  {$ENDIF}
end;

procedure TComboBoxSafe.SetSafeItems(const AValue: TArray<string>);
var
  I: Integer;
begin
  {$IFDEF VCLLIB}
  if WindowHandle <> 0 then
  begin
  {$ENDIF}
    Items.Clear;
    for I := 0 to Length(AValue) - 1 do
      Items.Add(AValue[I]);
  {$IFDEF VCLLIB}
  end
  else
    FSafeItems := AValue;
  {$ENDIF}
end;

{$IFDEF WEBLIB}

{ TTMSFNCDataGridCellControlWrapperListItem }

constructor TTMSFNCDataGridCellControlWrapperListItem.Create(AKey: string;
  AWrapper: TTMSFNCDataGridCellControlWrapper);
begin
  FKey := AKey;
  FWrapper := AWrapper;
end;

{ TTMSFNCDataGridCellControlWrapperList }

procedure TTMSFNCDataGridCellControlWrapperList.AddOrSetValue(AKey: string;
  AWrapper: TTMSFNCDataGridCellControlWrapper);
var
  I: Integer;
  it: TTMSFNCDataGridCellControlWrapperListItem;
begin
  it := nil;
  for I := 0 to Count - 1 do
  begin
    if AKey = Items[I].Key then
    begin
      it := Items[I];
      Break;
    end;
  end;

  if not Assigned(it) then
  begin
    it := TTMSFNCDataGridCellControlWrapperListItem.Create(AKey, AWrapper);
    Add(it);
  end
  else
    it.Wrapper := AWrapper;
end;

function TTMSFNCDataGridCellControlWrapperList.GetKeys: TArray<string>;
var
  I: Integer;
begin
  SetLength(Result, Count);
  for I := 0 to Count - 1 do
    Result[I] := Items[I].Key;
end;

procedure TTMSFNCDataGridCellControlWrapperList.Remove(AKey: string);
var
  I: Integer;
  it: Integer;
begin
  it := -1;
  for I := 0 to Count - 1 do
  begin
    if AKey = Items[I].Key then
    begin
      it := I;
      Break;
    end;
  end;

  if it <> -1 then
    Self.Delete(it);
end;

function TTMSFNCDataGridCellControlWrapperList.TryGetValue(AKey: string;
  var AWrapper: TTMSFNCDataGridCellControlWrapper): Boolean;
var
  I: Integer;
begin
  Result := False;
  for I := 0 to Count - 1 do
  begin
    if AKey = Items[I].Key then
    begin
      AWrapper := Items[I].Wrapper;
      Result := True;
      Break;
    end;
  end;
end;
{$ENDIF}

{ TTMSFNCDataGridLocalizationOptions }

procedure TTMSFNCDataGridLocalizationOptions.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridLocalizationOptions then
  begin
    FFilterClearButtonHint := (Source as TTMSFNCDataGridLocalizationOptions).FilterClearButtonHint;
    FFilterTypeButtonHint := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeButtonHint;
    FFilterAllText := (Source as TTMSFNCDataGridLocalizationOptions).FilterAllText;
    FFilterEmptyText := (Source as TTMSFNCDataGridLocalizationOptions).FilterEmptyText;
    FFilterNotEmptyText := (Source as TTMSFNCDataGridLocalizationOptions).FilterNotEmptyText;
    FFilterEditPrompt := (Source as TTMSFNCDataGridLocalizationOptions).FilterEditPrompt;
    FFilterSortButtonAscendingText := (Source as TTMSFNCDataGridLocalizationOptions).FilterSortButtonAscendingText;
    FFilterSortButtonDescendingText := (Source as TTMSFNCDataGridLocalizationOptions).FilterSortButtonDescendingText;
    FFilterSortButtonAscendingHint := (Source as TTMSFNCDataGridLocalizationOptions).FilterSortButtonAscendingHint;
    FFilterSortButtonDescendingHint := (Source as TTMSFNCDataGridLocalizationOptions).FilterSortButtonDescendingHint;
    FFilterTypeEmptyText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeEmptyText;
    FFilterTypeNotEmptyText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeNotEmptyText;
    FFilterTypeStartsWithText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeStartsWithText;
    FFilterTypeEndsWithText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeEndsWithText;
    FFilterTypeContainsText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeContainsText;
    FFilterTypeNotContainsText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeNotContainsText;
    FFilterTypeEqualText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeEqualText;
    FFilterTypeNotEqualText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeNotEqualText;
    FFilterTypeLargerThanText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeLargerThanText;
    FFilterTypeSmallerThanText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeSmallerThanText;
    FFilterTypeLargerOrEqualThanText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeLargerOrEqualThanText;
    FFilterTypeSmallerOrEqualThanText := (Source as TTMSFNCDataGridLocalizationOptions).FilterTypeSmallerOrEqualThanText;
  end;
end;

constructor TTMSFNCDataGridLocalizationOptions.Create;
begin
  FFilterClearButtonHint := sTMSFNCDataGridFilterClearButtonHint;
  FFilterTypeButtonHint := sTMSFNCDataGridFilterTypeButtonHint;
  FFilterTypeNotContainsText := sTMSFNCDataGridFilterTypeNotContainsText;
  FFilterTypeNotEqualText := sTMSFNCDataGridFilterTypeNotEqualText;
  FFilterTypeEmptyText := sTMSFNCDataGridFilterTypeEmptyText;
  FFilterAllText := sTMSFNCDataGridFilterAllText;
  FFilterEmptyText := sTMSFNCDataGridFilterEmptyText;
  FFilterNotEmptyText := sTMSFNCDataGridFilterNotEmptyText;
  FFilterTypeNotEmptyText := sTMSFNCDataGridFilterTypeNotEmptyText;
  FFilterTypeSmallerThanText := sTMSFNCDataGridFilterTypeSmallerThanText;
  FFilterTypeLargerThanText := sTMSFNCDataGridFilterTypeLargerThanText;
  FFilterTypeStartsWithText := sTMSFNCDataGridFilterTypeStartsWithText;
  FFilterSortButtonDescendingText := sTMSFNCDataGridFilterSortButtonDescendingText;
  FFilterSortButtonAscendingText := sTMSFNCDataGridFilterSortButtonAscendingText;
  FFilterSortButtonDescendingHint := sTMSFNCDataGridFilterSortButtonDescendingHint;
  FFilterSortButtonAscendingHint := sTMSFNCDataGridFilterSortButtonAscendingHint;
  FFilterTypeSmallerOrEqualThanText := sTMSFNCDataGridFilterTypeSmallerOrEqualThanText;
  FFilterTypeLargerOrEqualThanText := sTMSFNCDataGridFilterTypeLargerOrEqualThanText;
  FFilterTypeEndsWithText := sTMSFNCDataGridFilterTypeEndsWithText;
  FFilterTypeContainsText := sTMSFNCDataGridFilterTypeContainsText;
  FFilterEditPrompt := sTMSFNCDataGridFilterEditPrompt;
  FFilterTypeEqualText := sTMSFNCDataGridFilterTypeEqualText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterAllTextStored: Boolean;
begin
  Result := FilterAllText <> sTMSFNCDataGridFilterAllText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterEmptyTextStored: Boolean;
begin
  Result := FilterEmptyText <> sTMSFNCDataGridFilterEmptyText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterNotEmptyTextStored: Boolean;
begin
  Result := FilterNotEmptyText <> sTMSFNCDataGridFilterNotEmptyText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterClearButtonHintStored: Boolean;
begin
  Result := FilterClearButtonHint <> sTMSFNCDataGridFilterClearButtonHint;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterEditPromptStored: Boolean;
begin
  Result := FilterEditPrompt <> sTMSFNCDataGridFilterEditPrompt;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterSortButtonAscendingHintStored: Boolean;
begin
  Result := FilterSortButtonAscendingHint <> sTMSFNCDataGridFilterSortButtonAscendingHint;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterSortButtonAscendingTextStored: Boolean;
begin
  Result := FilterSortButtonAscendingText <> sTMSFNCDataGridFilterSortButtonAscendingText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterSortButtonDescendingHintStored: Boolean;
begin
  Result := FilterSortButtonDescendingHint <> sTMSFNCDataGridFilterSortButtonDescendingHint;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterSortButtonDescendingTextStored: Boolean;
begin
  Result := FilterSortButtonDescendingText <> sTMSFNCDataGridFilterSortButtonDescendingText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeButtonHintStored: Boolean;
begin
  Result := FilterTypeButtonHint <> sTMSFNCDataGridFilterTypeButtonHint;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeContainsTextStored: Boolean;
begin
  Result := FilterTypeContainsText <> sTMSFNCDataGridFilterTypeContainsText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeEmptyTextStored: Boolean;
begin
  Result := FilterTypeEmptyText <> sTMSFNCDataGridFilterTypeEmptyText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeEndsWithTextStored: Boolean;
begin
  Result := FilterTypeEndsWithText <> sTMSFNCDataGridFilterTypeEndsWithText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeEqualTextStored: Boolean;
begin
  Result := FilterTypeEqualText <> sTMSFNCDataGridFilterTypeEqualText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeLargerOrEqualThanTextStored: Boolean;
begin
  Result := FilterTypeLargerOrEqualThanText <> sTMSFNCDataGridFilterTypeLargerOrEqualThanText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeLargerThanTextStored: Boolean;
begin
  Result := FilterTypeLargerThanText <> sTMSFNCDataGridFilterTypeLargerThanText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeNotContainsTextStored: Boolean;
begin
  Result := FilterTypeNotContainsText <> sTMSFNCDataGridFilterTypeNotContainsText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeNotEmptyTextStored: Boolean;
begin
  Result := FilterTypeNotEmptyText <> sTMSFNCDataGridFilterTypeNotEmptyText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeNotEqualTextStored: Boolean;
begin
  Result := FilterTypeNotEqualText <> sTMSFNCDataGridFilterTypeNotEqualText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeSmallerOrEqualThanTextStored: Boolean;
begin
  Result := FilterTypeSmallerOrEqualThanText <> sTMSFNCDataGridFilterTypeSmallerOrEqualThanText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeSmallerThanTextStored: Boolean;
begin
  Result := FilterTypeSmallerThanText <> sTMSFNCDataGridFilterTypeSmallerThanText;
end;

function TTMSFNCDataGridLocalizationOptions.IsFilterTypeStartsWithTextStored: Boolean;
begin
  Result := FilterTypeStartsWithText <> sTMSFNCDataGridFilterTypeStartsWithText;
end;

{ TTMSFNCDataGridInplaceEditorHelper }

function TTMSFNCDataGridInplaceEditorHelper.AsColorPicker: TTMSFNCDataGridColorPicker;
begin
  Result := Self as TTMSFNCDataGridColorPicker;
end;

function TTMSFNCDataGridInplaceEditorHelper.AsComboBox: TTMSFNCDataGridComboBox;
begin
  Result := Self as TTMSFNCDataGridComboBox;
end;

function TTMSFNCDataGridInplaceEditorHelper.AsComboEdit: TTMSFNCDataGridComboEdit;
begin
  Result := Self as TTMSFNCDataGridComboEdit;
end;

function TTMSFNCDataGridInplaceEditorHelper.AsDatePicker: TTMSFNCDataGridDatePicker;
begin
  Result := Self as TTMSFNCDataGridDatePicker;
end;

function TTMSFNCDataGridInplaceEditorHelper.AsEdit: TTMSFNCDataGridEdit;
begin
  Result := Self as TTMSFNCDataGridEdit;
end;

function TTMSFNCDataGridInplaceEditorHelper.AsHTMLEditor: TTMSFNCDataGridHTMLEditor;
begin
  Result := Self as TTMSFNCDataGridHTMLEditor;
end;

function TTMSFNCDataGridInplaceEditorHelper.AsMemo: TTMSFNCDataGridMemo;
begin
  Result := Self as TTMSFNCDataGridMemo;
end;

function TTMSFNCDataGridInplaceEditorHelper.AsSpinBox: TTMSFNCDataGridSpinBox;
begin
  Result := Self as TTMSFNCDataGridSpinBox;
end;

function TTMSFNCDataGridInplaceEditorHelper.AsTrackBar: TTMSFNCDataGridTrackBar;
begin
  Result := Self as TTMSFNCDataGridTrackBar;
end;

function TTMSFNCDataGridInplaceEditorHelper.GetDataValue: TTMSFNCDataGridCellValue;
begin
  Result := GetObjectValue(Self);
end;

function TTMSFNCDataGridInplaceEditorHelper.IsColorPicker: Boolean;
begin
  Result := Self is TTMSFNCDataGridColorPicker;
end;

function TTMSFNCDataGridInplaceEditorHelper.IsComboBox: Boolean;
begin
  Result := Self is TTMSFNCDataGridComboBox;
end;

function TTMSFNCDataGridInplaceEditorHelper.IsComboEdit: Boolean;
begin
  Result := Self is TTMSFNCDataGridComboEdit;
end;

function TTMSFNCDataGridInplaceEditorHelper.IsDatePicker: Boolean;
begin
  Result := Self is TTMSFNCDataGridDatePicker;
end;

function TTMSFNCDataGridInplaceEditorHelper.IsEdit: Boolean;
begin
  Result := Self is TTMSFNCDataGridEdit;
end;

function TTMSFNCDataGridInplaceEditorHelper.IsHTMLEditor: Boolean;
begin
  Result := Self is TTMSFNCDataGridHTMLEditor;
end;

function TTMSFNCDataGridInplaceEditorHelper.IsMemo: Boolean;
begin
  Result := Self is TTMSFNCDataGridMemo;
end;

function TTMSFNCDataGridInplaceEditorHelper.IsSpinBox: Boolean;
begin
  Result := Self is TTMSFNCDataGridSpinBox;
end;

function TTMSFNCDataGridInplaceEditorHelper.IsTrackBar: Boolean;
begin
  Result := Self is TTMSFNCDataGridTrackBar;
end;

procedure TTMSFNCDataGridInplaceEditorHelper.SetDataValue(
  const Value: TTMSFNCDataGridCellValue);
begin
  SetObjectValue(Self, Value);
end;

initialization
begin
  {$IFDEF WEBLIB}
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDCLOSE);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDEXPAND);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDCOLLAPSE);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDFILTER);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDFILTERACTIVE);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDFILTERCLEAR);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDSORTASC);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDSORTDESC);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDFILTERTYPE);
  {$ENDIF}
end;

end.
